<!-- 药店收款台页面（参考图片布局） -->
<template>
    <div class="cashier-page">
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <!-- 顶部信息区 -->
        <div class="header-info">
            <div class="header-left">
                <el-form inline size="small">
                    <div style="display: flex;align-items: center;flex-wrap: wrap;" v-if="cashierForm">
                        <template v-for="(formItem, formKey) in cashierForm.jurconfigform">
                            <div :key="formKey" v-if="formItem.isShow == 1">
                                <el-form-item v-if="formItem.entityField == 'salesPersonName' && keyMap.XSYXZ" :label="`${formItem.showField}[${keyMap.XSYXZ.showName}]`">
                                    <el-select ref="salesPersonSelect" v-model="memberInfo.salesPerson" :placeholder="formItem.showField" style="width: 100px" @focus="onSalesPersonFocus(1)" @blur="onSales" @change="onSalesPersonChange"
                                        @keydown.native="handleTopInputKeydown" :class="{ 'sales-person-focused': isSalesPersonFocused }">
                                        <el-option v-for="salesPerson in salesPersonList" :key="salesPerson.opmId" :label="salesPerson.opmName" :value="salesPerson.opmId" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-else-if="formItem.entityField == 'memPhone' && keyMap.HYLR" :label="`${formItem.showField}[${keyMap.HYLR.showName}]`">
                                    <el-input ref="memberCardInput" v-model="memberInfo.customerPhoneNumber" placeholder="手机号/卡号/姓名搜索" style="width: 140px" @keyup.enter.native="handleMemberCardEnter" @keydown.native="handleTopInputKeydown"
                                        @focus="onInputFocus" @blur="onInputBlur" :disabled="isMemberFromDropdown" />
                                </el-form-item>
                                <el-form-item :label="formItem.showField" v-else-if="formItem.entityField == 'memName'">
                                    <el-input ref="customerNameInput" v-model="memberInfo.customerName" :placeholder="formItem.showField" style="width: 120px" @keydown.native="handleTopInputKeydown" @focus="onInputFocus" @blur="onInputBlur"
                                        @input="onMemberInfoChange" :disabled="isMemberFromDropdown" />
                                </el-form-item>
                                <el-form-item :label="formItem.showField" v-else-if="formItem.entityField == 'memIdcard'">
                                    <el-input ref="customerIdCardInput" v-model="memberInfo.customerIdCard" :placeholder="formItem.showField" style="width: 150px" @keydown.native="handleTopInputKeydown" @focus="onInputFocus"
                                        @blur="onInputBlur" @input="onMemberInfoChange" :disabled="isMemberFromDropdown" />
                                </el-form-item>
                                <el-form-item :label="formItem.showField" v-else-if="formItem.entityField == 'doctor'">
                                    <el-select ref="doctorSelect" v-model="memberInfo.doctor" :placeholder="formItem.showField" style="width: 100px" @keydown.native="handleTopInputKeydown" @focus="onSalesPersonFocus(2)" @blur="onDoctorBlur"
                                        :class="{ 'sales-person-focused': isDoctorFocused }">
                                        <el-option v-for="doctor in doctorList" :key="doctor.opmId" :label="doctor.opmName" :value="doctor.opmId" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="formItem.showField" v-else-if="formItem.entityField == 'pharmacist'">
                                    <el-select ref="pharmacistSelect" v-model="memberInfo.pharmacist" :placeholder="formItem.showField" style="width: 100px" @keydown.native="handleTopInputKeydown" @focus="onSalesPersonFocus(3)"
                                        @blur="onPharmacistBlur" :class="{ 'sales-person-focused': isPharmacistFocused }">
                                        <el-option v-for="pharmacist in pharmacistList" :key="pharmacist.opmId" :label="pharmacist.opmName" :value="pharmacist.opmId" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="formItem.showField" v-else>
                                    <el-select v-if="formItem.entityField == 'assistanceInfo'" ref="assistanceInfoSelect" clearable v-model="assistObj.assistanceInfo" placeholder="辅助项目" style="width: 100px">
                                        <el-option v-for="(pharmacist, index) in dictionariesData.SKTFZX" :key="index" :label="pharmacist.diName" :value="pharmacist.diValue" />
                                    </el-select>
                                    <el-input v-else-if="formItem.entityField == 'remark'" ref="remarkInput" v-model="assistObj.remark" placeholder="备注" style="width: 120px" @keydown.native="handleTopInputKeydown" @focus="onInputFocus"
                                        @blur="onInputBlur" />
                                </el-form-item>
                            </div>
                        </template>
                    </div>
                </el-form>
            </div>
            <div class="header-right">
                <el-form inline size="small" style="text-align: right; margin-bottom: 5px">
                    <!-- <el-form-item label="是否开启打印小票:">
                        <el-switch v-model="autoPrint" active-value="1" inactive-value="0" active-color="#13ce66">
                        </el-switch>
                    </el-form-item> -->
                    <span class="time-value" style="cursor: pointer; margin-right: 10px" @click="onExit()">退出收银台</span>
                    <span class="time-value" style="cursor: pointer; margin-right: 10px" @click="openFormDesign()">
                        <i class="el-icon-setting icons" @click="openFormDesign"></i>
                    </span>
                    <!-- <span class="time-value" style="cursor: pointer; margin-right: 10px" @click="onExtract()">提取O2O订单</span> -->
                    <span class="time-value" style="margin-right: 40px;">{{ currentTime }}</span>
                </el-form>
                <el-form id="header-right-form" inline size="small">
                    <el-form-item label="会员积分:">
                        <span class="points-value">{{ memberInfo.points || "0" }}</span>
                    </el-form-item>
                    <el-form-item label="门店收款台:">
                        <span style="display: inline-block">{{ memberInfo.deskCode }}</span>
                    </el-form-item>
                    <el-form-item label="收银员:">
                        <span style="display: inline-block">{{ memberInfo.cashier }}</span>
                    </el-form-item>
                    <el-form-item label="门店名称:">
                        <span style="display: inline-block">{{memberInfo.storeName}}</span>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="main-content-row">
            <!-- 主体内容（表格+信息区） -->
            <div class="main-content">
                <!-- 商品明细表格 -->
                <div class="main-table-area">
                    <el-table v-if="shopCartForm" :data="cartItems" border height="320px" size="small" @keyup.native="handleCartKeyDown" class="cart-table" ref="cartTable" :row-class-name="getRowClassName" @row-click="selectRow"
                        tabindex="0">
                        <template v-for="(tableValye, tableKey) in shopCartForm.jurconfigform">
                            <el-table-column v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                                <template slot-scope="scope">
                                    <div class="sales-person-display" v-if="tableValye.entityField == 'salesName'">
                                        <span>{{ scope.row.salesPersonName || "-" }}</span>
                                    </div>
                                    <div v-else-if="tableValye.entityField == 'salesPrice'">
                                        <div>
                                            <!-- 赠品特殊显示 -->
                                            <span v-if="scope.row.isGift">
                                                {{ (scope.row.changePrice || 0).toFixed(2) }} (赠品)
                                            </span>
                                            <!-- 普通商品显示 -->
                                            <span v-else>{{ scope.row.showOriginalPrice ? scope.row.displayPrice :scope.row.changePrice }}</span>

                                            <span v-if="scope.row.isDiscounted" class="discount-tag" :title="scope.row.discountInfo">
                                                <i class="el-icon-discount"></i>
                                            </span>

                                            <!-- 赠品原价显示 -->
                                            <div v-if="scope.row.isGift && scope.row.displayPrice && scope.row.displayPrice > 0" style=" color: #909399; font-size: 12px; text-decoration: line-through;">
                                                (原价: ¥{{ scope.row.displayPrice }}元)
                                            </div>

                                            <!-- 普通商品折扣信息显示 -->
                                            <div v-else-if="scope.row.showOriginalPrice && scope.row.changePrice !== scope.row.displayPrice" style="color: #ff6600; font-size: 12px">
                                                (折后价: {{ scope.row.changePrice }}元)
                                            </div>
                                            <div v-else-if="!scope.row.showOriginalPrice && scope.row.displayPrice && scope.row.changePrice !== scope.row.displayPrice" style="color: #ff6600; font-size: 12px">
                                                (原价: {{ scope.row.displayPrice }}元)
                                            </div>
                                        </div>
                                        <div v-if="scope.row.isLimitedQuantity && scope.row.quantity > scope.row.limitedQuantity" style="color: #ff6600; font-size: 12px; white-space: nowrap">
                                            <div>
                                                优惠价: {{ scope.row.changePrice }}元 (限{{ scope.row.limitedQuantity }}件)
                                            </div>
                                            <div>
                                                {{ memberInfo.customerPhoneNumber || memberInfo.memId ? "会员价" : "原价" }}: {{scope.row.extraPrice }}元
                                            </div>
                                        </div>
                                        <div v-else-if="scope.row.limitInfo" style="color: #ff6600; font-size: 12px; white-space: nowrap">
                                            {{ scope.row.limitInfo }}
                                        </div>
                                    </div>
                                    <div class="cart-qty-display" v-else-if="tableValye.entityField == 'salesNum'">
                                        <span>{{ scope.row.tcmDosage ? scope.row.quantity * scope.row.tcmDosage : scope.row.quantity}}</span>
                                        <span v-if="scope.row.tcmDosage && scope.row.tcmDosage > 1" style="color: #e6a23c; font-weight: bold; font-size: 12px; ">
                                            ({{ scope.row.tcmDosage }}副)
                                        </span>
                                    </div>
                                    <div v-else-if="tableValye.entityField == 'salesMoney'">
                                        <span>{{  $common.getDecimalInfo(getCartItemReceivablePrice(scope.row).type, getCartItemReceivablePrice(scope.row).amount) }}</span>
                                    </div>
                                    <div v-else-if="tableValye.entityField == 'expidate'">
                                        <span :style="{ color: getExpidateColor(scope.row.expidate) }">
                                            {{ $common.getLocalTime(scope.row.expidate) }}
                                        </span>
                                    </div>
                                    <div v-else-if="tableValye.entityField == 'retailMoney'">
                                        <span>{{ retailMoneyChange(scope.row) }}</span>
                                    </div>
                                    <span v-else-if="tableValye.fieldType == 'formatter'">
                                        <span v-if="tableValye.formatterContent">
                                            {{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}
                                        </span>
                                    </span>
                                    <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                </div>
                <!-- 件数和应收金额显眼展示 -->
                <div class="summary-bar" v-if="collectForm">
                    <span class="summary-balance" v-if="memberInfo.memId">会员余额：<b>¥{{ memberInfo.storedBalance
                     }}</b></span>
                    <span class="summary-balance" v-if="memberInfo.memId">获得积分：<b>{{ totalEarnedPoints.toFixed(2)
                     }}</b></span>
                    <template v-for="(formItem, formKey) in collectForm.jurconfigform">
                        <span :key="formKey" v-if="formItem.isShow == 1">
                            <span v-if="formItem.entityField == 'totalCount'" class="summary-qty">{{ formItem.showField }}：<b>{{totalCount}}</b></span>
                            <span v-else-if="formItem.entityField == 'totalNumber'" class="summary-qty">{{ formItem.showField}}：<b>{{totalQuantity }}</b></span>
                            <span v-else-if="formItem.entityField == 'disMoney'" class="summary-discount">{{ formItem.showField}}：<b>¥{{discountAmount && discountAmount > 0? $common.getDecimalInfo(3, discountAmount): "0.00"}}</b></span>
                            <span v-else-if="formItem.entityField == 'totalMoney'" class="summary-amount">{{ formItem.showField}}：<b>¥{{ $common.getDecimalInfo(3, payableAmount) }}</b></span>
                        </span>
                    </template>
                    <span class="summary-small" v-if="memberInfo.isSmall === 1||memberInfo.isSmall === 2" style="color: #67c23a; font-size: 16px">
                        <i class="el-icon-info"></i> 抹零模式
                    </span>
                </div>
                <!-- 商品选择区域 -->
                <div class="product-select-area">
                    <el-form inline size="small">
                        <el-form-item v-if="keyMap.SPLR" :label="'商品录入[' + keyMap.SPLR.showName + ']'">
                            <el-input ref="productSearchInput" v-model="searchKey" placeholder="商品编号/名称" style="width: 180px" @keydown.enter.native="handleProductSearch" />
                        </el-form-item>
                        <el-form-item label="数量">
                            <el-input ref="quantityInput" v-model="quantityChange" placeholder="数量" style="width: 120px" @input="onQuantityChange" @keyup.enter.native="onQuantityEnter" />
                        </el-form-item>
                    </el-form>
                    <div class="product-select-area-right">
                        <p style="margin-top: 3px;" class="is-zero-checkbox">
                            是否零库存 <el-checkbox v-model="isZero" true-label="1" false-label="0"></el-checkbox>
                        </p>
                        <p v-if="keyMap.DZJG" @click="handleShortcutKeyShop('DZJG')">
                            扫电子监管 <span class="product-select-area-right-key">{{ keyMap.DZJG.showName }}</span>
                        </p>
                        <p v-if="keyMap.ZYFS" @click="handleShortcutKeyShop('ZYFS')">
                            输入中药副数 <span class="product-select-area-right-key">{{ keyMap.ZYFS.showName }}</span>
                        </p>
                        <p v-if="keyMap.SZXSY" @click="handleShortcutKeyShop('SZXSY')">
                            设置销售员 <span class="product-select-area-right-key">{{ keyMap.SZXSY.showName }}</span>
                        </p>
                        <p v-if="keyMap.XGDJ" @click="handleShortcutKeyShop('XGDJ')">修改单价 <span class="product-select-area-right-key">{{
                           keyMap.XGDJ.showName }}</span></p>
                        <p v-if="keyMap.XGSL" @click="handleShortcutKeyShop('XGSL')">修改数量 <span class="product-select-area-right-key">{{
                           keyMap.XGSL.showName }}</span></p>
                        <p v-if="keyMap.SCSP" @click="handleShortcutKeyShop('SCSP')">
                            删除商品 <span class="product-select-area-right-key">{{ keyMap.SCSP.showName }}</span>
                        </p>
                    </div>
                </div>
                <!-- 商品信息展示区 -->
                <product-info-display :product="selectedProduct" :keyMap="keyMap" />
            </div>
            <!-- 右侧快捷键展示区 -->
            <shortcut-panel @shortcut-key="handleShortcutKey" />
        </div>
        <!-- 商品选择弹窗 -->
        <el-dialog title="商品录入" :visible.sync="productSelectDialogVisible" width="85%" @open="onProductDialogOpen" @close="onProductDialogClose" append-to-body>
            <el-table v-if="productEntryForm" id="productTable" ref="productTable" :data="productSelectList" border height="320px" @row-dblclick="selectCurrentProduct" @row-click="onProductRowClick" highlight-current-row
                style="margin-bottom: 8px" @keydown.native="handleProductDialogKeyDown" :row-class-name="getProductRowClassName" tabindex="0">
                <template v-for="(tableValye, tableKey) in productEntryForm.jurconfigform">
                    <el-table-column v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <el-input v-if="tableValye.entityField == 'salesNum'" v-model.number="scope.row.inputQuantity" type="number" :min="1" :step="1" placeholder="数量" size="mini"
                                @keydown.native="handleQuantityInputKeyDown($event, scope.$index)">
                            </el-input>
                            <span v-else-if="tableValye.entityField == 'expidate'" :style="{ color: getExpidateColor(scope.row[tableValye.entityField]) }">{{$common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                            <span v-else-if="tableValye.fieldType == 'date'">{{$common.getLocalTime(scope.row[tableValye.entityField]) }}</span>
                            <span v-else-if="tableValye.fieldType == 'formatter'">
                                <span v-if="tableValye.formatterContent">
                                    {{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}
                                </span>
                            </span>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="productSelectDialogVisible = false">取消</el-button>
            </span>
        </el-dialog>
        <!-- 会员卡选择弹窗 -->
        <el-dialog title="会员卡选择" :visible.sync="memberSelectDialogVisible" width="60%" append-to-body @open="onMemberDialogOpen">
            <el-table ref="memberTable" :data="filterMemberSelectList()" border height="320px" @row-dblclick="onMemberSelect" highlight-current-row style="margin-bottom: 8px" @keydown.native="handleMemberDialogKeyDown"
                :row-class-name="getMemberRowClassName" tabindex="0">
                <el-table-column prop="storeName" label="注册门店" width="120" />
                <el-table-column prop="cardNo" label="会员卡号" width="120" />
                <el-table-column prop="name" label="姓名" width="100" />
                <el-table-column prop="phone" label="手机号" width="120" />
                <el-table-column prop="idCard" label="身份证号" min-width="180" />
                <el-table-column prop="capName" label="卡类型" width="90" />
                <el-table-column prop="pointBalance" label="积分余额" min-width="120" />
                <el-table-column prop="storedBalance" label="储值余额" min-width="120" />
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="memberSelectDialogVisible = false">取消</el-button>
            </span>
        </el-dialog>
        <!-- 促销方案选择弹窗 -->
        <el-dialog title="促销方案选择" :visible.sync="promotionSelectDialogVisible" width="80%" @close="promotionSelectDialogVisible = false" @opened="onPromotionDialogOpened" append-to-body class="promotion-dialog">
            <div class="promotion-dialog-tip">
                请选择可用的促销方案（同一商品只能参与一个促销优惠，选择后其他冲突方案将被禁用）
            </div>
            <el-table ref="promotionTable" :data="filterPromotionSelectList()" border height="400px" highlight-current-row style="margin-bottom: 8px" tabindex="0" @keydown.native="handleKeyDown"
                @selection-change="handlePromotionSelectionChange" @select-all="handleSelectAll" @row-click="onPromotionSelect">
                <el-table-column type="selection" width="55" :selectable="promotionSelectable" :reserve-selection="false" />
                <el-table-column prop="sellType" label="类型" width="150">
                    <template slot-scope="scope">
                        <span class="promotion-type">
                            {{scope.row.sellType === 31? "超量促销": scope.row.sellType === 32? "买赠促销": scope.row.sellType === 41? "调价：积分倍数": scope.row.sellType === 42? "调价：单品特价": scope.row.sellType === 43? "整单优惠": "整单优惠"}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="planName" label="方案名称" width="200">
                    <template slot-scope="scope">
                        <span class="promotion-name">{{ scope.row.planName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="planDesc" label="描述" min-width="220">
                    <template slot-scope="scope">
                        <span class="promotion-desc">{{ scope.row.planDesc }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <template>
                <div v-if="selectedPromotions.some((plan) => plan.mzGiftType === 1) &&(singleSelectGiftList.length > 0 || multiSelectGiftList.length > 0)" class="gift-select-area">
                    <h4 style="margin: 10px 0; color: #409eff">请选择赠品</h4>
                    <!-- 任选一个赠品（单选模式） -->
                    <template v-if="selectedPromotions.some((plan) => plan.mzGiftNumType === 1) &&singleSelectGiftList.length > 0">
                        <div style="margin-bottom: 10px; color: #e6a23c; font-size: 14px">
                            <i class="el-icon-info"></i>
                            任选一个赠品模式：请从下列赠品中选择一个
                        </div>
                        <el-table ref="singleGiftTable" :data="singleSelectGiftList" border size="small" style="margin-bottom: 8px" tabindex="0" highlight-current-row @keydown.native="handleGiftKeyDown">
                            <el-table-column label="选择" width="60" align="center">
                                <template slot-scope="scope">
                                    <el-radio v-model="selectedSingleGift" :label="scope.row.bgmId" @change="onSingleGiftChange(scope.row)">
                                        <span></span>
                                    </el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="planName" label="促销方案" width="160" />
                            <el-table-column prop="bgmName" label="赠品名称" width="120" />
                            <el-table-column prop="spec" label="规格" width="100" />
                            <el-table-column prop="manufacturer" label="生产厂家" width="150" />
                            <el-table-column prop="giftNum" label="赠送数量" width="120" />
                        </el-table>
                    </template>
                    <!-- 多选模式（原有逻辑） -->
                    <template v-if="selectedPromotions.some((plan) => plan.mzGiftNumType === 2) &&multiSelectGiftList.length > 0">
                        <div style="margin-bottom: 10px; color: #67c23a; font-size: 14px">
                            <i class="el-icon-info"></i> 赠送以下商品
                        </div>
                        <el-table :data="multiSelectGiftList" border size="small" style="margin-bottom: 8px">
                            <el-table-column prop="planName" label="促销方案" width="160" />
                            <!-- <el-table-column prop="stageDesc" label="赠送条件" width="120" /> -->
                            <el-table-column prop="bgmName" label="赠品名称" width="120" />
                            <el-table-column prop="spec" label="规格" width="100" />
                            <el-table-column prop="manufacturer" label="生产厂家" width="150" />
                            <el-table-column label="赠送数量" prop="giftNum" width="120" />
                        </el-table>
                    </template>
                </div>
            </template>
            <template>
                <div v-if="selectedPromotions.some((plan) => plan.mzGiftType === 2) &&(singleSelectCouponList.length > 0 ||multiSelectCouponList.length > 0)" class="gift-select-area">
                    <h4 style="margin: 10px 0; color: #409eff">请选择优惠券</h4>
                    <!-- 任选一个优惠券（单选模式） -->
                    <template v-if="selectedPromotions.some((plan) => plan.mzGiftNumType === 1) &&singleSelectCouponList.length > 0">
                        <div style="margin-bottom: 10px; color: #e6a23c; font-size: 14px">
                            <i class="el-icon-info"></i>
                            任选一个优惠券模式：请从下列优惠券中选择一个
                        </div>
                        <el-table ref="singleCouponTable" :data="singleSelectCouponList" border size="small" style="margin-bottom: 8px" tabindex="0" highlight-current-row @keydown.native="handleCouponKeyDown">
                            <el-table-column label="选择" width="60" align="center">
                                <template slot-scope="scope">
                                    <el-radio v-model="selectedSingleCoupon" :label="scope.row.yhqId" @change="onSingleCouponChange(scope.row)">
                                        <span></span>
                                    </el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="planName" label="促销方案" width="160" />
                            <el-table-column prop="yhqName" label="优惠券名称" width="160" />
                            <el-table-column prop="yhqDesc" label="优惠券描述" width="120" />
                            <el-table-column prop="limitDay" label="使用期限(自发放后有效期)" width="160" />
                            <el-table-column prop="remark" label="备注" width="100" />
                            <el-table-column label="赠送数量" prop="giftNum" width="120" />
                        </el-table>
                    </template>
                    <!-- 多选模式（原有逻辑） -->
                    <template v-if="selectedPromotions.some((plan) => plan.mzGiftNumType === 2) &&multiSelectCouponList.length > 0">
                        <div style="margin-bottom: 10px; color: #67c23a; font-size: 14px">
                            <i class="el-icon-info"></i> 赠送以下优惠券
                        </div>
                        <el-table :data="multiSelectCouponList" border size="small" style="margin-bottom: 8px">
                            <el-table-column prop="planName" label="促销方案" width="160" />
                            <!-- <el-table-column prop="stageDesc" label="赠送条件" width="120" /> -->
                            <el-table-column prop="yhqName" label="优惠券名称" width="160" />
                            <el-table-column prop="yhqDesc" label="优惠券描述" width="120" />
                            <el-table-column prop="limitDay" label="使用期限(自发放后有效期)" width="160" />
                            <el-table-column prop="remark" label="备注" width="100" />
                            <el-table-column label="赠送数量" prop="giftNum" width="120" />
                        </el-table>
                    </template>
                </div>
            </template>
            <div class="promotion-dialog-footer">
                <el-button v-if="!isAllPromotion" ref="confirmButton" @click="confirmPromotionSelection" type="primary" @keydown.native="handleConfirmButtonKeyDown">确认选择</el-button>
                <el-button v-else ref="confirmButton" @click="confirmPromotionSelectionIII" type="primary" @keydown.native="handleConfirmButtonKeyDown">确认选择</el-button>
            </div>
        </el-dialog>
        <el-dialog title="促销方案显示" :visible.sync="promotionSelectDialogVisibleII" width="50%" @close="promotionSelectDialogVisibleII = false" append-to-body class="promotion-dialog">
            <el-table ref="promotionTable" :data="filterPromotionSelectList()" border height="400px" highlight-current-row style="margin-bottom: 8px">
                <el-table-column prop="sellType" label="类型" width="180">
                    <template slot-scope="scope">
                        <span class="promotion-type">
                            {{scope.row.sellType === 31? "超量促销": scope.row.sellType === 32? "买赠促销": scope.row.sellType === 41? "调价：积分倍数": scope.row.sellType === 42? "调价：单品特价": scope.row.sellType === 43? "整单优惠": "整单优惠"}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="planName" label="方案名称" width="200">
                    <template slot-scope="scope">
                        <span class="promotion-name">{{ scope.row.planName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="planDesc" label="描述" min-width="220">
                    <template slot-scope="scope">
                        <span class="promotion-desc">{{ scope.row.planDesc }}</span>
                    </template>
                </el-table-column>
            </el-table>

            <div class="promotion-dialog-footer">
                <el-button @click="promotionSelectDialogVisibleII = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 账簿选择弹窗 -->
        <el-dialog title="请选择付款账簿" :visible.sync="bookSelectDialogVisible" width="80%" append-to-body @close="onBookSelectCancel" @opened="onBookSelectDialogOpened" :close-on-press-escape="false">
            <!-- 应付金额和选择付款方式标题行 -->
            <div class="book-select-title-row">
                <div class="payable-amount-display">
                    <i class="el-icon-money"></i>
                    <span>应付金额：</span>
                    <b>¥{{ $common.getDecimalInfo(3, payableAmount) }}</b>
                </div>
                <div class="payment-method-title">
                    <h3><i class="el-icon-bank-card"></i> 选择付款方式</h3>
                </div>
            </div>

            <!-- 快捷键提示 -->
            <div class="book-select-shortcut-tip">
                <i class="el-icon-keyboard"></i>
                <span>快捷键：F+1-12直接选择账簿，↑↓选择账簿，
                    Enter确认结账（可在任何输入框中使用）</span>
            </div>

            <!-- 账簿选择区域 -->
            <div class="book-select-container">
                <div class="book-select-grid">
                    <div v-for="(book, index) in bookList" :key="book.value" class="book-card" :class="{ 'book-card-active': book.inputMoney > 0 }">
                        <!-- 快捷键标识 -->
                        <div class="book-card-shortcut" v-if="index < 12">
                            <span class="shortcut-number">F{{ index + 1 }}</span>
                        </div>
                        <div class="book-card-header">
                            <div class="book-card-icon">
                                <i class="el-icon-coin"></i>
                            </div>
                            <div class="book-card-info">
                                <div class="book-card-title">{{ book.name }}</div>
                                <div class="book-card-code">
                                    编号：{{ book.code || book.abookCode || book.value }}
                                </div>
                            </div>
                        </div>
                        <div class="book-card-body">
                            <el-input class="book-card-input" v-model="book.inputMoney" :disabled="book.disabled" @focus="handleBookInputFocus(book)" @change="handleBookInputChange(book)" type="number" :min="0" :step="0.01"
                                placeholder="请输入金额">
                            </el-input>
                            <div class="book-card-status" v-if="book.inputMoney > 0||book.inputMoney<0">
                                <i class="el-icon-check"></i>
                                <span>已输入：¥{{book.inputMoney? $common.getDecimalInfo(3, Number(book.inputMoney)):0 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 底部操作栏 -->
            <div class="book-select-footer">
                <div class="book-select-summary">
                    <span>已输入金额：<b>¥{{ $common.getDecimalInfo(3, totalInputMoney) }}</b></span>
                    <span v-if="cashChangeAmount > 0">找零：<b style="color: #67C23A;">¥{{$common.getDecimalInfo(3, cashChangeAmount)
               }}</b></span>
                </div>
                <div class="book-select-actions">
                    <!-- <el-button @click="onBookSelectCancel" size="medium">取消</el-button> -->
                    <el-button type="primary" :disabled="disabled" @click="onBookSelectConfirm" size="medium">
                        <i class="el-icon-check"></i> 确认结账
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 付款信息 -->
        <el-dialog title="请客户出示付款码" :visible.sync="payShow" width="450px" append-to-body center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="escPayShow">
            <div class="payment-code-container" v-if="payShow">
                <div class="payment-amount-section">
                    <p class="payment-title">付款金额</p>
                    <p class="payment-amount">¥{{ $common.getDecimalInfo(3, payMoney) }}</p>
                </div>

                <div class="payment-input-section">
                    <el-input :readonly="payReadonly" v-model="payCode" type="text" ref="payCode" maxlength="30" :disabled="disabled" placeholder="请输入或扫描付款码" @keyup.enter.native="onBookSelectConfirm" class="payment-input">
                        <i slot="prefix" class="el-icon-mobile-phone el-input__icon"></i>
                        <template slot="append">
                            <el-button size="mini" type="primary" icon="el-icon-refresh" @click="clearPayCode" circle></el-button>
                        </template>
                    </el-input>

                    <div class="shortcut-info">
                        <i class="el-icon-keyboard"></i> 快捷键：<kbd>Enter</kbd>
                    </div>
                </div>
                <!--   :class="'success': payMessage.includes('成功'), 'error': payMessage.includes('失败'),{ 'warning': payMessage.includes('注意') }" -->
                <div class="payment-message-section">
                    <p class="payment-message" :class="{ 'warning': payMessage != '' }">
                        {{ payMessage }}
                    </p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer" v-if="closeFlag">
                <el-button type="primary" @click="closePayClick">停止支付</el-button>
            </span>
        </el-dialog>
        <!-- 购买人信息弹窗 -->
        <el-dialog title="请填写购买人信息" :visible.sync="buyerInfoDialogVisible" width="400px" append-to-body @close="onBuyerInfoDialogClose" @open="onBuyerInfoDialogOpen" @keydown.native="handleBuyerInfoDialogKeyDown">
            <el-form id="buyerInfoForm" :model="buyerInfoForm" :rules="buyerInfoRules" ref="buyerInfoFormRef" label-width="80px" size="small">
                <el-form-item label="姓名" prop="name" style="color: #000">
                    <el-input ref="buyerNameInput" v-model="buyerInfoForm.name" placeholder="请输入姓名" @keydown.down.native.prevent="focusNextBuyerInput('buyerNameInput')" @keydown.up.native.prevent="focusLastBuyerInput('buyerNameInput')"
                        @keydown.enter.native="onBuyerInfoConfirm" />
                </el-form-item>
                <el-form-item label="手机号" prop="phone" style="color: #000">
                    <el-input ref="buyerPhoneInput" v-model="buyerInfoForm.phone" placeholder="请输入手机号" maxlength="11" @keydown.down.native.prevent="
                     focusNextBuyerInput('buyerPhoneInput')
                     " @keydown.up.native.prevent="focusLastBuyerInput('buyerPhoneInput')" @keydown.enter.native="onBuyerInfoConfirm" />
                </el-form-item>
                <el-form-item label="身份证号" prop="idCard" style="color: #000">
                    <el-input ref="buyerIdCardInput" v-model="buyerInfoForm.idCard" placeholder="请输入身份证号" maxlength="18" @keydown.down.native.prevent="
                     focusNextBuyerInput('buyerIdCardInput')
                     " @keydown.up.native.prevent="focusLastBuyerInput('buyerIdCardInput')" @keydown.enter.native="onBuyerInfoConfirm" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button ref="buyerInfoConfirmButton" type="primary" @click="onBuyerInfoConfirm" @keydown.enter.native="onBuyerInfoConfirm" @keydown.up.native.prevent="
                  focusLastBuyerInput('buyerInfoConfirmButton')
                  " @keydown.down.native.prevent="
                     focusNextBuyerInput('buyerInfoConfirmButton')
                     ">确认</el-button>
            </span>
        </el-dialog>
        <!-- 挂单备注输入弹窗 -->
        <el-dialog title="请输入挂单备注" :visible.sync="holdOrderRemarkDialogVisible" width="400px" append-to-body @opened="onHoldOrderRemarkDialogOpened">
            <el-input v-model="holdOrderRemark" ref="holdOrderRemarkInput" placeholder="请输入备注（如客户姓名、手机号等）" maxlength="30" @keyup.enter.native="confirmHoldOrder" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="holdOrderRemarkDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmHoldOrder">确认挂单</el-button>
            </span>
        </el-dialog>
        <!-- 挂单列表弹窗 -->
        <hold-order-list-dialog :visible.sync="holdOrderDialogVisible" :member-info="memberInfo" :hold-order-list="holdOrderList" @opened="onHoldOrderDialogOpened" @close="onHoldOrderDialogClose" @restore-hold-order="restoreHoldOrder"
            @print-hold-order="printHoldOrder" />
        <!-- 修改密码弹窗 -->
        <change-password-dialog :visible.sync="changePasswordDialogVisible" :member-info="memberInfo" @opened="onChangePasswordDialogOpened" @close="onChangePasswordDialogClose" @confirm="onChangePasswordConfirm" />
        <!-- 选择执业药师弹窗 -->
        <pharmacist-select-dialog :visible.sync="pharmacistSelectDialogVisible" :pending-product="pendingProductForPharmacist" :pharmacist-list="pharmacistList" :selected-pharmacist="memberInfo.pharmacist"
            @opened="onPharmacistSelectDialogOpened" @close="onPharmacistSelectDialogClose" @confirm="onPharmacistSelectConfirm" @focus-product-input="focusProductSearchInput" />
        <!-- 销售员选择弹窗 -->
        <sales-person-select-dialog :visible.sync="salesPersonSelectDialogVisible" :selected-cart-item="selectedCartItem" :sales-person-list="salesPersonList" @opened="onSalesPersonSelectDialogOpened" @close="onSalesPersonSelectDialogClose"
            @confirm="onSalesPersonSelectConfirm" @focus-cart="focusCartTable" />
        <!-- 修改数量弹窗 -->
        <quantity-edit-dialog :visible.sync="quantityEditDialogVisible" :selected-cart-item="selectedCartItem" :cart-items="cartItems" :selected-item-index="selectedItemIndex" @opened="onQuantityEditDialogOpened"
            @close="onQuantityEditDialogClose" @confirm="onQuantityEditConfirm" />
        <!-- 修改单价弹窗 -->
        <price-edit-dialog :visible.sync="priceEditDialogVisible" :selected-cart-item="selectedCartItem" @opened="onPriceEditDialogOpened" @close="onPriceEditDialogClose" :isChangePriceCheck="isChangePriceCheck"
            @confirm="onPriceEditConfirm" />
        <!-- 会员卡弹窗 -->
        <el-dialog :visible.sync="showStatus" :title="'新增会员信息'" width="65%" :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="true" center>
            <memberModal v-if="showStatus" ref="storeMastRef" @drawerCancel="drawerCancel" :actionData="actionData">
            </memberModal>
        </el-dialog>
        <!-- 会员储值弹窗 -->
        <member-recharge-dialog :visible.sync="rechargeDialogVisible" :member-info="rechargeForm" @opened="onRechargeDialogOpened" @confirm="onRechargeConfirm" @cancel="onRechargeCancel" />
        <!-- 收款台选择弹窗 -->
        <desk-select-dialog :visible.sync="deskSelectDialogVisible" :desk-list="cashdeskList" @confirm="onDeskSelectConfirm" @cancel="onDeskSelectCancel" />
        <!-- 退货弹窗 -->
        <return-dialog :visible.sync="returnDialogVisible" :cur-date="curDate" :cur-time="curTime" :day="day" :week="week" :store-id="storeId" @confirm="onReturnConfirm" @opened="onReturnDialogOpened" @close="onReturnDialogClose" />
        <!-- 交班弹窗 -->
        <shift-dialog :bcCode="bcCode" :visible.sync="shiftDialogVisible" :store-id="storeId" @confirm="onShiftConfirm" @opened="onShiftDialogOpened" @close="onShiftDialogClose" />
        <!-- 拆分商品弹窗 -->
        <split-item-dialog :visible.sync="splitItemDialogVisible" :store-id="storeId" :cur-date="curDate" :cur-time="curTime" :day="day" :week="week" @opened="onSplitItemDialogOpened" @close="onSplitItemDialogClose"
            @confirm="onSplitItemConfirm" />
        <printPlan ref="printPlan"></printPlan>

        <!-- 赠品选择弹窗组件 -->
        <GiftSelectionDialog ref="giftSelectionDialog" :visible.sync="batchSelectionDialog.visible" :gift-info="batchSelectionDialog.giftInfo" @confirm="onGiftSelectionConfirm" @confirmII="onGiftSelectionConfirmIII"
            @close="onGiftSelectionClose" />
        <!-- 赠品选择弹窗组件 全部赠送-->
        <GiftSelectionDialogII ref="giftSelectionDialogII" :visible.sync="batchSelectionDialogII.visible" :gift-info="batchSelectionDialogII.giftInfo" @confirm="onGiftSelectionConfirmII" @close="onGiftSelectionCloseII" />
        <!-- 电子监管码弹窗 -->
        <regulatory-code-dialog :visible.sync="regulatoryCodeDialogVisible" :cart-items="cartItems" :scanCodeList="esuList" @confirm="onRegulatoryCodeConfirm" @close="onRegulatoryCodeClose" />
        <!-- 汇总明细查询弹窗 收银台获取的10单 -->
        <summary-detail-dialog :visible.sync="summaryDetailDialogVisible" :query-params="summaryQueryParams" @opened="onSummaryDetailDialogOpened" @close="onSummaryDetailDialogClose" />
        <!-- 条码维护弹窗 -->
        <barcode-maintenance-dialog :visible.sync="barcodeMaintenanceDialogVisible" :selected-cart-item="cartItems[this.selectedItemIndex]" @opened="onBarcodeMaintenanceDialogOpened" @close="onBarcodeMaintenanceDialogClose"
            @confirm="onBarcodeMaintenanceConfirm" />
        <!-- 中药副数弹窗 -->
        <TCMDosageDialog :visible.sync="tcmDosageDialogVisible" :selected-cart-item="cartItems[this.selectedItemIndex]" @opened="onTCMDosageDialogOpened" @close="onTCMDosageDialogClose" @confirm="onTCMDosageConfirm" />
        <!-- 计算器弹窗 -->
        <CalculatorDialog :visible.sync="calculatorDialogVisible" @opened="onCalculatorDialogOpened" @close="onCalculatorDialogClose" />
        <!-- 商品批号查询 -->
        <!-- <ProductBatchDialog :visible.sync="productBatchDialogVisible" :cur-date="curDate" :cur-time="curTime" :day="day" :week="week" :store-id="storeId" :selected-product="selectedProductForBatch" @opened="onProductBatchDialogOpened" @close="onProductBatchDialogClose" @confirm="onProductBatchConfirm" /> -->
        <!-- 制作卤药弹窗 -->
        <LuyaoMakeDialog :visible.sync="luyaoMakeDialogVisible" :product-list="luyaoProductList" @opened="onLuyaoMakeDialogOpened" @close="onLuyaoMakeDialogClose" @confirm="onLuyaoMakeConfirm" />
        <!-- 临时退货弹窗 -->
        <TempReturnDialog :visible.sync="tempReturnDialogVisible" :cur-date="curDate" :cur-time="curTime" :day="day" :week="week" :store-id="storeId" @opened="onTempReturnDialogOpened" @close="onTempReturnDialogClose"
            @confirm="onTempReturnConfirm" />
        <!-- 库存分布弹窗 -->
        <StockDistributionDialog v-if="stockDistributionDialogVisible" :formList="inventoryList" :parentSearchData="parentSearchData" :visible.sync="stockDistributionDialogVisible" @opened="onStockDistributionDialogOpened"
            @close="onStockDistributionDialogClose" />
    </div>
</template>

<script>
import NP from 'number-precision'
import memberModal from "./penetrateCashier/memberModal.vue";
import shortcutPanel from "./penetrateCashier/shortcutPanel.vue";
import DeskSelectDialog from "./penetrateCashier/DeskSelectDialog.vue";
import MemberRechargeDialog from "./penetrateCashier/MemberRechargeDialog.vue";
import ProductInfoDisplay from "./penetrateCashier/ProductInfoDisplay.vue";
import PriceEditDialog from "./penetrateCashier/PriceEditDialog.vue";
import GiftSelectionDialog from "./penetrateCashier/GiftSelectionDialog.vue";
import GiftSelectionDialogII from "./penetrateCashier/GiftSelectionDialogII.vue";
import QuantityEditDialog from "./penetrateCashier/QuantityEditDialog.vue";
import SalesPersonSelectDialog from "./penetrateCashier/SalesPersonSelectDialog.vue";
import PharmacistSelectDialog from "./penetrateCashier/PharmacistSelectDialog.vue";
import ChangePasswordDialog from "./penetrateCashier/ChangePasswordDialog.vue";
import ReturnDialog from "./penetrateCashier/ReturnDialog.vue";
import keyHandlerMixin from "./penetrateCashier/keyHandlerMixin.js";
import modalCommonMixin from "./penetrateCashier/modalCommonMixin.js";
import shopCategory from "./penetrateCashier/shopCategory.js";
import shiftDialog from "./penetrateCashier/shiftDialog.vue";
import splitItemDialog from "./penetrateCashier/splitItemDialog.vue";
import RegulatoryCodeDialog from "./penetrateCashier/RegulatoryCodeDialog.vue";
import SummaryDetailDialog from "./penetrateCashier/SummaryDetailDialog.vue";
import BarcodeMaintenanceDialog from "./penetrateCashier/BarcodeMaintenanceDialog.vue";
import HoldOrderListDialog from "./penetrateCashier/HoldOrderListDialog.vue";
import TCMDosageDialog from "./penetrateCashier/TCMDosageDialog.vue";
import CalculatorDialog from "./penetrateCashier/CalculatorDialog.vue";
import LuyaoMakeDialog from "./penetrateCashier/LuyaoMakeDialog.vue";
import TempReturnDialog from "./penetrateCashier/TempReturnDialog.vue";
import StockDistributionDialog from "./penetrateCashier/StockDistributionDialog.vue";
// import ProductBatchDialog from "./penetrateCashier/ProductBatchDialog.vue";
export default {
    name: "penetrateCashier",
    mixins: [keyHandlerMixin, modalCommonMixin, shopCategory],
    props: ["jurId"],
    components: {
        memberModal,
        shortcutPanel,
        DeskSelectDialog,
        GiftSelectionDialog,
        GiftSelectionDialogII,
        MemberRechargeDialog,
        ProductInfoDisplay,
        PriceEditDialog,
        QuantityEditDialog,
        SalesPersonSelectDialog,
        PharmacistSelectDialog,
        ChangePasswordDialog,
        ReturnDialog,
        shiftDialog,
        splitItemDialog,
        RegulatoryCodeDialog,
        SummaryDetailDialog,
        BarcodeMaintenanceDialog,
        HoldOrderListDialog,
        TCMDosageDialog,
        CalculatorDialog,
        LuyaoMakeDialog,
        TempReturnDialog,
        StockDistributionDialog,
        // ProductBatchDialog,
    },
    data() {
        return {
            // 价格设置类型常量
            PRICE_SET_TYPES: {
                KEEP_CURRENT: 1, // 保持现状
                RESTORE_ORIGINAL: 2, // 恢复原价
                PARTIAL_RESTORE: 3, // 部分恢复原价
            },
            // 促销类型常量
            PROMOTION_TYPES: {
                GIFT: 1, // 满赠
                COUPON: 2, // 优惠券
                DISCOUNT: 4, // 打折
                POINTS: 3, // 积分
                CASH_BACK: 5, // 金额减免
                LOWEST_PRICE: 6, // 优惠最低价格品种金额
            },
            // ----------顶部信息---------
            // memberCardNo: '',
            memberInfo: {
                name: "",
                points: "",
                level: "",
                storedBalance: "",
                storeName: "",
                cashier: "", //收银员
                salesPerson: "", // 销售员ID
                salesPersonName: "", // 销售员名称
                doctor: "", // 开方医师，初始为空
                pharmacist: "", // 执业药师，初始为空
                customerName: "",
                customerPhoneNumber: "",
                customerIdCard: "",
                cardType: "",
                memId: "", // 会员ID
                registerStore: "",
                isSmall: 0, //是否允许抹零
                addRate: 0,
            },
            assistObj: {
                remark: "",
                assistanceInfo: "",
            },
            isMemberFromDropdown: false, // 新增：标记会员信息是否来自下拉选择
            quantityChange: "", //  更改数量
            storeId: null,
            opmStore: 0, //复验 1可以修改单价，0不可以修改单价
            opmName: "",
            isChangePriceCheck: 0,
            // ----------商品明细---------
            cartItems: [],
            totalQuantity: 0,
            totalCount: 0,//条目数
            payableAmount: 0,
            payableRemark: "",//备注
            calculatedPoints: 0, // 计算得到的积分
            pointsCalculationTimer: null, // 积分计算防抖定时器
            // ----------促销方案弹窗---------
            promotionSelectDialogVisible: false,
            promotionSelectDialogVisibleII: false,
            promotionSelectList: [], // 促销方案列表
            promotionPlan: {
                detailsList: [],//明细促销
                orderList: [],//整单促销
                combinationList: [],//组合促销
            },
            promotionSelectSearch: "", // 促销方案搜索
            promotionSearchTimer: null, // 促销方案搜索防抖
            selectedPromotions: [], // 选中的促销方案列表
            currentHighlightRowIndex: 0, // 当前高亮行索引
            currentFocusArea: "promotion", // 当前聚焦区域：'promotion', 'gift', 'coupon', 'confirm'
            selectedGifts: [], // 赠品选择
            giftList: [], // 赠品列表
            allGiftList: [], // 整单赠品列表
            giftYhqList: [], // 优惠券列表
            allGiftYhqList: [], // 整单优惠券列表
            selectedSingleCoupon: null, // 选中的单个优惠券ID（任选一个优惠券模式）
            _needAutoSelectCoupon: false, // 标记是否需要自动选择优惠券
            discountAmount: 0, // 新增：优惠金额
            originAmount: 0, // 新增：原价合计
            pointMultiplyItems: [], // 积分倍数参与的商品
            usedPromotions: [], // 已使用的促销方案列表
            mzGiftNum: 0, // 促销方案赠送优惠券数量
            mzGiftTypeNum: 0, //促销方案赠送商品数量
            isAllPromotion: false, // 是否是整单促销
            allGiftGoods: [], //整单赠送商品
            allYhq: [], //整单赠送优惠券
            yhqGift: [], //优惠券列表

            // 单选赠品相关
            selectedSingleGift: null, // 选中的单个赠品ID（任选一个商品模式）
            _needAutoSelectGift: false, // 标记是否需要自动选择赠品

            // 批号选择弹窗数据
            batchSelectionDialog: {
                visible: false,
                giftInfo: [],
                resolve: null
            },
            batchSelectionDialogII: {
                visible: false,
                giftInfo: [],
                resolve: null
            },
            // 电子监管码弹窗状态
            regulatoryCodeDialogVisible: false,
            isDZJG: false,//是否手动点击扫码 true：手动点击 false：再付款的时候拦截判断强制扫码
            esuList: [],
            // 汇总明细查询弹窗状态
            summaryDetailDialogVisible: false,
            summaryQueryParams: {}, // 查询参数
            // 条码维护弹窗状态
            barcodeMaintenanceDialogVisible: false,
            // 中药副数弹窗状态
            tcmDosageDialogVisible: false,
            // 计算器弹窗状态
            calculatorDialogVisible: false,
            // 制作卤药弹窗状态
            luyaoMakeDialogVisible: false,
            luyaoProductList: [], // 卤药品种列表
            // 临时退货弹窗状态
            tempReturnDialogVisible: false,
            // 库存分布弹窗状态
            stockDistributionDialogVisible: false,
            parentSearchData: {
                bgmCode: "",
            },
            // 商品批号查询弹窗状态
            productBatchDialogVisible: false,
            selectedProductForBatch: null, // 选中要查询批号的商品
            // ----------账簿选择弹窗---------
            bookSelectDialogVisible: false, // 账簿选择弹窗
            alertShow: false,//控制是否付款报错拦截再次提交
            escShow: true,//控制是否esc关闭付款账簿
            bookList: [], // 账簿列表，每个账簿对象需有 inputMoney 字段
            isRechargeMode: false, // 是否为会员储值模式
            // 防抖相关
            debounceTimers: {}, // 存储防抖定时器
            selectedBook: "",
            selectedItemIndex: -1, // 当前选中的商品索引
            selectedColumnIndex: 0, // 当前选中的列索引（0:销售员, 1:单价, 2:数量）
            isSalesPersonFocused: false, // 销售员选择框聚焦状态
            isDoctorFocused: false, // 开方医师选择框聚焦状态
            isPharmacistFocused: false, // 执业药师选择框聚焦状态
            assistanceInfoFocused: false, // 辅助项目选择框聚焦状态
            focusedInput: "", // 当前聚焦的输入框标识
            selectedMemberIndex: -1, // 当前选中的会员索引
            previousSalesPerson: "", // 记录之前的销售员值，用于智能更新购物车
            selectedProductIndex: -1, // 当前选中的商品索引
            selectedProductIndex2: -1, // 当前选中的商品索引
            buyerInfoProduct: null, // 临时存储待添加的商品
            pointAmount: 0, //多倍积分字段
            pointChange: 0, //赠送积分/冲减积分
            allRePointTotal: 0, //整单减积分
            allAddPointTotal: 0, //整单加积分
            // --------会员卡弹窗---------
            showStatus: false,
            actionData: {},
            pendingProductForPharmacist: null, // 保存待添加的商品信息
            pendingBatchProducts: null, // 保存批量待添加的商品列表
            lastBookInputIndex: null, // 记录最近修改的账簿索引
            // 销售员选择弹窗相关
            salesPersonSelectDialogVisible: false, // 销售员选择弹窗
            selectedCartItem: null, // 当前选中的购物车商品
            isProgrammaticQuantityChange: false, // 防止程序设置数量时触发购物车更新
            // 执业药师选择弹窗相关
            pharmacistSelectDialogVisible: false, // 执业药师选择弹窗
            // 修改密码弹窗相关
            changePasswordDialogVisible: false, // 修改密码弹窗
            // 退货弹窗相关
            returnDialogVisible: false, // 退货弹窗显示状态
            originId: "", //原单号
            autoPrint: 1, //是否自动打印小票
            skPrint: "",
            jbPrint: "",
            hjPrint: "",
            bcCode: "", //班次编码
            shiftDialogVisible: false,
            splitItemDialogVisible: false,
            scanCode: 0,//是否启用扫电子监管码
            orderList: [], // 原单商品列表
            isZt: 0,
            autoPayMoney: 0,//是否自动带出收银金额
            isMoreGift: false,
            MoreGiftPlan: null,
            //-------------------------------对应动态表单
            pageShowData: null,
            shopCartForm: null,//购物车表单
            productEntryForm: null,//商品录入表单
            cashierForm: null,//收款台顶部数据
            collectForm: null,//收款台汇总
            inventoryList: null,//库存分布
            //------------------付款拦截字段
            orderSubmitId: "",
            orderSubmitTime: "",
            //------------------字典
            dictionariesData: {},
            //-------------付款码
            payReadonly: false,
            payMoney: 0,
            payShow: false,
            closeIndex: 0,
            closeFlag: false,
            escPayShow: true,
            payCode: "",
            payMessage: "",
            payTimer: null,
            payReturnList: [],
            //打印小票
            printShow: false,
            //----------提取O2O订单
            extractO2OOrderDialogVisible: false,
            extractO2OOrderData: [],
            timerO2OOrder: null,
            //---------
            return_money: 0,
            refundOffLineMoney: 0,
            //---------
            disabled: false,//添加禁用，付款不能多次付款
        };
    },
    async mounted() {
        // 获取门店信息
        await this.getCurStoreInfo();
        await this.getPageInfo();
        await this.getDictionaries()
        // this.queryO2O()
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.handleBookDialogKeyDown);
        if (this.timeTimer) clearInterval(this.timeTimer);
        if (this.timerO2OOrder) clearTimeout(this.timerO2OOrder);
        // 清理所有防抖定时器
        Object.keys(this.debounceTimers).forEach(key => {
            if (this.debounceTimers[key]) {
                clearTimeout(this.debounceTimers[key]);
            }
        });
        this.debounceTimers = {};
    },
    methods: {
        //提取O2O订单
        async onExtract() {
            this.extractO2OOrderDialogVisible = true
            this.queryO2O(true)
        },
        async queryO2O(val) {
            const responseData = await this.$http.retailWebqueryO2OOrder({})
            if (responseData.status == 200) {
                this.extractO2OOrderData = responseData.data
                if (!val) {
                    this.timerO2OOrder = setTimeout(() => {
                        this.queryO2O()
                    }, 60000)
                }
            } else {
                clearTimeout(this.timerO2OOrder)
                this.$message.error(responseData.message);
            }
        },
        //新增挂单
        async pendingOrder(val) {
            const params = {
                jsonContent: val.jsonContent,
                modelType: "收款台-挂单",
                remark: val.remark
            }
            let responseData = await this.$http.draftAddDraft(params);
            if (responseData.status == 200) {
                this.$message({
                    message: "挂单成功",
                    type: "success",
                });
            } else {
                this.$message.error(responseData.message);
            }
        },
        //删除挂单
        async pendingOrderDel(val) {
            const params = { ids: [val.id] }
            let responseData = await this.$http.draftDelById(params);
        },
        //获取上单销售员
        async storemastgetLaseSalesPerson() {
            let responseData = await this.$http.storemastgetLaseSalesPerson({
                ids: [this.memberInfo.deskId],
            });
            console.log(responseData, "测试");
            // this.memberInfo.salesPersonName = salesPersonObj.opmName;
            // this.memberInfo.salesPerson = salesPersonObj.opmId;
            if (responseData.status == 200) {
                this.memberInfo.salesPersonName = responseData.result.opmName;
                this.memberInfo.salesPerson = responseData.result.opmId;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getDictionaries() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [68],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        retailMoneyChange(val) {
            var num = 0
            if (val.tcmDosage) {
                num = NP.times(val.quantity, val.tcmDosage)
            } else {
                num = val.quantity
            }
            return this.$common.getDecimalInfo(3, NP.times((val.price || 0), num))
        },
        async getPageInfo() {
            let responseData = await this.$http.getJur({ ids: [this.jurId] })
            if (responseData.status == 200) {
                var pageShowData = responseData.result
                if (responseData.result.jurFormVoList) {
                    // 购物车表单
                    this.shopCartForm = responseData.result.jurFormVoList.filter(item => item.jciId == 1800000080450)[0]
                    // 商品录入表单
                    this.productEntryForm = responseData.result.jurFormVoList.filter(item => item.jciId == 1800000080451)[0]
                    //收款台顶部数据
                    this.cashierForm = responseData.result.jurFormVoList.filter(item => item.jciId == 1800000080506)[0]
                    //收款台汇总
                    this.collectForm = responseData.result.jurFormVoList.filter(item => item.jciId == 1800000080507)[0]
                    // 库存分布
                    this.inventoryList = responseData.result.jurFormVoList.filter(item => item.jciId == 1800000080534)[0]
                }
                if (!pageShowData.jurHead) {
                    pageShowData.jurHead = {
                        jurconfigform: [],
                    }
                }
                if (!pageShowData.jurTableVo) {
                    pageShowData.jurTableVo = {
                        jurconfigform: [],
                    }
                }
                this.pageShowData = pageShowData
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        openFormDesign() {
            this.$refs['customDesign'].openBox(this.jurId, this.pageShowData, "收款台")
        },
        /**
         * 获取失效日期的提示颜色：30天内标红，90天内标黄，180天内标蓝
         * @param {string} expidate - 失效日期
         * @returns {string} - 颜色值，不符合条件时返回空字符串
         */
        getExpidateColor(expidate) {
            if (!expidate) return '';

            const expireDate = new Date(expidate);
            const currentDate = new Date();
            const diffTime = expireDate.getTime() - currentDate.getTime();
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays < 0) return '';
            if (diffDays <= 30) return '#ff4757';
            if (diffDays <= 90) return '#e6a23c';
            if (diffDays <= 180) return '#409eff';
            return '';
        },

        /**
         * 通用防抖函数
         * @param {Function} func - 需要防抖的函数
         * @param {number} delay - 延迟时间（毫秒）
         * @param {string} key - 防抖标识符，用于区分不同的防抖函数
         * @returns {Function} - 防抖后的函数
         */
        debounce(func, delay = 300, key = 'default') {
            return (...args) => {
                // 清除之前的定时器
                if (this.debounceTimers[key]) {
                    clearTimeout(this.debounceTimers[key]);
                }

                // 设置新的定时器
                this.debounceTimers[key] = setTimeout(() => {
                    func.apply(this, args);
                    // 执行完成后清除定时器引用
                    delete this.debounceTimers[key];
                }, delay);
            };
        },

        /**
         * 检查促销条件是否满足
         * @param {Object} plan - 促销方案
         * @returns {Object} - { conditionMet: boolean, matchedConditionItems: Array }
         */
        checkPromotionConditions(plan) {
            let conditionMet = false;
            let matchedConditionItems = [];
            if (!plan) {
                console.warn("促销方案为空");
                return { conditionMet, matchedConditionItems };
            }
            try {
                if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                    const conditionItemsInCart = [];
                    plan.conBgmList.forEach((conditionItem) => {
                        // 查找所有匹配的商品（包括不同批号）
                        const matchedCartItems = this.cartItems.filter(
                            (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                        );
                        if (matchedCartItems.length > 0) {
                            // 计算同一商品所有批号的总数量
                            const totalQuantity = matchedCartItems.reduce(
                                (sum, item) => sum + (item.quantity || 0),
                                0
                            );
                            conditionItemsInCart.push({
                                cartItems: matchedCartItems, // 改为数组，包含所有相同商品的记录
                                conditionItem: conditionItem,
                                required: conditionItem.num || 1,
                                actual: totalQuantity, // 使用合并后的总数量
                                priceSet:
                                    conditionItem.priceSet || this.PRICE_SET_TYPES.KEEP_CURRENT,
                            });
                        }
                    });

                    if (conditionItemsInCart.length > 0) {
                        const allConditionsMet = conditionItemsInCart.every(
                            (item) => item.actual >= item.required
                        );
                        if (allConditionsMet) {
                            conditionMet = true;
                            matchedConditionItems = conditionItemsInCart;
                            console.log("满足所有条件商品要求");
                        } else {
                            console.log("条件商品数量不满足要求");
                        }
                    } else {
                        console.log("购物车中没有找到条件商品");
                    }
                } else if (plan.mzConBgmNum) {
                    // 检查总数量要求
                    const totalQuantity = this.cartItems.reduce(
                        (sum, item) => sum + (item.quantity || 0),
                        0
                    );
                    if (totalQuantity >= plan.mzConBgmNum) {
                        conditionMet = true;
                        console.log(
                            "满足总数量要求:",
                            totalQuantity,
                            ">=",
                            plan.mzConBgmNum
                        );
                    } else {
                        console.log(
                            "不满足总数量要求:",
                            totalQuantity,
                            "<",
                            plan.mzConBgmNum
                        );
                    }
                }
            } catch (error) {
                console.error("检查促销条件时发生错误:", error);
            }

            return { conditionMet, matchedConditionItems };
        },

        /**
         * 获取价格设置类型
         * @param {Object} plan - 促销方案
         * @returns {number} - 价格设置类型
         */
        getPriceSetType(plan) {
            if (
                !plan ||
                !plan.conBgmList ||
                !Array.isArray(plan.conBgmList) ||
                plan.conBgmList.length === 0
            ) {
                return this.PRICE_SET_TYPES.KEEP_CURRENT;
            }
            return plan.conBgmList[0].priceSet || this.PRICE_SET_TYPES.KEEP_CURRENT;
        },

        /**
         * 安全的数值计算
         * @param {number} value - 数值
         * @param {number} defaultValue - 默认值
         * @returns {number} - 安全的数值
         */
        safeNumber(value, defaultValue = 0) {
            const num = parseFloat(value);
            return isNaN(num) ? defaultValue : num;
        },

        /**
         * 安全设置商品的响应式属性
         * @param {Object} item - 商品对象
         * @param {string} property - 属性名
         * @param {any} value - 属性值
         */
        setItemProperty(item, property, value) {
            if (item.hasOwnProperty(property)) {
                item[property] = value;
            } else {
                this.$set(item, property, value);
            }
        },

        /**
         * 应用价格规则的统一处理方法
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {string} promotionType - 促销类型描述
         */
        applyPriceRule(plan, matchedConditionItems, promotionType = "促销") {
            if (!plan) {
                console.warn("促销方案为空，无法应用价格规则");
                return;
            }

            const priceSet = this.getPriceSetType(plan);
            console.log(`${promotionType}价格设置方式 priceSet:`, priceSet);

            try {
                switch (priceSet) {
                    case this.PRICE_SET_TYPES.KEEP_CURRENT:
                        this.handleKeepCurrentPrice(
                            plan,
                            matchedConditionItems,
                            promotionType
                        );
                        break;
                    case this.PRICE_SET_TYPES.RESTORE_ORIGINAL:
                        this.handleRestoreOriginalPrice(
                            plan,
                            matchedConditionItems,
                            promotionType
                        );
                        break;
                    case this.PRICE_SET_TYPES.PARTIAL_RESTORE:
                        this.handlePartialRestorePrice(
                            plan,
                            matchedConditionItems,
                            promotionType
                        );
                        break;
                    default:
                        console.warn(`未知的价格设置方式: ${priceSet}`);
                }
            } catch (error) {
                console.error(`应用${promotionType}价格规则时发生错误:`, error);
            }
        },

        /**
         * 处理保持现状的价格策略
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {string} promotionType - 促销类型
         */
        handleKeepCurrentPrice(plan, matchedConditionItems, promotionType) {
            console.log(`${promotionType} - 保持现状处理`);
            const repeatMultiple = this.calculateRepeatMultiple(plan);
            if (plan.mzGiftType === this.PROMOTION_TYPES.GIFT) {
                this.mergePromotionItems(plan, matchedConditionItems, "保持现状");
                this.addGiftsToCart(plan);
            } else if (plan.mzGiftType === this.PROMOTION_TYPES.COUPON) {
                this.handleCouponPromotionKeepCurrent(
                    plan,
                    matchedConditionItems,
                    repeatMultiple
                );
                this.addCouponsToList(plan);
            } else if (
                plan.mzGiftType === this.PROMOTION_TYPES.DISCOUNT &&
                plan.mzDiscount
            ) {
                this.applyDiscountToTargetItems(plan, plan.mzDiscount);
            } else if (
                plan.mzGiftType === this.PROMOTION_TYPES.CASH_BACK &&
                plan.mzCashBack
            ) {
                this.applyCashBackToTargetItems(plan, plan.mzCashBack);
            } else if (plan.mzGiftType === this.PROMOTION_TYPES.POINTS) {
                this.handlePointsPromotion(plan, matchedConditionItems, repeatMultiple);
            } else if (plan.mzGiftType === this.PROMOTION_TYPES.LOWEST_PRICE) {
                this.handleLowestPricePromotion(
                    plan,
                    matchedConditionItems,
                    repeatMultiple
                );
            }
        },
        /**
         * 处理恢复原价的价格策略
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {string} promotionType - 促销类型
         */
        handleRestoreOriginalPrice(plan, matchedConditionItems, promotionType) {
            console.log(`${promotionType} - 恢复原价处理`);
            // 计算重复倍数
            const repeatMultiple = this.calculateRepeatMultiple(plan);

            // 对于满赠和优惠券，需要根据条件商品数量要求和重复倍数来恢复原价
            if (
                plan.mzGiftType === this.PROMOTION_TYPES.GIFT ||
                plan.mzGiftType === this.PROMOTION_TYPES.COUPON
            ) {
                this.handleConditionalRestoreOriginalPrice(
                    plan,
                    matchedConditionItems,
                    promotionType
                );
            } else {
                // 其他类型的促销，恢复所有指定商品的原价
                if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                    plan.planBgmIdList.forEach((bgmId) => {
                        const item = this.cartItems.find((item) => item.bgmId === bgmId);
                        if (item) {
                            item.changePrice = item.price;
                            item.actualPrice = item.price;
                            item.amount = Number(this.$common.getDecimalInfo(2, item.price * item.quantity));
                        }
                    });
                }
            }

            // 然后应用相应的促销规则
            if (plan.mzGiftType === this.PROMOTION_TYPES.GIFT) {
                this.mergePromotionItems(plan, matchedConditionItems, "恢复原价");
                this.addGiftsToCart(plan);
            } else if (plan.mzGiftType === this.PROMOTION_TYPES.COUPON) {
                this.handleCouponPromotionRestoreOriginal(
                    plan,
                    matchedConditionItems,
                    repeatMultiple
                );
                this.addCouponsToList(plan);
            } else if (
                plan.mzGiftType === this.PROMOTION_TYPES.DISCOUNT &&
                plan.mzDiscount
            ) {
                this.applyDiscountToTargetItems(plan, plan.mzDiscount, true);
            } else if (
                plan.mzGiftType === this.PROMOTION_TYPES.CASH_BACK &&
                plan.mzCashBack
            ) {
                this.applyCashBackToTargetItems(plan, plan.mzCashBack, true);
            } else if (plan.mzGiftType === this.PROMOTION_TYPES.LOWEST_PRICE) {
                this.handleLowestPricePromotion(
                    plan,
                    matchedConditionItems,
                    repeatMultiple
                );
            }
        },

        /**
         * 处理满赠和优惠券的条件性恢复原价
         * 根据条件商品数量要求和重复倍数来恢复原价，多余的数量保持当前价格
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {string} promotionType - 促销类型
         */
        handleConditionalRestoreOriginalPrice(
            plan,
            matchedConditionItems,
            promotionType
        ) {
            console.log(`${promotionType} - 条件性恢复原价处理`);

            // 计算重复倍数
            const repeatMultiple = this.calculateRepeatMultiple(plan);
            // 计算每次促销需要的条件商品数量
            const conditionNum = this.safeNumber(plan.mzConBgmNum, 1);

            // 计算总的需要恢复原价的数量
            const totalRestoreQuantity = conditionNum * repeatMultiple;
            if (totalRestoreQuantity <= 0) {
                console.log("不需要恢复原价");
                return;
            }

            // 如果有条件商品列表，按条件商品恢复原价
            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                this.restoreOriginalPriceByConditionItems(plan, totalRestoreQuantity);
            }
            // 如果有方案商品列表，按方案商品恢复原价
            else if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                this.restoreOriginalPriceByPlanItems(plan, totalRestoreQuantity);
            }
            // 如果都没有，按购物车中的商品恢复原价
            else {
                this.restoreOriginalPriceByCartItems(plan, totalRestoreQuantity);
            }
        },

        /**
         * 按条件商品恢复原价
         * @param {Object} plan - 促销方案
         * @param {number} totalRestoreQuantity - 总的需要恢复原价的数量
         */
        restoreOriginalPriceByConditionItems(plan, totalRestoreQuantity) {
            let remainingRestoreQuantity = totalRestoreQuantity;

            plan.conBgmList.forEach((conditionItem) => {
                if (remainingRestoreQuantity <= 0) return;

                const cartItem = this.cartItems.find(
                    (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                );
                console.log(this.cartItems, "cartItem8889");

                if (cartItem) {
                    const restoreQuantity = Math.min(
                        remainingRestoreQuantity,
                        cartItem.quantity
                    );

                    if (restoreQuantity > 0) {
                        this.applyMixedPriceRestore(
                            cartItem,
                            restoreQuantity,
                            plan,
                            "恢复原价"
                        );
                        remainingRestoreQuantity -= restoreQuantity;

                        console.log(
                            `条件商品 ${cartItem.bgmName
                            }: 恢复原价数量=${restoreQuantity}, 剩余数量=${cartItem.quantity - restoreQuantity
                            }`
                        );
                    }
                }
            });
        },

        /**
         * 按方案商品恢复原价
         * @param {Object} plan - 促销方案
         * @param {number} totalRestoreQuantity - 总的需要恢复原价的数量
         */
        restoreOriginalPriceByPlanItems(plan, totalRestoreQuantity) {
            let remainingRestoreQuantity = totalRestoreQuantity;

            plan.planBgmIdList.forEach((bgmId) => {
                if (remainingRestoreQuantity <= 0) return;

                const cartItem = this.cartItems.find(
                    (item) => item.bgmId === bgmId && !item.isGift
                );

                if (cartItem) {
                    const restoreQuantity = Math.min(
                        remainingRestoreQuantity,
                        cartItem.quantity
                    );

                    if (restoreQuantity > 0) {
                        this.applyMixedPriceRestore(
                            cartItem,
                            restoreQuantity,
                            plan,
                            "恢复原价"
                        );
                        remainingRestoreQuantity -= restoreQuantity;

                        console.log(
                            `方案商品 ${cartItem.bgmName
                            }: 恢复原价数量=${restoreQuantity}, 剩余数量=${cartItem.quantity - restoreQuantity
                            }`
                        );
                    }
                }
            });
        },

        /**
         * 按购物车商品恢复原价
         * @param {Object} plan - 促销方案
         * @param {number} totalRestoreQuantity - 总的需要恢复原价的数量
         */
        restoreOriginalPriceByCartItems(plan, totalRestoreQuantity) {
            let remainingRestoreQuantity = totalRestoreQuantity;

            const nonGiftItems = this.cartItems.filter((item) => !item.isGift);

            nonGiftItems.forEach((cartItem) => {
                if (remainingRestoreQuantity <= 0) return;

                const restoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );

                if (restoreQuantity > 0) {
                    this.applyMixedPriceRestore(
                        cartItem,
                        restoreQuantity,
                        plan,
                        "恢复原价"
                    );
                    remainingRestoreQuantity -= restoreQuantity;

                    console.log(
                        `购物车商品 ${cartItem.bgmName
                        }: 恢复原价数量=${restoreQuantity}, 剩余数量=${cartItem.quantity - restoreQuantity
                        }`
                    );
                }
            });
        },

        /**
         * 应用混合价格恢复（部分恢复原价，部分保持当前价格）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         * @param {string} processType - 处理类型
         */
        applyMixedPriceRestore(cartItem, restoreQuantity, plan, processType) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            console.log(cartItem, "cartItem");
        },

        /**
         * 处理部分恢复原价的价格策略
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {string} promotionType - 促销类型
         */
        handlePartialRestorePrice(plan, matchedConditionItems, promotionType) {
            console.log(`${promotionType} - 部分恢复原价处理`);

            // 对于满赠和优惠券，使用新的条件性部分恢复原价逻辑
            if (
                plan.mzGiftType === this.PROMOTION_TYPES.GIFT ||
                plan.mzGiftType === this.PROMOTION_TYPES.COUPON
            ) {
                this.handleConditionalPartialRestorePrice(
                    plan,
                    matchedConditionItems,
                    promotionType
                );
            } else {
                // 其他类型的促销，使用原有逻辑
                if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                    plan.conBgmList.forEach((conditionItem) => {
                        const cartItem = this.cartItems.find(
                            (item) => item.bgmId === conditionItem.bgmId
                        );
                        if (cartItem) {
                            const requiredNum = this.safeNumber(conditionItem.num, 1);
                            const numToRestore = Math.min(requiredNum, cartItem.quantity);

                            if (numToRestore > 0) {
                                this.applyPartialPriceRestore(cartItem, numToRestore, plan);
                            }
                        }
                    });
                }
            }

            // 计算重复倍数
            const repeatMultiple = this.calculateRepeatMultiple(plan);

            // 应用相应的促销规则
            if (plan.mzGiftType === this.PROMOTION_TYPES.GIFT) {
                console.log("🎁 部分恢复原价 - 处理赠品促销");
                this.mergePromotionItems(plan, matchedConditionItems, "部分恢复原价");
                this.addGiftsToCart(plan);
            } else if (plan.mzGiftType === this.PROMOTION_TYPES.COUPON) {
                console.log("🎫 部分恢复原价 - 处理优惠券促销");
                this.handleCouponPromotionPartialRestore(
                    plan,
                    matchedConditionItems,
                    repeatMultiple
                );
                this.addCouponsToList(plan);
            } else if (
                plan.mzGiftType === this.PROMOTION_TYPES.DISCOUNT &&
                plan.mzDiscount
            ) {
                console.log("💰 部分恢复原价 - 处理原品打折促销");
                this.applyPartialRestoreDiscountToTargetItems(plan, plan.mzDiscount);
            } else if (
                plan.mzGiftType === this.PROMOTION_TYPES.CASH_BACK &&
                plan.mzCashBack
            ) {
                console.log("💵 部分恢复原价 - 处理原品金额减免促销");
                this.applyPartialRestoreCashBackToTargetItems(plan, plan.mzCashBack);
            } else if (plan.mzGiftType === this.PROMOTION_TYPES.LOWEST_PRICE) {
                this.handleLowestPricePromotion(
                    plan,
                    matchedConditionItems,
                    repeatMultiple
                );
            }
        },

        /**
         * 处理满赠和优惠券的条件性部分恢复原价
         * 根据单品数量要求和重复倍数来恢复原价，其他保持当前价格
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {string} promotionType - 促销类型
         */
        handleConditionalPartialRestorePrice(
            plan,
            matchedConditionItems,
            promotionType
        ) {
            console.log(`${promotionType} - 条件性部分恢复原价处理`);

            // 计算重复倍数
            const repeatMultiple = this.calculateRepeatMultiple(plan);
            console.log(`重复倍数: ${repeatMultiple}`);

            if (repeatMultiple <= 0) {
                console.log("不满足重复条件，不执行部分恢复原价");
                return;
            }

            // 如果有条件商品列表，按条件商品处理
            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                plan.conBgmList.forEach((conditionItem) => {
                    // 查找所有匹配的商品（包括不同批号）
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                    );

                    matchingItems.forEach((cartItem) => {
                        // 单品数量要求
                        const singleItemRequiredNum = this.safeNumber(conditionItem.num, 1);

                        // 根据重复倍数计算总的恢复数量：单品数量要求 × 重复倍数
                        const totalRestoreNum = singleItemRequiredNum * repeatMultiple;

                        // 实际恢复数量不能超过购买数量
                        const actualRestoreNum = Math.min(
                            totalRestoreNum,
                            cartItem.quantity
                        );

                        console.log(
                            `商品 ${cartItem.bgmName}: 单品要求=${singleItemRequiredNum}, 重复倍数=${repeatMultiple}, 总恢复数量=${totalRestoreNum}, 实际恢复=${actualRestoreNum}, 购买数量=${cartItem.quantity}`
                        );

                        if (actualRestoreNum > 0) {
                            this.applyPartialPriceRestoreWithMultiple(
                                cartItem,
                                actualRestoreNum,
                                plan,
                                singleItemRequiredNum,
                                repeatMultiple
                            );
                        }
                    });
                });
            }
            // 如果有方案商品列表，按方案商品处理
            else if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                plan.planBgmIdList.forEach((bgmId) => {
                    const cartItem = this.cartItems.find(
                        (item) => item.bgmId === bgmId && !item.isGift
                    );

                    if (cartItem) {
                        // 默认单品数量要求为1
                        const singleItemRequiredNum = 1;

                        // 根据重复倍数计算总的恢复数量
                        const totalRestoreNum = singleItemRequiredNum * repeatMultiple;

                        // 实际恢复数量不能超过购买数量
                        const actualRestoreNum = Math.min(
                            totalRestoreNum,
                            cartItem.quantity
                        );

                        console.log(
                            `方案商品 ${cartItem.bgmName}: 单品要求=${singleItemRequiredNum}, 重复倍数=${repeatMultiple}, 总恢复数量=${totalRestoreNum}, 实际恢复=${actualRestoreNum}, 购买数量=${cartItem.quantity}`
                        );

                        if (actualRestoreNum > 0) {
                            this.applyPartialPriceRestoreWithMultiple(
                                cartItem,
                                actualRestoreNum,
                                plan,
                                singleItemRequiredNum,
                                repeatMultiple
                            );
                        }
                    }
                });
            }
        },

        /**
         * 应用带重复倍数的部分价格恢复
         * @param {Object} cartItem - 购物车商品
         * @param {number} actualRestoreNum - 实际恢复原价的数量
         * @param {Object} plan - 促销方案
         * @param {number} singleItemRequiredNum - 单品数量要求
         * @param {number} repeatMultiple - 重复倍数
         */
        applyPartialPriceRestoreWithMultiple(
            cartItem,
            actualRestoreNum,
            plan,
            singleItemRequiredNum,
            repeatMultiple
        ) {
            const originalPrice = cartItem.price;
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - actualRestoreNum;
            // 确定超出部分应该使用的价格
            let remainingPrice;
            if (this.memberInfo.memId) {
                // 有会员：超出部分使用会员价
                remainingPrice = cartItem.memberPrice || cartItem.price;
                console.log(`会员用户 - 超出部分使用会员价: ${remainingPrice}元`);
            } else {
                // 无会员：超出部分使用当前价格（可能是促销价等）
                remainingPrice = cartItem.changePrice || cartItem.price;
                console.log(`非会员用户 - 超出部分使用当前价格: ${remainingPrice}元`);
            }

            if (actualRestoreNum >= totalQuantity) {
                // 全部恢复原价
                cartItem.changePrice = originalPrice;
                cartItem.actualPrice = originalPrice;
                cartItem.amount = this.$common.getDecimalInfo(3, NP.times(originalPrice, totalQuantity));

                cartItem.discountInfo = `${plan.planName}：部分恢复原价(全部)`;
                cartItem.mixedPriceInfo = null;
            } else {
                // 部分恢复原价，计算混合价格
                const restoreAmount = originalPrice * actualRestoreNum;
                const remainingAmount = remainingPrice * remainingQuantity;
                const totalAmount = restoreAmount + remainingAmount;
                const averagePrice = totalAmount / totalQuantity;

                cartItem.changePrice = this.$common.getDecimalInfo(3, averagePrice);
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = this.$common.getDecimalInfo(3, totalAmount);

                // 记录详细的混合价格信息
                cartItem.mixedPriceInfo = {
                    restoreNum: actualRestoreNum,
                    restorePrice: originalPrice,
                    discountNum: remainingQuantity,
                    discountPrice: remainingPrice,
                    averagePrice: averagePrice,
                    singleItemRequiredNum: singleItemRequiredNum,
                    repeatMultiple: repeatMultiple,
                    isPartialRestore: true,
                    isMemberPrice: !!this.memberInfo.memId, // 标记是否为会员价
                };

                // 构建折扣信息描述
                const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                cartItem.discountInfo = `${plan.planName}：部分恢复原价(${actualRestoreNum}件×${originalPrice}元+${remainingQuantity}件×${remainingPrice}元${priceTypeDesc})`;

                console.log(
                    `混合价格计算: ${actualRestoreNum}件×${originalPrice}元(原价) + ${remainingQuantity}件×${remainingPrice}元(${priceTypeDesc}) = 平均${averagePrice.toFixed(9)}元`
                );
            }

            cartItem.isDiscounted = true;
        },

        /**
         * 应用折扣到目标商品（支持多批号）
         * @param {Object} plan - 促销方案
         * @param {number} discount - 折扣值
         * @param {boolean} isRestoreOriginal - 是否已恢复原价
         */
        applyDiscountToTargetItems(plan, discount, isRestoreOriginal = false) {
            if (!plan.planBgmIdList || !Array.isArray(plan.planBgmIdList)) {
                console.log("没有指定需要打折的商品列表");
                return;
            }

            console.log(
                `🎯 原品打折处理开始 - 方案: ${plan.planName}, 折扣: ${discount}, 恢复原价: ${isRestoreOriginal}`
            );

            // 收集所有参与的商品实例（包括多批号）
            const allParticipatingItems = [];
            plan.planBgmIdList.forEach((bgmId) => {
                const matchingItems = this.cartItems.filter(
                    (item) => item.bgmId === bgmId && !item.isGift
                );
                allParticipatingItems.push(...matchingItems);
            });

            console.log(`🛒 参与商品总数: ${allParticipatingItems.length}`);
            allParticipatingItems.forEach((item, index) => {
                console.log(
                    `   ${index + 1}. ${item.bgmName} (批号: ${item.sterBatchno || "无"
                    }) - 数量: ${item.quantity}`
                );
            });

            // 如果是恢复原价模式，需要根据条件数量处理
            if (isRestoreOriginal) {
                this.applyDiscountWithRestoreOriginal(
                    plan,
                    discount,
                    allParticipatingItems
                );
            } else {
                // 保持现状模式，直接对所有商品打折
                this.applyDiscountKeepCurrent(plan, discount, allParticipatingItems);
            }

            console.log(`✅ 原品打折处理完成 - 方案: ${plan.planName}`);
        },

        /**
         * 原品打折 - 保持现状处理（支持多批号）
         * @param {Object} plan - 促销方案
         * @param {number} discount - 折扣值
         * @param {Array} allParticipatingItems - 所有参与商品
         */
        applyDiscountKeepCurrent(plan, discount, allParticipatingItems) {
            console.log(
                `🎯 原品打折保持现状处理 - 方案: ${plan.planName}, 折扣: ${discount}`
            );
            allParticipatingItems.forEach((item) => {
                const originalPrice = item.changePrice || item.price;
                const discountedPrice = this.$common.getDecimalInfo(3, NP.times(originalPrice, discount));
                item.changePrice = discountedPrice;
                item.actualPrice = discountedPrice;
                item.amount = this.$common.getDecimalInfo(3, NP.times(discountedPrice, item.quantity));

                // 添加折扣信息
                item.discountInfo = `${plan.planName}：${discount}折`;
                item.isDiscounted = true;
                item.mzConType = plan.mzConType;
                item.mzGiftType = plan.mzGiftType;
                item.planType = plan.planType;

                console.log(
                    `原品打折商品处理完成(保持现状) - 商品: ${item.bgmName} (批号: ${item.sterBatchno || "无"
                    }), 原价: ${originalPrice}, 折后价: ${discountedPrice}`
                );
            });

            console.log(`✅ 原品打折保持现状处理完成`);
        },

        /**
         * 原品打折 - 恢复原价处理（支持多批号，参考优惠券逻辑）
         * @param {Object} plan - 促销方案
         * @param {number} discount - 折扣值
         * @param {Array} allParticipatingItems - 所有参与商品
         */
        applyDiscountWithRestoreOriginal(plan, discount, allParticipatingItems) {
            console.log(
                `🎯 原品打折恢复原价处理 - 方案: ${plan.planName}, 折扣: ${discount}`
            );
            // 没有条件商品列表，按总数量处理（全部恢复原价）
            const conditionNum = this.safeNumber(plan.mzConBgmNum, 1);
            const repeatMultiple = this.calculateRepeatMultiple(plan);
            const totalRestoreQuantity = conditionNum * repeatMultiple;
            const totalParticipatingQuantity = allParticipatingItems.reduce(
                (sum, item) => sum + item.quantity,
                0
            );
            if (totalRestoreQuantity >= totalParticipatingQuantity) {
                // 需要恢复的数量 >= 商品总数，所有商品都恢复原价后打折
                this.restoreAllDiscountItems(
                    allParticipatingItems,
                    plan,
                    discount,
                    conditionNum,
                    repeatMultiple
                );
            } else {
                // 需要恢复的数量 < 商品总数，按数量分配恢复原价后打折
                this.distributeDiscountRestoreQuantity(
                    allParticipatingItems,
                    totalRestoreQuantity,
                    plan,
                    discount,
                    repeatMultiple
                );
            }
        },
        /**
         * 原品打折 - 为单个商品分配部分恢复原价数量到多个批号
         * @param {Array} cartItems - 同一商品的多个批号
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         */
        distributeDiscountPartialRestoreQuantity(
            cartItems,
            totalRestoreQuantity,
            plan
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;
            // 按顺序依次给多批号商品设置恢复原价
            cartItems.forEach((cartItem) => {
                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格
                    let currentPrice;
                    if (this.memberInfo.memId) {
                        // 有会员：使用会员价
                        currentPrice = cartItem.memberPrice || cartItem.price;
                    } else {
                        // 无会员：使用当前价格（可能是促销价等）
                        currentPrice = cartItem.changePrice || cartItem.price;
                    }

                    cartItem.changePrice = Number(this.$common.getDecimalInfo(2, currentPrice));
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity));
                    cartItem.mixedPriceInfo = null;

                    console.log(
                        `原品打折商品保持当前价(待整体打折) - 商品: ${cartItem.bgmName
                        } (批号: ${cartItem.sterBatchno || "无"}), 当前价: ${currentPrice}`
                    );
                    return;
                }

                // 计算当前批号需要恢复的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;

                // 应用混合价格恢复原价（不打折，等待后续整体打折）
                this.applyDiscountMixedPriceRestoreForPartial(
                    cartItem,
                    itemRestoreQuantity,
                    plan
                );
            });

            console.log(
                `✅ 单个商品恢复原价数量分配完成，剩余未分配: ${remainingRestoreQuantity}`
            );
        },

        /**
         * 原品打折 - 应用混合价格恢复（部分恢复原价用，不打折）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         */
        applyDiscountMixedPriceRestoreForPartial(cartItem, restoreQuantity, plan) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            const originalPrice = Number(cartItem.price);
            if (restoreQuantity >= totalQuantity) {
                // 该批号全部恢复原价
                cartItem.changePrice = originalPrice;
                cartItem.actualPrice = originalPrice;
                cartItem.amount = Number(this.$common.getDecimalInfo(3, originalPrice * totalQuantity));
                cartItem.mixedPriceInfo = null;

                console.log(
                    `原品打折商品全部恢复原价(待整体打折) - 商品: ${cartItem.bgmName
                    } (批号: ${cartItem.sterBatchno || "无"}), 原价: ${originalPrice}`
                );
            } else if (restoreQuantity > 0) {
                // 该批号部分恢复原价，计算混合价格
                // 确定剩余部分应该使用的价格
                let remainingPrice;
                if (this.memberInfo.memId) {
                    // 有会员：剩余部分使用会员价
                    remainingPrice = cartItem.memberPrice || cartItem.price;
                } else {
                    // 无会员：剩余部分使用当前价格（可能是促销价等）
                    remainingPrice = cartItem.changePrice || cartItem.price;
                }

                // 计算混合价格（不打折）
                const originalPriceAmount = originalPrice * restoreQuantity;
                const remainingPriceAmount = remainingPrice * remainingQuantity;
                const totalAmount = originalPriceAmount + remainingPriceAmount;
                const averagePrice = totalAmount / totalQuantity;

                cartItem.changePrice = Number(this.$common.getDecimalInfo(2, averagePrice));
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

                // 记录混合价格信息
                cartItem.mixedPriceInfo = {
                    originalPriceNum: restoreQuantity,
                    originalPrice: originalPrice,
                    remainingPriceNum: remainingQuantity,
                    remainingPrice: remainingPrice,
                    isDiscountPromotion: true,
                };

                const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                console.log(
                    `原品打折商品部分恢复原价(待整体打折) - 商品: ${cartItem.bgmName
                    } (批号: ${cartItem.sterBatchno || "无"
                    }), 恢复原价数量: ${restoreQuantity}, 剩余数量: ${remainingQuantity}, 平均价格: ${averagePrice.toFixed(
                        9
                    )}`
                );
            }
        },

        /**
         * 原品打折 - 恢复所有商品原价后整体打折
         * @param {Array} allParticipatingItems - 所有参与商品
         * @param {Object} plan - 促销方案
         * @param {number} discount - 折扣值
         * @param {number} conditionNum - 条件数量
         * @param {number} repeatMultiple - 重复倍数
         */
        restoreAllDiscountItems(
            allParticipatingItems,
            plan,
            discount,
            conditionNum,
            repeatMultiple
        ) {
            // 第一步：先恢复所有商品到原价
            allParticipatingItems.forEach((cartItem) => {
                const originalPrice = Number(cartItem.price);
                cartItem.changePrice = originalPrice;
                cartItem.actualPrice = originalPrice;
                cartItem.amount = Number(
                    this.$common.getDecimalInfo(3, originalPrice * cartItem.quantity)
                );
                cartItem.mixedPriceInfo = null;

                console.log(
                    `   📦 ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                    }) - 恢复原价: ${originalPrice}元`
                );
            });

            // 第二步：计算整体金额并打折
            const totalAmount = allParticipatingItems.reduce(
                (sum, item) => sum + item.amount,
                0
            );
            const discountedTotalAmount = Number(this.$common.getDecimalInfo(3, totalAmount * discount));
            const discountAmount = totalAmount - discountedTotalAmount;

            console.log(
                `🔄 整体打折计算: 原价总额=${totalAmount}元, 折扣=${discount}, 折后总额=${discountedTotalAmount}元, 优惠=${discountAmount}元`
            );

            // 第三步：按比例分配折扣到各个商品
            this.distributeDiscountToItems(
                allParticipatingItems,
                discountAmount,
                plan,
                `恢复原价后整体${discount}折(条件${conditionNum}×${repeatMultiple}倍)`
            );
        },

        /**
         * 原品打折 - 分配恢复原价数量到多个批号后整体打折
         * @param {Array} allParticipatingItems - 所有参与商品
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         * @param {number} discount - 折扣值
         * @param {number} repeatMultiple - 重复倍数
         */
        distributeDiscountRestoreQuantity(
            allParticipatingItems,
            totalRestoreQuantity,
            plan,
            discount,
            repeatMultiple
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;
            console.log(
                `🔄 开始分配原品打折恢复原价数量: 总需要恢复=${totalRestoreQuantity}`
            );

            // 第一步：按数量分配恢复原价（所有商品都要处理，确保都参与后续的整体打折）
            allParticipatingItems.forEach((cartItem) => {
                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格（但仍要参与整体打折）
                    const currentPrice = cartItem.changePrice || cartItem.price;
                    cartItem.changePrice = currentPrice;
                    cartItem.actualPrice = currentPrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, currentPrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    console.log(
                        `原品打折商品保持当前价(待整体打折) - 商品: ${cartItem.bgmName
                        } (批号: ${cartItem.sterBatchno || "无"}), 当前价: ${currentPrice}`
                    );
                    return;
                }

                // 计算当前商品需要恢复的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;

                if (itemRestoreQuantity >= cartItem.quantity) {
                    // 该批号全部恢复原价
                    const originalPrice = Number(cartItem.price);
                    cartItem.changePrice = originalPrice;
                    cartItem.actualPrice = originalPrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, originalPrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    console.log(
                        `原品打折商品全部恢复原价(待整体打折) - 商品: ${cartItem.bgmName
                        } (批号: ${cartItem.sterBatchno || "无"
                        }), 恢复原价: ${originalPrice}`
                    );
                } else if (itemRestoreQuantity > 0) {
                    // 该批号部分恢复原价，使用混合价格（待整体打折）
                    this.applyPartialRestorePrice(cartItem, itemRestoreQuantity);
                }
            });

            // 第二步：计算整体金额并打折
            const totalAmount = allParticipatingItems.reduce(
                (sum, item) => sum + item.amount,
                0
            );
            const discountedTotalAmount = Number(this.$common.getDecimalInfo(2, totalAmount * discount));
            const discountAmount = totalAmount - discountedTotalAmount;

            // 第三步：按比例分配折扣到各个商品
            if (discountAmount > 0) {
                console.log(`🎯 开始执行第三步：按比例分配折扣`);
                this.distributeDiscountToItems(
                    allParticipatingItems,
                    discountAmount,
                    plan,
                    `部分恢复原价后整体${discount}折`
                );
            } else {
                console.log(`⚠️ 折扣金额为0，跳过分配折扣步骤`);
            }
        },

        /**
         * 原品打折 - 应用部分恢复原价（不打折，只是混合价格）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         */
        applyPartialRestorePrice(cartItem, restoreQuantity) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            const originalPrice = Number(cartItem.price);
            // 确定剩余部分应该使用的价格
            let remainingPrice;
            if (this.memberInfo.memId) {
                // 有会员：剩余部分使用会员价
                remainingPrice = cartItem.memberPrice || cartItem.price;
            } else {
                // 无会员：剩余部分使用当前价格（可能是促销价等）
                remainingPrice = cartItem.changePrice || cartItem.price;
            }

            // 计算混合价格（不打折）
            const originalPriceAmount = originalPrice * restoreQuantity;
            const remainingPriceAmount = remainingPrice * remainingQuantity;
            const totalAmount = originalPriceAmount + remainingPriceAmount;
            const averagePrice = totalAmount / totalQuantity;

            cartItem.changePrice = Number(this.$common.getDecimalInfo(2, averagePrice));
            cartItem.actualPrice = cartItem.changePrice;
            cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

            // 记录混合价格信息
            cartItem.mixedPriceInfo = {
                originalPriceNum: restoreQuantity,
                originalPrice: originalPrice,
                remainingPriceNum: remainingQuantity,
                remainingPrice: remainingPrice,
                isDiscountPromotion: true,
            };

            console.log(
                `原品打折商品部分恢复原价 - 商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                }), 恢复原价数量: ${restoreQuantity}, 剩余数量: ${remainingQuantity}, 平均价格: ${averagePrice.toFixed(
                    9
                )}`
            );
        },

        /**
         * 按比例分配折扣到各个商品
         * @param {Array} allParticipatingItems - 所有参与商品
         * @param {number} discountAmount - 总折扣金额
         * @param {Object} plan - 促销方案
         * @param {string} discountInfo - 折扣信息描述
         */
        distributeDiscountToItems(
            allParticipatingItems,
            discountAmount,
            plan,
            discountInfo
        ) {
            const totalAmount = allParticipatingItems.reduce(
                (sum, item) => sum + item.amount,
                0
            );
            let remainingDiscountAmount = discountAmount;

            console.log(
                `🔄 开始按比例分配折扣: 总金额=${totalAmount}元, 总折扣=${discountAmount}元`
            );

            allParticipatingItems.forEach((item, index) => {
                // 计算该商品应分配的折扣金额
                let itemDiscountAmount;
                if (index === allParticipatingItems.length - 1) {
                    // 最后一个商品，分配剩余的所有折扣（避免精度问题）
                    itemDiscountAmount = remainingDiscountAmount;
                } else {
                    // 按比例分配
                    const proportion = item.amount / totalAmount;
                    itemDiscountAmount = Number(this.$common.getDecimalInfo(2, discountAmount * proportion));
                    remainingDiscountAmount -= itemDiscountAmount;
                }

                // 应用折扣
                const discountedAmount = item.amount - itemDiscountAmount;
                const discountedPrice = discountedAmount / item.quantity;

                item.changePrice = Number(this.$common.getDecimalInfo(2, discountedPrice));
                item.actualPrice = item.changePrice;
                item.amount = Number(this.$common.getDecimalInfo(3, discountedAmount));

                // 设置促销信息
                item.discountInfo = `${plan.planName}：${discountInfo}`;
                item.isDiscounted = true;
                item.mzConType = plan.mzConType;
                item.mzGiftType = plan.mzGiftType;
                item.planType = plan.planType;

                console.log(
                    `   📦 ${item.bgmName} (批号: ${item.sterBatchno || "无"
                    }) - 分配折扣: ${itemDiscountAmount}元, 折后价: ${discountedPrice.toFixed(
                        9
                    )}元`
                );
            });

            console.log(`✅ 折扣分配完成`);
        },

        /**
         * 应用现金减免到目标商品（支持多批号）
         * @param {Object} plan - 促销方案
         * @param {number} cashBack - 减免金额
         * @param {boolean} isRestoreOriginal - 是否已恢复原价
         */
        applyCashBackToTargetItems(plan, cashBack, isRestoreOriginal = false) {
            if (!plan.planBgmIdList || !Array.isArray(plan.planBgmIdList)) {
                console.log("没有指定需要减免的商品列表");
                return;
            }

            console.log(
                `🎯 原品金额减免处理 - 方案: ${plan.planName}, 减免金额: ${cashBack}, 恢复原价: ${isRestoreOriginal}`
            );

            // 收集所有参与的商品实例（包括多批号）
            const allParticipatingItems = [];
            plan.planBgmIdList.forEach((bgmId) => {
                const matchingItems = this.cartItems.filter(
                    (item) => item.bgmId === bgmId && !item.isGift
                );
                allParticipatingItems.push(...matchingItems);
            });

            console.log(`🛒 参与商品总数: ${allParticipatingItems.length}`);
            allParticipatingItems.forEach((item, index) => {
                console.log(
                    `   ${index + 1}. ${item.bgmName} (批号: ${item.sterBatchno || "无"
                    }) - 数量: ${item.quantity}`
                );
            });

            // 如果是恢复原价模式，需要根据条件数量处理
            if (isRestoreOriginal) {
                this.applyCashBackWithRestoreOriginal(
                    plan,
                    cashBack,
                    allParticipatingItems
                );
            } else {
                // 保持现状模式，直接对所有商品减免
                this.applyCashBackKeepCurrent(plan, cashBack, allParticipatingItems);
            }

            console.log(`✅ 原品金额减免处理完成 - 方案: ${plan.planName}`);
        },

        /**
         * 原品金额减免 - 保持现状处理（支持多批号，精度优化版本）
         * @param {Object} plan - 促销方案
         * @param {number} cashBack - 减免金额
         * @param {Array} allParticipatingItems - 所有参与商品
         */
        applyCashBackKeepCurrent(plan, cashBack, allParticipatingItems) {
            console.log(
                `🎯 原品金额减免保持现状处理 - 方案: ${plan.planName}, 减免金额: ${cashBack}`
            );

            // 计算所有商品的总金额（精确计算）
            const totalAmount = Number(this.$common.getDecimalInfo(3, allParticipatingItems.reduce((sum, item) => {
                const currentPrice = Number(
                    this.$common.getDecimalInfo(2, item.changePrice || item.price)
                );
                const itemAmount = Number(
                    (currentPrice * item.quantity).toFixed(9)
                );
                return Number((sum + itemAmount).toFixed(9));
            }, 0))
            );

            if (totalAmount <= 0) {
                console.log("商品总金额为0，无法进行减免");
                return;
            }

            // 确保减免金额不超过总金额（精确计算）
            const requestedDiscount = Number(
                Number(this.safeNumber(cashBack)).toFixed(9)
            );
            const actualDiscount = Number(
                Math.min(requestedDiscount, totalAmount).toFixed(9)
            );

            console.log(
                `🔄 金额减免计算: 总金额=${totalAmount}元, 请求减免=${requestedDiscount}元, 实际减免=${actualDiscount}元`
            );

            // 按比例分摊减免金额到各个商品
            this.distributeCashBackToItems(
                allParticipatingItems,
                actualDiscount,
                plan,
                `金额减免${actualDiscount}元`
            );

            console.log(`✅ 原品金额减免保持现状处理完成`);
        },

        /**
         * 原品金额减免 - 恢复原价处理（支持多批号，参考原品打折逻辑）
         * @param {Object} plan - 促销方案
         * @param {number} cashBack - 减免金额
         * @param {Array} allParticipatingItems - 所有参与商品
         */
        applyCashBackWithRestoreOriginal(plan, cashBack, allParticipatingItems) {
            console.log(
                `🎯 原品金额减免恢复原价处理 - 方案: ${plan.planName}, 减免金额: ${cashBack}`
            );

            // 判断是按条件商品处理还是按总数量处理
            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                // 有条件商品列表，按条件商品分别处理（部分恢复原价）
                console.log(`📊 部分恢复原价处理，按条件商品分别计算`);
                this.applyCashBackPartialRestoreByCondition(plan, cashBack);
            } else {
                // 没有条件商品列表，按总数量处理（全部恢复原价）
                const conditionNum = this.safeNumber(plan.mzConBgmNum, 1);
                const repeatMultiple = this.calculateRepeatMultiple(plan);
                const totalRestoreQuantity = conditionNum * repeatMultiple;
                const totalParticipatingQuantity = allParticipatingItems.reduce(
                    (sum, item) => sum + item.quantity,
                    0
                );

                if (totalRestoreQuantity >= totalParticipatingQuantity) {
                    // 需要恢复的数量 >= 商品总数，所有商品都恢复原价后减免
                    console.log(
                        "📈 需要恢复的数量超过商品总数，所有商品都恢复原价后减免"
                    );
                    this.restoreAllCashBackItems(
                        allParticipatingItems,
                        plan,
                        cashBack,
                        conditionNum,
                        repeatMultiple
                    );
                } else {
                    // 需要恢复的数量 < 商品总数，按数量分配恢复原价后减免
                    console.log(
                        `📊 按条件数量恢复原价后减免，分配${totalRestoreQuantity}件到各批号`
                    );
                    this.distributeCashBackRestoreQuantity(
                        allParticipatingItems,
                        totalRestoreQuantity,
                        plan,
                        cashBack,
                        repeatMultiple
                    );
                }
            }

            console.log(`✅ 原品金额减免恢复原价处理完成`);
        },

        /**
         * 原品金额减免 - 恢复所有商品原价后整体减免
         * @param {Array} allParticipatingItems - 所有参与商品
         * @param {Object} plan - 促销方案
         * @param {number} cashBack - 减免金额
         * @param {number} conditionNum - 条件数量
         * @param {number} repeatMultiple - 重复倍数
         */
        restoreAllCashBackItems(
            allParticipatingItems,
            plan,
            cashBack,
            conditionNum,
            repeatMultiple
        ) {
            // 第一步：先恢复所有商品到原价
            allParticipatingItems.forEach((cartItem) => {
                const originalPrice = Number(cartItem.price);
                cartItem.changePrice = originalPrice;
                cartItem.actualPrice = originalPrice;
                cartItem.amount = Number(
                    this.$common.getDecimalInfo(2, originalPrice * cartItem.quantity)
                );
                cartItem.mixedPriceInfo = null;

                console.log(
                    `   📦 ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                    }) - 恢复原价: ${originalPrice}元`
                );
            });

            // 第二步：计算整体金额并减免
            const totalAmount = allParticipatingItems.reduce(
                (sum, item) => sum + item.amount,
                0
            );
            const actualDiscount = Math.min(this.safeNumber(cashBack), totalAmount);

            console.log(
                `🔄 整体减免计算: 原价总额=${totalAmount}元, 减免金额=${actualDiscount}元`
            );

            // 第三步：按比例分配减免到各个商品
            this.distributeCashBackToItems(
                allParticipatingItems,
                actualDiscount,
                plan,
                `恢复原价后整体减免${actualDiscount}元(条件${conditionNum}×${repeatMultiple}倍)`
            );
        },

        /**
         * 按比例分配减免金额到各个商品（精度优化版本）
         * @param {Array} allParticipatingItems - 所有参与商品
         * @param {number} discountAmount - 总减免金额
         * @param {Object} plan - 促销方案
         * @param {string} discountInfo - 减免信息描述
         */
        distributeCashBackToItems(
            allParticipatingItems,
            discountAmount,
            plan,
            discountInfo
        ) {
            // 使用精确的金额计算，避免浮点数精度问题
            const totalAmount = Number(
                allParticipatingItems
                    .reduce((sum, item) => sum + item.amount, 0)
                    .toFixed(9)
            );
            const actualDiscountAmount = Number(this.$common.getDecimalInfo(2, discountAmount));

            if (totalAmount <= 0) {
                console.log("⚠️ 总金额为0，无法进行减免分配");
                return;
            }

            console.log(
                `🔄 开始按比例分配减免: 总金额=${totalAmount}元, 总减免=${actualDiscountAmount}元`
            );

            // 计算每个商品应分配的减免金额（保持精度）
            const itemDiscounts = [];
            let totalCalculatedDiscount = 0;

            // 第一轮：计算每个商品的理论减免金额
            allParticipatingItems.forEach((item, index) => {
                if (index === allParticipatingItems.length - 1) {
                    // 最后一个商品，分配剩余的所有减免（确保总和精确）
                    const remainingDiscount = Number(
                        (actualDiscountAmount - totalCalculatedDiscount).toFixed(9)
                    );
                    itemDiscounts.push(remainingDiscount);
                } else {
                    // 按比例分配，保持2位小数精度
                    const proportion = item.amount / totalAmount;
                    const itemDiscountAmount = Number(
                        (actualDiscountAmount * proportion).toFixed(9)
                    );
                    itemDiscounts.push(itemDiscountAmount);
                    totalCalculatedDiscount = Number(
                        (totalCalculatedDiscount + itemDiscountAmount).toFixed(9)
                    );
                }
            });

            // 第二轮：应用减免到各个商品
            allParticipatingItems.forEach((item, index) => {
                const itemDiscountAmount = itemDiscounts[index];

                // 确保减免金额不超过商品总金额
                const maxDiscount = item.amount;
                const actualItemDiscount = Math.min(itemDiscountAmount, maxDiscount);

                // 计算减免后的金额（确保不为负数）
                const discountedAmount = Number(
                    Math.max(0, item.amount - actualItemDiscount).toFixed(9)
                );

                // 计算减免后的单价（确保精度）
                const discountedPrice =
                    item.quantity > 0
                        ? Number((discountedAmount / item.quantity).toFixed(9))
                        : 0;

                // 重新计算总金额以确保一致性（单价 × 数量）
                const recalculatedAmount = Number(
                    this.$common.getDecimalInfo(3, discountedPrice * item.quantity)
                );

                // 更新商品信息
                item.changePrice = discountedPrice;
                item.actualPrice = discountedPrice;
                item.amount = recalculatedAmount;

                // 设置促销信息
                item.discountInfo = `${plan.planName}：${discountInfo}`;
                item.isDiscounted = true;
                item.mzConType = plan.mzConType;
                item.mzGiftType = plan.mzGiftType;
                item.planType = plan.planType;
            });
        },

        /**
         * 原品金额减免 - 按条件商品分别处理部分恢复原价（参考原品打折逻辑）
         * @param {Object} plan - 促销方案
         * @param {number} cashBack - 减免金额
         */
        applyCashBackPartialRestoreByCondition(plan, cashBack) {
            console.log(
                `🎯 原品金额减免按条件商品分别处理部分恢复原价 - 方案: ${plan.planName}`
            );

            const repeatMultiple = this.calculateRepeatMultiple(plan);
            console.log(`📊 重复倍数: ${repeatMultiple}`);

            // 收集所有参与的商品，用于最后的整体减免
            const allParticipatingItems = [];

            // 按条件商品处理部分恢复原价
            plan.conBgmList.forEach((conditionItem) => {
                const matchingItems = this.cartItems.filter(
                    (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                );

                if (matchingItems.length > 0) {
                    // 单品数量要求
                    const singleItemRequiredNum = this.safeNumber(conditionItem.num, 1);
                    // 根据重复倍数计算该商品需要恢复原价的总数量：单品数量要求 × 重复倍数
                    const totalRestoreNum = singleItemRequiredNum * repeatMultiple;
                    // 计算该商品所有批号的总数量
                    const totalItemQuantity = matchingItems.reduce(
                        (sum, item) => sum + item.quantity,
                        0
                    );

                    console.log(`🔄 处理商品: ${matchingItems[0].bgmName}`);
                    console.log(
                        `📊 单品要求: ${singleItemRequiredNum}, 重复倍数: ${repeatMultiple}, 需要恢复数量: ${totalRestoreNum}`
                    );
                    console.log(
                        `🛒 该商品批号数量: ${matchingItems.length}, 总数量: ${totalItemQuantity}`
                    );

                    // 按条件数量依次分配恢复原价到该商品的各批号
                    this.distributeCashBackPartialRestoreQuantity(
                        matchingItems,
                        totalRestoreNum,
                        plan
                    );

                    // 将处理过的商品添加到总列表中
                    allParticipatingItems.push(...matchingItems);
                }
            });

            // 最后对所有商品进行整体减免
            if (allParticipatingItems.length > 0) {
                console.log(`🎯 开始对所有商品进行整体减免`);

                // 计算整体金额并减免
                const totalAmount = allParticipatingItems.reduce(
                    (sum, item) => sum + item.amount,
                    0
                );
                const actualDiscount = Math.min(this.safeNumber(cashBack), totalAmount);

                console.log(
                    `🔄 整体减免计算: 恢复后总额=${totalAmount}元, 减免金额=${actualDiscount}元`
                );

                // 按比例分配减免到各个商品
                if (actualDiscount > 0) {
                    this.distributeCashBackToItems(
                        allParticipatingItems,
                        actualDiscount,
                        plan,
                        `部分恢复原价后整体减免${actualDiscount}元`
                    );
                }
            }

            console.log(`✅ 原品金额减免按条件商品分别处理部分恢复原价完成`);
        },

        /**
         * 原品金额减免 - 分配恢复原价数量到多个批号后整体减免
         * @param {Array} allParticipatingItems - 所有参与商品
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         * @param {number} cashBack - 减免金额
         * @param {number} repeatMultiple - 重复倍数
         */
        distributeCashBackRestoreQuantity(
            allParticipatingItems,
            totalRestoreQuantity,
            plan,
            cashBack,
            repeatMultiple
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;

            console.log(
                `🔄 开始分配原品金额减免恢复原价数量: 总需要恢复=${totalRestoreQuantity}`
            );
            // 第一步：按数量分配恢复原价（所有商品都要处理，确保都参与后续的整体减免）
            allParticipatingItems.forEach((cartItem) => {
                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格（但仍要参与整体减免）
                    const currentPrice = cartItem.changePrice || cartItem.price;
                    cartItem.changePrice = currentPrice;
                    cartItem.actualPrice = currentPrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, currentPrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    console.log(
                        `原品金额减免商品保持当前价(待整体减免) - 商品: ${cartItem.bgmName
                        } (批号: ${cartItem.sterBatchno || "无"}), 当前价: ${currentPrice}`
                    );
                    return;
                }

                // 计算当前商品需要恢复的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;

                if (itemRestoreQuantity >= cartItem.quantity) {
                    // 该批号全部恢复原价
                    const originalPrice = Number(cartItem.price);
                    cartItem.changePrice = originalPrice;
                    cartItem.actualPrice = originalPrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, originalPrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    console.log(
                        `原品金额减免商品全部恢复原价(待整体减免) - 商品: ${cartItem.bgmName
                        } (批号: ${cartItem.sterBatchno || "无"
                        }), 恢复原价: ${originalPrice}`
                    );
                } else if (itemRestoreQuantity > 0) {
                    // 该批号部分恢复原价，使用混合价格（待整体减免）
                    this.applyCashBackPartialRestorePrice(cartItem, itemRestoreQuantity);
                }
            });

            // 第二步：计算整体金额并减免
            const totalAmount = allParticipatingItems.reduce(
                (sum, item) => sum + item.amount,
                0
            );
            const actualDiscount = Math.min(this.safeNumber(cashBack), totalAmount);

            console.log(
                `🔄 整体减免计算: 恢复后总额=${totalAmount}元, 减免金额=${actualDiscount}元`
            );

            // 第三步：按比例分配减免到各个商品
            this.distributeCashBackToItems(
                allParticipatingItems,
                actualDiscount,
                plan,
                `部分恢复原价后整体减免${actualDiscount}元`
            );
        },

        /**
         * 原品金额减免 - 应用部分恢复原价（不减免，只是混合价格，精度优化版本）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         */
        applyCashBackPartialRestorePrice(cartItem, restoreQuantity) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            const originalPrice = Number(Number(cartItem.price).toFixed(9));
            // 确定剩余部分应该使用的价格
            let remainingPrice;
            if (this.memberInfo.memId) {
                // 有会员：剩余部分使用会员价
                remainingPrice = Number(
                    Number(cartItem.memberPrice || cartItem.price).toFixed(9)
                );
            } else {
                // 无会员：剩余部分使用当前价格（可能是促销价等）
                remainingPrice = Number(
                    Number(cartItem.changePrice || cartItem.price).toFixed(9)
                );
            }

            // 计算混合价格（精确计算，避免浮点数精度问题）
            const originalPriceAmount = Number(
                (originalPrice * restoreQuantity).toFixed(9)
            );
            const remainingPriceAmount = Number(
                (remainingPrice * remainingQuantity).toFixed(9)
            );
            const totalAmount = Number(
                (originalPriceAmount + remainingPriceAmount).toFixed(9)
            );
            const averagePrice =
                totalQuantity > 0
                    ? Number((totalAmount / totalQuantity).toFixed(9))
                    : 0;

            // 重新计算总金额以确保一致性（单价 × 数量）
            const recalculatedAmount = Number(
                this.$common.getDecimalInfo(3, averagePrice * totalQuantity)

            );

            cartItem.changePrice = averagePrice;
            cartItem.actualPrice = averagePrice;
            cartItem.amount = recalculatedAmount;

            // 记录混合价格信息
            cartItem.mixedPriceInfo = {
                originalPriceNum: restoreQuantity,
                originalPrice: originalPrice,
                remainingPriceNum: remainingQuantity,
                remainingPrice: remainingPrice,
                isCashBackPromotion: true,
                // 添加精度验证信息
                calculatedTotalAmount: totalAmount,
                recalculatedAmount: recalculatedAmount,
                priceDifference: Number(
                    Math.abs(totalAmount - recalculatedAmount).toFixed(9)
                ),
            };
        },

        /**
         * 应用部分价格恢复
         * @param {Object} cartItem - 购物车商品
         * @param {number} numToRestore - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         */
        applyPartialPriceRestore(cartItem, numToRestore, plan) {
            const originalPrice = cartItem.price;
            const currentPrice = cartItem.changePrice || originalPrice;
            if (numToRestore >= cartItem.quantity) {
                // 全部恢复原价
                cartItem.changePrice = originalPrice;
                cartItem.actualPrice = originalPrice;
                cartItem.amount = Number(
                    this.$common.getDecimalInfo(3, originalPrice * cartItem.quantity)
                );
            } else {
                // 部分恢复原价，计算混合价格
                const restoreAmount = originalPrice * numToRestore;
                const remainingAmount =
                    currentPrice * (cartItem.quantity - numToRestore);
                const totalAmount = restoreAmount + remainingAmount;
                const averagePrice = totalAmount / cartItem.quantity;

                cartItem.changePrice = Number(averagePrice.toFixed(9));
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

                // 记录混合价格信息
                cartItem.mixedPriceInfo = {
                    restoreNum: numToRestore,
                    restorePrice: originalPrice,
                    discountNum: cartItem.quantity - numToRestore,
                    discountPrice: currentPrice,
                    averagePrice: averagePrice,
                };
            }

            cartItem.discountInfo = `${plan.planName}：${numToRestore}件恢复原价${originalPrice}元`;
            cartItem.isDiscounted = true;
            cartItem.mzConType = plan.mzConType;
            cartItem.mzGiftType = plan.mzGiftType;
            cartItem.planType = plan.planType;
        },

        /**
         * 应用部分恢复原价后的折扣到目标商品（支持多批号，参考优惠券逻辑）
         * @param {Object} plan - 促销方案
         * @param {number} discount - 折扣值
         */
        applyPartialRestoreDiscountToTargetItems(plan, discount) {
            console.log(
                `🎯 原品打折部分恢复原价处理 - 方案: ${plan.planName}, 折扣: ${discount}`
            );

            const repeatMultiple = this.calculateRepeatMultiple(plan);
            console.log(`📊 重复倍数: ${repeatMultiple}`);

            // 收集所有参与的商品，用于最后的整体打折
            const allParticipatingItems = [];

            // 判断是按条件商品处理还是按商品列表处理
            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                // 按条件商品处理部分恢复原价（参考优惠券逻辑）
                plan.conBgmList.forEach((conditionItem) => {
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                    );

                    if (matchingItems.length > 0) {
                        // 单品数量要求
                        const singleItemRequiredNum = this.safeNumber(conditionItem.num, 1);
                        // 根据重复倍数计算该商品需要恢复原价的总数量：单品数量要求 × 重复倍数
                        const totalRestoreNum = singleItemRequiredNum * repeatMultiple;
                        // 计算该商品所有批号的总数量
                        const totalItemQuantity = matchingItems.reduce(
                            (sum, item) => sum + item.quantity,
                            0
                        );

                        console.log(`🔄 处理商品: ${matchingItems[0].bgmName}`);
                        console.log(
                            `📊 单品要求: ${singleItemRequiredNum}, 重复倍数: ${repeatMultiple}, 需要恢复数量: ${totalRestoreNum}`
                        );
                        console.log(
                            `🛒 该商品批号数量: ${matchingItems.length}, 总数量: ${totalItemQuantity}`
                        );

                        // 按条件数量依次分配恢复原价到该商品的各批号
                        this.distributeDiscountPartialRestoreQuantity(
                            matchingItems,
                            totalRestoreNum,
                            plan
                        );

                        // 将处理过的商品添加到总列表中
                        allParticipatingItems.push(...matchingItems);
                    }
                });
            } else if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 按商品列表处理（收集所有批号）
                plan.planBgmIdList.forEach((bgmId) => {
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === bgmId && !item.isGift
                    );
                    allParticipatingItems.push(...matchingItems);
                });
            }

            // 最后对所有商品进行整体打折
            if (allParticipatingItems.length > 0) {
                console.log(`🎯 开始对所有商品进行整体打折`);

                // 计算整体金额并打折
                const totalAmount = allParticipatingItems.reduce(
                    (sum, item) => sum + item.amount,
                    0
                );
                const discountedTotalAmount = Number(
                    (totalAmount * discount).toFixed(9)
                );
                const discountAmount = totalAmount - discountedTotalAmount;

                console.log(
                    `🔄 整体打折计算: 恢复后总额=${totalAmount}元, 折扣=${(
                        discount * 100
                    ).toFixed(
                        1
                    )}%, 折后总额=${discountedTotalAmount}元, 优惠=${discountAmount}元`
                );

                // 按比例分配折扣到各个商品
                if (discountAmount > 0) {
                    this.distributeDiscountToItems(
                        allParticipatingItems,
                        discountAmount,
                        plan,
                        `部分恢复原价后整体${discount}折`
                    );
                }
            }

            console.log(`✅ 原品打折部分恢复原价处理完成`);
        },

        /**
         * 应用部分恢复原价后的金额减免到目标商品（支持多批号，参考原品打折逻辑）
         * @param {Object} plan - 促销方案
         * @param {number} cashBack - 减免金额
         */
        applyPartialRestoreCashBackToTargetItems(plan, cashBack) {
            console.log(
                `🎯 原品金额减免部分恢复原价处理 - 方案: ${plan.planName}, 减免金额: ${cashBack}`
            );

            const repeatMultiple = this.calculateRepeatMultiple(plan);
            console.log(`📊 重复倍数: ${repeatMultiple}`);

            // 收集所有参与的商品，用于最后的整体减免
            const allParticipatingItems = [];

            // 判断是按条件商品处理还是按商品列表处理
            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                // 按条件商品处理部分恢复原价（参考优惠券逻辑）
                plan.conBgmList.forEach((conditionItem) => {
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                    );

                    if (matchingItems.length > 0) {
                        // 单品数量要求
                        const singleItemRequiredNum = this.safeNumber(conditionItem.num, 1);
                        // 根据重复倍数计算该商品需要恢复原价的总数量：单品数量要求 × 重复倍数
                        const totalRestoreNum = singleItemRequiredNum * repeatMultiple;
                        // 计算该商品所有批号的总数量
                        const totalItemQuantity = matchingItems.reduce(
                            (sum, item) => sum + item.quantity,
                            0
                        );

                        console.log(`🔄 处理商品: ${matchingItems[0].bgmName}`);
                        console.log(
                            `📊 单品要求: ${singleItemRequiredNum}, 重复倍数: ${repeatMultiple}, 需要恢复数量: ${totalRestoreNum}`
                        );
                        console.log(
                            `🛒 该商品批号数量: ${matchingItems.length}, 总数量: ${totalItemQuantity}`
                        );

                        // 按条件数量依次分配恢复原价到该商品的各批号
                        this.distributeCashBackPartialRestoreQuantity(
                            matchingItems,
                            totalRestoreNum,
                            plan
                        );

                        // 将处理过的商品添加到总列表中
                        allParticipatingItems.push(...matchingItems);
                    }
                });
            } else if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 按商品列表处理（收集所有批号）
                plan.planBgmIdList.forEach((bgmId) => {
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === bgmId && !item.isGift
                    );
                    allParticipatingItems.push(...matchingItems);
                });
            }

            // 最后对所有商品进行整体减免
            if (allParticipatingItems.length > 0) {
                console.log(`🎯 开始对所有商品进行整体减免`);

                // 计算整体金额并减免
                const totalAmount = allParticipatingItems.reduce(
                    (sum, item) => sum + item.amount,
                    0
                );
                const actualDiscount = Math.min(this.safeNumber(cashBack), totalAmount);

                console.log(
                    `🔄 整体减免计算: 恢复后总额=${totalAmount}元, 减免金额=${actualDiscount}元`
                );

                // 按比例分配减免到各个商品
                if (actualDiscount > 0) {
                    this.distributeCashBackToItems(
                        allParticipatingItems,
                        actualDiscount,
                        plan,
                        `部分恢复原价后整体减免${actualDiscount}元`
                    );
                }
            }

            console.log(`✅ 原品金额减免部分恢复原价处理完成`);
        },

        /**
         * 原品金额减免 - 为单个商品分配部分恢复原价数量到多个批号
         * @param {Array} cartItems - 同一商品的多个批号
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         */
        distributeCashBackPartialRestoreQuantity(
            cartItems,
            totalRestoreQuantity,
            plan
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;
            console.log(
                `🔄 开始为单个商品分配恢复原价数量: 总需要恢复=${totalRestoreQuantity}`
            );

            // 按顺序依次给多批号商品设置恢复原价
            cartItems.forEach((cartItem) => {
                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格
                    let currentPrice;
                    if (this.memberInfo.memId) {
                        // 有会员：使用会员价
                        currentPrice = cartItem.memberPrice || cartItem.price;
                    } else {
                        // 无会员：使用当前价格（可能是促销价等）
                        currentPrice = cartItem.changePrice || cartItem.price;
                    }

                    cartItem.changePrice = Number(currentPrice.toFixed(9));
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    console.log(
                        `原品金额减免商品保持当前价(待整体减免) - 商品: ${cartItem.bgmName
                        } (批号: ${cartItem.sterBatchno || "无"}), 当前价: ${currentPrice}`
                    );
                    return;
                }

                // 计算当前批号需要恢复的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;

                // 应用混合价格恢复原价（不减免，等待后续整体减免）
                this.applyCashBackMixedPriceRestoreForPartial(
                    cartItem,
                    itemRestoreQuantity,
                    plan
                );
            });

            console.log(
                `✅ 单个商品恢复原价数量分配完成，剩余未分配: ${remainingRestoreQuantity}`
            );
        },

        /**
         * 原品金额减免 - 应用混合价格恢复（部分恢复原价用，不减免）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         */
        applyCashBackMixedPriceRestoreForPartial(cartItem, restoreQuantity, plan) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            const originalPrice = Number(cartItem.price);
            if (restoreQuantity >= totalQuantity) {
                // 该批号全部恢复原价
                cartItem.changePrice = originalPrice;
                cartItem.actualPrice = originalPrice;
                cartItem.amount = Number(this.$common.getDecimalInfo(3, originalPrice * totalQuantity));
                cartItem.mixedPriceInfo = null;

                console.log(
                    `原品金额减免商品全部恢复原价(待整体减免) - 商品: ${cartItem.bgmName
                    } (批号: ${cartItem.sterBatchno || "无"}), 原价: ${originalPrice}`
                );
            } else if (restoreQuantity > 0) {
                // 该批号部分恢复原价，计算混合价格
                // 确定剩余部分应该使用的价格
                let remainingPrice;
                if (this.memberInfo.memId) {
                    // 有会员：剩余部分使用会员价
                    remainingPrice = cartItem.memberPrice || cartItem.price;
                } else {
                    // 无会员：剩余部分使用当前价格（可能是促销价等）
                    remainingPrice = cartItem.changePrice || cartItem.price;
                }

                // 计算混合价格（不减免）
                const originalPriceAmount = originalPrice * restoreQuantity;
                const remainingPriceAmount = remainingPrice * remainingQuantity;
                const totalAmount = originalPriceAmount + remainingPriceAmount;
                const averagePrice = totalAmount / totalQuantity;

                cartItem.changePrice = Number(averagePrice.toFixed(9));
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

                // 记录混合价格信息
                cartItem.mixedPriceInfo = {
                    originalPriceNum: restoreQuantity,
                    originalPrice: originalPrice,
                    remainingPriceNum: remainingQuantity,
                    remainingPrice: remainingPrice,
                    isCashBackPromotion: true,
                };

                console.log(
                    `原品金额减免商品部分恢复原价(待整体减免) - 商品: ${cartItem.bgmName
                    } (批号: ${cartItem.sterBatchno || "无"
                    }), 恢复原价数量: ${restoreQuantity}, 剩余数量: ${remainingQuantity}, 平均价格: ${averagePrice.toFixed(
                        9
                    )}`
                );
            }
        },

        /**
         * 计算重复赠送倍数
         * @param {Object} plan - 促销方案
         * @returns {number} - 重复倍数
         */
        calculateRepeatMultiple(plan) {
            if (!plan.mzIsRepeat || plan.mzIsRepeat !== 1) {
                return 1;
            }
            let qualifiedQuantity = 0;
            try {
                if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                    // 如果有指定条件商品，计算条件商品的总数量（合并同一商品不同批号）
                    plan.conBgmList.forEach((conditionItem) => {
                        const matchedCartItems = this.cartItems.filter(
                            (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                        );
                        if (matchedCartItems.length > 0) {
                            // 计算同一商品所有批号的总数量
                            const totalQuantity = matchedCartItems.reduce(
                                (sum, item) => sum + (item.quantity || 0),
                                0
                            );
                            qualifiedQuantity += totalQuantity;
                        }
                    });
                } else if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                    // 如果没有条件商品但有方案商品列表，计算方案商品的总数量（合并同一商品不同批号）
                    plan.planBgmIdList.forEach((bgmId) => {
                        const matchedCartItems = this.cartItems.filter(
                            (item) => item.bgmId === bgmId && !item.isGift
                        );
                        if (matchedCartItems.length > 0) {
                            // 计算同一商品所有批号的总数量
                            const totalQuantity = matchedCartItems.reduce(
                                (sum, item) => sum + (item.quantity || 0),
                                0
                            );
                            qualifiedQuantity += totalQuantity;
                        }
                    });
                } else {
                    // 如果都没有，计算购物车中所有非赠品的总数量
                    qualifiedQuantity = this.cartItems
                        .filter((item) => !item.isGift)
                        .reduce((sum, item) => sum + item.quantity, 0);
                }

                // 根据条件商品数量要求计算倍数（向下取整）
                const conditionNum = this.safeNumber(plan.mzConBgmNum, 1);
                const repeatMultiple = Math.floor(qualifiedQuantity / conditionNum);
                return Math.max(0, repeatMultiple);
            } catch (error) {
                console.error("计算重复倍数时发生错误:", error);
                return 1;
            }
        },

        /**
         * 处理积分促销的特殊逻辑
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handlePointsPromotion(plan, matchedConditionItems, repeatMultiple) {
            // 分别处理增加积分和减少积分
            const totalAddPoint =
                this.safeNumber(plan.mzAddPoint, 0) * repeatMultiple;
            const totalReducePoint =
                this.safeNumber(plan.mzReducePoint, 0) * repeatMultiple;
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 获取参与积分促销的商品列表
                const participatingItems = this.getParticipatingItems(plan);
                // 分别计算增加积分和减少积分的分配
                const addPointsPerItem =
                    totalAddPoint > 0
                        ? this.distributePointsToItems(totalAddPoint, participatingItems)
                        : {};
                const reducePointsPerItem =
                    totalReducePoint > 0
                        ? this.distributePointsToItems(totalReducePoint, participatingItems)
                        : {};
                // 为每个商品实例分配积分
                participatingItems.forEach((item) => {
                    const itemKey = this.cartItems.indexOf(item);
                    const itemAddPoints = addPointsPerItem[itemKey] || 0;
                    const itemReducePoints = reducePointsPerItem[itemKey] || 0;
                    // 添加积分促销标记和信息
                    this.setItemProperty(item, "isPointPromotion", true);
                    this.setItemProperty(item, "addPoint", itemAddPoints); // mzAddPoint 对应 addPoint
                    this.setItemProperty(item, "rePoint", itemReducePoints); // mzReducePoint 对应 rePoint
                    this.setItemProperty(item, "repeatMultiple", repeatMultiple);
                    this.setItemProperty(item, "mzConType", plan.mzConType);
                    this.setItemProperty(item, "mzGiftType", plan.mzGiftType);
                    this.setItemProperty(item, "planType", plan.planType);
                    this.setItemProperty(item, "isDiscounted", true);
                    this.setItemProperty(
                        item,
                        "totalPromotionPoints",
                        totalAddPoint + totalReducePoint
                    ); // 记录总积分用于调试
                    // 更新折扣信息
                    const currentInfo = item.discountInfo || "";
                    let pointInfo = "";
                    if (itemAddPoints > 0 && itemReducePoints > 0) {
                        pointInfo = `+${itemAddPoints}积分，-${itemReducePoints}积分`;
                    } else if (itemAddPoints > 0) {
                        pointInfo = `+${itemAddPoints}积分`;
                    } else if (itemReducePoints > 0) {
                        pointInfo = `-${itemReducePoints}积分`;
                    }

                    item.discountInfo = currentInfo
                        ? `${currentInfo}；${plan.planName}：${pointInfo}`
                        : `${plan.planName}：积分促销${pointInfo}`;

                    console.log(
                        `积分促销商品: ${item.bgmName} (批号: ${item.sterBatchno || "无"
                        }), 增加积分: ${itemAddPoints}, 减少积分: ${itemReducePoints}, 倍数: ${repeatMultiple}`
                    );
                });
            }
        },

        /**
         * 处理积分促销的特殊价格逻辑（包含复杂的混合价格计算，支持多批号商品）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handleSpecialPointsPromotion(plan, matchedConditionItems, repeatMultiple) {
            console.log(
                `🎯 积分促销特殊处理开始 - 方案: ${plan.planName}, 重复倍数: ${repeatMultiple}`
            );
            const priceSet = this.getPriceSetType(plan);
            // 参考优惠券促销的处理方式，根据价格设置类型调用不同的处理方法
            switch (priceSet) {
                case this.PRICE_SET_TYPES.KEEP_CURRENT:
                    this.handlePointsPromotionKeepCurrent(
                        plan,
                        matchedConditionItems,
                        repeatMultiple
                    );
                    break;
                case this.PRICE_SET_TYPES.RESTORE_ORIGINAL:
                    this.handlePointsPromotionRestoreOriginal(
                        plan,
                        matchedConditionItems,
                        repeatMultiple
                    );
                    break;
                case this.PRICE_SET_TYPES.PARTIAL_RESTORE:
                    this.handlePointsPromotionPartialRestore(
                        plan,
                        matchedConditionItems,
                        repeatMultiple
                    );
                    break;
                default:
                    console.warn("未知的积分促销价格设置方式:", priceSet);
                    // 默认使用保持现状处理
                    this.handlePointsPromotionKeepCurrent(
                        plan,
                        matchedConditionItems,
                        repeatMultiple
                    );
            }

            console.log(`✅ 积分促销特殊处理完成 - 方案: ${plan.planName}`);
        },

        /**
         * 积分促销 - 保持现状处理（支持多批号）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handlePointsPromotionKeepCurrent(
            plan,
            matchedConditionItems,
            repeatMultiple
        ) {
            console.log(`🎯 积分促销保持现状处理 - 方案: ${plan.planName}`);

            // 分别处理增加积分和减少积分
            const totalAddPoint =
                this.safeNumber(plan.mzAddPoint, 0) * repeatMultiple;
            const totalReducePoint =
                this.safeNumber(plan.mzReducePoint, 0) * repeatMultiple;

            // 收集所有参与的商品实例（参考优惠券做法）
            const allParticipatingItems = [];
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 直接从方案商品列表获取所有批号
                plan.planBgmIdList.forEach((bgmId) => {
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === bgmId && !item.isGift
                    );
                    allParticipatingItems.push(...matchingItems);
                });
            }

            console.log(`🛒 参与商品总数: ${allParticipatingItems.length}`);
            allParticipatingItems.forEach((item, index) => {
                console.log(
                    `   ${index + 1}. ${item.bgmName} (批号: ${item.sterBatchno || "无"
                    }) - 数量: ${item.quantity}`
                );
            });

            // 分别计算增加积分和减少积分的分配
            const addPointsPerItem =
                totalAddPoint > 0
                    ? this.distributePointsToItems(totalAddPoint, allParticipatingItems)
                    : {};
            const reducePointsPerItem =
                totalReducePoint > 0
                    ? this.distributePointsToItems(
                        totalReducePoint,
                        allParticipatingItems
                    )
                    : {};

            allParticipatingItems.forEach((item) => {
                const currentPrice = item.changePrice || item.price;
                item.changePrice = currentPrice;
                item.actualPrice = currentPrice;
                item.amount = Number((item.changePrice * item.quantity).toFixed(9));

                // 使用分配给该商品实例的积分
                const itemKey = this.cartItems.indexOf(item);
                const itemAddPoints = addPointsPerItem[itemKey] || 0;
                const itemReducePoints = reducePointsPerItem[itemKey] || 0;
                this.setPointPromotionInfo(
                    item,
                    plan,
                    itemAddPoints,
                    itemReducePoints,
                    repeatMultiple,
                    "积分促销保持现状",
                    totalAddPoint,
                    totalReducePoint
                );
                this.setItemProperty(item, "isDiscounted", true);
            });
        },

        /**
         * 积分促销 - 全部恢复原价处理（支持多批号，参考优惠券做法）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handlePointsPromotionRestoreOriginal(
            plan,
            matchedConditionItems,
            repeatMultiple
        ) {
            console.log(`🎯 积分促销全部恢复原价处理 - 方案: ${plan.planName}`);
            // 分别处理增加积分和减少积分
            const totalAddPoint =
                this.safeNumber(plan.mzAddPoint, 0) * repeatMultiple;
            const totalReducePoint =
                this.safeNumber(plan.mzReducePoint, 0) * repeatMultiple;

            // 计算需要恢复原价的总数量（参考优惠券做法）
            const conditionNum = this.safeNumber(plan.mzConBgmNum, 1);
            const totalRestoreQuantity = conditionNum * repeatMultiple;

            console.log(`🔄 积分促销恢复原价处理:`);
            console.log(
                `   📊 条件数量要求: ${conditionNum}, 重复倍数: ${repeatMultiple}`
            );
            console.log(`   📊 需要恢复原价数量: ${totalRestoreQuantity}`);

            // 收集所有参与的商品实例（参考优惠券做法）
            const allParticipatingItems = [];
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                // 直接从方案商品列表获取所有批号
                plan.planBgmIdList.forEach((bgmId) => {
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === bgmId && !item.isGift
                    );
                    allParticipatingItems.push(...matchingItems);
                });
            }

            // 计算所有参与商品的总数量
            const totalParticipatingQuantity = allParticipatingItems.reduce(
                (sum, item) => sum + item.quantity,
                0
            );

            // 分别计算增加积分和减少积分的分配
            const addPointsPerItem =
                totalAddPoint > 0
                    ? this.distributePointsToItems(totalAddPoint, allParticipatingItems)
                    : {};
            const reducePointsPerItem =
                totalReducePoint > 0
                    ? this.distributePointsToItems(
                        totalReducePoint,
                        allParticipatingItems
                    )
                    : {};

            if (totalRestoreQuantity >= totalParticipatingQuantity) {
                // 需要恢复的数量 >= 商品总数，所有商品都恢复原价
                allParticipatingItems.forEach((cartItem) => {
                    const originalPrice = Number(cartItem.price);
                    const itemKey = this.cartItems.indexOf(cartItem);
                    const itemAddPoints = addPointsPerItem[itemKey] || 0;
                    const itemReducePoints = reducePointsPerItem[itemKey] || 0;

                    cartItem.changePrice = originalPrice;
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    this.setPointPromotionInfo(
                        cartItem,
                        plan,
                        itemAddPoints,
                        itemReducePoints,
                        repeatMultiple,
                        `积分促销恢复原价(条件${conditionNum}×${repeatMultiple}倍)`,
                        totalAddPoint,
                        totalReducePoint
                    );
                    this.setItemProperty(cartItem, "isDiscounted", true);
                });
            } else {
                // 需要恢复的数量 < 商品总数，按数量分配恢复原价
                this.distributePointsPromotionRestoreQuantity(
                    allParticipatingItems,
                    totalRestoreQuantity,
                    plan,
                    addPointsPerItem,
                    reducePointsPerItem,
                    repeatMultiple,
                    totalAddPoint,
                    totalReducePoint
                );
            }

            console.log(`✅ 积分促销全部恢复原价处理完成`);
        },

        /**
         * 积分促销 - 部分恢复原价处理（支持多批号）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handlePointsPromotionPartialRestore(
            plan,
            matchedConditionItems,
            repeatMultiple
        ) {
            console.log(`🎯 积分促销部分恢复原价处理 - 方案: ${plan.planName}`);
            // 分别处理增加积分和减少积分
            const totalAddPoint =
                this.safeNumber(plan.mzAddPoint, 0) * repeatMultiple;
            const totalReducePoint =
                this.safeNumber(plan.mzReducePoint, 0) * repeatMultiple;

            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                // 按条件商品处理部分恢复原价
                plan.conBgmList.forEach((conditionItem) => {
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                    );
                    if (matchingItems.length > 0) {
                        // 单品数量要求
                        const singleItemRequiredNum = this.safeNumber(conditionItem.num, 1);
                        // 根据重复倍数计算该商品需要恢复原价的总数量：单品数量要求 × 重复倍数
                        const totalRestoreNum = singleItemRequiredNum * repeatMultiple;

                        // 分别计算增加积分和减少积分的分配（只针对当前商品的批号）
                        const addPointsPerItem =
                            totalAddPoint > 0
                                ? this.distributePointsToItems(totalAddPoint, matchingItems)
                                : {};
                        const reducePointsPerItem =
                            totalReducePoint > 0
                                ? this.distributePointsToItems(totalReducePoint, matchingItems)
                                : {};

                        // 按条件数量依次分配恢复原价到该商品的各批号
                        this.distributePointsPromotionPartialRestoreQuantity(
                            matchingItems,
                            totalRestoreNum,
                            plan,
                            addPointsPerItem,
                            reducePointsPerItem,
                            repeatMultiple,
                            totalAddPoint,
                            totalReducePoint
                        );
                    }
                });
            }
        },
        /**
         * 为积分促销分配恢复原价数量到多个批号（全部恢复原价用）
         * @param {Array} allParticipatingItems - 所有参与的商品实例
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         * @param {Object} addPointsPerItem - 每个商品分配的增加积分
         * @param {Object} reducePointsPerItem - 每个商品分配的减少积分
         * @param {number} repeatMultiple - 重复倍数
         * @param {number} totalAddPoint - 总增加积分
         * @param {number} totalReducePoint - 总减少积分
         */
        distributePointsPromotionRestoreQuantity(
            allParticipatingItems,
            totalRestoreQuantity,
            plan,
            addPointsPerItem,
            reducePointsPerItem,
            repeatMultiple,
            totalAddPoint,
            totalReducePoint
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;
            allParticipatingItems.forEach((cartItem) => {
                // 使用分配给该商品实例的积分
                const itemKey = this.cartItems.indexOf(cartItem);
                const itemAddPoints = addPointsPerItem[itemKey] || 0;
                const itemReducePoints = reducePointsPerItem[itemKey] || 0;

                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格但仍需分配积分
                    const currentPrice = cartItem.changePrice || cartItem.price;
                    cartItem.changePrice = currentPrice;
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    this.setPointPromotionInfo(
                        cartItem,
                        plan,
                        itemAddPoints,
                        itemReducePoints,
                        repeatMultiple,
                        "积分促销保持当前价",
                        totalAddPoint,
                        totalReducePoint
                    );
                    this.setItemProperty(cartItem, "isDiscounted", true);

                    console.log(
                        `积分促销商品保持当前价 - 商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                        }), 当前价: ${currentPrice}, 增加积分: ${itemAddPoints}, 减少积分: ${itemReducePoints}`
                    );
                    return;
                }

                // 计算当前商品需要恢复的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;

                if (itemRestoreQuantity >= cartItem.quantity) {
                    // 该批号全部恢复原价
                    cartItem.changePrice = Number(cartItem.price);
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;
                    this.setPointPromotionInfo(
                        cartItem,
                        plan,
                        itemAddPoints,
                        itemReducePoints,
                        repeatMultiple,
                        "积分促销恢复原价",
                        totalAddPoint,
                        totalReducePoint
                    );
                    this.setItemProperty(cartItem, "isDiscounted", true);

                    console.log(
                        `积分促销商品全部恢复原价 - 商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                        }), 原价: ${cartItem.price
                        }, 增加积分: ${itemAddPoints}, 减少积分: ${itemReducePoints}`
                    );
                } else if (itemRestoreQuantity > 0) {
                    // 该批号部分恢复原价，使用混合价格
                    this.applyPointsPromotionMixedPriceRestoreForFull(
                        cartItem,
                        itemRestoreQuantity,
                        plan,
                        itemAddPoints,
                        itemReducePoints,
                        repeatMultiple,
                        totalAddPoint,
                        totalReducePoint
                    );
                }
            });
        },

        /**
         * 为积分促销应用混合价格恢复（全部恢复原价中的部分恢复）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         * @param {number} itemAddPoints - 该商品分配的增加积分
         * @param {number} itemReducePoints - 该商品分配的减少积分
         * @param {number} repeatMultiple - 重复倍数
         * @param {number} totalAddPoint - 总增加积分
         * @param {number} totalReducePoint - 总减少积分
         */
        applyPointsPromotionMixedPriceRestoreForFull(
            cartItem,
            restoreQuantity,
            plan,
            itemAddPoints,
            itemReducePoints,
            repeatMultiple,
            totalAddPoint,
            totalReducePoint
        ) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            const originalPrice = Number(cartItem.price);
            // 确定剩余部分应该使用的价格
            let remainingPrice;
            if (this.memberInfo.memId) {
                // 有会员：剩余部分使用会员价
                remainingPrice = cartItem.memberPrice || cartItem.price;
            } else {
                // 无会员：剩余部分使用当前价格（可能是促销价等）
                remainingPrice = cartItem.changePrice || cartItem.price;
            }

            // 计算混合价格
            const originalPriceAmount = originalPrice * restoreQuantity;
            const remainingPriceAmount = remainingPrice * remainingQuantity;
            const totalAmount = originalPriceAmount + remainingPriceAmount;
            const averagePrice = totalAmount / totalQuantity;

            cartItem.changePrice = Number(averagePrice.toFixed(9));
            cartItem.actualPrice = cartItem.changePrice;
            cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

            // 记录混合价格信息
            cartItem.mixedPriceInfo = {
                originalPriceNum: restoreQuantity,
                originalPrice: originalPrice,
                remainingPriceNum: remainingQuantity,
                remainingPrice: remainingPrice,
                isPointPromotion: true,
                addPoint: itemAddPoints,
                rePoint: itemReducePoints,
                repeatMultiple: repeatMultiple,
                totalAddPoint: totalAddPoint,
                totalReducePoint: totalReducePoint,
            };

            // 构建价格类型描述
            const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";

            this.setPointPromotionInfo(
                cartItem,
                plan,
                itemAddPoints,
                itemReducePoints,
                repeatMultiple,
                `积分促销恢复原价(${restoreQuantity}件原价+${remainingQuantity}件${priceTypeDesc})`,
                totalAddPoint,
                totalReducePoint
            );
            this.setItemProperty(cartItem, "isDiscounted", true);

            console.log(
                `积分促销商品混合价格 - 商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                }), 恢复原价数量: ${restoreQuantity}, 剩余数量: ${remainingQuantity}, 平均价格: ${averagePrice.toFixed(
                    9
                )}, 增加积分: ${itemAddPoints}, 减少积分: ${itemReducePoints}`
            );
        },

        /**
         * 为积分促销部分恢复原价分配数量到多个批号（使用混合价格）
         * @param {Array} cartItems - 同一商品的多个批号
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         * @param {Object} addPointsPerItem - 每个商品分配的增加积分
         * @param {Object} reducePointsPerItem - 每个商品分配的减少积分
         * @param {number} repeatMultiple - 重复倍数
         * @param {number} totalAddPoint - 总增加积分
         * @param {number} totalReducePoint - 总减少积分
         */
        distributePointsPromotionPartialRestoreQuantity(
            cartItems,
            totalRestoreQuantity,
            plan,
            addPointsPerItem,
            reducePointsPerItem,
            repeatMultiple,
            totalAddPoint,
            totalReducePoint
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;
            // 按顺序依次给多批号商品设置恢复原价
            cartItems.forEach((cartItem) => {
                // 使用分配给该商品实例的积分
                const itemKey = this.cartItems.indexOf(cartItem);
                const itemAddPoints = addPointsPerItem[itemKey] || 0;
                const itemReducePoints = reducePointsPerItem[itemKey] || 0;

                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格但仍需分配积分
                    let currentPrice;
                    if (this.memberInfo.memId) {
                        // 有会员：使用会员价
                        currentPrice = cartItem.memberPrice || cartItem.price;
                    } else {
                        // 无会员：使用当前价格（可能是促销价等）
                        currentPrice = cartItem.changePrice || cartItem.price;
                    }

                    cartItem.changePrice = Number(currentPrice.toFixed(9));
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    this.setPointPromotionInfo(
                        cartItem,
                        plan,
                        itemAddPoints,
                        itemReducePoints,
                        repeatMultiple,
                        "积分促销保持当前价",
                        totalAddPoint,
                        totalReducePoint
                    );
                    this.setItemProperty(cartItem, "isDiscounted", true);

                    console.log(
                        `积分促销商品保持当前价 - 商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                        }), 当前价: ${currentPrice}, 增加积分: ${itemAddPoints}, 减少积分: ${itemReducePoints}`
                    );
                    return;
                }

                // 计算该批号需要恢复原价的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;

                if (itemRestoreQuantity >= cartItem.quantity) {
                    // 该批号全部恢复原价
                    cartItem.changePrice = Number(cartItem.price);
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );
                    cartItem.mixedPriceInfo = null;

                    this.setPointPromotionInfo(
                        cartItem,
                        plan,
                        itemAddPoints,
                        itemReducePoints,
                        repeatMultiple,
                        "积分促销全部恢复原价",
                        totalAddPoint,
                        totalReducePoint
                    );
                    this.setItemProperty(cartItem, "isDiscounted", true);

                    console.log(
                        `积分促销商品全部恢复原价 - 商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                        }), 原价: ${cartItem.price
                        }, 增加积分: ${itemAddPoints}, 减少积分: ${itemReducePoints}`
                    );
                } else {
                    // 该批号部分恢复原价，使用混合价格
                    this.applyPointsPromotionMixedPriceRestoreForPartial(
                        cartItem,
                        itemRestoreQuantity,
                        plan,
                        itemAddPoints,
                        itemReducePoints,
                        repeatMultiple,
                        totalAddPoint,
                        totalReducePoint
                    );
                }
            });
        },

        /**
         * 为积分促销应用混合价格恢复（部分恢复原价用）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         * @param {number} itemAddPoints - 该商品分配的增加积分
         * @param {number} itemReducePoints - 该商品分配的减少积分
         * @param {number} repeatMultiple - 重复倍数
         * @param {number} totalAddPoint - 总增加积分
         * @param {number} totalReducePoint - 总减少积分
         */
        applyPointsPromotionMixedPriceRestoreForPartial(
            cartItem,
            restoreQuantity,
            plan,
            itemAddPoints,
            itemReducePoints,
            repeatMultiple,
            totalAddPoint,
            totalReducePoint
        ) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            const originalPrice = Number(cartItem.price);
            // 确定剩余部分应该使用的价格
            let remainingPrice;
            if (this.memberInfo.memId) {
                // 有会员：剩余部分使用会员价
                remainingPrice = cartItem.memberPrice || cartItem.price;
            } else {
                // 无会员：剩余部分使用当前价格（可能是促销价等）
                remainingPrice = cartItem.changePrice || cartItem.price;
            }

            // 计算混合价格
            const originalPriceAmount = originalPrice * restoreQuantity;
            const remainingPriceAmount = remainingPrice * remainingQuantity;
            const totalAmount = originalPriceAmount + remainingPriceAmount;
            const averagePrice = totalAmount / totalQuantity;

            cartItem.changePrice = Number(averagePrice.toFixed(9));
            cartItem.actualPrice = cartItem.changePrice;
            cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

            // 记录混合价格信息
            cartItem.mixedPriceInfo = {
                originalPriceNum: restoreQuantity,
                originalPrice: originalPrice,
                remainingPriceNum: remainingQuantity,
                remainingPrice: remainingPrice,
                isPointPromotion: true,
                addPoint: itemAddPoints,
                rePoint: itemReducePoints,
                repeatMultiple: repeatMultiple,
                totalAddPoint: totalAddPoint,
                totalReducePoint: totalReducePoint,
            };

            // 构建价格类型描述
            const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";

            this.setPointPromotionInfo(
                cartItem,
                plan,
                itemAddPoints,
                itemReducePoints,
                repeatMultiple,
                `积分促销部分恢复原价(${restoreQuantity}件原价+${remainingQuantity}件${priceTypeDesc})`,
                totalAddPoint,
                totalReducePoint
            );
            this.setItemProperty(cartItem, "isDiscounted", true);

            console.log(
                `积分促销商品部分恢复原价 - 商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                }), 恢复原价数量: ${restoreQuantity}, 剩余数量: ${remainingQuantity}, 平均价格: ${averagePrice.toFixed(
                    9
                )}, 增加积分: ${itemAddPoints}, 减少积分: ${itemReducePoints}`
            );
        },

        /**
         * 获取参与积分促销的商品列表
         * @param {Object} plan - 促销方案
         * @returns {Array} - 参与商品列表
         */
        getParticipatingItems(plan) {
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                const allItems = [];
                plan.planBgmIdList.forEach((bgmId) => {
                    // 查找所有匹配的商品（包括不同批号）
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === bgmId && !item.isGift
                    );
                    allItems.push(...matchingItems);
                });
                return allItems;
            }
            return [];
        },

        /**
         * 将总积分平分给参与商品（支持多批号）
         * @param {number} totalPoints - 总积分
         * @param {Array} participatingItems - 参与商品列表（包含所有批号）
         * @returns {Object} - 每个商品实例分配的积分映射（使用商品在购物车中的索引作为key）
         */
        distributePointsToItems(totalPoints, participatingItems) {
            if (!participatingItems || participatingItems.length === 0) {
                return {};
            }

            const pointsPerItem = {};
            const itemCount = participatingItems.length; // 这里是实际的商品实例数量（包括多批号）
            const basePoints = Math.floor(totalPoints / itemCount);
            const remainder = totalPoints % itemCount;

            console.log(
                `🔢 积分分配计算: 总积分=${totalPoints}, 商品实例数量=${itemCount}, 基础积分=${basePoints}, 余数=${remainder}`
            );

            // 给每个商品实例分配积分（包括同一商品的不同批号）
            let totalDistributed = 0;
            participatingItems.forEach((item, index) => {
                // 使用商品在购物车中的索引作为唯一标识
                const itemKey = this.cartItems.indexOf(item);
                pointsPerItem[itemKey] = basePoints;
                // 将余数分配给前几个商品实例
                if (index < remainder) {
                    pointsPerItem[itemKey] += 1;
                }
                totalDistributed += pointsPerItem[itemKey];
                console.log(
                    `   📦 ${item.bgmName} (批号: ${item.sterBatchno || "无"
                    }) -> 分配积分: ${pointsPerItem[itemKey]}`
                );
            });

            console.log(
                `✅ 积分分配完成: 总分配=${totalDistributed}, 原始总积分=${totalPoints}, 是否一致=${totalDistributed === totalPoints
                }`
            );

            return pointsPerItem;
        },
        /**
         * 设置积分促销信息
         */
        setPointPromotionInfo(
            item,
            plan,
            itemAddPoints,
            itemReducePoints,
            repeatMultiple,
            discountInfo,
            totalAddPoint = null,
            totalReducePoint = null
        ) {
            // 构建积分信息
            let pointInfo = "";
            if (itemAddPoints > 0 && itemReducePoints > 0) {
                pointInfo = `+${itemAddPoints}积分，-${itemReducePoints}积分`;
            } else if (itemAddPoints > 0) {
                pointInfo = `+${itemAddPoints}积分`;
            } else if (itemReducePoints > 0) {
                pointInfo = `-${itemReducePoints}积分`;
            }

            item.discountInfo = discountInfo.includes("：")
                ? discountInfo
                : `${plan.planName}：${discountInfo}${pointInfo}`;
            item.mzConType = plan.mzConType;
            item.mzGiftType = plan.mzGiftType;
            item.planType = plan.planType;
            item.isDiscounted = true;
            item.isPointPromotion = true;
            item.addPoint = itemAddPoints; // mzAddPoint 对应 addPoint
            item.rePoint = itemReducePoints; // mzReducePoint 对应 rePoint
            item.repeatMultiple = repeatMultiple;

            // 如果提供了总积分，也记录下来用于调试
            if (totalAddPoint !== null || totalReducePoint !== null) {
                item.totalPromotionPoints =
                    (totalAddPoint || 0) + (totalReducePoint || 0);
            }

            console.log(
                `商品 ${item.bgmName
                } 积分分配: 增加积分=${itemAddPoints}, 减少积分=${itemReducePoints}, 总增加积分=${totalAddPoint || "未提供"
                }, 总减少积分=${totalReducePoint || "未提供"}`
            );
        },

        /**
         * 处理最低价格促销
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handleLowestPricePromotion(plan, matchedConditionItems, repeatMultiple) {
            if (!plan.planBgmIdList || !Array.isArray(plan.planBgmIdList)) {
                console.log("没有指定需要应用最低价格的商品列表");
                return;
            }
            plan.planBgmIdList.forEach((bgmId) => {
                const item = this.cartItems.find((item) => item.bgmId === bgmId);
                if (item) {
                    const currentPrice = item.changePrice || item.price;
                    const lowestPrice = this.safeNumber(plan.mzCashBack, currentPrice);

                    // 只有当最低价格低于当前价格时才应用
                    if (lowestPrice < currentPrice) {
                        item.changePrice = Number(lowestPrice.toFixed(9));
                        item.actualPrice = item.changePrice;
                        item.amount = Number((item.changePrice * item.quantity).toFixed(9));

                        // 添加促销信息
                        item.discountInfo = `${plan.planName}：最低价格${lowestPrice}元`;
                        item.mzConType = plan.mzConType;
                        item.mzGiftType = plan.mzGiftType;
                        item.planType = plan.planType;
                        item.isDiscounted = true;

                        console.log(
                            `最低价格促销应用成功 - 商品: ${item.bgmName}, 原价: ${currentPrice}, 最低价: ${lowestPrice}`
                        );
                    } else {
                        console.log(
                            `商品 ${item.bgmName} 当前价格 ${currentPrice} 已低于或等于最低价格 ${lowestPrice}，无需调整`
                        );
                    }
                }
            });
        },

        // 子组件触发
        drawerCancel() {
            this.showStatus = false;
        },
        // 获取门店信息
        async getCurStoreInfo() {
            try {
                // 获取门店信息
                const storeRes = await this.$http.getCurStoreInfo();
                if (storeRes && storeRes.status === 200 && storeRes.result) {
                    this.cashdeskList = storeRes.result.cashdeskList || [];
                    this.bcCode = storeRes.result.bcCode;
                    console.log(this.cashdeskList, "this.cashdeskList");
                    if (this.cashdeskList.length === 1) {
                        // 只有一个收款台，直接赋值并聚焦销售员
                        const desk = this.cashdeskList[0];
                        this.memberInfo.deskCode = desk.deskCode;
                        this.memberInfo.deskId = desk.deskId;
                        this.memberInfo.isSmall = desk.isSmall;
                        this.$nextTick(() => {
                            if (this.$refs.salesPersonSelect) {
                                this.$refs.salesPersonSelect.focus();
                            }
                        });
                    } else if (this.cashdeskList.length > 1) {
                        // 多个收款台，弹窗选择
                        this.deskSelectDialogVisible = true;
                    }
                    this.storeId = storeRes.result.store.storeId;
                    this.scanCode = storeRes.result.store.scanCode;
                    this.memberInfo.storeName = storeRes.result.store.storeName;
                    this.autoPrint = storeRes.result.store.autoPrint;
                    this.skPrint = storeRes.result.store.skPrint;
                    this.hjPrint = storeRes.result.store.hjPrint;
                    this.jbPrint = storeRes.result.store.jbPrint;
                    this.autoPayMoney = storeRes.result.store.autoPayMoney || 0;
                    this.isChangePriceCheck = storeRes.result.store.isChangePriceCheck
                    // 获取销售员列表
                    if (
                        storeRes.result.salesPersonList &&
                        storeRes.result.salesPersonList.length > 0
                    ) {
                        this.salesPersonList = storeRes.result.salesPersonList;
                        this.memberInfo.salesPersonName = this.salesPersonList[0].opmName;
                        this.memberInfo.salesPerson = this.salesPersonList[0].opmId;
                        // 默认选择第一个销售员
                        this.storemastgetLaseSalesPerson()
                        this.previousSalesPerson = this.memberInfo.salesPersonName; // 初始化记录
                        // this.memberInfo.cashier = this.salesPersonList[0].opmName;

                        var info = sessionStorage.getItem("userInfo");
                        // this.memberInfo.salesPerson = JSON.parse(info).opmId;
                        this.memberInfo.cashier = JSON.parse(info).opmName;
                        // 销售员列表加载完成后，聚焦到销售员选择框
                        this.$nextTick(() => {
                            if (this.$refs.salesPersonSelect) {
                                this.$refs.salesPersonSelect.focus();
                            }
                        });
                    }
                    // 获取医师列表
                    if (
                        storeRes.result.docterList &&
                        storeRes.result.docterList.length > 0
                    ) {
                        this.doctorList = storeRes.result.docterList;
                        console.log(this.doctorList, "this.doctorList");
                        // 初始为空，不默认选择
                        this.memberInfo.doctor = "";
                    }
                    // 获取药师列表
                    if (
                        storeRes.result.pharmacistList &&
                        storeRes.result.pharmacistList.length > 0
                    ) {
                        this.pharmacistList = storeRes.result.pharmacistList;
                        console.log(this.pharmacistList, "this.pharmacistList");
                        // 初始为空，不默认选择
                        this.memberInfo.pharmacist = "";
                    }
                } else {
                    this.$message.error(storeRes.message);
                    setTimeout(() => {
                        this.onExit();
                    }, 1500);
                }
            } catch (error) {
                this.$message.error("获取门店信息失败");
            }
        },
        // 合并买赠促销中的条件商品显示
        mergePromotionItems(plan, matchedConditionItems, processType) {
            if (!matchedConditionItems || matchedConditionItems.length === 0) {
                console.log("没有匹配的条件商品需要合并");
                return;
            }
            let mzIsRepeatNum = this.calculateRepeatMultiple(plan);
            // 分别计算增加积分和减少积分的总数
            const totalAddPoint = (plan.mzAddPoint || 0) * mzIsRepeatNum;
            const totalReducePoint = (plan.mzReducePoint || 0) * mzIsRepeatNum;
            // 收集所有需要分配积分的商品
            const allParticipatingItems = [];
            matchedConditionItems.forEach((matchedItem) => {
                const cartItems = matchedItem.cartItems;
                allParticipatingItems.push(...cartItems);
            });
            // 分别分配增加积分和减少积分
            const addPointsPerItem =
                totalAddPoint > 0
                    ? this.distributePointsToItems(totalAddPoint, allParticipatingItems)
                    : {};
            const reducePointsPerItem =
                totalReducePoint > 0
                    ? this.distributePointsToItems(
                        totalReducePoint,
                        allParticipatingItems
                    )
                    : {};

            if (processType === "恢复原价") {
                // 全部恢复原价：按条件数量和重复倍数来处理
                this.handleMergePromotionRestoreOriginal(
                    plan,
                    matchedConditionItems,
                    addPointsPerItem,
                    reducePointsPerItem,
                    mzIsRepeatNum,
                    totalAddPoint,
                    totalReducePoint
                );
            } else if (processType === "部分恢复原价") {
                // 部分恢复原价：按单品数量要求恢复原价，考虑重复赠送
                this.handleMergePromotionPartialRestore(
                    plan,
                    matchedConditionItems,
                    addPointsPerItem,
                    reducePointsPerItem,
                    mzIsRepeatNum,
                    totalAddPoint,
                    totalReducePoint
                );
            } else {
                // 保持现状或其他处理类型
                this.handleMergePromotionKeepCurrent(
                    plan,
                    matchedConditionItems,
                    addPointsPerItem,
                    reducePointsPerItem,
                    processType,
                    totalAddPoint,
                    totalReducePoint
                );
            }

            // 商品处理完成，不需要合并
            console.log("买赠促销商品处理完成，保持各批号独立性");
        },

        /**
         * 买赠促销 - 恢复原价处理（按条件数量和重复倍数）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {Object} addPointsPerItem - 增加积分分配
         * @param {Object} reducePointsPerItem - 减少积分分配
         * @param {number} mzIsRepeatNum - 重复倍数
         * @param {number} totalAddPoint - 总增加积分
         * @param {number} totalReducePoint - 总减少积分
         */
        handleMergePromotionRestoreOriginal(
            plan,
            matchedConditionItems,
            addPointsPerItem,
            reducePointsPerItem,
            mzIsRepeatNum,
            totalAddPoint,
            totalReducePoint
        ) {
            console.log(`🔄 买赠促销恢复原价处理 - 方案: ${plan.planName}`);
            // 计算需要恢复原价的总数量
            const conditionNum = this.safeNumber(plan.mzConBgmNum, 1);
            const totalRestoreQuantity = conditionNum * mzIsRepeatNum;

            console.log(
                `📊 条件数量要求: ${conditionNum}, 重复倍数: ${mzIsRepeatNum}, 需要恢复原价数量: ${totalRestoreQuantity}`
            );

            // 收集所有参与的商品实例
            const allParticipatingItems = [];
            matchedConditionItems.forEach((matchedItem) => {
                allParticipatingItems.push(...matchedItem.cartItems);
            });

            console.log(`🛒 参与商品总数: ${allParticipatingItems.length}`);
            allParticipatingItems.forEach((item, index) => {
                console.log(
                    `   ${index + 1}. ${item.bgmName} (批号: ${item.sterBatchno || "无"
                    }) - 数量: ${item.quantity}`
                );
            });

            // 按条件数量依次恢复原价
            let remainingRestoreQuantity = totalRestoreQuantity;

            allParticipatingItems.forEach((cartItem, index) => {
                const itemKey = this.cartItems.indexOf(cartItem);
                const itemAddPoints = addPointsPerItem[itemKey] || 0;
                const itemReducePoints = reducePointsPerItem[itemKey] || 0;

                // 设置积分属性
                this.setItemProperty(cartItem, "addPoint", itemAddPoints);
                this.setItemProperty(cartItem, "rePoint", itemReducePoints);
                this.setItemProperty(cartItem, "mzConType", plan.mzConType);
                this.setItemProperty(cartItem, "mzGiftType", plan.mzGiftType);
                this.setItemProperty(cartItem, "planType", plan.planType);

                if (cartItem && !cartItem.isGift) {
                    const originalPrice = Number(cartItem.price);
                    const discountPrice = cartItem.changePrice || cartItem.price;

                    // 计算当前商品需要恢复原价的数量
                    const itemRestoreQuantity = Math.min(
                        remainingRestoreQuantity,
                        cartItem.quantity
                    );
                    remainingRestoreQuantity -= itemRestoreQuantity;

                    console.log(
                        `   📦 处理商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                        })`
                    );
                    console.log(
                        `      商品数量: ${cartItem.quantity}, 恢复数量: ${itemRestoreQuantity}, 剩余待恢复: ${remainingRestoreQuantity}`
                    );

                    if (itemRestoreQuantity >= cartItem.quantity) {
                        // 该批号全部恢复原价
                        cartItem.changePrice = originalPrice;
                        cartItem.actualPrice = cartItem.changePrice;
                        cartItem.amount = Number(
                            this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                        );

                        let pointInfo = this.getPointInfo(itemAddPoints, itemReducePoints);
                        cartItem.discountInfo = pointInfo
                            ? `${plan.planName}：满赠恢复原价(${pointInfo})`
                            : `${plan.planName}：满赠恢复原价`;

                        console.log(`      ✅ 全部恢复原价: ${originalPrice}元`);
                    } else if (itemRestoreQuantity > 0) {
                        // 该批号部分恢复原价，使用混合价格
                        this.applyMixedPricingForMergePromotion(
                            cartItem,
                            originalPrice,
                            discountPrice,
                            itemRestoreQuantity,
                            plan,
                            itemAddPoints,
                            itemReducePoints
                        );
                        console.log(
                            `      📊 混合价格: ${itemRestoreQuantity}件恢复原价，${cartItem.quantity - itemRestoreQuantity
                            }件保持优惠价`
                        );
                    } else {
                        // 该批号保持优惠价
                        cartItem.changePrice = discountPrice;
                        cartItem.actualPrice = cartItem.changePrice;
                        cartItem.amount = Number(
                            this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                        );

                        let pointInfo = this.getPointInfo(itemAddPoints, itemReducePoints);
                        cartItem.discountInfo = pointInfo
                            ? `${plan.planName}：满赠保持优惠价(${pointInfo})`
                            : `${plan.planName}：满赠保持优惠价`;

                        console.log(`      ⏸️ 保持优惠价: ${discountPrice}元`);
                    }

                    this.setItemProperty(cartItem, "isDiscounted", true);
                }
            });

            console.log(
                `✅ 买赠促销恢复原价处理完成，剩余未恢复数量: ${remainingRestoreQuantity}`
            );
        },

        /**
         * 买赠促销 - 部分恢复原价处理（按单品数量要求和重复倍数）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {Object} addPointsPerItem - 增加积分分配
         * @param {Object} reducePointsPerItem - 减少积分分配
         * @param {number} mzIsRepeatNum - 重复倍数
         * @param {number} totalAddPoint - 总增加积分
         * @param {number} totalReducePoint - 总减少积分
         */
        handleMergePromotionPartialRestore(
            plan,
            matchedConditionItems,
            addPointsPerItem,
            reducePointsPerItem,
            mzIsRepeatNum,
            totalAddPoint,
            totalReducePoint
        ) {
            console.log(`🔄 买赠促销部分恢复原价处理 - 方案: ${plan.planName}`);
            console.log(`📊 重复倍数: ${mzIsRepeatNum}`);

            // 如果有条件商品列表，按条件商品处理
            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                plan.conBgmList.forEach((conditionItem) => {
                    // 查找所有匹配的商品（包括不同批号）
                    const matchingItems = matchedConditionItems.find(
                        (item) => item.conditionItem.bgmId === conditionItem.bgmId
                    );

                    if (matchingItems && matchingItems.cartItems.length > 0) {
                        const cartItems = matchingItems.cartItems;

                        // 单品数量要求
                        const singleItemRequiredNum = this.safeNumber(conditionItem.num, 1);

                        // 根据重复倍数计算该商品需要恢复原价的总数量：单品数量要求 × 重复倍数
                        const totalRestoreNum = singleItemRequiredNum * mzIsRepeatNum;

                        // 计算该商品所有批号的总数量
                        const totalItemQuantity = cartItems.reduce(
                            (sum, item) => sum + item.quantity,
                            0
                        );

                        console.log(`🔄 处理商品: ${cartItems}`);
                        console.log(
                            `📊 单品要求: ${singleItemRequiredNum}, 重复倍数: ${mzIsRepeatNum}, 需要恢复数量: ${totalRestoreNum}`
                        );
                        console.log(
                            `🛒 该商品批号数量: ${cartItems.length}, 总数量: ${totalItemQuantity}`
                        );

                        // 按条件数量依次分配恢复原价到该商品的各批号
                        this.distributeMergePromotionPartialRestoreQuantity(
                            cartItems,
                            totalRestoreNum,
                            plan,
                            addPointsPerItem,
                            reducePointsPerItem
                        );
                    }
                });
            }

            console.log(`✅ 买赠促销部分恢复原价处理完成`);
        },

        /**
         * 为买赠促销部分恢复原价分配数量到多个批号（使用混合价格）
         * @param {Array} cartItems - 同一商品的多个批号
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         * @param {Object} addPointsPerItem - 增加积分分配
         * @param {Object} reducePointsPerItem - 减少积分分配
         */
        distributeMergePromotionPartialRestoreQuantity(
            cartItems,
            totalRestoreQuantity,
            plan,
            addPointsPerItem,
            reducePointsPerItem
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;
            console.log(
                `🔄 开始分配部分恢复原价数量: 总需要恢复=${totalRestoreQuantity}`
            );

            // 按顺序依次给多批号商品设置恢复原价
            cartItems.forEach((cartItem) => {
                const itemKey = this.cartItems.indexOf(cartItem);
                const itemAddPoints = addPointsPerItem[itemKey] || 0;
                const itemReducePoints = reducePointsPerItem[itemKey] || 0;

                // 设置积分属性
                this.setItemProperty(cartItem, "addPoint", itemAddPoints);
                this.setItemProperty(cartItem, "rePoint", itemReducePoints);
                this.setItemProperty(cartItem, "mzConType", plan.mzConType);
                this.setItemProperty(cartItem, "mzGiftType", plan.mzGiftType);
                this.setItemProperty(cartItem, "planType", plan.planType);

                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格
                    // 确定当前应该使用的价格：优先使用会员价或促销价，而不是原价
                    let currentPrice;
                    if (this.memberInfo.memId) {
                        // 有会员：使用会员价
                        currentPrice = cartItem.memberPrice || cartItem.price;
                    } else {
                        // 无会员：使用当前价格（可能是促销价等）
                        currentPrice = cartItem.changePrice || cartItem.price;
                    }

                    cartItem.changePrice = currentPrice;
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );

                    let pointInfo = this.getPointInfo(itemAddPoints, itemReducePoints);
                    const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                    cartItem.discountInfo = pointInfo
                        ? `${plan.planName}：满赠保持${priceTypeDesc}(${pointInfo})`
                        : `${plan.planName}：满赠保持${priceTypeDesc}`;

                    cartItem.mixedPriceInfo = null;
                    this.setItemProperty(cartItem, "isDiscounted", true);
                    return;
                }

                // 计算当前批号需要恢复的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;

                console.log(
                    `   📦 ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                    }) - 商品数量: ${cartItem.quantity}, 恢复数量: ${itemRestoreQuantity}`
                );

                // 应用混合价格恢复原价
                this.applyMergePromotionMixedPriceRestore(
                    cartItem,
                    itemRestoreQuantity,
                    plan,
                    itemAddPoints,
                    itemReducePoints
                );
            });

            console.log(
                `✅ 部分恢复原价数量分配完成，剩余未分配: ${remainingRestoreQuantity}`
            );
        },

        /**
         * 为买赠促销应用混合价格恢复（部分恢复原价）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         * @param {number} itemAddPoints - 增加积分
         * @param {number} itemReducePoints - 减少积分
         */
        applyMergePromotionMixedPriceRestore(
            cartItem,
            restoreQuantity,
            plan,
            itemAddPoints,
            itemReducePoints
        ) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            if (restoreQuantity >= totalQuantity) {
                // 该批号全部恢复原价
                cartItem.changePrice = Number(cartItem.price);
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(
                    this.$common.getDecimalInfo(3, cartItem.changePrice * totalQuantity)
                );
                let pointInfo = this.getPointInfo(itemAddPoints, itemReducePoints);
                cartItem.discountInfo = pointInfo
                    ? `${plan.planName}：满赠部分恢复原价(全部,${pointInfo})`
                    : `${plan.planName}：满赠部分恢复原价(全部)`;
                cartItem.mixedPriceInfo = null;
            } else if (restoreQuantity > 0) {
                // 该批号部分恢复原价，计算混合价格
                const originalPrice = Number(cartItem.price);

                // 确定剩余部分应该使用的价格
                let remainingPrice;
                if (this.memberInfo.memId) {
                    // 有会员：剩余部分使用会员价
                    remainingPrice = cartItem.memberPrice || cartItem.price;
                } else {
                    // 无会员：剩余部分使用当前价格（可能是促销价等）
                    remainingPrice = cartItem.changePrice || cartItem.price;
                }

                // 计算混合价格：(原价×恢复数量 + 剩余价格×剩余数量) / 总数量
                const totalAmount =
                    originalPrice * restoreQuantity + remainingPrice * remainingQuantity;
                const averagePrice = totalAmount / totalQuantity;

                cartItem.changePrice = Number(averagePrice.toFixed(9));
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

                // 记录混合价格信息
                cartItem.mixedPriceInfo = {
                    restoreQuantity: restoreQuantity,
                    restorePrice: originalPrice,
                    remainingQuantity: remainingQuantity,
                    remainingPrice: remainingPrice,
                    averagePrice: averagePrice,
                };
                let pointInfo = this.getPointInfo(itemAddPoints, itemReducePoints);
                const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                cartItem.discountInfo = pointInfo
                    ? `${plan.planName}：满赠部分恢复原价(${restoreQuantity}件原价+${remainingQuantity}件${priceTypeDesc},${pointInfo})`
                    : `${plan.planName}：满赠部分恢复原价(${restoreQuantity}件原价+${remainingQuantity}件${priceTypeDesc})`;
            } else {
                // 该批号不恢复原价，保持当前价格
                let currentPrice;
                if (this.memberInfo.memId) {
                    // 有会员：使用会员价
                    currentPrice = cartItem.memberPrice || cartItem.price;
                } else {
                    // 无会员：使用当前价格（可能是促销价等）
                    currentPrice = cartItem.changePrice || cartItem.price;
                }

                cartItem.changePrice = currentPrice;
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(
                    this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                );

                let pointInfo = this.getPointInfo(itemAddPoints, itemReducePoints);
                const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                cartItem.discountInfo = pointInfo
                    ? `${plan.planName}：满赠保持${priceTypeDesc}(${pointInfo})`
                    : `${plan.planName}：满赠保持${priceTypeDesc}`;

                cartItem.mixedPriceInfo = null;
            }

            this.setItemProperty(cartItem, "isDiscounted", true);
        },

        /**
         * 优惠券促销 - 保持现状处理（支持多批号）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handleCouponPromotionKeepCurrent(
            plan,
            matchedConditionItems,
            repeatMultiple
        ) {
            console.log(`🎫 优惠券促销保持现状处理 - 方案: ${plan.planName}`);

            // 处理积分（如果有）
            if (plan.mzAddPoint || plan.mzReducePoint) {
                this.handlePointsPromotion(plan, matchedConditionItems, repeatMultiple);
            }

            // 处理价格：保持当前价格，支持多批号
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                const participatingItems = this.getParticipatingItems(plan);

                participatingItems.forEach((cartItem) => {
                    // 确定当前应该使用的价格
                    let currentPrice;
                    if (this.memberInfo.memId) {
                        // 有会员：使用会员价
                        currentPrice = cartItem.memberPrice || cartItem.price;
                    } else {
                        // 无会员：使用当前价格（可能是促销价等）
                        currentPrice = cartItem.changePrice || cartItem.price;
                    }

                    cartItem.changePrice = currentPrice;
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );

                    const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                    cartItem.discountInfo = `${plan.planName}：优惠券促销保持${priceTypeDesc}`;

                    this.setItemProperty(cartItem, "isDiscounted", true);
                    console.log(
                        `   📦 ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                        }) - 保持${priceTypeDesc}: ${currentPrice}元`
                    );
                });
            }
        },

        /**
         * 优惠券促销 - 全部恢复原价处理（支持多批号，参考满赠做法）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handleCouponPromotionRestoreOriginal(
            plan,
            matchedConditionItems,
            repeatMultiple
        ) {
            console.log(`🎫 优惠券促销全部恢复原价处理 - 方案: ${plan.planName}`);

            // 处理积分（如果有）
            if (plan.mzAddPoint || plan.mzReducePoint) {
                this.handlePointsPromotion(plan, matchedConditionItems, repeatMultiple);
            }

            // 计算需要恢复原价的总数量（参考满赠做法）
            const conditionNum = this.safeNumber(plan.mzConBgmNum, 1);
            const totalRestoreQuantity = conditionNum * repeatMultiple;

            console.log(`🔄 优惠券促销恢复原价处理:`);
            console.log(
                `   📊 条件数量要求: ${conditionNum}, 重复倍数: ${repeatMultiple}`
            );
            console.log(`   📊 需要恢复原价数量: ${totalRestoreQuantity}`);

            // 收集所有参与的商品实例
            const allParticipatingItems = [];
            matchedConditionItems.forEach((matchedItem) => {
                allParticipatingItems.push(...matchedItem.cartItems);
            });

            // 计算所有参与商品的总数量
            const totalParticipatingQuantity = allParticipatingItems.reduce(
                (sum, item) => sum + item.quantity,
                0
            );

            console.log(
                `🛒 参与商品总数: ${allParticipatingItems.length}, 总数量: ${totalParticipatingQuantity}`
            );
            allParticipatingItems.forEach((item, index) => {
                console.log(
                    `   ${index + 1}. ${item.bgmName} (批号: ${item.sterBatchno || "无"
                    }) - 数量: ${item.quantity}`
                );
            });

            if (totalRestoreQuantity >= totalParticipatingQuantity) {
                // 需要恢复的数量 >= 商品总数，所有商品都恢复原价
                console.log("📈 需要恢复的数量超过商品总数，所有商品都恢复原价");
                allParticipatingItems.forEach((cartItem) => {
                    const originalPrice = Number(cartItem.price);

                    cartItem.changePrice = originalPrice;
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );

                    cartItem.discountInfo = `${plan.planName}：优惠券促销恢复原价(条件${conditionNum}×${repeatMultiple}倍)`;

                    this.setItemProperty(cartItem, "isDiscounted", true);
                    console.log(
                        `   📦 ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                        }) - 恢复原价: ${originalPrice}元`
                    );
                });
            } else {
                // 需要恢复的数量 < 商品总数，按数量分配恢复原价
                console.log(
                    `📊 按条件数量恢复原价，分配${totalRestoreQuantity}件到各批号`
                );
                this.distributeCouponPromotionRestoreQuantity(
                    allParticipatingItems,
                    totalRestoreQuantity,
                    plan,
                    repeatMultiple
                );
            }
        },

        /**
         * 为优惠券促销分配恢复原价数量到多个批号（全部恢复原价用）
         * @param {Array} allParticipatingItems - 所有参与的商品实例
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         * @param {number} repeatMultiple - 重复倍数
         */
        distributeCouponPromotionRestoreQuantity(
            allParticipatingItems,
            totalRestoreQuantity,
            plan,
            repeatMultiple
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;
            console.log(
                `🔄 开始分配优惠券促销恢复原价数量: 总需要恢复=${totalRestoreQuantity}`
            );

            // 按顺序分配恢复数量到各个批号
            allParticipatingItems.forEach((cartItem) => {
                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格
                    let currentPrice;
                    if (this.memberInfo.memId) {
                        // 有会员：使用会员价
                        currentPrice = cartItem.memberPrice || cartItem.price;
                    } else {
                        // 无会员：使用当前价格（可能是促销价等）
                        currentPrice = cartItem.changePrice || cartItem.price;
                    }

                    cartItem.changePrice = currentPrice;
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );

                    const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                    cartItem.discountInfo = `${plan.planName}：优惠券促销保持${priceTypeDesc}`;

                    cartItem.mixedPriceInfo = null;
                    this.setItemProperty(cartItem, "isDiscounted", true);
                    console.log(
                        `   📦 ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                        }) - 保持${priceTypeDesc}: ${currentPrice}元`
                    );
                    return;
                }

                // 计算当前商品需要恢复的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;

                if (itemRestoreQuantity >= cartItem.quantity) {
                    // 该批号全部恢复原价
                    cartItem.changePrice = Number(cartItem.price);
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );
                    cartItem.discountInfo = `${plan.planName}：优惠券促销恢复原价`;
                    cartItem.mixedPriceInfo = null;
                    this.setItemProperty(cartItem, "isDiscounted", true);
                } else if (itemRestoreQuantity > 0) {
                    // 该批号部分恢复原价，使用混合价格
                    this.applyCouponPromotionMixedPriceRestoreForFull(
                        cartItem,
                        itemRestoreQuantity,
                        plan
                    );
                }
            });
        },

        /**
         * 为优惠券促销应用混合价格恢复（全部恢复原价中的部分恢复）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         */
        applyCouponPromotionMixedPriceRestoreForFull(
            cartItem,
            restoreQuantity,
            plan
        ) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            const originalPrice = Number(cartItem.price);

            // 确定剩余部分应该使用的价格
            let remainingPrice;
            if (this.memberInfo.memId) {
                // 有会员：剩余部分使用会员价
                remainingPrice = cartItem.memberPrice || cartItem.price;
            } else {
                // 无会员：剩余部分使用当前价格（可能是促销价等）
                remainingPrice = cartItem.changePrice || cartItem.price;
            }

            // 计算混合价格：(原价×恢复数量 + 剩余价格×剩余数量) / 总数量
            const totalAmount =
                originalPrice * restoreQuantity + remainingPrice * remainingQuantity;
            const averagePrice = totalAmount / totalQuantity;

            cartItem.changePrice = Number(averagePrice.toFixed(9));
            cartItem.actualPrice = cartItem.changePrice;
            cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

            // 记录混合价格信息
            cartItem.mixedPriceInfo = {
                restoreQuantity: restoreQuantity,
                restorePrice: originalPrice,
                remainingQuantity: remainingQuantity,
                remainingPrice: remainingPrice,
                averagePrice: averagePrice,
            };
            const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
            cartItem.discountInfo = `${plan.planName}：优惠券促销恢复原价(${restoreQuantity}件原价+${remainingQuantity}件${priceTypeDesc})`;
            this.setItemProperty(cartItem, "isDiscounted", true);
        },

        /**
         * 优惠券促销 - 部分恢复原价处理（支持多批号）
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {number} repeatMultiple - 重复倍数
         */
        handleCouponPromotionPartialRestore(
            plan,
            matchedConditionItems,
            repeatMultiple
        ) {
            console.log(`🎫 优惠券促销部分恢复原价处理 - 方案: ${plan.planName}`);
            console.log(`📊 重复倍数: ${repeatMultiple}`);

            // 处理积分（如果有）
            if (plan.mzAddPoint || plan.mzReducePoint) {
                this.handlePointsPromotion(plan, matchedConditionItems, repeatMultiple);
            }

            // 处理价格：部分恢复原价，支持多批号
            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                plan.conBgmList.forEach((conditionItem) => {
                    // 查找所有匹配的商品（包括不同批号）
                    const matchingItems = this.cartItems.filter(
                        (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                    );

                    if (matchingItems.length > 0) {
                        // 单品数量要求
                        const singleItemRequiredNum = this.safeNumber(conditionItem.num, 1);

                        // 根据重复倍数计算该商品需要恢复原价的总数量：单品数量要求 × 重复倍数
                        const totalRestoreNum = singleItemRequiredNum * repeatMultiple;

                        // 计算该商品所有批号的总数量
                        const totalItemQuantity = matchingItems.reduce(
                            (sum, item) => sum + item.quantity,
                            0
                        );
                        console.log(`🔄 处理商品: ${matchingItems[0].bgmName}`);
                        console.log(
                            `📊 单品要求: ${singleItemRequiredNum}, 重复倍数: ${repeatMultiple}, 需要恢复数量: ${totalRestoreNum}`
                        );
                        console.log(
                            `🛒 该商品批号数量: ${matchingItems.length}, 总数量: ${totalItemQuantity}`
                        );

                        // 按条件数量依次分配恢复原价到该商品的各批号
                        this.distributeCouponPromotionPartialRestoreQuantity(
                            matchingItems,
                            totalRestoreNum,
                            plan
                        );
                    }
                });
            }

            console.log(`✅ 优惠券促销部分恢复原价处理完成`);
        },

        /**
         * 为优惠券促销部分恢复原价分配数量到多个批号（使用混合价格）
         * @param {Array} cartItems - 同一商品的多个批号
         * @param {number} totalRestoreQuantity - 需要恢复原价的总数量
         * @param {Object} plan - 促销方案
         */
        distributeCouponPromotionPartialRestoreQuantity(
            cartItems,
            totalRestoreQuantity,
            plan
        ) {
            let remainingRestoreQuantity = totalRestoreQuantity;
            // 按顺序依次给多批号商品设置恢复原价
            cartItems.forEach((cartItem) => {
                if (remainingRestoreQuantity <= 0) {
                    // 没有剩余恢复数量，该批号保持当前价格
                    let currentPrice;
                    if (this.memberInfo.memId) {
                        // 有会员：使用会员价
                        currentPrice = cartItem.memberPrice || cartItem.price;
                    } else {
                        // 无会员：使用当前价格（可能是促销价等）
                        currentPrice = cartItem.changePrice || cartItem.price;
                    }
                    cartItem.changePrice = currentPrice;
                    cartItem.actualPrice = cartItem.changePrice;
                    cartItem.amount = Number(
                        this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                    );
                    const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                    cartItem.discountInfo = `${plan.planName}：优惠券促销保持${priceTypeDesc}`;
                    cartItem.mixedPriceInfo = null;
                    this.setItemProperty(cartItem, "isDiscounted", true);
                    return;
                }

                // 计算当前批号需要恢复的数量
                const itemRestoreQuantity = Math.min(
                    remainingRestoreQuantity,
                    cartItem.quantity
                );
                remainingRestoreQuantity -= itemRestoreQuantity;
                // 应用混合价格恢复原价
                this.applyCouponPromotionMixedPriceRestore(
                    cartItem,
                    itemRestoreQuantity,
                    plan
                );
            });

            console.log(
                `✅ 优惠券促销部分恢复原价数量分配完成，剩余未分配: ${remainingRestoreQuantity}`
            );
        },

        /**
         * 为优惠券促销应用混合价格恢复（部分恢复原价）
         * @param {Object} cartItem - 购物车商品
         * @param {number} restoreQuantity - 需要恢复原价的数量
         * @param {Object} plan - 促销方案
         */
        applyCouponPromotionMixedPriceRestore(cartItem, restoreQuantity, plan) {
            const totalQuantity = cartItem.quantity;
            const remainingQuantity = totalQuantity - restoreQuantity;
            if (restoreQuantity >= totalQuantity) {
                // 该批号全部恢复原价
                cartItem.changePrice = Number(cartItem.price);
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(
                    this.$common.getDecimalInfo(3, cartItem.changePrice * totalQuantity)
                );

                cartItem.discountInfo = `${plan.planName}：优惠券促销部分恢复原价(全部)`;

                cartItem.mixedPriceInfo = null;
                console.log(`      ✅ 该批号全部恢复原价: ${cartItem.price}元`);
            } else if (restoreQuantity > 0) {
                // 该批号部分恢复原价，计算混合价格
                const originalPrice = Number(cartItem.price);

                // 确定剩余部分应该使用的价格
                let remainingPrice;
                if (this.memberInfo.memId) {
                    // 有会员：剩余部分使用会员价
                    remainingPrice = cartItem.memberPrice || cartItem.price;
                } else {
                    // 无会员：剩余部分使用当前价格（可能是促销价等）
                    remainingPrice = cartItem.changePrice || cartItem.price;
                }

                // 计算混合价格：(原价×恢复数量 + 剩余价格×剩余数量) / 总数量
                const totalAmount =
                    originalPrice * restoreQuantity + remainingPrice * remainingQuantity;
                const averagePrice = totalAmount / totalQuantity;

                cartItem.changePrice = Number(averagePrice.toFixed(9));
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

                // 记录混合价格信息
                cartItem.mixedPriceInfo = {
                    restoreQuantity: restoreQuantity,
                    restorePrice: originalPrice,
                    remainingQuantity: remainingQuantity,
                    remainingPrice: remainingPrice,
                    averagePrice: averagePrice,
                };

                const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                cartItem.discountInfo = `${plan.planName}：优惠券促销部分恢复原价(${restoreQuantity}件原价+${remainingQuantity}件${priceTypeDesc})`;
            } else {
                // 该批号不恢复原价，保持当前价格
                let currentPrice;
                if (this.memberInfo.memId) {
                    // 有会员：使用会员价
                    currentPrice = cartItem.memberPrice || cartItem.price;
                } else {
                    // 无会员：使用当前价格（可能是促销价等）
                    currentPrice = cartItem.changePrice || cartItem.price;
                }
                cartItem.changePrice = currentPrice;
                cartItem.actualPrice = cartItem.changePrice;
                cartItem.amount = Number(
                    this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                );
                const priceTypeDesc = this.memberInfo.memId ? "会员价" : "当前价";
                cartItem.discountInfo = `${plan.planName}：优惠券促销保持${priceTypeDesc}`;
                cartItem.mixedPriceInfo = null;
            }
            this.setItemProperty(cartItem, "isDiscounted", true);
        },

        /**
         * 买赠促销 - 保持现状处理
         * @param {Object} plan - 促销方案
         * @param {Array} matchedConditionItems - 匹配的条件商品
         * @param {Object} addPointsPerItem - 增加积分分配
         * @param {Object} reducePointsPerItem - 减少积分分配
         * @param {string} processType - 处理类型
         * @param {number} totalAddPoint - 总增加积分
         * @param {number} totalReducePoint - 总减少积分
         */
        handleMergePromotionKeepCurrent(
            plan,
            matchedConditionItems,
            addPointsPerItem,
            reducePointsPerItem,
            processType,
            totalAddPoint,
            totalReducePoint
        ) {
            console.log(
                `🔄 买赠促销保持现状处理 - 方案: ${plan.planName}, 处理类型: ${processType}`
            );
            matchedConditionItems.forEach((matchedItem) => {
                const cartItems = matchedItem.cartItems;

                cartItems.forEach((cartItem) => {
                    const itemKey = this.cartItems.indexOf(cartItem);
                    const itemAddPoints = addPointsPerItem[itemKey] || 0;
                    const itemReducePoints = reducePointsPerItem[itemKey] || 0;

                    // 设置积分属性
                    this.setItemProperty(cartItem, "addPoint", itemAddPoints);
                    this.setItemProperty(cartItem, "rePoint", itemReducePoints);
                    this.setItemProperty(cartItem, "mzConType", plan.mzConType);
                    this.setItemProperty(cartItem, "mzGiftType", plan.mzGiftType);
                    this.setItemProperty(cartItem, "planType", plan.planType);
                    this.setItemProperty(cartItem, "planId", plan.planId);

                    if (cartItem && !cartItem.isGift) {
                        let targetPrice;

                        if (processType === "保持现状") {
                            targetPrice = cartItem.changePrice || cartItem.price;
                        } else {
                            targetPrice = Number(cartItem.price);
                        }

                        cartItem.changePrice = Number(targetPrice.toFixed(9));
                        cartItem.actualPrice = cartItem.changePrice;
                        cartItem.amount = Number(
                            this.$common.getDecimalInfo(3, cartItem.changePrice * cartItem.quantity)
                        );

                        let pointInfo = this.getPointInfo(itemAddPoints, itemReducePoints);
                        cartItem.discountInfo = pointInfo
                            ? `${plan.planName}：买赠促销(${pointInfo})`
                            : `${plan.planName}：买赠促销`;

                        this.setItemProperty(cartItem, "isDiscounted", true);

                        console.log(
                            `处理商品: ${cartItem.bgmName} (批号: ${cartItem.sterBatchno || "无"
                            }), 价格: ${cartItem.changePrice
                            }, 积分: +${itemAddPoints}/-${itemReducePoints}`
                        );
                    }
                });
            });
        },

        /**
         * 获取积分信息字符串
         * @param {number} itemAddPoints - 增加积分
         * @param {number} itemReducePoints - 减少积分
         * @returns {string} - 积分信息字符串
         */
        getPointInfo(itemAddPoints, itemReducePoints) {
            if (itemAddPoints > 0 && itemReducePoints > 0) {
                return `+${itemAddPoints}积分，-${itemReducePoints}积分`;
            } else if (itemAddPoints > 0) {
                return `+${itemAddPoints}积分`;
            } else if (itemReducePoints > 0) {
                return `-${itemReducePoints}积分`;
            }
            return "";
        },

        /**
         * 为买赠促销应用混合价格
         * @param {Object} cartItem - 购物车商品
         * @param {number} originalPrice - 原价
         * @param {number} discountPrice - 优惠价
         * @param {number} restoreQuantity - 恢复原价数量
         * @param {Object} plan - 促销方案
         * @param {number} itemAddPoints - 增加积分
         * @param {number} itemReducePoints - 减少积分
         */
        applyMixedPricingForMergePromotion(
            cartItem,
            originalPrice,
            discountPrice,
            restoreQuantity,
            plan,
            itemAddPoints,
            itemReducePoints
        ) {
            const remainingQuantity = cartItem.quantity - restoreQuantity;
            const originalPriceAmount = originalPrice * restoreQuantity;
            const discountPriceAmount = discountPrice * remainingQuantity;
            const totalAmount = originalPriceAmount + discountPriceAmount;
            const averagePrice = totalAmount / cartItem.quantity;

            cartItem.changePrice = Number(averagePrice.toFixed(9));
            cartItem.actualPrice = cartItem.changePrice;
            cartItem.amount = Number(this.$common.getDecimalInfo(3, totalAmount));

            // 记录混合价格信息
            cartItem.mixedPriceInfo = {
                restoreQuantity: restoreQuantity,
                restorePrice: originalPrice,
                remainingQuantity: remainingQuantity,
                remainingPrice: discountPrice,
                averagePrice: averagePrice,
            };

            let pointInfo = this.getPointInfo(itemAddPoints, itemReducePoints);
            cartItem.discountInfo = pointInfo
                ? `${plan.planName}：满赠混合价格(${restoreQuantity}件原价+${remainingQuantity}件优惠价,${pointInfo})`
                : `${plan.planName}：满赠混合价格(${restoreQuantity}件原价+${remainingQuantity}件优惠价)`;
        },

        /**
         * 获取最优价格（比较会员价、促销会员价和促销价，取较低者）
         * @param {Object} product - 商品信息
         * @param {number} quantity - 购买数量
         * @returns {number} - 最优价格
         */
        getOptimalPrice(product, quantity = 1) {
            // 如果是赠品，直接返回原价格，不进行价格优化计算
            if (product.isGift) {
                return product.price || product.changePrice || 0;
            }

            // 获取固定的限购数量（商品属性，不变的）
            let limitedQuantity = product.numPerOrder || 0;

            // 如果商品有总库存限制，需要考虑剩余可用数量
            if (product.totalNum !== undefined && product.usedNum !== undefined) {
                const remainDiscountNum = product.totalNum - product.usedNum;
                // 限购数量不能超过剩余可用数量
                limitedQuantity = Math.min(
                    limitedQuantity || Number.MAX_SAFE_INTEGER,
                    remainDiscountNum
                );
            }

            // 检查是否超出限购数量
            if (
                limitedQuantity &&
                limitedQuantity > 0 &&
                quantity > limitedQuantity
            ) {
                console.log("超出限购数量:", limitedQuantity);
                // 确定优惠部分的价格
                let limitedPartPrice;
                // 如果有会员（检查会员卡号和会员ID）
                if (this.memberInfo.memId) {
                    // 会员价和促销价取较低者
                    const memberPrice = product.memberPrice || product.price || 0;
                    const promotionPrice = product.spPrice || product.price || 0;
                    limitedPartPrice = Math.min(
                        memberPrice,
                        promotionPrice
                    );
                    console.log("会员 - 优惠部分使用最优价格:", limitedPartPrice);
                } else {
                    // 非会员使用促销价
                    limitedPartPrice =
                        product.spPrice && product.spPrice > 0
                            ? product.spPrice
                            : product.price;
                    console.log("非会员 - 优惠部分使用促销价:", limitedPartPrice);
                }

                // 超出部分价格，会员使用会员原价，非会员使用普通原价
                let originalPrice;
                if (this.memberInfo.memId) {
                    // 会员使用会员原价
                    originalPrice = product.memberPrice || product.price || 0;
                    console.log("会员 - 超出部分使用会员原价:", originalPrice);
                } else {
                    // 非会员使用普通原价
                    originalPrice = product.price || 0;
                    console.log("非会员 - 超出部分使用普通原价:", originalPrice);
                }

                // 不使用加权平均价格，而是分别存储限购部分和超出部分的价格和数量
                // 将价格信息存储到product对象中，以便后续使用
                product.isLimitedQuantity = true;
                product.limitedQuantity = limitedQuantity;
                product.limitedPrice = parseFloat(limitedPartPrice.toFixed(9));
                product.extraPrice = parseFloat(originalPrice.toFixed(9));

                // 计算总价（不使用加权平均价格）
                const limitedPartTotal = limitedQuantity * limitedPartPrice;
                const extraPartTotal = (quantity - limitedQuantity) * originalPrice;
                const totalAmount = limitedPartTotal + extraPartTotal;
                product.totalAmount = totalAmount;
                // 返回优惠部分的价格，用于显示单价
                return parseFloat(limitedPartPrice.toFixed(9));
            } else {
                // 未超出可优惠数量，正常计算价格

                // 清除之前可能设置的限购标记
                product.isLimitedQuantity = false;
                product.limitedQuantity = 0;
                product.limitedPrice = 0;
                product.extraPrice = 0;

                // 如果有会员（检查会员卡号和会员ID）
                if (this.memberInfo.memId) {
                    // 会员价和促销价取较低者
                    const memberPrice = product.memberPrice || product.price || 0;
                    const promotionPrice = product.spPrice || product.price || 0;
                    const optimalPrice = Math.min(
                        memberPrice,
                        promotionPrice
                    );
                    console.log(
                        "会员 - 未超出可优惠数量，使用最优价格:",
                        parseFloat(optimalPrice.toFixed(9))
                    );
                    return parseFloat(optimalPrice.toFixed(9));
                } else {
                    // 非会员
                    if (product.spPrice && product.spPrice > 0) {
                        console.log(
                            "非会员 - 未超出可优惠数量，使用促销价:",
                            parseFloat(product.spPrice)
                        );
                        return parseFloat(product.spPrice);
                    } else {
                        console.log(
                            "非会员 - 无促销价，使用原价:",
                            parseFloat((product.price || 0).toFixed(9))
                        );
                        return parseFloat((product.price || 0).toFixed(9));
                    }
                }
            }
        },
        // 添加到购物车
        addToCart(product, customQuantity) {
            console.log("product", product);
            const batchNo = product.batchno;
            const bgmId = product.bgmId;
            const prodate = product.prodate;
            const expidate = product.expidate;

            // 决定新商品的销售员
            let nextSalesPerson = this.memberInfo.salesPerson || "";
            let nextSalesPersonName = this.memberInfo.salesPersonName || "";
            if (this.cartItems.length > 0) {
                const lastItem = this.cartItems[this.cartItems.length - 1];
                if (
                    lastItem.salesPerson &&
                    lastItem.salesPerson !== this.previousSalesPerson
                ) {
                    nextSalesPerson = lastItem.salesPerson;
                    nextSalesPersonName = lastItem.salesPersonName;
                }
            }
            // 限制含麻/专管商品数量不能大于2盒
            const isSpecial =
                product.bgiType &&
                (product.bgiType.includes("含麻") || product.bgiType.includes("专管"));
            // 使用 customQuantity，如果未设置则默认为1
            let addQuantity =
                typeof customQuantity === "number" && customQuantity > 0
                    ? customQuantity
                    : 1;

            // 如果是专管/含麻药品，先检查总数量
            if (isSpecial) {
                // 统计购物车中所有专管/含麻商品的总数量
                const specialTotal = this.cartItems
                    .filter(
                        (item) =>
                            item.bgiType &&
                            (item.bgiType.includes("含麻") || item.bgiType.includes("专管"))
                    )
                    .reduce((sum, item) => sum + (item.quantity || 0), 0);

                // 如果购物车中已有该商品，需要减去该商品的数量，再加上新的数量
                const existItem = this.cartItems.find(
                    (item) => item.batchno === batchNo && item.bgmId === bgmId
                );
                let currentItemQuantity = existItem ? existItem.quantity : 0;

                // 计算添加后的总数量
                const newTotalSpecial =
                    specialTotal - currentItemQuantity + addQuantity;

                // 如果总数量超过2，则提示并阻止添加
                if (newTotalSpecial > 2) {
                    this.$message.warning("专管/含麻类商品总数量不能超过2盒");
                    return;
                }

                // 单个商品数量限制
                if (addQuantity > 2) {
                    addQuantity = 2;
                    this.$message.warning(
                        "专管/含麻类商品单次购买不能超过2盒，已自动限制为2盒"
                    );
                }
            }

            // 检查处方药是否需要执业药师（放在专管/含麻药品检查之后）
            if (!this.checkPrescriptionTypeAndSelectPharmacist(product)) {
                return; // 如果是处方药且未选择执业药师，直接返回不添加到购物车
            }

            const existItemIndex = this.cartItems.findIndex(
                (item) => item.batchno === batchNo && item.bgmId === bgmId && !item.isGift && item.prodate === prodate && item.expidate === expidate
            );
            console.log("existItemIndex33333", existItemIndex);
            let targetItemIndex = -1; // 记录要选中的商品索引

            if (existItemIndex !== -1) {
                const existItem = this.cartItems[existItemIndex];
                targetItemIndex = existItemIndex; // 如果是更新已存在商品，选中该商品

                // 累加数量
                let newTotalQuantity = existItem.quantity + addQuantity;

                // 检查库存数量：如果是中药饮片，需要考虑副数
                const isTCMDecoction = existItem.bgiType && existItem.bgiType.includes('中药饮片');
                const actualQuantity = (isTCMDecoction && existItem.tcmDosage)
                    ? newTotalQuantity * existItem.tcmDosage
                    : newTotalQuantity;

                if (existItem.num && actualQuantity > existItem.num) {
                    const itemType = isTCMDecoction ? '中药饮片' : '商品';
                    const dosageInfo = (isTCMDecoction && existItem.tcmDosage)
                        ? `（副数：${existItem.tcmDosage}，实际需要：${actualQuantity}）`
                        : '';
                    this.$message.warning(`${itemType}库存不足${dosageInfo}，当前库存：${existItem.num}，请选择其他批号`);
                    return;
                }

                if (isSpecial) {
                    const otherSpecialTotal = this.cartItems
                        .filter(
                            (item) =>
                                item !== existItem &&
                                item.bgiType &&
                                (item.bgiType.includes("含麻") || item.bgiType.includes("专管"))
                        )
                        .reduce((sum, item) => sum + (item.quantity || 0), 0);
                    const totalSpecialQuantity = otherSpecialTotal + newTotalQuantity;
                    if (totalSpecialQuantity > 2) {
                        const maxAllowed = 2 - otherSpecialTotal;
                        newTotalQuantity = Math.max(existItem.quantity, maxAllowed);
                        this.$message.warning(
                            `专管/含麻类商品总数量不能超过2盒，当前其他商品已占用${otherSpecialTotal}盒，已自动调整为${newTotalQuantity}盒`
                        );
                    }
                }
                existItem.quantity = newTotalQuantity;
                // 根据最新数量计算最优价格（考虑限购数量）- 但不影响赠品价格
                if (!existItem.isGift) {
                    existItem.actualPrice = this.getOptimalPrice(product, newTotalQuantity);
                    // 如果没有手动修改过价格，则更新显示价格
                    if (!existItem.isPriceManuallyChanged) {
                        existItem.changePrice = existItem.actualPrice;
                    }
                }

                // 计算金额，考虑可优惠数量
                if (
                    existItem.isLimitedQuantity &&
                    existItem.quantity > existItem.limitedQuantity
                ) {
                    // 如果超出可优惠数量，分别计算优惠部分和超出部分的金额
                    const limitedPartAmount =
                        existItem.limitedQuantity * existItem.changePrice;
                    const extraPartAmount =
                        (existItem.quantity - existItem.limitedQuantity) *
                        existItem.extraPrice;
                    existItem.amount = limitedPartAmount + extraPartAmount;

                    // 添加优惠信息到商品，方便显示
                    existItem.limitInfo = this.memberInfo.memId
                        ? `可优惠${existItem.limitedQuantity}件，超出按会员价`
                        : `可优惠${existItem.limitedQuantity}件，超出按原价`;

                    console.log(
                        "商品金额计算 - 限购部分:",
                        limitedPartAmount,
                        "超出部分:",
                        extraPartAmount,
                        "总金额:",
                        existItem.amount
                    );
                } else {
                    // 未超出限购数量，正常计算金额
                    existItem.amount = existItem.changePrice * existItem.quantity;

                    // 清除限购信息
                    existItem.limitInfo = "";
                }

                if (this.memberInfo.isSmall === 1) {
                    existItem.amount = Math.round(existItem.amount * 10) / 10;
                } else if (this.memberInfo.isSmall === 2) {
                    existItem.amount = Math.floor(existItem.amount * 10) / 10;
                }
                existItem.salesPerson = nextSalesPerson;
                existItem.salesPersonName = nextSalesPersonName;
            } else {
                // 根据购买数量计算最优价格（考虑限购数量）
                const optimalPrice = this.getOptimalPrice(product, addQuantity);

                // 计算金额，考虑限购数量
                let newItemAmount;
                let limitInfo = "";

                if (
                    product.isLimitedQuantity &&
                    addQuantity > product.limitedQuantity
                ) {
                    // 如果超出可优惠数量，分别计算优惠部分和超出部分的金额
                    const limitedPartAmount = product.limitedQuantity * optimalPrice;
                    const extraPartAmount =
                        (addQuantity - product.limitedQuantity) * product.extraPrice;
                    newItemAmount = limitedPartAmount + extraPartAmount;

                    // 添加优惠信息
                    limitInfo = this.memberInfo.memId
                        ? `可优惠${product.limitedQuantity}件，超出按会员价`
                        : `可优惠${product.limitedQuantity}件，超出按原价`;

                    console.log(
                        "新商品金额计算 - 限购部分:",
                        limitedPartAmount,
                        "超出部分:",
                        extraPartAmount,
                        "总金额:",
                        newItemAmount
                    );
                } else {
                    // 未超出限购数量，正常计算金额
                    newItemAmount = optimalPrice * addQuantity;
                }

                // 如果允许抹零，对金额进行处理
                if (this.memberInfo.isSmall === 1) {
                    newItemAmount = Math.round(newItemAmount * 10) / 10;
                } else if (this.memberInfo.isSmall === 2) {
                    newItemAmount = Math.floor(newItemAmount * 10) / 10;
                }
                console.log(product, "product9999");

                // 检查库存数量：如果是中药饮片，需要考虑副数
                const isTCMDecoction = product.bgiType && product.bgiType.includes('中药饮片');
                const actualQuantity = (isTCMDecoction && product.tcmDosage)
                    ? addQuantity * product.tcmDosage
                    : addQuantity;

                if (product.num && actualQuantity > product.num) {
                    const itemType = isTCMDecoction ? '中药饮片' : '商品';
                    const dosageInfo = (isTCMDecoction && product.tcmDosage)
                        ? `（副数：${product.tcmDosage}，实际需要：${actualQuantity}）`
                        : '';
                    this.$message.warning(`${itemType}库存不足${dosageInfo}，当前库存：${product.num}，请选择其他批号`);
                    return;
                }
                // 添加到购物车
                this.cartItems.push({
                    ...product,
                    actualPrice: optimalPrice,
                    changePrice: optimalPrice,
                    amount: newItemAmount,
                    // quantity: addQuantity,
                    quantity: product.inputQuantity ? product.inputQuantity : addQuantity,
                    // salesPerson: nextSalesPerson,
                    // salesPersonName: nextSalesPersonName,
                    salesPerson: this.memberInfo.salesPerson,
                    salesPersonName: this.memberInfo.salesPersonName,
                    isPriceManuallyChanged: false,
                    limitInfo: limitInfo,
                    // 初始化响应式属性
                    isDiscounted: false,
                    isRuleApplied: false,
                    isSelected: false,
                    isMergedItem: false,
                    isPointPromotion: false,
                    discountInfo: "",
                    mixedPriceInfo: null,
                    addPoint: 0,
                    rePoint: 0,
                    repeatMultiple: 0,
                    totalPromotionPoints: 0,

                });
                targetItemIndex = this.cartItems.length - 1; // 如果是添加新商品，选中最后一个商品
                if (this.memberInfo.addRate) {
                    this.updateItemPriceRate(targetItemIndex)
                }
            }

            // 统一在最后设置selectedItemIndex，避免多次触发
            this.$nextTick(() => {
                this.selectedItemIndex = targetItemIndex;
                // 滚动到新添加的商品
                this.scrollToSelectedCartItem();
            });

            // this.updateTotal();
            this.selectedBatch = null;

            // 添加商品后自动聚焦到购物车表格，以便可以使用上下键选择
            this.focusCartTable();
        },

        // 处理含麻/专管商品
        handleControlledDrugProduct(row) {
            if (
                row.bgiType &&
                (row.bgiType.includes("含麻") || row.bgiType.includes("专管"))
            ) {
                // 检查是否已经有姓名、手机号、身份证号信息
                if (
                    this.memberInfo.customerName &&
                    this.memberInfo.customerPhoneNumber &&
                    this.memberInfo.customerIdCard
                ) {
                    // 已经有姓名、手机号、身份证号信息，直接使用现有信息
                    this.buyerInfoProduct = row;
                    this.buyerInfoForm = {
                        name: this.memberInfo.customerName,
                        phone: this.memberInfo.customerPhoneNumber,
                        idCard: this.memberInfo.customerIdCard,
                    };
                    // 直接添加到购物车，不打开弹窗
                    const productWithBuyerInfo = {
                        ...row,
                        salesPerson: this.memberInfo.salesPerson || "",
                        salesPersonName: this.memberInfo.salesPersonName || "",
                    };
                    this.addToCart(productWithBuyerInfo);
                    // 选择商品后聚焦到数量输入框
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.focusQuantityInput();
                        }, 100);
                    });
                    return true; // 返回true表示已处理
                } else {
                    // 没有姓名、手机号、身份证号信息，打开弹窗填写购买人信息
                    this.buyerInfoProduct = row;
                    this.buyerInfoForm = { name: "", phone: "", idCard: "" };
                    this.buyerInfoDialogVisible = true;
                    return true; // 返回true表示已处理
                }
            }
            return false; // 返回false表示不是含麻/专管商品，未处理
        },

        // 根据处方类型选择执业药师
        checkPrescriptionTypeAndSelectPharmacist(product) {
            if (product.bgiPretype && product.bgiPretype === "处方药") {
                // 处方药必须先选择执业药师
                if (this.memberInfo.pharmacist) {
                    return true;
                } else {
                    // 保存待添加的商品信息
                    this.pendingProductForPharmacist = product;
                    this.pharmacistSelectDialogVisible = true;
                    return false; // 返回false表示暂时不能添加到购物车
                }
            }
            return true; // 返回true表示可以添加到购物车
        },
        // 更新合计
        updateTotal() {
            // 计算总数量
            this.totalQuantity = this.cartItems.reduce((sum, item) => {
                // 计算实际数量：如果是中药饮片且有副数，则数量*副数
                const isTCMDecoction = item.bgiType && item.bgiType.includes('中药饮片');
                const actualQuantity = (isTCMDecoction && item.tcmDosage)
                    ? item.quantity * item.tcmDosage
                    : item.quantity;
                return sum + (actualQuantity || 0);
            }, 0);

            // 计算应付金额 - 统一使用getCartItemReceivablePrice方法
            this.payableAmount = this.cartItems.reduce((sum, item) => {
                const itemPrice = this.getCartItemReceivablePrice(item).amount;
                console.log(`商品 ${item.bgmName}: 应收价=${itemPrice}, amount=${item.amount}`);
                return this.$common.getDecimalInfo(3, sum + itemPrice);
            }, 0);

            console.log('计算后的应付金额:', this.payableAmount);

            // 如果允许抹零，对总金额进行抹零处理（保留小数点后一位，不四舍五入）
            if (this.memberInfo.isSmall === 1) {
                if (this.payableAmount >= 0) {
                    this.payableAmount = Math.round(this.payableAmount * 10) / 10;
                } else {
                    this.payableAmount = (Math.round((this.payableAmount * -1) * 10) / 10) * -1;
                }
                console.log('抹零后的应付金额:', this.payableAmount);
            } else if (this.memberInfo.isSmall === 2) {
                if (this.payableAmount >= 0) {
                    this.payableAmount = Math.floor(this.payableAmount * 10) / 10;
                } else {
                    this.payableAmount = (Math.floor((this.payableAmount * -1) * 10) / 10) * -1;
                }
            }
            // 计算原价合计和优惠金额
            this.originAmount = this.cartItems.reduce(
                (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
                0
            );
            console.log(this.originAmount, "测试");
            this.originAmount = this.$common.getDecimalInfo(3, this.originAmount);
            this.discountAmount = this.originAmount - this.payableAmount;
        },
        // 异步计算积分
        async calculatePoints() {
            if (!this.cartItems || this.cartItems.length === 0) {
                this.calculatedPoints = 0;
                return;
            }

            try {
                let pointAmount = 0;
                let pointChange = 0;

                // 冲减/赠送积分
                this.cartItems.forEach((plan) => {
                    // 冲减积分最总计算
                    pointChange -= plan.rePoint ? plan.rePoint : 0;
                    pointChange += plan.addPoint ? plan.addPoint : 0;
                });

                this.cartItems.forEach((item) => {
                    if (item.pointMultiply) {
                        // 参与多倍积分的数量
                        const multiplyQuantity = this.getAppliedValue(item);
                        // 剩余数量（只获得1倍积分）
                        const remainingQuantity = item.quantity - multiplyQuantity;

                        // 多倍积分部分
                        const multiplyPoints =
                            multiplyQuantity * item.actualPrice * item.pointMultiply;
                        // 剩余数量1倍积分部分
                        const remainingPoints = remainingQuantity * item.actualPrice * 1;

                        pointAmount += multiplyPoints + remainingPoints;
                    } else {
                        pointAmount += item.actualPrice * item.quantity;
                    }
                });

                const res = await this.$http.retailPointPreCheck({
                    pointAmount: pointAmount,
                    pointChange: pointChange,
                    storeId: this.storeId
                });

                this.calculatedPoints = res.result || 0;
                console.log('积分计算结果:', this.calculatedPoints);
            } catch (error) {
                console.error('积分计算失败:', error);
                this.calculatedPoints = 0;
            }
        },
        filterPromotionSelectList() {
            // 直接返回促销方案列表，不调用接口
            return this.promotionSelectList;
        },
        // 处理商品行点击事件
        onProductRowClick(row, column, event) {
            // 找到点击的商品在列表中的索引
            const index = this.productSelectList.findIndex((item) => item === row);
            if (index !== -1) {
                this.selectedProductIndex2 = index;
                // 设置Element UI的当前行高亮
                if (this.$refs.productTable) {
                    this.$refs.productTable.setCurrentRow(row);
                }
                // 滚动到选中的商品
                this.$nextTick(() => {
                    this.scrollToSelectedProduct();
                });
            }
        },
        async onProductSelect(row) {
            console.log(row, 'row789')
            this.productSelectDialogVisible = false;
            this.selectedProductIndex2 = -1; // 重置选中状态
            // 含麻/专管商品需填写购买人信息
            if (this.handleControlledDrugProduct(row)) {
                return true;
            }
            // 失效期判断
            if (row.expidate) {
                let expTimestamp = row.expidate;
                if (typeof expTimestamp === "string") {
                    expTimestamp = new Date(expTimestamp).getTime();
                }
                if (expTimestamp < 1e12) {
                    expTimestamp = expTimestamp * 1000;
                }
                // 即将失效提醒（30天内，但未过期）
                // const diffDays = Math.ceil((expTimestamp - Date.now()) / (1000 * 60 * 60 * 24));
                // let expiDay = window.global_config.expiDay || 30;

                // if (diffDays > 0 && diffDays < expiDay) {
                //     this.$message({ message: `此商品距离过期仅剩 ${diffDays} 天，请尽快处理`, type: 'error', duration: 2000 });
                // }

                if (expTimestamp < Date.now()) {
                    this.$message.error("此商品已过期，不能购买");
                    return true;
                }
            }
            // 1. 回显商品信息到商品选择区域
            const res = await this.$http.sellPlanCheckBgmPlan({
                batchno: row.batchno,
                bgmId: row.bgmId,
                curDate: this.curDate,
                curTime: this.curTime,
                day: this.day,
                memId: this.memberInfo.memId ? this.memberInfo.memId : "",
                storeId: this.storeId,
                week: this.week,
                isZero:this.isZero
            });
            // 先设置基本商品信息
            this.selectedProduct = {
                ...row,
                promotionPlan: this.selectedProduct
                    ? this.selectedProduct.promotionPlan
                    : "", // 保留原有的促销方案信息
            };
            if (res && res.status === 200 && res.result) {
                // 处理促销方案名称
                let promotionPlans = [];
                // 处理特价促销列表
                if (res.result.tjPrice && res.result.tjPrice.length > 0) {
                    promotionPlans.push(
                        ...res.result.tjPrice.map((item) => `${item.planName}`)
                    );
                    // 获取第一个价格促销方案
                    const firstPricePromotion = res.result.tjPrice[0];
                    // -------------------更新商品信息区域显示的价格---------------
                    this.selectedProduct.spMemberPrice = firstPricePromotion.memPrice;
                    this.selectedProduct.spPrice = firstPricePromotion.price;
                    this.selectedProduct.isSpecialPrice = true; // 标识为特价商品
                    row.spMemberPrice = firstPricePromotion.memPrice; // 设置促销会员价
                    row.spPrice = firstPricePromotion.price; //设置促销价
                    row.isSpecialPrice = true; // 标识为特价商品
                    row.isMem = firstPricePromotion.isMem; // 标识为特价商品

                    // -----------------计算还能优惠的数量-----------------
                    let remainDiscountNum =
                        firstPricePromotion.totalNum - firstPricePromotion.usedNum;
                    // 获取促销方案的限购数量（如果有）
                    if (firstPricePromotion.numPerOrder) {
                        row.numPerOrder = firstPricePromotion.numPerOrder;
                        // 如果还能优惠的数量小于限购数量，则实际可优惠数量为剩余数量
                        row.actualDiscountNum = Math.min(
                            remainDiscountNum,
                            firstPricePromotion.numPerOrder
                        );
                    } else {
                        // 如果没有限购，则实际可优惠数量就是剩余数量
                        row.actualDiscountNum = remainDiscountNum;
                    }
                    // 获取已销数量和总数量（如果有）
                    if (firstPricePromotion.usedNum !== undefined) {
                        row.usedNum = firstPricePromotion.usedNum;
                    }
                    if (firstPricePromotion.totalNum !== undefined) {
                        row.totalNum = firstPricePromotion.totalNum;
                    }
                    // 方案id
                    row.faId = res.result.tjPrice[0].id;
                    // 如果购物车中已有该商品，立即更新其价格
                    const existingItem = this.cartItems.find(
                        (item) => item.bgmId === row.bgmId && item.batchno === row.batchno
                    );
                    if (existingItem) {
                        // 更新购物车中商品的价格
                        existingItem.spMemberPrice = firstPricePromotion.memPrice; // 设置促销会员价
                        existingItem.spPrice = firstPricePromotion.price;
                        // 获取促销方案的限购数量（如果有）
                        if (firstPricePromotion.numPerOrder) {
                            existingItem.numPerOrder = firstPricePromotion.numPerOrder;
                        }
                        // 获取已销数量和总数量（如果有）
                        if (firstPricePromotion.usedNum !== undefined) {
                            existingItem.usedNum = firstPricePromotion.usedNum;
                        }
                        if (firstPricePromotion.totalNum !== undefined) {
                            existingItem.totalNum = firstPricePromotion.totalNum;
                        }
                        // 计算还能优惠的数量
                        const remainingNum =
                            firstPricePromotion.totalNum - firstPricePromotion.usedNum;
                        // 计算实际可优惠数量：剩余可优惠数量、限购数量、当前购买数量三者取最小值
                        existingItem.actualDiscountNum = Math.min(
                            remainingNum,
                            firstPricePromotion.numPerOrder || Number.MAX_SAFE_INTEGER,
                            existingItem.quantity
                        );
                        // 重新计算最优价格（考虑限购数量）
                        existingItem.actualPrice = this.getOptimalPrice(
                            existingItem,
                            existingItem.quantity
                        );
                        // 如果没有手动修改过价格，则更新显示价格
                        if (!existingItem.isPriceManuallyChanged) {
                            existingItem.changePrice = existingItem.actualPrice;
                        }
                        // 重新计算金额
                        existingItem.amount =
                            existingItem.changePrice * existingItem.quantity;
                        // 如果允许抹零，对单个商品金额进行抹零处理
                        if (this.memberInfo.isSmall === 1) {
                            existingItem.amount = Math.round(existingItem.amount * 10) / 10;
                        } else if (this.memberInfo.isSmall === 2) {
                            existingItem.amount = Math.floor(existingItem.amount * 10) / 10;
                        }
                        // 添加特价标识
                        existingItem.isSpecialPrice = true;

                        // 强制更新视图
                        this.cartItems = [...this.cartItems];
                        // 更新总计
                        setTimeout(() => {
                            this.updateTotal();
                        }, 200);
                    }
                    setTimeout(() => {
                        this.updateTotal();
                    }, 200);
                } else {
                    // 多倍积分 - 参考特价促销列表的处理方式
                    if (res.result.tjPoint && res.result.tjPoint.length > 0) {
                        const pointMultiplyPromotion = res.result.tjPoint[0];
                        // 更新商品信息区域显示的积分倍数信息
                        this.selectedProduct.pointMultiply =
                            pointMultiplyPromotion.pointMultiply;
                        this.selectedProduct.pointPlanName =
                            pointMultiplyPromotion.planName;
                        // 将积分倍数信息添加到row对象中，这样添加到购物车时会包含这些信息
                        row.pointMultiply = pointMultiplyPromotion.pointMultiply; // 积分倍数
                        row.pointPlanName = pointMultiplyPromotion.planName; // 积分方案名称
                        row.faId = pointMultiplyPromotion.planId; // 积分方案ID
                        // 计算还能参与积分倍数的数量
                        let remainPointNum =
                            pointMultiplyPromotion.totalNum - pointMultiplyPromotion.usedNum;
                        // 获取积分方案的限购数量（如果有）
                        if (pointMultiplyPromotion.numPerOrder) {
                            row.pointNumPerOrder = pointMultiplyPromotion.numPerOrder;
                            // 如果还能参与积分的数量小于限购数量，则实际可参与数量为剩余数量
                            row.actualPointNum = Math.min(
                                remainPointNum,
                                pointMultiplyPromotion.numPerOrder
                            );
                        } else {
                            // 如果没有限购，则实际可参与数量就是剩余数量
                            row.actualPointNum = remainPointNum;
                        }
                        // 获取已销数量和总数量（如果有）
                        if (pointMultiplyPromotion.usedNum !== undefined) {
                            row.pointUsedNum = pointMultiplyPromotion.usedNum;
                        }
                        if (pointMultiplyPromotion.totalNum !== undefined) {
                            row.pointTotalNum = pointMultiplyPromotion.totalNum;
                        }
                        // 记录积分倍数参与的商品（保持原有逻辑）
                        const pointMultiplyRecord = {
                            bgmId: row.bgmId,
                            batchno: row.batchno,
                            pointMultiply: pointMultiplyPromotion.pointMultiply, //促销积分倍数
                            planId: pointMultiplyPromotion.planId,
                            planName: pointMultiplyPromotion.planName,
                            numPerOrder: pointMultiplyPromotion.numPerOrder, //每单限购数量
                            totalNum: pointMultiplyPromotion.totalNum, //促销总数量
                            usedNum: pointMultiplyPromotion.usedNum, //已销数量
                        };
                        // 检查是否已存在该商品的记录，如果存在则更新，否则添加新记录
                        const existingRecordIndex = this.pointMultiplyItems.findIndex(
                            (item) => item.bgmId === row.bgmId && item.batchno === row.batchno
                        );

                        if (existingRecordIndex !== -1) {
                            // 更新已有记录
                            this.$set(
                                this.pointMultiplyItems,
                                existingRecordIndex,
                                pointMultiplyRecord
                            );
                        } else {
                            // 添加新记录
                            this.pointMultiplyItems.push(pointMultiplyRecord);
                        }

                        // 如果购物车中已有该商品，立即更新其积分倍数信息
                        const existingItem = this.cartItems.find(
                            (item) => item.bgmId === row.bgmId && item.batchno === row.batchno
                        );

                        if (existingItem) {
                            // 更新购物车中商品的积分倍数信息
                            existingItem.pointMultiply = pointMultiplyPromotion.pointMultiply;
                            existingItem.pointPlanName = pointMultiplyPromotion.planName;
                            existingItem.pointPlanId = pointMultiplyPromotion.planId;
                            // 获取积分方案的限购数量（如果有）
                            if (pointMultiplyPromotion.numPerOrder) {
                                existingItem.pointNumPerOrder =
                                    pointMultiplyPromotion.numPerOrder;
                            }
                            // 获取已销数量和总数量（如果有）
                            if (pointMultiplyPromotion.usedNum !== undefined) {
                                existingItem.pointUsedNum = pointMultiplyPromotion.usedNum;
                            }
                            if (pointMultiplyPromotion.totalNum !== undefined) {
                                existingItem.pointTotalNum = pointMultiplyPromotion.totalNum;
                            }
                            // 计算还能参与积分倍数的数量
                            const remainingPointNum =
                                pointMultiplyPromotion.totalNum -
                                pointMultiplyPromotion.usedNum;
                            // 计算实际可参与积分数量：剩余可参与数量、限购数量、当前购买数量三者取最小值
                            existingItem.actualPointNum = Math.min(
                                remainingPointNum,
                                pointMultiplyPromotion.numPerOrder || Number.MAX_SAFE_INTEGER,
                                existingItem.quantity
                            );
                        }
                    }
                }
                // 处理积分促销列表
                if (res.result.tjPoint && res.result.tjPoint.length > 0) {
                    promotionPlans.push(
                        ...res.result.tjPoint.map((item) => `${item.planName}`)
                    );
                }

                // 处理组合促销列表
                if (res.result.clList && res.result.clList.length > 0) {
                    promotionPlans.push(
                        ...res.result.clList.map((item) => `${item.planName}`)
                    );
                }
                // 处理买赠促销列表
                if (res.result.mzList && res.result.mzList.length > 0) {
                    promotionPlans.push(
                        ...res.result.mzList.map((item) => `${item.planName}`)
                    );
                }
                // 将所有促销方案名称用逗号拼接并赋值
                if (promotionPlans.length > 0) {
                    this.$set(
                        this.selectedProduct,
                        "promotionPlan",
                        promotionPlans.join(",")
                    );
                } else {
                    this.$set(this.selectedProduct, "promotionPlan", "无可用促销方案");
                }
            } else {
                // 如果没有促销方案数据，设置为无可用促销方案
                this.$set(this.selectedProduct, "promotionPlan", "无可用促销方案");
            }

            this.quantity = 1; // 默认数量为1
            // 2. 添加到购物车（主表格）
            // 保证销售员为顶部选择
            const productWithSalesPerson = {
                ...row,
                salesPerson: this.memberInfo.salesPerson || "",
                salesPersonName: this.memberInfo.salesPersonName || "",
                promotionPlan: this.selectedProduct.promotionPlan || "", // 保留促销方案信息
            };
            console.log("row111", row);
            // 检查购物车中是否已存在该商品
            const existingIndex = this.cartItems.findIndex(
                (item) => item.bgmId === row.bgmId && item.batchno === row.batchno && !item.isGift && item.prodate === row.prodate && item.expidate === row.expidate
            );
            console.log("existingIndex", existingIndex);
            if (existingIndex !== -1) {


                // 如果商品已存在，更新数量和其他信息
                const existingItem = this.cartItems[existingIndex];
                const newQuantity = (existingItem.quantity || 0) + 1;

                // 检查库存数量：如果是中药饮片，需要考虑副数
                const isTCMDecoction = existingItem.bgiType && existingItem.bgiType.includes('中药饮片');
                const actualQuantity = (isTCMDecoction && existingItem.tcmDosage)
                    ? newQuantity * existingItem.tcmDosage
                    : newQuantity;

                if (existingItem.num && actualQuantity > existingItem.num) {
                    const itemType = isTCMDecoction ? '中药饮片' : '商品';
                    const dosageInfo = (isTCMDecoction && existingItem.tcmDosage)
                        ? `（副数：${existingItem.tcmDosage}，实际需要：${actualQuantity}）`
                        : '';
                    this.$message.warning(`${itemType}库存不足${dosageInfo}，当前库存：${existingItem.num}，请选择其他批号`);
                    return;
                }

                existingItem.quantity = newQuantity;

                // 清除促销状态标识，因为数量变化可能影响促销
                existingItem.isDiscounted = false;
                existingItem.isRuleApplied = false;
                existingItem.discountInfo = "";
                existingItem.isMergedItem = false;

                // 重新计算最优价格（考虑限购数量）
                existingItem.actualPrice = this.getOptimalPrice(
                    existingItem,
                    newQuantity
                );
                // 如果没有手动修改过价格，则更新显示价格
                if (!existingItem.isPriceManuallyChanged) {
                    existingItem.changePrice = existingItem.actualPrice;
                }
                existingItem.amount = existingItem.changePrice * existingItem.quantity;
                if (this.memberInfo.isSmall === 1) {
                    existingItem.amount = Math.round(existingItem.amount * 10) / 10;
                } else if (this.memberInfo.isSmall === 2) {
                    existingItem.amount = Math.floor(existingItem.amount * 10) / 10;
                }
                // 更新选中的商品索引
                this.selectedItemIndex = existingIndex;
            } else {
                // 如果是新商品，添加到购物车
                this.addToCart(productWithSalesPerson);
            }
            // 实时参与活动方案
            this.getRealTimePromotions();

            // 选择商品后聚焦到数量输入框
            this.$nextTick(() => {
                setTimeout(() => {
                    this.focusQuantityInput();
                    this.updateTotal();
                }, 100);
            });
        },
        // 更新商品单价
        updateItemPrice(index) {
            const item = this.cartItems[index];
            if (item && item.changePrice !== undefined) {
                // 验证单价不能小于0
                if (item.changePrice < 0) {
                    item.changePrice = 0;
                    this.$message.warning("单价不能小于0");
                }
                // 标记为手动修改价格，这样getCartItemReceivablePrice会使用修改后的单价而不是促销价
                item.isPriceManuallyChanged = true;
                // 使用修改后的单价计算金额
                item.actualPrice = item.changePrice;
                // 如果允许抹零，对单个商品金额进行抹零处理（保留小数点后一位，不四舍五入）
                var num = 0
                if (item.tcmDosage) {
                    num = NP.times(item.quantity, item.tcmDosage)
                } else {
                    num = item.quantity
                }
                item.amount = this.$common.getDecimalInfo(3, item.changePrice * num);
                this.updateTotal();
            }
        },
        // 更新商品单价
        updateItemPriceRate(index) {
            const item = this.cartItems[index];
            let price = 0
            let priceRate = 0
            if (item.isDiscounted) {
                price = item.actualPrice || 0
            } else if (this.memberInfo && this.memberInfo.memId) {
                if (item.spPrice) {
                    price = Math.min(
                        item.memberPrice !== undefined ? item.memberPrice : Infinity,
                        item.spPrice !== undefined ? item.spPrice : Infinity
                    )
                } else {
                    price = item.memberPrice || 0
                }
            } else {
                if (item.spPrice) {
                    price = item.spPrice || 0
                } else {
                    price = item.price || 0
                }
            }
            priceRate = NP.plus(Number(price), NP.times(this.memberInfo.addRate, Number(price)))
            item.changePrice = priceRate
            item.oldPsprice = price
            this.updateItemPriceYS(index)
        },
        // 更新商品单价
        updateItemPriceYS(index) {
            const item = this.cartItems[index];
            if (item && item.changePrice !== undefined) {
                // 验证单价不能小于0
                if (item.changePrice < 0) {
                    item.changePrice = 0;
                    this.$message.warning("单价不能小于0");
                }
                // 使用修改后的单价计算金额
                item.actualPrice = item.changePrice;
                var num = 0
                if (item.tcmDosage) {
                    num = NP.times(item.quantity, item.tcmDosage)
                } else {
                    num = item.quantity
                }
                item.amount = this.$common.getDecimalInfo(3, item.changePrice * num);
                this.updateTotal();
            }
        },

        // 聚焦到数量输入框
        focusQuantityInput() {
            this.$nextTick(() => {
                // 聚焦到商品选择区域右边的数量输入框
                if (this.$refs.quantityInput) {
                    // 设置标志，防止触发购物车更新
                    this.isProgrammaticQuantityChange = true;
                    // 重置数量输入框为1（默认值）
                    this.quantityChange = 1;
                    // 强制更新DOM
                    this.$forceUpdate();
                    this.$refs.quantityInput.focus();
                    this.$refs.quantityInput.select(); // 选中输入框中的内容
                    // 重置标志
                    this.$nextTick(() => {
                        this.isProgrammaticQuantityChange = false;
                    });
                }
            });
        },
        // 数量改变事件
        onQuantityChange() {
            // 如果是程序设置数量，不触发购物车更新
            if (this.isProgrammaticQuantityChange) {
                return;
            }

            // 注释掉重置促销方案的调用，保持商品的促销状态
            // this.resetPromotion();
            // 改变数量的时候  先清除参与活动的标识，但赠品除外

            // 如果当前有选中的商品，先进行校验
            if (
                this.selectedItemIndex >= 0 &&
                this.selectedItemIndex < this.cartItems.length
            ) {
                const item = this.cartItems[this.selectedItemIndex];
                console.log(item, 'item789');
                if (item) {
                    // 如果是赠品，不允许改变数量
                    if (item.isGift) {
                        this.$message.warning("赠品数量不能修改");
                        return;
                    }


                    // 库存校验：检查同bgmId同批号的商品总数量（包括赠品）是否超过库存
                    const totalQuantity = this.cartItems.reduce((sum, cartItem, index) => {
                        if (cartItem.bgmId === item.bgmId && cartItem.batchno === item.batchno && cartItem.prodate === item.prodate && cartItem.expidate === item.expidate) {
                            if (index === this.selectedItemIndex) {
                                // 当前选中商品使用新的数量
                                return sum + parseInt(this.quantityChange);
                            } else {
                                // 其他商品使用现有数量
                                return sum + (cartItem.quantity || 0);
                            }
                        }
                        return sum;
                    }, 0);
                    console.log(this.cartItems, 'this.cartItems');
                    if (item.num && totalQuantity > item.num) {
                        // 计算其他同批号商品的数量
                        const otherQuantity = this.cartItems.reduce((sum, cartItem, index) => {
                            if (cartItem.bgmId === item.bgmId && cartItem.batchno === item.batchno && index !== this.selectedItemIndex) {
                                return sum + (cartItem.quantity || 0);
                            }
                            return sum;
                        }, 0);

                        this.$message.warning(`设置数量超过库存限制，当前库存：${item.num}，其他同批号商品已占用：${otherQuantity}，可设置最大数量：${Math.max(0, item.num - otherQuantity)}`);
                        return;
                    }
                }
            }
            if (this.cartItems[this.selectedItemIndex].isMoreGift) {
                // 获取当前商品的planId
                const currentPlanId = this.cartItems[this.selectedItemIndex].planId;
                this.cartItems = this.cartItems.filter(item => {
                    // 保留非赠品或者planId不同的赠品
                    return !item.isGift || item.planId !== currentPlanId;
                });

            }
            // 校验通过后，重置商品到正确的基础状态
            this.resetSingleItemToOriginal(this.cartItems[this.selectedItemIndex]);

            // 更新购物车中对应商品的数量
            if (
                this.selectedItemIndex >= 0 &&
                this.selectedItemIndex < this.cartItems.length
            ) {
                const item = this.cartItems[this.selectedItemIndex];
                if (item) {
                    let newQuantity = parseInt(this.quantityChange);
                    // 验证数量
                    if (isNaN(newQuantity) || newQuantity < 1) {
                        newQuantity = 1;
                        this.quantityChange = "";
                    }
                    // 限制含麻/专管商品最大为2盒
                    // const isSpecial =
                    //     item.bgiType &&
                    //     (item.bgiType.includes("含麻") || item.bgiType.includes("专管"));
                    // if (isSpecial) {
                    //     // 计算其他专管/含麻商品的数量（不包括当前商品）
                    //     const otherSpecialTotal = this.cartItems
                    //         .filter(
                    //             (cartItem, index) =>
                    //                 index !== this.selectedItemIndex &&
                    //                 cartItem.bgiType &&
                    //                 (cartItem.bgiType.includes("含麻") ||
                    //                     cartItem.bgiType.includes("专管"))
                    //         )
                    //         .reduce((sum, cartItem) => sum + (cartItem.quantity || 0), 0);

                    //     // 检查总数量是否超过限制
                    //     const totalSpecialQuantity = otherSpecialTotal + newQuantity;
                    //     if (totalSpecialQuantity > 2) {
                    //         const maxAllowed = 2 - otherSpecialTotal;
                    //         newQuantity = Math.max(1, maxAllowed);
                    //         this.quantityChange = newQuantity;
                    //     }
                    // }
                    // 更新购物车中商品的数量
                    item.quantity = newQuantity;

                    // 先更新总计（基于当前状态）
                    // this.updateTotal();

                    // 然后异步处理促销，完成后再次更新总计
                    this.getRealTimePromotions().then(() => {
                        // 促销处理完成后，再次更新总计以确保数据一致性
                        this.$nextTick(() => {
                            this.updateTotal();
                        });
                    }).catch((error) => {
                        console.error('促销处理失败:', error);
                        // 即使促销失败，也要更新总计
                        this.$nextTick(() => {
                            this.updateTotal();
                        });
                    });


                }
            }
        },
        // 聚焦购物车表格
        focusCartTable() {
            this.$nextTick(() => {
                if (this.$refs.cartTable) {
                    const tableEl = this.$refs.cartTable.$el;
                    if (tableEl) {
                        tableEl.focus();
                        console.log("购物车表格聚焦成功");
                    }
                }
            });
        },

        // 数量输入框回车事件
        onQuantityEnter() {
            // 正常情况下聚焦到商品选择输入框
            this.$nextTick(() => {
                if (this.$refs.productSearchInput) {
                    this.$refs.productSearchInput.focus();
                    this.$refs.productSearchInput.select(); // 选中输入框中的内容
                }
            });

        },
        // 应用递增变价到单个商品（合并显示）
        applyIncrementalDiscountToItem(item, sortedRules, plan, discountType) {
            console.log("应用递增变价到商品:", item.bgmName, "数量:", item.quantity);
            // 计算每个数量段的价格
            const priceSegments = [];
            let processedQuantity = 0;
            let totalAmount = 0;

            for (const rule of sortedRules) {
                // 计算此规则适用的数量
                const ruleQuantity = Math.min(
                    rule.num - processedQuantity,
                    item.quantity - processedQuantity
                );

                if (ruleQuantity <= 0) break;

                // 计算此段的价格
                let segmentPrice;
                if (discountType === "rate") {
                    // 按折扣
                    segmentPrice = this.$common.getDecimalInfo(3, item.price * rate);
                } else {
                    // 按金额（减免）
                    segmentPrice = Number((item.price - rule.money).toFixed(9));
                    if (segmentPrice < 0) segmentPrice = 0;
                }

                const segmentAmount = segmentPrice * ruleQuantity;
                totalAmount += segmentAmount;

                priceSegments.push({
                    startNum: processedQuantity + 1,
                    endNum: processedQuantity + ruleQuantity,
                    quantity: ruleQuantity,
                    price: segmentPrice,
                    amount: segmentAmount,
                    rate: rule.rate,
                    money: rule.money,
                });

                processedQuantity += ruleQuantity;

                // 如果已处理完所有数量，跳出循环
                if (processedQuantity >= item.quantity) break;
            }

            // 如果还有剩余数量，使用原价
            if (processedQuantity < item.quantity) {
                const remainingQuantity = item.quantity - processedQuantity;
                const remainingAmount = item.price * remainingQuantity;
                totalAmount += remainingAmount;

                priceSegments.push({
                    startNum: processedQuantity + 1,
                    endNum: item.quantity,
                    quantity: remainingQuantity,
                    price: item.price,
                    amount: remainingAmount,
                    rate: 1,
                    money: 0,
                });
            }

            // 计算平均单价
            const averagePrice = totalAmount / item.quantity;

            // 设置混合价格
            item.changePrice = Number(averagePrice.toFixed(9));
            item.actualPrice = item.changePrice;
            item.amount = Number(totalAmount.toFixed(9));

            // 记录详细的价格信息用于显示
            item.incrementalPriceInfo = {
                segments: priceSegments,
                isIncremental: true,
                discountType: discountType,
            };

            // 生成折扣信息
            const segmentDescriptions = priceSegments.map((segment) => {
                if (segment.quantity === 1) {
                    return `第${segment.startNum}件${segment.price}元`;
                } else {
                    return `第${segment.startNum}-${segment.endNum}件${segment.price}元`;
                }
            });

            item.discountInfo = `${plan.planName}：${segmentDescriptions.join("，")}`;
            item.isDiscounted = true;
            item.isRuleApplied = true;

            console.log(
                `递增变价处理完成 - 平均单价:`,
                item.changePrice,
                "总金额:",
                item.amount
            );
            console.log("价格段详情:", priceSegments);
        },

        // 应用递增变价到多个商品（合并显示）
        applyIncrementalDiscountMerged(eligibleItems, sortedRules, plan, discountType) {
            console.log("应用递增变价合并处理:", eligibleItems.length, "个商品");
            // 计算所有商品的总数量
            const totalQuantity = eligibleItems.reduce((sum, item) => sum + item.quantity, 0);

            // 计算总金额
            let totalAmount = 0;
            let processedQuantity = 0;

            // 按规则计算每个数量段的总金额
            for (const rule of sortedRules) {
                const ruleQuantity = Math.min(rule.num - processedQuantity, totalQuantity - processedQuantity);

                if (ruleQuantity <= 0) break;

                // 计算此段的单价
                let segmentPrice;
                if (discountType === "rate") {
                    //  segmentPrice = eligibleItems[0].price * rule.rate;
                    segmentPrice = this.$common.getDecimalInfo(3, NP.times(eligibleItems[0].price, rule.rate));
                } else {
                    //  segmentPrice = Number(rule.money);
                    segmentPrice = this.$common.getDecimalInfo(3, Number(rule.money));
                }

                // totalAmount += segmentPrice * ruleQuantity;
                totalAmount += this.$common.getDecimalInfo(3, NP.times(segmentPrice, ruleQuantity));
                processedQuantity += ruleQuantity;

                if (processedQuantity >= totalQuantity) break;
            }

            // 剩余数量使用原价
            if (processedQuantity < totalQuantity) {
                // const remainingQuantity = totalQuantity - processedQuantity;
                const remainingQuantity = totalQuantity - processedQuantity;
                totalAmount += this.$common.getDecimalInfo(3, NP.times(eligibleItems[0].price, remainingQuantity));
            }

            // 计算平均单价
            const averagePrice = this.$common.getDecimalInfo(3, NP.divide(totalAmount, totalQuantity));

            // 移除除第一个商品外的所有商品
            const firstItem = eligibleItems[0];
            for (let i = 1; i < eligibleItems.length; i++) {
                const itemIndex = this.cartItems.indexOf(eligibleItems[i]);
                if (itemIndex > -1) {
                    this.cartItems.splice(itemIndex, 1);
                }
            }

            // 更新第一个商品为合并后的数据
            firstItem.quantity = totalQuantity;
            firstItem.changePrice = this.$common.getDecimalInfo(3, averagePrice);
            firstItem.actualPrice = firstItem.changePrice;
            firstItem.amount = this.$common.getDecimalInfo(3, totalAmount);
            console.log(firstItem.amount, 'firstItem.amount')
            // 生成折扣信息
            const ruleDescriptions = sortedRules.map((rule) => {
                if (discountType === "rate") {
                    return `前${rule.num}件${rule.rate}折`;
                } else {
                    return `前${rule.num}件${rule.money}元`;
                }
            });

            firstItem.discountInfo = `${plan.planName}：递增变价(${ruleDescriptions.join("，")})`;
            firstItem.isDiscounted = true;
            firstItem.isRuleApplied = true;

            console.log(`递增变价合并完成 - 总数量:${totalQuantity}, 平均单价:${firstItem.changePrice}, 总金额:${firstItem.amount}`);
        },

        // 应用循环促销价格到单个商品
        applyCyclicDiscountToItem(
            item,
            sortedRules,
            plan,
            discountType,
            cycleTotalQuantity
        ) {
            console.log(
                "应用循环促销到商品:",
                item.bgmName,
                "数量:",
                item.quantity,
                "循环周期:",
                cycleTotalQuantity
            );
            // 计算商品在循环中的位置
            let totalAmount = 0;

            // 对每个商品数量进行循环处理
            for (let i = 0; i < item.quantity; i++) {
                // 计算当前商品在循环中的位置（从1开始）
                const positionInCycle = (i % cycleTotalQuantity) + 1;

                // 找到适用的规则 - 按照规则的范围匹配
                let applicableRule = null;
                let previousRuleNum = 0;

                for (const rule of sortedRules) {
                    // 检查当前位置是否在这个规则的范围内
                    if (
                        positionInCycle > previousRuleNum &&
                        positionInCycle <= rule.num
                    ) {
                        applicableRule = rule;
                        break;
                    }
                    previousRuleNum = rule.num;
                }

                // 计算当前商品的价格
                let itemPrice;
                if (applicableRule) {
                    if (discountType === "rate") {
                        // 按折扣
                        itemPrice = this.$common.getDecimalInfo(3, NP.times(item.price, applicableRule.rate));

                    } else {
                        // 按金额 - 这里应该是固定价格，不是减免
                        itemPrice = this.$common.getDecimalInfo(3, applicableRule.money);
                    }
                } else {
                    // 没有适用规则，使用原价
                    itemPrice = item.price;
                }

                console.log(
                    `第${i + 1}件商品，循环位置${positionInCycle}，适用规则:`,
                    applicableRule,
                    "价格:",
                    itemPrice
                );
                totalAmount += itemPrice;
            }

            // 计算平均单价
            const averagePrice = totalAmount / item.quantity;

            // 设置商品价格
            item.changePrice = this.$common.getDecimalInfo(3, averagePrice);
            item.actualPrice = item.changePrice;
            item.amount = this.$common.getDecimalInfo(3, totalAmount);

            // 生成折扣信息
            const ruleDescriptions = sortedRules.map((rule) => {
                if (discountType === "rate") {
                    return `前${rule.num}件${rule.rate}折`;
                } else {
                    return `前${rule.num}件${rule.money}元`;
                }
            });

            item.discountInfo = `${plan.planName}：循环促销(${ruleDescriptions.join(
                "，"
            )}，每${cycleTotalQuantity}件循环)`;
            item.isDiscounted = true;
            item.isRuleApplied = true;

            console.log(
                `循环促销处理完成 - 平均单价:`,
                item.changePrice,
                "总金额:",
                item.amount
            );
        },

        // 应用循环促销到多个商品（保留各批号）
        applyCyclicDiscountToMultipleItems(eligibleItems, sortedRules, plan, discountType, cycleTotalQuantity) {
            console.log("应用循环促销到多个批号:", eligibleItems.length, "个商品", "循环周期:", cycleTotalQuantity);
            // 计算所有商品的总数量
            const totalQuantity = eligibleItems.reduce((sum, item) => sum + item.quantity, 0);

            // 按顺序分配折扣：逐个处理每个批号的商品
            let processedQuantity = 0;

            eligibleItems.forEach((item) => {
                const itemQuantity = item.quantity;
                // const originalPrice = item.changePrice || item.price;
                // 始终使用商品原价作为折扣计算基础
                const originalPrice = item.price;

                // 计算这个商品中每个数量对应的价格
                let totalItemAmount = 0;

                // 为当前商品的每个数量分配价格
                for (let i = 0; i < itemQuantity; i++) {
                    const currentGlobalPosition = processedQuantity + i + 1; // 全局位置（第几件）

                    // 计算在循环中的位置（从1开始）
                    const positionInCycle = ((currentGlobalPosition - 1) % cycleTotalQuantity) + 1;

                    let unitPrice = originalPrice; // 默认原价

                    // 查找适用的规则 - 按照规则的范围匹配
                    let applicableRule = null;
                    let previousRuleNum = 0;

                    for (const rule of sortedRules) {
                        // 检查当前位置是否在这个规则的范围内
                        if (positionInCycle > previousRuleNum && positionInCycle <= rule.num) {
                            applicableRule = rule;
                            break;
                        }
                        previousRuleNum = rule.num;
                    }

                    // 计算当前商品的价格
                    if (applicableRule) {
                        if (discountType === "rate") {
                            unitPrice = this.$common.getDecimalInfo(3, NP.times(originalPrice, applicableRule.rate));
                        } else {
                            unitPrice = this.$common.getDecimalInfo(3, Number(applicableRule.money));
                        }
                    }

                    totalItemAmount += unitPrice;
                }

                // 计算该商品的平均单价
                const averagePrice = this.$common.getDecimalInfo(3, NP.divide(totalItemAmount, itemQuantity));

                // 更新商品价格
                item.changePrice = averagePrice;
                item.actualPrice = item.changePrice;
                item.amount = this.$common.getDecimalInfo(3, totalItemAmount);

                // 生成折扣信息
                const startPosition = processedQuantity + 1;
                const endPosition = processedQuantity + itemQuantity;
                const ruleDescriptions = sortedRules.map((rule) => {
                    if (discountType === "rate") {
                        return `前${rule.num}件${rule.rate}折`;
                    } else {
                        return `前${rule.num}件${rule.money}元`;
                    }
                });

                item.discountInfo = `${plan.planName}：第${startPosition}-${endPosition}件循环促销(${ruleDescriptions.join("，")}，每${cycleTotalQuantity}件循环)`;
                item.isDiscounted = true;
                item.isRuleApplied = true;

                processedQuantity += itemQuantity;

                console.log(`批号 ${item.batchno} - 数量:${itemQuantity}, 平均单价:${item.changePrice}, 总金额:${item.amount}`);
            });

            console.log(`循环促销处理完成 - 总数量:${totalQuantity}, 处理了${eligibleItems.length}个批号`);
        },
        // 促销方案弹窗打开后的处理
        onPromotionDialogOpened() {
            console.log("促销方案弹窗已打开");

            // 初始化高亮行索引和聚焦区域
            this.currentHighlightRowIndex = 0;
            this.currentFocusArea = "promotion";

            // 确保表格已完全渲染
            setTimeout(() => {
                if (
                    this.usedPromotions &&
                    this.usedPromotions.length > 0 &&
                    this.$refs.promotionTable
                ) {
                    this.usedPromotions.forEach((item) => {
                        const matchedPlan = this.promotionSelectList.find(
                            (plan) => plan.planId === item.planId
                        );
                        if (matchedPlan) {
                            console.log("弹窗打开事件中勾选:", matchedPlan.planName);
                            this.$refs.promotionTable.toggleRowSelection(matchedPlan, true);
                        }
                    });
                }

                // 聚焦到促销方案表格
                this.focusPromotionTable();
            }, 200);
        },
        confirmPromotionSelection() {
            // 检查是否有新的促销方案需要应用（避免重复应用）
            const newPromotions = this.selectedPromotions.filter(
                (selectedPlan) =>
                    !this.usedPromotions.some(
                        (usedPlan) => usedPlan.planId === selectedPlan.planId
                    )
            );

            // 重置积分倍数
            newPromotions.forEach((plan) => {
                this.cartItems.forEach((item) => {
                    if (plan.planBgmIdList.includes(item.bgmId)) {
                        item.pointMultiply = 1;
                        item.isLimitedQuantity = false;
                    }
                });
            });

            // 只处理新增的促销方案
            if (newPromotions.length === 0) {
                // 更新已使用的促销方案列表
                this.usedPromotions = JSON.parse(
                    JSON.stringify(this.selectedPromotions)
                );

                this.promotionSelectDialogVisible = false;
                return;
            }

            // ---------------促销赠送------------
            if (newPromotions.some((plan) => plan.planType === 1)) {
                // ---------买赠促销---------
                if (newPromotions.some((plan) => plan.mzGiftType === 1)) {
                    console.log("买赠促销");
                    newPromotions
                        .filter((plan) => plan.mzGiftType === 1)
                        .forEach((plan) => {
                            // 按商品分类
                            if (plan.mzConType == 3) {
                                this.mzPromotion(plan);
                            }
                            if (plan.mzGiftType === this.PROMOTION_TYPES.GIFT) {
                                // 1. 检查促销条件
                                const { conditionMet, matchedConditionItems } =
                                    this.checkPromotionConditions(plan);
                                // 2. 如果条件满足，应用价格规则
                                if (conditionMet) {
                                    this.applyPriceRule(plan, matchedConditionItems, "买赠促销");
                                } else {
                                    console.log("未满足条件，不应用赠品规则");
                                }
                            }
                            // 更新总计金额
                            this.updateTotal();
                        });
                }
                // --------优惠券  giftYhqList 数组信息 有需要付款的时候传过去--------
                if (newPromotions.some((plan) => plan.mzGiftType === 2)) {
                    newPromotions.forEach((plan) => {
                        if (plan.mzConType == 3) {
                            this.yhqPromotion(plan);
                            return;
                        }
                        if (plan.mzGiftType === this.PROMOTION_TYPES.COUPON) {
                            // 1. 检查促销条件
                            const { conditionMet, matchedConditionItems } =
                                this.checkPromotionConditions(plan);
                            // 2. 如果条件满足，应用价格规则
                            if (conditionMet) {
                                const repeatMultiple = this.calculateRepeatMultiple(plan);
                                if (repeatMultiple <= 0) {
                                    console.log("不满足重复赠送条件，不赠送积分");
                                    return;
                                }
                                this.applyPriceRule(plan, matchedConditionItems, "优惠券促销");
                            }
                        }
                        // 更新总计金额
                        this.updateTotal();
                    });
                }
                // ---------积分促销---------
                if (newPromotions.some((plan) => plan.mzGiftType === 3)) {
                    console.log("积分促销");

                    newPromotions.forEach((plan) => {
                        if (plan.mzConType == 3) {
                            this.jifenPromotion(plan);
                            return;
                        }
                        if (plan.mzGiftType === this.PROMOTION_TYPES.POINTS) {
                            // 1. 检查促销条件
                            const { conditionMet, matchedConditionItems } =
                                this.checkPromotionConditions(plan);

                            // 2. 如果条件满足，应用价格规则
                            if (conditionMet) {
                                const repeatMultiple = this.calculateRepeatMultiple(plan);
                                if (repeatMultiple <= 0) {
                                    console.log("不满足重复赠送条件，不赠送积分");
                                    return;
                                }
                                // 积分促销需要特殊处理，因为它有复杂的混合价格逻辑
                                this.handleSpecialPointsPromotion(
                                    plan,
                                    matchedConditionItems,
                                    repeatMultiple
                                );
                            } else {
                                console.log("未满足条件，不应用积分促销");
                            }

                            // 更新总计金额
                            this.updateTotal();
                        }
                    });
                }
                // ---------原品打折  mzDiscount---------
                if (newPromotions.some((plan) => plan.mzGiftType === 4)) {
                    console.log("原品打折");
                    newPromotions.forEach((plan) => {
                        if (plan.mzGiftType === this.PROMOTION_TYPES.DISCOUNT) {
                            if (plan.mzConType == 3) {
                                this.mzDiscount(plan);
                                return;
                            }
                            // 1. 检查促销条件
                            const { conditionMet, matchedConditionItems } =
                                this.checkPromotionConditions(plan);
                            // 2. 如果条件满足，应用价格规则
                            if (conditionMet) {
                                this.applyPriceRule(plan, matchedConditionItems, "打折促销");
                            } else {
                                console.log("未满足条件，不应用价格规则");
                            }
                            // 更新总计金额
                            this.updateTotal();
                        }
                    });
                }
                // ---------原品金额减免 mzCashBack---------
                if (
                    newPromotions.some(
                        (plan) => plan.mzGiftType === this.PROMOTION_TYPES.CASH_BACK
                    )
                ) {
                    console.log("原品金额减免");
                    newPromotions.forEach((plan) => {
                        if (plan.mzGiftType === this.PROMOTION_TYPES.CASH_BACK) {
                            if (plan.mzConType == 3) {
                                this.mzReduce(plan);
                                return;
                            }
                            // 1. 检查促销条件
                            const { conditionMet, matchedConditionItems } =
                                this.checkPromotionConditions(plan);
                            // 2. 如果条件满足，应用价格规则
                            if (conditionMet) {
                                this.applyPriceRule(
                                    plan,
                                    matchedConditionItems,
                                    "金额减免促销"
                                );
                            } else {
                                console.log("未满足条件，不应用价格规则");
                            }
                            // 更新总计金额
                            this.updateTotal();
                        }
                    });
                }
            }

            if (newPromotions.some((plan) => plan.planType === 3)) {
                // ---------------超量促销------------
                if (newPromotions.some((plan) => plan.clType === 1)) {
                    // 整体变价
                    // 获取所有超量促销的整体变价方案
                    const discountPlans = newPromotions.filter(
                        (plan) => plan.planType === 3 && plan.clType === 1
                    );
                    // 处理每个方案
                    discountPlans.forEach((plan) => {
                        // 整体折扣变价
                        // 检查是否有clList数据
                        if (plan.clList && Array.isArray(plan.clList)) {
                            // 遍历每个clList项
                            plan.clList.forEach((clItem) => {
                                if (clItem.clType === 2) {
                                    // 检查该商品是否有规则列表
                                    if (clItem.clRuleList && Array.isArray(clItem.clRuleList)) {
                                        // 找出符合条件的商品 (匹配bgmId)
                                        const eligibleItems = this.cartItems.filter(
                                            (item) =>
                                                item.bgmId === clItem.bgmId && !item.isDiscounted
                                        );
                                        if (eligibleItems.length > 0) {
                                            // 计算符合条件的商品总数量
                                            const totalQuantity = eligibleItems.reduce(
                                                (sum, item) => sum + (item.quantity || 0),
                                                0
                                            );
                                            // 按照数量从大到小排序规则，找到满足条件的最大折扣
                                            const sortedRules = [...clItem.clRuleList].sort(
                                                (a, b) => b.num - a.num
                                            );
                                            let applicableRule = null;
                                            // 查找适用的规则
                                            for (const rule of sortedRules) {
                                                if (totalQuantity >= rule.num) {
                                                    applicableRule = rule;
                                                    break;
                                                }
                                            }
                                            // 如果找到了适用的规则，应用折扣
                                            if (applicableRule && applicableRule.rate !== 1) {
                                                const discountRate = applicableRule.rate;
                                                // 应用折扣到所有符合条件的商品
                                                eligibleItems.forEach((item) => {
                                                    // 保存原价用于显示折扣信息
                                                    //直接item.price作为原价
                                                    // const originalPrice = item.changePrice || item.price;
                                                    const originalPrice = item.price;
                                                    // 应用折扣到单价
                                                    item.changePrice = this.$common.getDecimalInfo(3, NP.times(originalPrice || 0, discountRate));
                                                    // 更新总金额
                                                    item.amount = this.$common.getDecimalInfo(3, NP.times(item.changePrice || 0, item.quantity || 0));
                                                    // 更新实际价格(应收价)
                                                    item.actualPrice = item.changePrice;

                                                    // 该商品参与的方案内容
                                                    item.promotionContent = {
                                                        planName: plan.planName,
                                                        planId: plan.planId,
                                                    };
                                                    // 添加折扣信息以便显示
                                                    item.discountInfo = `${plan.planName}：满${applicableRule.num}件${discountRate}折`;
                                                    // 标记为已打折
                                                    item.isDiscounted = true;
                                                });
                                            } else if (totalQuantity > 0 && !applicableRule) {
                                                // 有商品但没有满足折扣条件
                                                this.$message.info(
                                                    `${clItem.bgmName}数量${totalQuantity}不满足折扣条件`
                                                );
                                            }
                                        }
                                    }
                                }

                                if (clItem.clType === 1) {
                                    // 整体金额变价
                                    // 检查该商品是否有规则列表
                                    if (clItem.clRuleList && Array.isArray(clItem.clRuleList)) {
                                        // 找出符合条件的商品 (匹配bgmId)
                                        const eligibleItems = this.cartItems.filter(
                                            (item) =>
                                                item.bgmId === clItem.bgmId && !item.isDiscounted
                                        );

                                        if (eligibleItems.length > 0) {
                                            // 计算符合条件的商品总数量
                                            const totalQuantity = eligibleItems.reduce(
                                                (sum, item) => sum + (item.quantity || 0),
                                                0
                                            );

                                            // 按照数量从大到小排序规则，找到满足条件的最大折扣
                                            const sortedRules = [...clItem.clRuleList].sort(
                                                (a, b) => b.num - a.num
                                            );
                                            let applicableRule = null;

                                            // 查找适用的规则
                                            for (const rule of sortedRules) {
                                                if (totalQuantity >= rule.num) {
                                                    applicableRule = rule;
                                                    break;
                                                }
                                            }
                                            // 如果找到了适用的规则，应用金额变价
                                            if (applicableRule && applicableRule.money) {
                                                // 应用固定金额到所有符合条件的商品
                                                eligibleItems.forEach((item) => {
                                                    // 保存原价用于显示折扣信息
                                                    const originalPrice = item.changePrice || item.price;
                                                    // 应用固定金额到单价
                                                    item.changePrice = Number(
                                                        this.$common.getDecimalInfo(3, applicableRule.money)
                                                    )
                                                    // 更新总金额
                                                    item.amount = Number(
                                                        this.$common.getDecimalInfo(3, item.changePrice * item.quantity)
                                                    );
                                                    // 更新实际价格(应收价)
                                                    item.actualPrice = item.changePrice;

                                                    // 该商品参与的方案内容
                                                    item.promotionContent = {
                                                        planName: plan.planName,
                                                        planId: plan.planId,
                                                    };
                                                    // 添加折扣信息以便显示
                                                    item.discountInfo = `${plan.planName}：满${applicableRule.num}件${applicableRule.money}元`;
                                                    // 标记为已打折
                                                    item.isDiscounted = true;
                                                });
                                            } else if (totalQuantity > 0 && !applicableRule) {
                                                // 有商品但没有满足折扣条件
                                                this.$message.info(
                                                    `${clItem.bgmName}数量${totalQuantity}不满足条件`
                                                );
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });

                    // 更新总金额
                    this.updateTotal();
                }

                if (newPromotions.some((plan) => plan.clType === 2)) {
                    // ---------------递增变价------------
                    // 递增变价只促销一次
                    if (newPromotions.some((plan) => plan.clRoundType === 1)) {
                        // 递增变价
                        // 获取所有超量促销的整体变价方案
                        const discountPlans = newPromotions.filter(
                            (plan) => plan.planType === 3 && plan.clType === 2
                        );
                        // 处理每个方案
                        discountPlans.forEach((plan) => {
                            console.log(plan, "plan333");
                            // 整体折扣变价
                            // 检查是否有clList数据
                            if (plan.clList && Array.isArray(plan.clList)) {
                                // 遍历每个clList项
                                plan.clList.forEach((clItem) => {
                                    // 找出符合条件的商品 (匹配bgmId)
                                    const eligibleItems = this.cartItems.filter(
                                        (item) =>
                                            item.bgmId === clItem.bgmId && !item.isDiscounted
                                    );

                                    if (eligibleItems.length > 0) {
                                        // 按照数量从小到大排序规则
                                        const sortedRules = [...clItem.clRuleList].sort(
                                            (a, b) => a.num - b.num
                                        );

                                        if (sortedRules.length > 0) {
                                            // 合并处理所有符合条件的商品
                                            this.applyIncrementalDiscountMerged(
                                                eligibleItems,
                                                sortedRules,
                                                plan,
                                                clItem.clType === 2 ? "rate" : "money"
                                            );

                                            // 更新总金额
                                            this.updateTotal();
                                        }
                                    }
                                });
                            }
                        });
                    }

                    if (newPromotions.some((plan) => plan.clRoundType === 2)) {
                        // 递增变价循环促销条件
                        console.log("递增变价循环");

                        // 获取所有超量促销的递增变价循环方案
                        const discountPlans = newPromotions.filter(
                            (plan) =>
                                plan.planType === 3 &&
                                plan.clType === 2 &&
                                plan.clRoundType === 2
                        );

                        // 处理每个方案
                        discountPlans.forEach((plan) => {
                            // 检查是否有clList数据
                            if (plan.clList && Array.isArray(plan.clList)) {
                                // 遍历每个clList项
                                plan.clList.forEach((clItem) => {
                                    // 检查该商品是否有规则列表
                                    if (clItem.clRuleList && Array.isArray(clItem.clRuleList)) {
                                        // 找出符合条件的商品 (匹配bgmId)
                                        const eligibleItems = this.cartItems.filter(
                                            (item) =>
                                                item.bgmId === clItem.bgmId && !item.isDiscounted
                                        );

                                        if (eligibleItems.length > 0) {
                                            // 按照数量从小到大排序规则
                                            const sortedRules = [...clItem.clRuleList].sort(
                                                (a, b) => a.num - b.num
                                            );

                                            if (sortedRules.length > 0) {
                                                // 计算循环周期的总数量
                                                const cycleTotalQuantity =
                                                    sortedRules[sortedRules.length - 1].num;

                                                // 创建商品副本并按添加顺序排序
                                                const sortedItems = [...eligibleItems];

                                                // 记录已处理的商品数量
                                                let processedQuantity = 0;

                                                // 处理所有符合条件的商品（统一循环促销）
                                                const discountType = clItem.clType === 2 ? "rate" : "money";
                                                this.applyCyclicDiscountToMultipleItems(
                                                    eligibleItems,
                                                    sortedRules,
                                                    plan,
                                                    discountType,
                                                    cycleTotalQuantity
                                                );

                                                // 更新总金额
                                                this.updateTotal();
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }

                    if (newPromotions.some((plan) => plan.clRoundType === 3)) {
                        // 递增变价按最后一个优惠处理
                        console.log("递增变价按最后一个优惠处理");

                        // 获取所有递增变价按最后一个优惠处理的方案
                        const discountPlans = newPromotions.filter(
                            (plan) => plan.planType === 3 && plan.clRoundType === 3
                        );

                        // 处理每个方案
                        discountPlans.forEach((plan) => {
                            // 检查是否有clList数据
                            if (plan.clList && Array.isArray(plan.clList)) {
                                // 遍历每个clList项
                                plan.clList.forEach((clItem) => {
                                    // 检查该商品是否有规则列表
                                    if (clItem.clRuleList && Array.isArray(clItem.clRuleList)) {
                                        // 找出符合条件的商品 (匹配bgmId)
                                        const eligibleItems = this.cartItems.filter(
                                            (item) =>
                                                item.bgmId === clItem.bgmId && !item.isDiscounted
                                        );
                                        if (eligibleItems.length > 0) {
                                            // 按照数量从小到大排序规则
                                            const sortedRules = [...clItem.clRuleList].sort(
                                                (a, b) => a.num - b.num
                                            );
                                            if (sortedRules.length > 0) {
                                                // 获取最后一个规则（最大优惠）
                                                const lastRule = sortedRules[sortedRules.length - 1];
                                                // 创建商品副本并按添加顺序排序
                                                const sortedItems = [...eligibleItems];
                                                // 记录已处理的商品数量
                                                let processedQuantity = 0;
                                                // 遍历每个规则，应用到对应范围的商品
                                                for (const rule of sortedRules) {
                                                    // 计算此规则适用的商品数量
                                                    const ruleQuantity =
                                                        rule === lastRule
                                                            ? Number.MAX_SAFE_INTEGER // 最后一个规则应用到所有剩余商品
                                                            : rule.num - processedQuantity;
                                                    if (ruleQuantity <= 0) continue;
                                                    // 计算还有多少商品可以应用此规则
                                                    let remainingQuantity = ruleQuantity;
                                                    let appliedItems = [];
                                                    // 遍历商品，应用规则直到达到数量限制
                                                    for (const item of sortedItems) {
                                                        if (item.isRuleApplied) continue;

                                                        // 如果商品数量小于等于剩余可应用数量或者是最后一个规则
                                                        if (
                                                            item.quantity <= remainingQuantity ||
                                                            rule === lastRule
                                                        ) {
                                                            if (clItem.clType === 2) {
                                                                // 按折扣
                                                                // 保存原价用于显示折扣信息
                                                                // const originalPrice = item.changePrice || item.price;
                                                                // 折扣价计算取原价
                                                                const originalPrice = item.price;
                                                                // 应用折扣到单价
                                                                item.changePrice = Number(
                                                                    this.$common.getDecimalInfo(3, originalPrice * rule.rate)
                                                                );
                                                                // 更新总金额
                                                                item.amount = Number(
                                                                    this.$common.getDecimalInfo(3, item.changePrice * item.quantity)
                                                                );
                                                                // 更新实际价格(应收价)
                                                                item.actualPrice = item.changePrice;
                                                                // 添加折扣信息以便显示
                                                                if (
                                                                    rule === lastRule &&
                                                                    processedQuantity >= rule.num
                                                                ) {
                                                                    // 最后一个规则的后续商品
                                                                    item.discountInfo = `${plan.planName}：超过${rule.num}件后${rule.rate}折`;
                                                                } else {
                                                                    item.discountInfo = `${plan.planName}：第${processedQuantity + 1
                                                                        }-${processedQuantity + item.quantity}件${rule.rate
                                                                        }折`;
                                                                }
                                                            } else if (clItem.clType === 1) {
                                                                // 按金额
                                                                // 应用固定金额到单价
                                                                item.changePrice = Number(rule.money).toFixed(
                                                                    9
                                                                );
                                                                // 更新总金额
                                                                item.amount = Number(
                                                                    this.$common.getDecimalInfo(3, item.changePrice * item.quantity)
                                                                );
                                                                // 更新实际价格(应收价)
                                                                item.actualPrice = item.changePrice;
                                                                // 添加折扣信息以便显示
                                                                if (
                                                                    rule === lastRule &&
                                                                    processedQuantity >= rule.num
                                                                ) {
                                                                    // 最后一个规则的后续商品
                                                                    item.discountInfo = `${plan.planName}：超过${rule.num}件后${rule.money}元`;
                                                                } else {
                                                                    item.discountInfo = `${plan.planName}：第${processedQuantity + 1
                                                                        }-${processedQuantity + item.quantity}件${rule.money
                                                                        }元`;
                                                                }
                                                            }

                                                            // 标记为已打折
                                                            item.isDiscounted = true;
                                                            // 标记为已应用规则
                                                            item.isRuleApplied = true;

                                                            // 更新已处理数量和剩余可应用数量
                                                            processedQuantity += item.quantity;
                                                            remainingQuantity -= item.quantity;
                                                            appliedItems.push(item);
                                                        } else {
                                                            // 商品数量大于剩余可应用数量，需要拆分商品
                                                            // 创建新商品作为拆分后的第一部分（应用当前规则）
                                                            const splitItem = { ...item };
                                                            splitItem.quantity = remainingQuantity;

                                                            if (clItem.clType === 2) {
                                                                // 按折扣
                                                                splitItem.changePrice = Number(
                                                                    this.$common.getDecimalInfo(3, item.price * rule.rate)

                                                                );
                                                                splitItem.amount = Number(
                                                                    this.$common.getDecimalInfo(3, splitItem.changePrice * splitItem.quantity)

                                                                );
                                                                splitItem.actualPrice = splitItem.changePrice;
                                                                splitItem.discountInfo = `${plan.planName}：第${processedQuantity + 1
                                                                    }-${processedQuantity + remainingQuantity}件${rule.rate
                                                                    }折`;
                                                            } else if (clItem.clType === 1) {
                                                                // 按金额
                                                                splitItem.changePrice = Number(
                                                                    this.$common.getDecimalInfo(3, rule.money)
                                                                );
                                                                splitItem.amount = Number(
                                                                    this.$common.getDecimalInfo(3, (
                                                                        splitItem.changePrice * splitItem.quantity
                                                                    ))
                                                                );
                                                                splitItem.actualPrice = splitItem.changePrice;
                                                                splitItem.discountInfo = `${plan.planName}：第${processedQuantity + 1
                                                                    }-${processedQuantity + remainingQuantity}件${rule.money
                                                                    }元`;
                                                            }

                                                            splitItem.isDiscounted = true;
                                                            splitItem.isRuleApplied = true;

                                                            // 更新原商品为拆分后的第二部分（留待下一个规则处理）
                                                            item.quantity -= remainingQuantity;

                                                            // 添加拆分后的商品到购物车
                                                            this.cartItems.push(splitItem);
                                                            appliedItems.push(splitItem);

                                                            // 更新已处理数量和剩余可应用数量
                                                            processedQuantity += remainingQuantity;
                                                            remainingQuantity = 0;
                                                        }

                                                        // 如果已达到此规则的数量限制且不是最后一个规则，跳出循环
                                                        if (remainingQuantity <= 0 && rule !== lastRule)
                                                            break;
                                                    }
                                                }

                                                // 更新总金额
                                                this.updateTotal();
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                }
            }
            this.updateTotal();
            // 保存已选择的促销方案 - 使用深拷贝避免引用问题
            this.usedPromotions = JSON.parse(JSON.stringify(this.selectedPromotions));
            this.removeGiftItemsFromCart(this.usedPromotions); // 传入空数组，清除所有赠品



            this.promotionSelectDialogVisible = false;
        },
        async confirmPromotionSelectionIII() {
            this.selectedPromotions.forEach((plan) => {
                if (plan.mzGiftType == 1) {
                    // 赠品类型
                    // 1. 首先检查整单金额是否满足条件
                    const currentTotalAmount = this.cartItems
                        .filter((item) => !item.isGift)
                        .reduce((sum, item) => sum + (item.amount || 0), 0);
                    const requiredAmount = plan.mzOrderMoney || 0;
                    if (currentTotalAmount < requiredAmount) {
                        console.log("整单金额不满足条件，不赠送赠品");
                        return;
                    }

                    // 2. 计算重复赠送倍数
                    let mzIsRepeatNum = 1;
                    if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                        // 根据整单金额计算重复赠送倍数
                        mzIsRepeatNum = Math.floor(currentTotalAmount / requiredAmount);
                        console.log(
                            `整单满赠重复计算: 当前金额=${currentTotalAmount}, 要求金额=${requiredAmount}, 赠送倍数=${mzIsRepeatNum}`
                        );
                        this.allRePointTotal = mzIsRepeatNum * plan.memReqPoint;
                        // 如果倍数为0，说明不满足条件，不赠送
                        if (mzIsRepeatNum <= 0) {
                            console.log("不满足重复赠送条件，不赠送赠品");
                            return;
                        }
                    }

                    // 3. 处理赠品列表
                    if (plan.giftBgmList && Array.isArray(plan.giftBgmList)) {
                        plan.giftBgmList.forEach((gift) => {
                            // 计算最终赠品数量
                            const baseGiftNum = gift.giftNum || 1;
                            const finalGiftNum = baseGiftNum * mzIsRepeatNum;

                            console.log(
                                `整单满赠赠品: ${gift.bgmName}, 基础数量=${baseGiftNum}, 倍数=${mzIsRepeatNum}, 最终数量=${finalGiftNum}`
                            );

                            // 添加到 allGiftGoods
                            this.allGiftGoods.push({
                                ...gift,
                                planId: plan.planId,
                                planName: plan.planName,
                                stageDesc: `整单满${requiredAmount}元赠送`,
                                giftNum: finalGiftNum,
                                retailPrice: gift.retailPrice || 0,
                                price: gift.retailPrice || 0,
                                sellPrice: 0,
                                actualPrice: 0,
                                amount: 0,
                                retailPnumber: finalGiftNum, // 设置输入数量
                                quantity: finalGiftNum, // 设置输入数量
                                isWholeOrderGift: true, // 标记为整单满赠
                                repeatMultiple: mzIsRepeatNum, // 记录倍数
                                isGift: true,
                                allGiftGoods: true,
                                salesPerson: this.memberInfo.salesPerson,
                                salesPersonName: this.memberInfo.salesPersonName,
                                rePoint: mzIsRepeatNum * plan.mzReducePoint,
                            });
                        });
                    }

                    console.log("整单满赠赠品处理完成，赠品数量:", this.allGiftGoods);
                }
                if (plan.mzGiftType == 2) {
                    // 优惠券类型
                    console.log("处理整单满赠优惠券方案:", plan.planName);

                    // 1. 首先检查整单金额是否满足条件
                    const currentTotalAmount = this.cartItems
                        .filter((item) => !item.isGift)
                        .reduce((sum, item) => sum + (item.amount || 0), 0);

                    const requiredAmount = plan.mzOrderMoney || 0;
                    console.log(
                        `整单金额检查: 当前金额=${currentTotalAmount}, 要求金额=${requiredAmount}`
                    );
                    if (currentTotalAmount < requiredAmount) {
                        console.log("整单金额不满足条件，不赠送优惠券");
                        return;
                    }

                    // 2. 计算重复赠送倍数
                    let mzIsRepeatNum = 1;
                    if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                        // 根据整单金额计算重复赠送倍数
                        mzIsRepeatNum = Math.floor(currentTotalAmount / requiredAmount);
                        this.allRePointTotal = mzIsRepeatNum * plan.memReqPoint;
                        console.log(
                            `整单满赠优惠券重复计算: 当前金额=${currentTotalAmount}, 要求金额=${requiredAmount}, 赠送倍数=${mzIsRepeatNum}`
                        );
                        // 如果倍数为0，说明不满足条件，不赠送
                        if (mzIsRepeatNum <= 0) {
                            console.log("不满足重复赠送条件，不赠送优惠券");
                            return;
                        }
                    }
                    // 3. 处理优惠券列表
                    if (plan.giftYhqList && Array.isArray(plan.giftYhqList)) {
                        // 判断是否为任意选择模式
                        if (plan.mzGiftNumType === 1) {
                            // 任意选择模式：只处理用户选中的优惠券
                            console.log("整单满赠优惠券 - 任意选择模式");

                            // 查找用户选中的优惠券
                            const selectedCoupon = plan.giftYhqList.find(
                                (gift) => gift.yhqId === this.selectedSingleCoupon
                            );

                            if (selectedCoupon) {
                                // 计算最终优惠券数量
                                const baseCouponNum = selectedCoupon.giftNum || 1;
                                const finalCouponNum = baseCouponNum * mzIsRepeatNum;

                                console.log(
                                    `整单满赠优惠券(任选): ${selectedCoupon.yhqName}, 基础数量=${baseCouponNum}, 倍数=${mzIsRepeatNum}, 最终数量=${finalCouponNum}`
                                );

                                // 添加到 allYhq
                                this.allYhq.push({
                                    ...selectedCoupon,
                                    planId: plan.planId,
                                    planName: plan.planName,
                                    yhqId: selectedCoupon.yhqId,
                                    yhqName: selectedCoupon.yhqName,
                                    yhqDesc: selectedCoupon.yhqDesc,
                                    limitDay: selectedCoupon.limitDay,
                                    remark: selectedCoupon.remark,
                                    inputNum: finalCouponNum, // 设置输入数量
                                    stageDesc: `整单满${requiredAmount}元赠送`,
                                    isWholeOrderCoupon: true, // 标记为整单满赠
                                    repeatMultiple: mzIsRepeatNum, // 记录倍数
                                    giftNum: finalCouponNum || 1,
                                });
                            } else {
                                console.log("任意选择模式下未找到选中的优惠券");
                            }
                        } else {
                            // 多选模式：处理所有配置的优惠券
                            console.log("整单满赠优惠券 - 多选模式");

                            plan.giftYhqList.forEach((gift) => {
                                // 计算最终优惠券数量
                                const baseCouponNum = gift.giftNum || 1;
                                const finalCouponNum = baseCouponNum * mzIsRepeatNum;

                                console.log(
                                    `整单满赠优惠券(多选): ${gift.yhqName}, 基础数量=${baseCouponNum}, 倍数=${mzIsRepeatNum}, 最终数量=${finalCouponNum}`
                                );

                                // 添加到 allYhq
                                this.allYhq.push({
                                    ...gift,
                                    planId: plan.planId,
                                    planName: plan.planName,
                                    yhqId: gift.yhqId,
                                    yhqName: gift.yhqName,
                                    yhqDesc: gift.yhqDesc,
                                    limitDay: gift.limitDay,
                                    remark: gift.remark,
                                    inputNum: finalCouponNum, // 设置输入数量
                                    stageDesc: `整单满${requiredAmount}元赠送`,
                                    isWholeOrderCoupon: true, // 标记为整单满赠
                                    repeatMultiple: mzIsRepeatNum, // 记录倍数
                                    giftNum: finalCouponNum || 1,
                                });
                            });
                        }
                    }
                    console.log("整单满赠优惠券处理完成，优惠券数量:", this.allYhq);
                    this.yhqGift.push(...this.allYhq);
                    console.log("整单满赠优惠券处理完成，优惠券数量:", this.yhqGift);
                }
                if (plan.mzGiftType == 3) {
                    // 积分赠送
                    // 1. 首先检查整单金额是否满足条件
                    const currentTotalAmount = this.cartItems
                        .filter((item) => !item.isGift)
                        .reduce((sum, item) => sum + (item.amount || 0), 0);

                    const requiredAmount = plan.mzOrderMoney || 0;
                    console.log(
                        `整单积分赠送金额检查: 当前金额=${currentTotalAmount}, 要求金额=${requiredAmount}`
                    );
                    if (currentTotalAmount < requiredAmount) {
                        console.log("整单金额不满足条件，不赠送积分");
                        return;
                    }

                    // 2. 计算重复赠送倍数
                    let mzIsRepeatNum = 1;
                    if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                        // 根据整单金额计算重复赠送倍数
                        mzIsRepeatNum = Math.floor(currentTotalAmount / requiredAmount);
                        this.allAddPointTotal = mzIsRepeatNum * plan.mzAddPoint;
                        console.log(
                            `整单满赠积分重复计算: 当前金额=${currentTotalAmount}, 要求金额=${requiredAmount}, 赠送倍数=${mzIsRepeatNum}`
                        );
                        // 如果倍数为0，说明不满足条件，不赠送
                        if (mzIsRepeatNum <= 0) {
                            console.log("不满足重复赠送条件，不赠送积分");
                            return;
                        }
                    } else {
                        // 非重复模式，直接赠送配置的积分
                        this.allAddPointTotal = plan.mzAddPoint || 0;
                    }
                }
            });

            if (this.selectedPromotions.length) {
                const res = await this.$http.calculateOrderPrice({
                    bgmInfoList: this.cartItems.map((item) => ({
                        batchno: item.batchno,
                        bgmId: item.bgmId,
                        num: item.quantity,
                        recPrice: item.amount,
                        sellPrice: item.price * item.quantity,
                    })),
                    detailList: this.selectedPromotions.map((plan) => ({
                        bgmIdSet: plan.planBgmIdList,
                        mzCashBack: plan.mzCashBack,
                        mzDiscount: plan.mzDiscount,
                        mzGiftType: plan.mzGiftType,
                    })),
                });

                if (res && res.status === 200) {
                    let totalRecPrice = 0;
                    if (res.result && Array.isArray(res.result)) {
                        res.result.forEach((item) => {
                            if (item.recPrice && !isNaN(item.recPrice)) {
                                totalRecPrice += Number(item.recPrice);
                            }
                        });
                        this.payableAmount = totalRecPrice;
                    }
                    this.openBookSelectDialog();
                } else {
                    this.$message.error(res.message);
                }
            } else {
                this.openBookSelectDialog();
            }
            this.promotionSelectDialogVisible = false;
            this.isAllPromotion = false;
        },
        promotionSelectable(row) {
            // 没有传入行数据，返回false
            if (!row) return false;

            // 如果当前方案已经被选中，允许取消选择
            const isCurrentlySelected = this.selectedPromotions.some(
                (selected) => selected.planId === row.planId
            );
            if (isCurrentlySelected) return true;

            // 2. 检查与已选方案是否有商品冲突（一个商品只能参与一个促销方案）
            if (this.selectedPromotions.length === 0) return true;
            // 获取当前方案涉及的商品ID列表
            const currentBgmIds = row.planBgmIdList || [];
            // 检查是否与已选方案有商品冲突
            for (const selected of this.selectedPromotions) {
                // 跳过当前方案本身
                if (selected.planId === row.planId) continue;

                // 获取已选方案涉及的商品ID列表
                const selectedBgmIds = this.getPromotionBgmIds(selected);

                // 检查是否有商品ID重叠
                const hasConflict = currentBgmIds.some((id) =>
                    selectedBgmIds.includes(id)
                );
                if (hasConflict) {
                    console.log(
                        `促销方案冲突: ${row.planName} 与 ${selected.planName} 有相同商品`
                    );
                    return false;
                }
            }

            return true;
        },

        // 获取促销方案涉及的商品ID列表
        getPromotionBgmIds(plan) {
            const bgmIds = [];

            // 1. 从 planBgmIdList 获取（直接指定的商品）
            if (plan.planBgmIdList && Array.isArray(plan.planBgmIdList)) {
                bgmIds.push(...plan.planBgmIdList);
            }

            // 2. 从 bgmIdList 获取（直接指定的商品）
            if (plan.bgmIdList && Array.isArray(plan.bgmIdList)) {
                bgmIds.push(...plan.bgmIdList);
            }

            // 3. 从 conBgmList 获取（条件商品）
            if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                plan.conBgmList.forEach((item) => {
                    if (item.bgmId) {
                        bgmIds.push(item.bgmId);
                    }
                });
            }

            // 4. 从 clList 获取（递增变价商品）
            if (plan.clList && Array.isArray(plan.clList)) {
                plan.clList.forEach((item) => {
                    if (item.bgmId) {
                        bgmIds.push(item.bgmId);
                    }
                });
            }

            // 5. 从 stageList 获取（阶段商品）
            if (plan.stageList && Array.isArray(plan.stageList)) {
                plan.stageList.forEach((stage) => {
                    if (stage.bgmList && Array.isArray(stage.bgmList)) {
                        stage.bgmList.forEach((item) => {
                            if (item.bgmId) {
                                bgmIds.push(item.bgmId);
                            }
                        });
                    }
                });
            }

            // 6. 从其他可能的商品列表获取
            if (plan.bgmList && Array.isArray(plan.bgmList)) {
                plan.bgmList.forEach((item) => {
                    if (item.bgmId) {
                        bgmIds.push(item.bgmId);
                    }
                });
            }

            // 去重并返回
            return [...new Set(bgmIds)];
        },
        // 单选赠品变化处理（任选一个赠品模式）
        onSingleGiftChange(selectedGift) {
            console.log(
                "任选一个赠品模式 - 选择赠品:",
                selectedGift.bgmName,
                "促销方案:",
                selectedGift.planName
            );

            // 清除同一个促销方案中其他赠品的选择状态（确保只选择一个赠品）
            // 只清除任选一个模式（mzGiftNumType === 1）的促销方案中的其他赠品
            const clearOtherGiftsInSamePlan = (giftList) => {
                if (giftList && Array.isArray(giftList)) {
                    giftList.forEach((gift) => {
                        // 只清除同一个促销方案且不是当前选中的赠品
                        if (
                            gift.planId === selectedGift.planId &&
                            gift.bgmId !== selectedGift.bgmId
                        ) {
                            // 检查该促销方案是否为任选一个模式
                            const plan = this.selectedPromotions.find(
                                (p) => p.planId === gift.planId
                            );
                            if (plan && plan.mzGiftNumType === 1) {
                                gift.inputNum = 0;
                                console.log("清除同方案其他赠品选择:", gift.bgmName);
                            }
                        }
                    });
                }
            };

            clearOtherGiftsInSamePlan(this.giftList);
            clearOtherGiftsInSamePlan(this.allGiftList);

            // 设置选中赠品的数量为配置的固定值
            selectedGift.inputNum =
                selectedGift.giftNum || selectedGift.mzGiftNum || 1;

            // 同时更新原始数据中的对应项
            const updateOriginalGift = (giftList) => {
                if (giftList && Array.isArray(giftList)) {
                    const originalGift = giftList.find(
                        (gift) =>
                            gift.bgmId === selectedGift.bgmId &&
                            gift.planId === selectedGift.planId
                    );
                    if (originalGift) {
                        originalGift.inputNum = selectedGift.inputNum;
                        console.log(
                            "更新原始赠品数据:",
                            originalGift.bgmName,
                            "数量:",
                            originalGift.inputNum
                        );
                    }
                }
            };

            updateOriginalGift(this.giftList);
            updateOriginalGift(this.allGiftList);
            console.log("当前选中的单个赠品ID:", this.selectedSingleGift);
        },
        // 设置默认赠品选择
        setDefaultGiftSelection(defaultGift) {
            console.log("设置默认赠品选择:", defaultGift.bgmName);

            // 设置选中赠品的数量为配置的固定值
            const giftQuantity = defaultGift.giftNum || defaultGift.mzGiftNum || 1;

            // 更新原始数据中的对应项
            const updateOriginalGift = (giftList) => {
                if (giftList && Array.isArray(giftList)) {
                    const originalGift = giftList.find(
                        (gift) => gift.bgmId === defaultGift.bgmId
                    );
                    if (originalGift) {
                        originalGift.inputNum = giftQuantity;
                    }
                }
            };

            updateOriginalGift(this.giftList);
            updateOriginalGift(this.allGiftList);

            console.log(
                "默认赠品设置完成，赠品:",
                defaultGift.bgmName,
                "数量:",
                giftQuantity
            );
        },
        // 单选优惠券变化处理（任选一个优惠券模式）
        onSingleCouponChange(selectedCoupon) {
            console.log(
                "任选一个优惠券模式 - 选择优惠券:",
                selectedCoupon.yhqName,
                "促销方案:",
                selectedCoupon.planName
            );

            // 清除同一个促销方案中其他优惠券的选择状态（确保只选择一个优惠券）
            // 只清除任选一个模式（mzGiftNumType === 1）的促销方案中的其他优惠券
            const clearOtherCouponsInSamePlan = (couponList) => {
                if (couponList && Array.isArray(couponList)) {
                    couponList.forEach((coupon) => {
                        // 只清除同一个促销方案且不是当前选中的优惠券
                        if (
                            coupon.planId === selectedCoupon.planId &&
                            coupon.yhqId !== selectedCoupon.yhqId
                        ) {
                            // 检查该促销方案是否为任选一个模式
                            const plan = this.selectedPromotions.find(
                                (p) => p.planId === coupon.planId
                            );
                            if (plan && plan.mzGiftNumType === 1) {
                                coupon.inputNum = 0;
                                coupon.isSelected = false;
                                console.log("清除同方案其他优惠券选择:", coupon.yhqName);
                            }
                        }
                    });
                }
            };

            // 清除原始数据中其他优惠券的选择状态
            clearOtherCouponsInSamePlan(this.giftYhqList);
            clearOtherCouponsInSamePlan(this.allGiftYhqList);

            // 设置选中优惠券的数量
            this.setDefaultCouponSelection(selectedCoupon);
            console.log("当前选中的单个优惠券ID:", this.selectedSingleCoupon);
        },
        // 设置默认优惠券选择
        setDefaultCouponSelection(defaultCoupon) {
            console.log("设置默认优惠券选择:", defaultCoupon.yhqName);
            // 设置选中优惠券的数量为配置的固定值
            const couponQuantity =
                defaultCoupon.giftNum || defaultCoupon.mzGiftNum || 1;
            // 更新原始数据中的对应项
            const updateOriginalCoupon = (couponList) => {
                if (couponList && Array.isArray(couponList)) {
                    const targetCoupon = couponList.find(
                        (coupon) => coupon.yhqId === defaultCoupon.yhqId
                    );
                    if (targetCoupon) {
                        targetCoupon.inputNum = couponQuantity;
                        targetCoupon.isSelected = true;
                        console.log(
                            `更新优惠券 ${targetCoupon.yhqName} 数量为: ${couponQuantity}`
                        );
                    }
                }
            };
            updateOriginalCoupon(this.giftYhqList);
            updateOriginalCoupon(this.allGiftYhqList);
            console.log(
                "默认优惠券设置完成，优惠券:",
                defaultCoupon.yhqName,
                "数量:",
                couponQuantity
            );
        },
        // 添加优惠券到列表（区分任选一个和多选模式）
        addCouponsToList(plan) {
            console.log("处理优惠券赠送，促销方案:", plan.planName);

            if (plan.mzGiftNumType === 1) {
                // 任选一个优惠券模式
                this.addSelectedSingleCoupon(plan);
            } else {
                // 多选模式，赠送所有配置的优惠券
                this.addMultipleCoupons(plan);
            }
        },
        // 添加用户选择的单个优惠券（任选一个优惠券模式）
        addSelectedSingleCoupon(plan) {
            if (!this.selectedSingleCoupon) {
                console.log("未选择任何优惠券");
                return;
            }
            // 计算重复赠送倍数
            let mzIsRepeatNum = 1;
            if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                // 计算符合条件的商品数量
                let qualifiedQuantity = 0;
                if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                    // 如果有指定条件商品，计算条件商品的总数量
                    plan.conBgmList.forEach((conditionItem) => {
                        const matchedCartItem = this.cartItems.find(
                            (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                        );
                        if (matchedCartItem) {
                            qualifiedQuantity += matchedCartItem.quantity;
                        }
                    });
                }
                // 根据条件商品数量要求计算赠送倍数（向下取整）
                const conditionNum = plan.mzConBgmNum || 1;
                mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);
                console.log(
                    `赠品重复赠送计算: 符合条件商品数量=${qualifiedQuantity}, 条件要求=${conditionNum}, 赠送倍数=${mzIsRepeatNum}`
                );
                // 如果倍数为0，说明不满足条件，不赠送
                if (mzIsRepeatNum <= 0) {
                    console.log("不满足重复赠送条件，不赠送赠品");
                    return;
                }
            }
            console.log("未选择任何优惠券77777777777");
            // 查找选中的优惠券
            const selectedCoupon = this.availableCouponList.find(
                (coupon) =>
                    coupon.yhqId === this.selectedSingleCoupon &&
                    coupon.planId === plan.planId
            );

            console.log("赠送选中的优惠券---------:", selectedCoupon);

            if (selectedCoupon) {
                this.yhqGift.push({
                    ...selectedCoupon,
                    giftNum: selectedCoupon.giftNum * mzIsRepeatNum,
                });
                console.log("优惠券列表this.yhqGift", this.yhqGift);
            }
        },
        // 添加多个优惠券（多选模式）
        addMultipleCoupons(plan) {
            if (!plan.giftYhqList || !Array.isArray(plan.giftYhqList)) {
                console.log("促销方案没有配置优惠券列表");
                return;
            }
            // 获取有效的优惠券列表（有数量的优惠券）
            const couponsToAdd = this.availableCouponList.filter(
                (coupon) => coupon.inputNum > 0
            );
            let mzIsRepeatNum = 1;
            // 重复赠送判断 mzIsRepeat
            if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                // 计算符合条件的商品数量
                let qualifiedQuantity = 0;
                if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                    // 如果有指定条件商品，计算条件商品的总数量
                    plan.conBgmList.forEach((conditionItem) => {
                        const matchedCartItem = this.cartItems.find(
                            (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                        );
                        if (matchedCartItem) {
                            qualifiedQuantity += matchedCartItem.quantity;
                        }
                    });
                }

                // 根据条件商品数量要求计算赠送倍数（向下取整）
                const conditionNum = plan.mzConBgmNum || 1;
                mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);
                // 如果倍数为0，说明不满足条件，不赠送
                if (mzIsRepeatNum <= 0) {
                    console.log("不满足重复赠送条件，不赠送优惠券");
                    return;
                }
            }
            if (couponsToAdd.length === 0) {
                // 如果没有用户选择的优惠券，则添加所有配置的优惠券
                plan.giftYhqList.forEach((coupon) => {
                    const baseCouponQuantity = coupon.giftNum || 1;
                    const finalCouponQuantity = baseCouponQuantity * mzIsRepeatNum;
                    console.log(
                        `优惠券 ${coupon.yhqName}: 基础数量=${baseCouponQuantity}, 倍数=${mzIsRepeatNum}, 最终数量=${finalCouponQuantity}`
                    );
                    this.yhqGift.push({
                        ...coupon,
                        inputNum: finalCouponQuantity,
                        giftNum: finalCouponQuantity,
                    });
                    console.log("优惠券列表this.yhqGift", this.yhqGift);
                });
            }
        },
        // 添加赠品到购物车（区分任选一个和多选模式）
        async addGiftsToCart(plan) {
            this.MoreGiftPlan = plan;
            // 计算重复赠送倍数
            let mzIsRepeatNum = this.calculateRepeatMultiple(plan);
            // 将倍数信息传递给子方法
            plan._calculatedRepeatNum = mzIsRepeatNum;
            // 自动应用赠品选择功能
            if (plan.mzGiftNumType === 1) {
                await this.addSelectedSingleGiftAuto(plan);
            } else {
                await this.addMultipleGiftsAuto(plan);
            }
        },

        // 自动应用单选赠品模式（带弹窗选择和批号设置）
        async addSelectedSingleGiftAuto(plan) {
            try {
                console.log("🎁 开始自动应用单选赠品模式");
                console.log();

                // 获取可用赠品列表
                const availableGifts = this.getAvailableGiftsFromPlan(plan);
                console.log("可用赠品列表", availableGifts);

                if (!availableGifts || availableGifts.length === 0) {
                    this.$message.warning("当前促销方案没有可选赠品");
                    return;
                }
                let selectedGift;
                // 检查当前促销方案是否已有选中的赠品（从availableGifts中查找已设置数量的赠品）
                selectedGift = availableGifts.find(gift =>
                    gift.inputNum && gift.inputNum > 0 && gift.planId === plan.planId
                );
                // 如果当前促销方案没有选中赠品，进行选择
                if (!selectedGift) {
                    selectedGift = availableGifts
                }
                // 处理赠品数量
                const giftQuantity = selectedGift.giftNum || selectedGift.mzGiftNum || 1;
                const repeatNum = plan._calculatedRepeatNum || 1;
                const finalQuantity = giftQuantity * repeatNum;
                // 添加赠品并处理批号
                await this.addGiftWithBatchSelectionAuto(selectedGift, plan, finalQuantity);
            } catch (error) {
                console.error("🎁 自动应用单选赠品失败:", error);
                this.$message.error("赠品选择处理失败，请重试");
            }
        },

        // 自动应用多选赠品模式（全部赠送，每个都需要选择批号）
        async addMultipleGiftsAuto(plan) {
            try {
                console.log("🎁 开始自动应用多选赠品模式 - 全部赠送");

                // 获取可用赠品列表
                const availableGifts = this.getAvailableGiftsFromPlan(plan);

                if (!availableGifts || availableGifts.length === 0) {
                    this.$message.warning("当前促销方案没有可选赠品");
                    return;
                }

                console.log("🎁 多选模式 - 可用赠品列表:", availableGifts);

                const repeatNum = plan._calculatedRepeatNum || 1;

                // 检查购物车中是否已有该促销方案的赠品（已选择批号）
                const existingGiftsInCart = this.cartItems.filter(item =>
                    item.isGift &&
                    item.planId === plan.planId &&
                    item.batchno &&
                    plan.giftBgmList &&
                    plan.giftBgmList.some(bg => bg.bgmId === item.bgmId)
                );

                console.log("🎁 购物车中已存在的促销方案赠品:", existingGiftsInCart);

                if (existingGiftsInCart.length > 0) {
                    // 购物车中已有该促销方案的赠品，只修改数量，不弹窗
                    console.log("🎁 购物车中已有赠品，直接修改数量");

                    for (const gift of availableGifts) {
                        const giftQuantity = gift.giftNum || gift.mzGiftNum || 1;
                        const finalQuantity = giftQuantity * repeatNum;

                        // 查找购物车中对应的赠品
                        const existingGift = existingGiftsInCart.find(cartItem =>
                            plan.giftBgmList.some(bg => bg.bgmId === cartItem.bgmId && bg.bgmId === gift.bgmId)
                        );

                        if (existingGift) {
                            // 直接使用已有的批号信息，只修改数量
                            console.log(`🎁 更新已有赠品数量: ${gift.bgmName}, 新数量: ${finalQuantity}`);
                            this.addGiftToCartAuto(gift, plan, finalQuantity, {
                                batchno: existingGift.batchno,
                                expidate: existingGift.expidate,
                                prodate: existingGift.prodate,
                                ...existingGift
                            });
                        } else {
                            // 该赠品在购物车中不存在，需要选择批号
                            console.log(`🎁 新赠品需要选择批号: ${gift.bgmName}`);
                            await this.addGiftWithBatchSelectionAutoII(gift, plan, finalQuantity);
                        }
                    }
                } else {
                    // 购物车中没有该促销方案的赠品，显示批号选择弹窗
                    console.log("🎁 购物车中没有赠品，显示批号选择弹窗");

                    // 为每个赠品添加数量信息
                    const giftsWithQuantity = availableGifts.map(gift => ({
                        ...gift,
                        giftQuantity: (gift.giftNum || gift.mzGiftNum || 1) * repeatNum
                    }));

                    // 显示批号选择弹窗，传递所有赠品
                    const selectionResult = await this.showBatchSelectionDialogII(giftsWithQuantity);

                    if (selectionResult && selectionResult.length > 0) {
                        // 处理所有选择了批号的赠品
                        for (const giftWithBatch of selectionResult) {
                            console.log(`🎁 添加赠品到购物车: ${giftWithBatch.bgmName}, 批号: ${giftWithBatch.batchno}`);
                            this.addGiftToCartAuto(giftWithBatch, plan, giftWithBatch.giftQuantity, giftWithBatch);
                        }
                    }
                }

                console.log("🎁 多选模式 - 所有赠品处理完成");

            } catch (error) {
                console.error("🎁 自动应用多选赠品失败:", error);
                this.$message.error("赠品选择处理失败，请重试");
            }
        },



        // 添加赠品并自动处理批号选择
        async addGiftWithBatchSelectionAuto(gift, plan, quantity) {
            try {
                let selectedBatch = null;

                console.log("🎁 添加赠品并自动处理批号选择", this.cartItems);
                console.log("🎁 添加赠品并自动处理批号选择", plan);


                // 检查购物车中是否已存在相同促销方案的当前具体赠品（有批号）
                const existingGiftInCart = this.cartItems.find(item =>
                    plan.giftBgmList && plan.giftBgmList.some(bg => bg.bgmId === item.bgmId) &&
                    item.isGift &&
                    item.batchno
                    && item.planId === plan.planId // 确保是同一个促销方案

                );

                console.log("🎁 existingGiftInCart", existingGiftInCart);
                if (existingGiftInCart) {
                    selectedBatch = {
                        batchno: existingGiftInCart.batchno,
                        quantity: existingGiftInCart.giftNum,
                        expidate: existingGiftInCart.expidate || '',
                        prodate: existingGiftInCart.prodate || '',
                        num: existingGiftInCart.num,
                        ...existingGiftInCart
                    };
                } else {
                    // 购物车中没有相同赠品，弹窗选择批号
                    const selectionResult = await this.showBatchSelectionDialog(gift);
                    console.log("🎁 批号选择结果:", selectionResult);
                    if (selectionResult) {
                        // 批号已直接赋值到赠品对象中
                        selectedBatch = {
                            ...selectionResult,
                            num: selectionResult.num,
                            quantity: selectionResult.giftNum,
                        };
                        this.addGiftToCartAuto(gift, plan, selectionResult.giftNum, selectedBatch);
                        return;
                    }
                }

                // 添加赠品到购物车
                this.addGiftToCartAuto(gift, plan, quantity, selectedBatch);

            } catch (error) {
                console.error("🎁 添加赠品时发生错误:", error);

            }
        },
        // 添加赠品并自动处理批号选择
        async addGiftWithBatchSelectionAutoII(gift, plan, quantity) {

            try {
                let selectedBatch = null;

                console.log("🎁 添加赠品并自动处理批号选择", this.cartItems);
                console.log("🎁 添加赠品并自动处理批号选择", plan);


                // 检查购物车中是否已存在相同促销方案的当前具体赠品（有批号）
                const existingGiftInCart = this.cartItems.find(item =>
                    plan.giftBgmList && plan.giftBgmList.some(bg => bg.bgmId === item.bgmId) &&
                    item.isGift &&
                    item.batchno
                    && item.planId === plan.planId // 确保是同一个促销方案

                );

                console.log("🎁 existingGiftInCart", existingGiftInCart);
                if (existingGiftInCart) {
                    selectedBatch = {
                        batchno: existingGiftInCart.batchno,
                        quantity: existingGiftInCart.giftNum,
                        expidate: existingGiftInCart.expidate || '',
                        prodate: existingGiftInCart.prodate || '',
                        ...existingGiftInCart
                    };
                } else {
                    // 购物车中没有相同赠品，弹窗选择批号
                    const selectionResult = await this.showBatchSelectionDialogII(gift);
                    console.log("🎁 批号选择结果:", selectionResult);
                    if (selectionResult) {
                        // 批号已直接赋值到赠品对象中
                        selectedBatch = {
                            ...selectionResult,
                            quantity: selectionResult.giftNum,
                        };
                    }
                }

                // 添加赠品到购物车
                this.addGiftToCartAuto(gift, plan, quantity, selectedBatch);

            } catch (error) {
                console.error("🎁 添加赠品时发生错误:", error);

            }
        },

        // 显示批号选择弹窗
        async showBatchSelectionDialog(gift) {
            return new Promise((resolve) => {
                // 检查商品是否已经设置了批号
                if (gift.batchno) {
                    // 直接返回现有批号信息
                    resolve({
                        gift: gift
                    });
                    return;
                }

                // 设置弹窗数据
                this.batchSelectionDialog.giftInfo = gift;
                this.batchSelectionDialog.resolve = resolve;

                // 显示弹窗
                this.batchSelectionDialog.visible = true;
            });
        },
        // 显示批号选择弹窗（多选模式 - 处理赠品数组）
        async showBatchSelectionDialogII(gifts) {
            return new Promise((resolve) => {
                // 设置弹窗数据（传递赠品数组）
                this.batchSelectionDialogII.giftInfo = gifts;
                this.batchSelectionDialogII.resolve = resolve;

                // 显示弹窗
                this.batchSelectionDialogII.visible = true;
            });
        },
        // 处理赠品选择确认事件
        onGiftSelectionConfirm(selectionData) {
            this.isMoreGift = false;
            console.log("🎁 赠品选择确认:", selectionData);
            if (this.batchSelectionDialog.resolve) {
                // 校验同批号同bgmId的商品总数量是否超过库存
                const selectedGift = selectionData.gift;

                // 计算购物车中同批号同bgmId的总数量
                const totalQuantity = this.cartItems.reduce((sum, cartItem) => {
                    if (cartItem.bgmId === selectedGift.bgmId && cartItem.batchno === selectedGift.batchno) {
                        // 直接使用商品数量，不考虑中药饮片副数
                        return sum + cartItem.quantity;
                    }
                    return sum;
                }, 0);

                // 加上即将添加的赠品数量（默认为1）
                const giftQuantity = selectedGift.giftQuantity || selectedGift.quantity || 1;
                const newTotalQuantity = totalQuantity + giftQuantity;

                // 检查是否超过库存
                if (selectedGift.num && newTotalQuantity > selectedGift.num) {
                    // 计算可用的赠品数量（库存 - 购物车已有数量）
                    const availableQuantity = Math.max(0, selectedGift.num - totalQuantity);

                    if (availableQuantity > 0) {
                        // 还有可用库存，将赠品数量调整为可用数量
                        selectedGift.giftQuantity = availableQuantity;
                        selectedGift.quantity = availableQuantity;
                        this.$message.warning(`赠品"${selectedGift.bgmName}"批号"${selectedGift.batchno}"库存不足，已自动调整数量为：${availableQuantity}（当前库存：${selectedGift.num}，购物车已有：${totalQuantity}）`);
                    } else {
                        // 没有可用库存，阻止添加
                        this.$message.warning(`赠品"${selectedGift.bgmName}"批号"${selectedGift.batchno}"库存不足，无法添加（当前库存：${selectedGift.num}，购物车已有：${totalQuantity}）`);
                        return; // 阻止添加
                    }
                }

                this.batchSelectionDialog.resolve(selectedGift);
                console.log(this.batchSelectionDialog,"测试");
                
            }
            this.onQuantityEnter();

        },
        onGiftSelectionConfirmIII(selectionData) {
            console.log("🎁 单选赠品选择确认:", selectionData);
            this.isMoreGift = true;
            console.log("🎁 单选赠品选择确认:", this.MoreGiftPlan);

            this.cartItems.forEach(item => {
                if (item.planId === this.MoreGiftPlan.planId) {
                    item.isMoreGift = true;

                }
            });
            console.log("🎁 购物车商品:", this.cartItems);
            // 计算重复赠送倍数
            let mzIsRepeatNum = this.calculateRepeatMultiple(this.MoreGiftPlan);
            console.log("🎁 允许的重复倍数:", mzIsRepeatNum);

            // 计算选择的赠品数量总和
            let totalSelectedQuantity = 0;
            if (selectionData.gifts && selectionData.gifts.length > 0) {
                totalSelectedQuantity = selectionData.gifts.reduce((sum, gift) => {
                    return sum + (Number(gift.giftQuantity) || 0);
                }, 0);
            } else if (selectionData.gift) {
                totalSelectedQuantity = Number(selectionData.gift.giftQuantity) || 0;
            }

            console.log("🎁 选择的赠品数量总和:", totalSelectedQuantity);

            // 判断数量是否超过允许的倍数
            if (totalSelectedQuantity > mzIsRepeatNum) {
                this.$message.warning(`选择的赠品数量总和(${totalSelectedQuantity})超过了允许的数量(${mzIsRepeatNum})，请重新选择`);
                return;
            }
            // 校验库存是否充足  
            const validGifts = [];
            let hasStockIssue = false;

            if (selectionData.gifts && selectionData.gifts.length > 0) {
                // 处理多个赠品的库存校验
                selectionData.gifts.forEach(selectedGift => {
                    // 检查购物车中是否已有相同的赠品（相同bgmId和batchno）
                    const existingItems = this.cartItems.filter(item =>
                        item.bgmId === selectedGift.bgmId &&
                        item.batchno === selectedGift.batchno
                    );

                    // 计算购物车中已有的总数量
                    const totalQuantity = existingItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
                    const newTotalQuantity = totalQuantity + (Number(selectedGift.giftQuantity) || 0);

                    // 检查是否超过库存
                    if (selectedGift.num && newTotalQuantity > selectedGift.num) {
                        // 计算可用的赠品数量（库存 - 购物车已有数量）
                        const availableQuantity = Math.max(0, selectedGift.num - totalQuantity);

                        if (availableQuantity > 0) {
                            // 还有可用库存，将赠品数量调整为可用数量
                            selectedGift.giftQuantity = availableQuantity;
                            selectedGift.quantity = availableQuantity;
                            this.$message.warning(`赠品"${selectedGift.bgmName}"批号"${selectedGift.batchno}"库存不足，已自动调整数量为：${availableQuantity}（当前库存：${selectedGift.num}，购物车已有：${totalQuantity}）`);
                            validGifts.push(selectedGift);
                        } else {
                            // 没有可用库存，跳过这个赠品
                            this.$message.warning(`赠品"${selectedGift.bgmName}"批号"${selectedGift.batchno}"库存不足，无法添加（当前库存：${selectedGift.num}，购物车已有：${totalQuantity}）`);
                            hasStockIssue = true;
                        }
                    } else {
                        // 库存充足，直接添加
                        validGifts.push(selectedGift);
                    }
                });
            } else if (selectionData.gift) {
                // 处理单个赠品的库存校验
                const selectedGift = selectionData.gift;
                const existingItems = this.cartItems.filter(item =>
                    item.bgmId === selectedGift.bgmId &&
                    item.batchno === selectedGift.batchno
                );

                const totalQuantity = existingItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
                const newTotalQuantity = totalQuantity + (Number(selectedGift.giftQuantity) || 0);

                if (selectedGift.num && newTotalQuantity > selectedGift.num) {
                    const availableQuantity = Math.max(0, selectedGift.num - totalQuantity);

                    if (availableQuantity > 0) {
                        selectedGift.giftQuantity = availableQuantity;
                        selectedGift.quantity = availableQuantity;
                        this.$message.warning(`赠品"${selectedGift.bgmName}"批号"${selectedGift.batchno}"库存不足，已自动调整数量为：${availableQuantity}（当前库存：${selectedGift.num}，购物车已有：${totalQuantity}）`);
                        validGifts.push(selectedGift);
                    } else {
                        this.$message.warning(`赠品"${selectedGift.bgmName}"批号"${selectedGift.batchno}"库存不足，无法添加（当前库存：${selectedGift.num}，购物车已有：${totalQuantity}）`);
                        hasStockIssue = true;
                    }
                } else {
                    validGifts.push(selectedGift);
                }
            }

            // 如果有库存问题且没有有效赠品，则停止处理
            if (validGifts.length === 0) {
                this.$message.error('所有选择的赠品都库存不足，无法添加到购物车');
                return;
            }

            console.log("🎁 库存校验通过的赠品:", validGifts);

            // 将有效的赠品添加到购物车
            if (validGifts.length > 0) {
                validGifts.forEach(gift => {
                    // 设置赠品标识和属性
                    const giftItem = {
                        ...gift,
                        bgmId: gift.bgmId,
                        batchno: gift.batchno,
                        bgmName: this.MoreGiftPlan.giftBgmList[0].bgmName,
                        spec: this.MoreGiftPlan.giftBgmList[0].spec,
                        bgmCode: this.MoreGiftPlan.giftBgmList[0].bgmCode,
                        quantity: Number(gift.giftQuantity) || Number(gift.quantity) || 1,
                        price: this.MoreGiftPlan.giftBgmList[0].price, // 赠品价格为0
                        changePrice: this.MoreGiftPlan.giftBgmList[0].price,
                        actualPrice: this.MoreGiftPlan.giftBgmList[0].price,
                        memberPrice: this.MoreGiftPlan.giftBgmList[0].price,
                        amount: this.MoreGiftPlan.giftBgmList[0].price,
                        salesPerson: this.memberInfo.salesPerson || "",
                        salesPersonName: this.memberInfo.salesPersonName || "",
                        isGift: true,
                        planId: this.MoreGiftPlan.planId,
                        giftType: 'promotion', // 促销赠品类型
                        giftPlanId: this.MoreGiftPlan ? this.MoreGiftPlan.planId : null, // 关联的促销计划ID
                        addTime: new Date().getTime() // 添加时间戳
                    };

                    // 检查购物车中是否已存在相同的赠品
                    const existingGiftIndex = this.cartItems.findIndex(item =>
                        item.bgmId === gift.bgmId &&
                        item.batchno === gift.batchno &&
                        item.isGift === true
                    );

                    if (existingGiftIndex !== -1) {
                        // 如果已存在，更新数量
                        this.cartItems[existingGiftIndex].quantity += giftItem.quantity;
                        console.log(`🎁 更新购物车中已有赠品: ${gift.bgmName}, 新数量: ${this.cartItems[existingGiftIndex].quantity}`);
                    } else {
                        // 如果不存在，添加新的赠品项
                        this.cartItems.push(giftItem);
                        console.log(`🎁 添加新赠品到购物车: ${gift.bgmName}, 数量: ${giftItem.quantity}`);
                    }
                });

                // 显示成功消息
                this.$message.success(`成功添加 ${validGifts.length} 个赠品到购物车`);

                // 更新购物车显示和计算
                this.onQuantityEnter();

                // 记录赠品添加日志
                console.log("🎁 赠品添加完成，当前购物车:", this.cartItems.filter(item => item.isGift));

                // 如果有促销计划，可以记录已使用的赠品数量
                if (this.MoreGiftPlan) {
                    console.log(`🎁 促销计划 ${this.MoreGiftPlan.planId} 已使用赠品数量: ${validGifts.reduce((sum, gift) => sum + (gift.giftQuantity || 0), 0)}`);
                }
            } else {
                this.$message.warning('没有有效的赠品可以添加到购物车');
            }

        },
        // 处理赠品选择确认事件（多选模式）
        onGiftSelectionConfirmII(selectionData) {
            console.log("🎁 多选赠品选择确认:", selectionData);
            if (this.batchSelectionDialogII.resolve) {
                const selectedGifts = selectionData.gifts || [];
                // 所有赠品库存校验通过，返回赠品数组
                this.batchSelectionDialogII.resolve(selectedGifts);
            }
            this.onQuantityEnter();
        },

        // 处理赠品选择关闭事件
        onGiftSelectionClose() {
            console.log("🎁 赠品选择关闭");
            if (this.batchSelectionDialog.resolve) {
                this.batchSelectionDialog.resolve(null);
            }
        },
        // 处理赠品选择 全部赠送 关闭事件
        onGiftSelectionCloseII() {
            if (this.batchSelectionDialogII.resolve) {
                this.batchSelectionDialogII.resolve(null);
            }
        },
        // 添加赠品到购物车（自动版本）
        addGiftToCartAuto(gift, plan, quantity, batchInfo) {
            console.log("🎁 addGiftToCartAuto", gift, plan, quantity, batchInfo);
            if (this.isMoreGift) {
                return;
            }
            // 校验库存：检查同品种bgmId和同批号的商品数量之和不能超过库存
            const totalQuantity = this.cartItems.reduce((sum, cartItem) => {
                if (cartItem.bgmId === batchInfo.bgmId && cartItem.batchno === batchInfo.batchno && !cartItem.isGift) {
                    // 只统计非赠品的商品数量，排除赠品
                    return sum + cartItem.quantity;
                }
                return sum;
            }, 0);

            // quantity是赠品的总数量，需要检查总数量是否超过库存
            const newTotalQuantity = totalQuantity + quantity;

            // 检查是否超过库存
            if (batchInfo.num && newTotalQuantity > batchInfo.num) {
                // 计算可用的赠品数量（库存 - 购物车已有数量）
                const availableQuantity = Math.max(0, batchInfo.num - totalQuantity);

                if (availableQuantity > 0) {
                    // 调整赠品数量为可用数量
                    quantity = availableQuantity;
                    this.$message.warning(`赠品"${batchInfo.bgmName}"批号"${batchInfo.batchno}"库存不足，已自动调整数量为：${availableQuantity}（当前库存：${batchInfo.num}，购物车已有：${totalQuantity}）`);
                } else {
                    // 没有可用库存，阻止添加
                    this.$message.warning(`赠品"${batchInfo.bgmName}"批号"${batchInfo.batchno}"库存不足，无法添加（当前库存：${batchInfo.num}，购物车已有：${totalQuantity}）`);
                    return; // 阻止添加
                }
            }

            try {
                // 计算赠品价格
                const giftPrice = plan.giftBgmList[0].price || 0;
                const giftAmount = giftPrice * quantity;

                // 检查购物车是否已存在该赠品
                const existingGift = this.cartItems.find(
                    (item) => item.bgmId === batchInfo.bgmId && item.isGift && item.batchno === batchInfo.batchno && item.planId === plan.planId
                );
                console.log("🎁 existingGift数据:", existingGift);
                if (existingGift) {
                    // 更新已存在的赠品
                    existingGift.quantity = quantity;
                    existingGift.amount = giftAmount;
                    existingGift.actualPrice = giftPrice;
                    existingGift.changePrice = giftPrice;
                    existingGift.num = batchInfo.num;
                    existingGift.discountInfo = `${plan.planName}：赠品`;
                    console.log("🎁 更新已存在的赠品:", existingGift);
                    // 更新批号信息
                    if (batchInfo) {
                        existingGift.batchno = batchInfo.batchno;
                        existingGift.expidate = batchInfo.expidate;
                        existingGift.prodate = batchInfo.prodate;
                    }
                } else {
                    // 添加新的赠品到购物车
                    const giftItem = {
                        bgmId: batchInfo.bgmId,
                        bgmName: batchInfo.bgmName,
                        spec: batchInfo.spec,
                        manufacturer: batchInfo.manufacturer,
                        barcode: batchInfo.barcode,
                        bgmCode: batchInfo.bgmCode,
                        bgiIsesupervise: batchInfo.bgiIsesupervise,
                        price: giftPrice,
                        changePrice: giftPrice,
                        actualPrice: giftPrice,
                        memberPrice: giftPrice,
                        quantity: quantity,
                        amount: giftAmount,
                        num: batchInfo.num,
                        isGift: true,
                        giftPlanName: plan.planName,
                        bgiPretype: batchInfo.bgiPretype || "",
                        planId: plan.planId,
                        bgiType: batchInfo.bgiType || "",
                        expidate: batchInfo.expidate,
                        prodate: batchInfo.prodate,
                        batchno: batchInfo.batchno,
                        bgiAppnumber: batchInfo.bgiAppnumber,
                        bgiPerholder: batchInfo.bgiPerholder,
                        salesPerson: this.memberInfo.salesPerson || "",
                        salesPersonName: this.memberInfo.salesPersonName || "",
                        discountInfo: `${plan.planName}：赠品`,
                        // 初始化响应式属性
                        isDiscounted: false,
                        isRuleApplied: false,
                        isSelected: false,
                        isMergedItem: false,
                        isPointPromotion: false,
                        mixedPriceInfo: null,
                        addPoint: 0,
                        rePoint: 0,
                        repeatMultiple: 0,
                        totalPromotionPoints: 0,
                    };

                    this.cartItems.push(giftItem);
                }

                this.cartItems[this.selectedItemIndex].giftContent = {
                    quantity: quantity,
                    batchno: batchInfo.batchno,
                    bgmId: batchInfo.bgmId,

                };
                console.log("🎁 添加赠品到购物车（自动版本）6666:", this.cartItems);



                // 更新购物车总计
                this.updateTotal();
                console.log("🎁 添加赠品到购物车（自动版本）:", this.cartItems);
            } catch (error) {
                this.$message.info("取消添加赠品");

                this.resetSingleItemToOriginal(this.cartItems[this.selectedItemIndex]);

            }
        },


        // 从促销方案获取可用赠品列表
        getAvailableGiftsFromPlan(plan) {
            // 只从当前促销方案中获取赠品列表，不使用全局的 availableGiftList
            if (plan.giftBgmList && plan.giftBgmList.length > 0) {
                return plan.giftBgmList.map(gift => ({
                    ...gift,
                    planId: plan.planId,
                    planName: plan.planName
                }));
            }

            // 从其他可能的字段获取
            if (plan.mzGiftGoods && plan.mzGiftGoods.length > 0) {
                return plan.mzGiftGoods.map(gift => ({
                    ...gift,
                    planId: plan.planId,
                    planName: plan.planName
                }));
            }

            console.warn("🎁 促销方案中没有找到可选赠品列表:", plan.planName);
            return [];
        },

        // 添加用户选择的单个赠品（任选一个商品模式）
        addSelectedSingleGift(plan) {
            console.log("🎁 当前选中的赠品ID:", this.selectedSingleGift);
            console.log("🎁 可用赠品列表:", this.availableGiftList);

            const selectedGift = this.availableGiftList.find(
                (gift) => gift.bgmId === this.selectedSingleGift
            );

            if (!selectedGift) {
                console.log("🎁 未找到选中的赠品，尝试类型转换匹配");
                // 尝试类型转换匹配
                const selectedGiftByString = this.availableGiftList.find(
                    (gift) => String(gift.bgmId) === String(this.selectedSingleGift)
                );

                if (selectedGiftByString) {
                    this.addSingleGiftToCart(
                        selectedGiftByString,
                        selectedGiftByString.giftNum || 1,
                        plan
                    );
                    return;
                }
                return;
            }
            // 确保选中的赠品有正确的数量
            if (!selectedGift.inputNum || selectedGift.inputNum <= 0) {
                selectedGift.inputNum =
                    selectedGift.giftNum || selectedGift.mzGiftNum || 1;
            }

            // 应用重复赠送倍数（如果有的话）
            const repeatNum = plan._calculatedRepeatNum || 1;
            const finalQuantity = selectedGift.inputNum * repeatNum;

            // 检查购物车是否已存在该赠品
            const existingGift = this.cartItems.find(
                (item) => item.bgmId === selectedGift.bgmId && item.isGift
            );
            console.log("existingGift", existingGift);
            console.log("selectedGift", selectedGift);
            // 计算赠品价格：优先使用 gift.price，为空时使用 0
            const giftPrice = selectedGift.price || 0;
            const giftAmount = giftPrice * finalQuantity;
            if (existingGift) {
                // 更新已存在的赠品
                existingGift.quantity = finalQuantity;
                existingGift.amount = giftAmount;
                existingGift.actualPrice = giftPrice;
                existingGift.changePrice = giftPrice;
                existingGift.discountInfo = `${plan.planName}：赠品`;
            } else {
                // 添加新的赠品到购物车
                this.cartItems.push({
                    bgmId: selectedGift.bgmId,
                    bgmName: selectedGift.bgmName,
                    spec: selectedGift.spec,
                    manufacturer: selectedGift.manufacturer,
                    barcode: selectedGift.barcode,
                    bgmCode: selectedGift.bgmCode,
                    price: selectedGift.price || 0,
                    changePrice: selectedGift.price || 0,
                    actualPrice: selectedGift.price || 0,
                    quantity: finalQuantity,
                    amount: giftAmount,
                    isGift: true, // 标记为赠品
                    giftPlanName: plan.planName, // 记录促销方案名称
                    bgiPretype: selectedGift.bgiPretype || "",
                    bgiType: selectedGift.bgiType || "",
                    expidate: selectedGift.expidate,
                    prodate: selectedGift.prodate,
                    batchno: selectedGift.batchno,
                    bgiAppnumber: selectedGift.bgiAppnumber,
                    bgiPerholder: selectedGift.bgiPerholder,
                    salesPerson: this.memberInfo.salesPerson || "",
                    salesPersonName: this.memberInfo.salesPersonName || "",
                    discountInfo: `${plan.planName}：赠品`,
                    // 初始化响应式属性
                    isDiscounted: false,
                    isRuleApplied: false,
                    isSelected: false,
                    isMergedItem: false,
                    isPointPromotion: false,
                    mixedPriceInfo: null,
                    addPoint: 0,
                    rePoint: 0,
                    repeatMultiple: 0,
                    totalPromotionPoints: 0,
                });
            }
        },
        // 添加多个赠品（多选模式）
        addMultipleGifts(plan) {
            console.log("多选模式 - 添加赠品");
            if (!plan.giftBgmList || !Array.isArray(plan.giftBgmList)) {
                console.log("促销方案没有配置赠品列表");
                return;
            }
            let mzIsRepeatNum = this.calculateRepeatMultiple(plan);

            //添加所有配置的赠品
            plan.giftBgmList.forEach((gift) => {
                const baseGiftQuantity = gift.giftNum || 1;
                const finalGiftQuantity = baseGiftQuantity * mzIsRepeatNum;
                this.addSingleGiftToCart(gift, finalGiftQuantity, plan);
            });
        },
        // 添加单个赠品到购物车的通用方法
        addSingleGiftToCart(gift, quantity, plan) {
            console.log("添加赠品到购物车:", gift.bgmName, "数量:", quantity);
            // 计算最终赠品数量（考虑重复赠送）
            let finalQuantity = quantity;
            // 重复赠送判断 mzIsRepeat
            if (plan.mzIsRepeat && plan.mzIsRepeat == 1) {
                // 计算符合条件的商品数量
                let qualifiedQuantity = 0;

                if (plan.conBgmList && Array.isArray(plan.conBgmList)) {
                    // 如果有指定条件商品，计算条件商品的总数量（合并同一商品不同批号）
                    plan.conBgmList.forEach((conditionItem) => {
                        const matchedCartItems = this.cartItems.filter(
                            (item) => item.bgmId === conditionItem.bgmId && !item.isGift
                        );
                        if (matchedCartItems.length > 0) {
                            // 计算同一商品所有批号的总数量
                            const totalQuantity = matchedCartItems.reduce(
                                (sum, item) => sum + (item.quantity || 0),
                                0
                            );
                            qualifiedQuantity += totalQuantity;
                        }
                    });
                }

                // 根据条件商品数量要求计算赠送倍数（向下取整）
                const conditionNum = plan.mzConBgmNum || 1;
                const mzIsRepeatNum = Math.floor(qualifiedQuantity / conditionNum);

                console.log(
                    `单个赠品重复赠送计算: 符合条件商品数量=${qualifiedQuantity}, 条件要求=${conditionNum}, 赠送倍数=${mzIsRepeatNum}`
                );

                // 如果倍数为0，说明不满足条件，不赠送
                if (mzIsRepeatNum <= 0) {
                    console.log("不满足重复赠送条件，不赠送赠品");
                    return;
                }
                // 计算最终数量
                finalQuantity = quantity * mzIsRepeatNum;
                console.log(
                    `赠品 ${gift.bgmName}: 基础数量=${quantity}, 倍数=${mzIsRepeatNum}, 最终数量=${finalQuantity}`
                );
            }
            // 检查购物车是否已存在该赠品
            const existingGift = this.cartItems.find(
                (item) => item.bgmId === gift.bgmId && item.isGift
            );

            // 计算赠品价格：优先使用 gift.price，为空时使用 0
            const giftPrice = gift.price || 0;
            const giftAmount = giftPrice * finalQuantity;

            if (existingGift) {
                // 更新已存在的赠品
                existingGift.quantity = finalQuantity;
                existingGift.price = gift.retailPrice || 0;
                existingGift.changePrice = giftPrice;
                existingGift.actualPrice = giftPrice;
                existingGift.amount = giftAmount;
                existingGift.discountInfo = `${plan.planName}：赠品`;
            } else {
                // 添加新的赠品到购物车
                this.cartItems.push({
                    bgmId: gift.bgmId,
                    bgmName: gift.bgmName,
                    spec: gift.spec,
                    manufacturer: gift.manufacturer,
                    barcode: gift.barcode,
                    bgmCode: gift.bgmCode,
                    price: gift.retailPrice || 0,
                    changePrice: giftPrice,
                    actualPrice: giftPrice,
                    quantity: finalQuantity,
                    amount: giftAmount,
                    isGift: true, // 标记为赠品
                    giftPlanName: plan.planName, // 记录促销方案名称
                    bgiPretype: gift.bgiPretype || "",
                    bgiType: gift.bgiType || "",
                    expidate: gift.expidate,
                    prodate: gift.prodate,
                    batchno: gift.batchno,
                    bgiAppnumber: gift.bgiAppnumber,
                    bgiPerholder: gift.bgiPerholder,
                    salesPerson: this.memberInfo.salesPerson || "",
                    salesPersonName: this.memberInfo.salesPersonName || "",
                    discountInfo: `${plan.planName}：赠品`,
                    // 初始化响应式属性
                    isDiscounted: false,
                    isRuleApplied: false,
                    isSelected: false,
                    isMergedItem: false,
                    isPointPromotion: false,
                    mixedPriceInfo: null,
                    addPoint: 0,
                    rePoint: 0,
                    repeatMultiple: 0,
                    totalPromotionPoints: 0,
                });
                console.log(`已添加新赠品: ${gift.bgmName}, 数量: ${finalQuantity}`);
            }


        },
        getAppliedValue(item) {
            const { pointTotalNum, pointNumPerOrder, quantity } = item;

            // 如果没有任何积分限制，返回商品数量
            if (!pointTotalNum && !pointNumPerOrder) {
                return quantity;
            }

            // 确定上限值：如果总数量限制没值，使用每单限制数量
            let upperLimit;
            if (!pointTotalNum) {
                upperLimit = pointNumPerOrder;
            } else if (!pointNumPerOrder) {
                upperLimit = pointTotalNum;
            } else {
                // 两个都有值时，取较小值
                upperLimit =
                    pointTotalNum < pointNumPerOrder ? pointTotalNum : pointNumPerOrder;
            }

            return Math.min(quantity, upperLimit);
        },
        /**
      * 生成指定长度的不重复随机数字符串
      * @param {number} length - 随机数长度，默认为20
      * @returns {string} - 指定长度的随机数字符串
      */
        generateUniqueRandomId(length = 20) {
            let result = '';
            const characters = '0123456789';

            // 确保第一位不为0（如果是数字的话）
            result += characters.charAt(Math.floor(Math.random() * 9) + 1);

            // 生成剩余位数的随机数
            for (let i = 1; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }

            return result;
        },
        async _onBookSelectConfirmCore() {
            if (this.alertShow) {
                return;
            }
            if(this.disabled){
                return this.$message.warning('请先等待上一单交易完成');
            }
            console.log(this.payableAmount, "this.payableAmount");
            this.orderSubmitId = this.generateUniqueRandomId(20)
            this.orderSubmitTime = new Date().getTime()
            this.pointChange = 0;
            // 多倍积分
            console.log(this.cartItems, 9999);
            this.cartItems.forEach((item) => {
                if (item.pointMultiply) {
                    console.log(item.pointMultiply, "item.pointMultiply");
                    console.log(this.getAppliedValue(item), "this.getAppliedValue(item)");
                    console.log(item.actualPrice, "item.actualPrice");

                    // 参与多倍积分的数量
                    const multiplyQuantity = this.getAppliedValue(item);
                    // 剩余数量（只获得1倍积分）
                    const remainingQuantity = item.quantity - multiplyQuantity;

                    // 多倍积分部分
                    const multiplyPoints =
                        multiplyQuantity * item.actualPrice * item.pointMultiply;
                    // 剩余数量1倍积分部分
                    const remainingPoints = remainingQuantity * item.actualPrice * 1;

                    this.pointAmount += multiplyPoints + remainingPoints;
                } else {
                    this.pointAmount += item.actualPrice * item.quantity;
                }
            });
            this.allGiftGoods.forEach((item) => {
                this.pointChange -= item.rePoint ? item.rePoint : 0;
            });
            // 冲减/赠送积分
            this.cartItems.forEach((plan) => {
                // 冲减积分最总计算
                this.pointChange -= plan.rePoint ? plan.rePoint : 0;
                this.pointChange += plan.addPoint ? plan.addPoint : 0;
            });

            this.pointChange += this.allAddPointTotal ? this.allAddPointTotal : 0;
            this.pointChange -= this.allRePointTotal ? this.allRePointTotal : 0;
            console.log("当前商品:", this.cartItems);
            console.log("当前积分:", this.pointChange);
            // 会员储值
            this.rechargeForm.psmoney = this.payableAmount;
            let payList = [];
            // 收集所有输入了金额的账簿
            if (this.printShow) {
                payList = this.bookList
                    .filter((book) => book.payType == 1)
                    .map((book) => ({
                        abookId: book.value,
                        deskId: this.memberInfo.deskId,
                        money: this.payableAmount,
                        payType: book.payType,
                        isAbleWebPay: this.payableAmount,
                    }));
            } else {
                payList = this.bookList
                    // .filter(book => book.inputMoney > 0)
                    .filter((book) => book.inputMoney)
                    .map((book) => ({
                        abookId: book.value,
                        deskId: this.memberInfo.deskId,
                        money: book.inputMoney,
                        payType: book.payType,
                        isAbleWebPay: book.isAbleWebPay,
                    }));
                if (payList.length === 0) {
                    this.$message.warning("请输入付款金额");
                    return;
                }
            }


            // 验证总金额是否超过应付金额（正数）或小于应付金额（负数）
            const totalInputAmount = parseFloat(this.$common.getDecimalInfo(3, this.totalInputMoney));
            const payableAmount = parseFloat(this.$common.getDecimalInfo(3, this.payableAmount));

            var isReturn = false;
            if (payableAmount >= 0) {
                // 计算非现金付款金额（排除payType=1的现金）
                const nonCashInputAmount = this.bookList.reduce((sum, book) => {
                    if (book.payType != 1) { // 非现金
                        const amount = parseFloat(book.inputMoney) || 0;
                        return sum + amount;
                    }
                    return sum;
                }, 0);
                let money = this.$common.getDecimalInfo(3, nonCashInputAmount)
                // 正常销售：非现金付款金额不能超过应付金额
                if (money > payableAmount) {
                    this.$message.warning(
                        `非现金付款金额${this.$common.getDecimalInfo(3, nonCashInputAmount)}不能超过应付金额${this.$common.getDecimalInfo(3, payableAmount)}，请重新输入`
                    );
                    return;
                }
            } else {
                // 退货：输入金额不能小于应付金额（负数）
                if (totalInputAmount < payableAmount) {
                    this.$message.warning(
                        `输入金额${this.$common.getDecimalInfo(3, totalInputAmount)}小于应付金额${this.$common.getDecimalInfo(3, payableAmount)}，请重新输入`
                    );
                    return;
                }
                isReturn = true;
            }
            if (this.isRechargeMode) {
                if (totalInputAmount != this.rechargeForm.psmoney) {
                    this.$message.warning(`输入金额不符合，请重新输入`);
                    return;
                }

                try {
                    const res = await this.$http.memRechargeRecharge({
                        storeId: this.storeId,
                        memId: this.memberInfo.memId,
                        payList: payList,
                        remark: this.payableRemark,
                    });
                    if (res && res.status === 200) {
                        this.$message.success("会员储值成功");
                        this.isRechargeMode = false;
                        this.rechargeDialogVisible = false;
                        // 更新会员余额信息
                        const rechargeAmount = parseFloat(this.rechargeForm.psmoney) || 0;
                        const currentBalance =
                            parseFloat(this.memberInfo.storedBalance) || 0;
                        this.memberInfo.storedBalance = this.$common.getDecimalInfo(3, currentBalance + rechargeAmount);

                        // 清空充值表单
                        this.rechargeForm.psmoney = "";
                        // 清空账簿输入金额
                        this.bookList.forEach((book) => {
                            book.inputMoney = 0;
                        });
                        this.bookSelectDialogVisible = false;
                        // 移除键盘事件监听
                        document.removeEventListener(
                            "keydown",
                            this.handleBookDialogKeyDown
                        );
                        this.focusCartTable();
                    } else {
                        this.$message.error("会员储值失败");
                    }
                } catch (error) {
                    console.error("会员储值失败:", error);
                    this.$message.error("会员储值失败");
                }
            } else {
                if (this.allGiftGoods && this.allGiftGoods.length > 0) {
                    this.cartItems.push(...this.allGiftGoods);
                }
                try {
                    //调价
                    const tjInfoList = [];
                    this.cartItems.map((item) => {
                        console.log(item, 'item9999')
                        if (item.faId && item.faId != "" && item.isMem) {
                            tjInfoList.push({
                                id: item.faId,
                                num:
                                    item.limitedQuantity == 0
                                        ? item.quantity
                                        : item.limitedQuantity,
                            });
                        }
                    });

                    const usedYhqList = [];
                    try {
                        // 优惠券核销 选中的核销

                        const selectedRows = this.$refs.promotionTable.selection;
                        if (selectedRows && selectedRows.length > 0) {
                            selectedRows.map((item) => {
                                if (item.planType == 4) {
                                    console.log(item);
                                    usedYhqList.push(item.yhqMem.id);
                                }
                            });
                        }
                    } catch (error) { }

                    // 处理payList，添加skMoney和zlMoney字段
                    const changeAmount = this.cashChangeAmount;
                    payList.forEach(item => {
                        const book = this.bookList.find(b => b.value === item.abookId);
                        const isCash = book && book.payType == 1; // 是否为现金
                        const inputMoney = this.$common.getDecimalInfo(3, parseFloat(item.money) || 0);
                        const payType = this.payReturnList.filter(val => val.abookId == item.abookId)
                        if (payType.length > 0) {
                            item.originPayId = payType[0].payId
                        } else {
                            item.originPayId = ''
                        }
                        // 计算该账簿的找零金额（只有现金才有找零）
                        let bookChangeAmount = 0;
                        if (isCash && changeAmount > 0) {
                            // 如果是现金且有找零，找零金额分配给现金账簿
                            bookChangeAmount = this.$common.getDecimalInfo(3, changeAmount);
                        }
                        if ((item.payType == 3 || item.payType == 4) && item.isAbleWebPay === 1) {
                            item.authCode = this.payCode
                        } else {
                            item.authCode = ''
                        }

                        // 更新payList项目 - 使用精确计算避免精度问题
                        item.skMoney = inputMoney; // 收款金额（实收金额）
                        item.zlMoney = bookChangeAmount; // 找零金额
                        item.money = this.$common.getDecimalInfo(3, NP.minus(inputMoney, bookChangeAmount)); // 收款金额 - 找零

                    });
                    if (!isReturn) {
                        var wxArr = payList.filter(item => item.payType == 3)//是否勾选了微信
                        var zfbArr = payList.filter(item => item.payType == 4)//是否勾选了支付宝
                        if (wxArr.length > 0 && zfbArr.length > 0) {//微信支付宝是否同时存在
                            this.$alert('微信和支付宝不能同时选择', '提示', { type: "error" });
                            return
                        } else {
                            if (payList.filter(item => (item.payType == 3 || item.payType == 4) && item.isAbleWebPay === 1).length > 0 && !this.payShow) {
                                this.payMoney = payList.filter(item => (item.payType == 3 || item.payType == 4) && item.isAbleWebPay === 1)[0].money
                                this.payShow = true
                                this.escShow = false
                                this.$nextTick(() => {
                                    this.$refs['payCode'].focus()
                                })
                                return
                            } else if (payList.filter(item => (item.payType == 3 || item.payType == 4) && item.isAbleWebPay === 1).length > 0) {
                                if (this.payCode == "") {
                                    this.$nextTick(() => {
                                        this.$refs['payCode'].focus()
                                    })
                                    this.escPayShow = true
                                    return
                                }
                                this.closeIndex = 0
                                this.closeFlag = false
                                this.timeClose()
                                this.escPayShow = false
                                this.payReadonly = true
                                this.queryPay()
                            }
                        }
                    }
                    console.log(payList, 'payList789')
                    // var money=0
                    let payDataObj = {
                        isZt: this.isZt,
                        zlMoney: changeAmount,
                        skMoney: this.$common.getDecimalInfo(3, NP.plus(changeAmount, this.payableAmount)),
                        esuList: this.esuList,
                        bcCode: this.bcCode,
                        salesPersonId: this.memberInfo.salesPerson,
                        deskId: this.memberInfo.deskId,
                        customerIdCard: parseFloat(this.$common.getDecimalInfo(3, this.payableAmount)) > 0 ? this.memberInfo.customerIdCard : this.orderList.customerIdCard,
                        customerName: parseFloat(this.$common.getDecimalInfo(3, this.payableAmount)) > 0 ? this.memberInfo.customerName : this.orderList.customerName,
                        customerPhoneNumber: parseFloat(this.$common.getDecimalInfo(3, this.payableAmount)) > 0 ? this.memberInfo.customerPhoneNumber : this.orderList.customerPhoneNumber,
                        detailList: this.cartItems.map((item) => {
                            // 计算实际数量：如果是中药饮片且有副数，则数量*副数
                            const isTCMDecoction = item.bgiType && item.bgiType.includes('中药饮片');
                            const actualQuantity = (isTCMDecoction && item.tcmDosage)
                                ? item.quantity * item.tcmDosage
                                : item.quantity;

                            // 计算实际单价：如果是特价商品，根据总金额/实际数量计算
                            const totalAmount = this.$common.getDecimalInfo(3, item.amount)
                            let actualPrice = item.actualPrice;
                            let xsdNum = 0
                            if (String(item.actualPrice).split('.').length == 2) {
                                xsdNum = String(item.actualPrice).split('.')[1].length
                            }
                            // 如果是特价商品且有总金额和实际数量，重新计算单价
                            if (actualQuantity > 0 && totalAmount > 0 && item.actualPrice !== item.price) {
                                actualPrice = parseFloat((totalAmount / actualQuantity).toFixed(Number(xsdNum) + 1));
                            }
                            // money=NP.plus( Number(money), Number(this.$common.getDecimalInfo(3, NP.times(actualPrice, actualQuantity))))
                            return {
                                batchno: item.batchno || "",
                                bgmId: item.bgmId,
                                expidate: item.expidate || '',
                                isZp: item.isGift ? 1 : 0,
                                memPrice: item.memberPrice || '',
                                prodate: item.prodate || '',
                                psmoney: this.$common.getDecimalInfo(3, NP.times(actualPrice, actualQuantity)),
                                psprice: actualPrice,
                                retailPnumber: actualQuantity || 0,
                                retailPrice: item.price || 0,
                                salesPersonId: item.salesPerson || '',
                                sterBatchno: item.sterBatchno || "",
                                originId: item.rtgId || "",
                                tcmDosage: item.tcmDosage || null, // 保存副数信息用于记录
                                bgsId: item.bgsId || '',
                                oldPsprice: item.oldPsprice || "",
                                priceChangeOpm: item.priceChangeOpm || '',
                                addRate: this.memberInfo.addRate || 0,
                            };
                        }),
                        yhqList: this.yhqGift.flatMap((item) =>
                            Array(item.giftNum).fill(item.yhqId)
                        ), //giftNum
                        usedYhqList: usedYhqList, //优惠券核销
                        tjInfoList: tjInfoList, //	调价更新会员N天参与一次信息、促销总数量
                        disMoney: Number(this.$common.getDecimalInfo(3, this.discountAmount)),
                        doctor: this.memberInfo.doctor,
                        memId: parseFloat(this.$common.getDecimalInfo(3, this.payableAmount)) > 0 ? this.memberInfo.memId : this.orderList.memId,
                        payList: payList,
                        pharmacist: this.memberInfo.pharmacist,
                        pointAmount: this.pointAmount, //多倍积分字段
                        pointChange: this.pointChange, //赠送积分/冲减积分
                        recMoney: Number(this.$common.getDecimalInfo(3, this.payableAmount)), //实收金额
                        remark: this.assistObj.remark,
                        retailType: parseFloat(this.$common.getDecimalInfo(3, this.payableAmount)) > 0 ? 1 : 2, //单据类型（1:销售、2:退货）
                        saledate: Math.floor(new Date().getTime() / 1000), // 销售日期
                        storeId: this.storeId,
                        totalCount: this.cartItems.length, //总条目数
                        totalMoney: Number(this.$common.getDecimalInfo(3, this.originAmount)), //总金额（统一零售价合计）
                        totalNumber: Number(this.$common.getDecimalInfo(3, this.totalQuantity)), //总数量
                        originId: this.originId, //原单号
                        orderSubmitId: this.orderSubmitId,
                        orderSubmitTime: this.orderSubmitTime,
                        assistanceInfo: this.assistObj.assistanceInfo
                    }
                    console.log(payDataObj, 'payDataObj')
                    this.escShow = false
                    if (this.printShow) {
                        this.disabled = true
                        this.$http.printDataretailOrderPrePrint(payDataObj).then((res) => {
                            this.disabled = false
                            this.printShow = false
                            if (!isReturn) {
                                this.closeIndex = 0
                                this.closeFlag = false
                                this.payShow = false
                                clearTimeout(this.payTimer);
                            }
                            if (res && res.status === 200) {
                                this.escShow = true
                                //  // 打印方法
                                this.$printSocketApi.previewReport(
                                    res.result,
                                    this.skPrint,
                                    "print",
                                    "",
                                    0, //打印次数
                                );
                                // 新增：重置购物车和会员卡为初始状态，但保留销售员信息
                                this.initCart()
                            } else {
                                this.allGiftGoods = [];
                                this.pointAmount = 0;
                                this.escShow = false
                                this.alertShow = true
                                this.$alert(res.message, '提示', {
                                    type: "error", closeOnPressEscape: true, callback: action => {
                                        this.alertShow = false
                                        this.escShow = true
                                    }
                                });
                            }
                        });
                    } else {
                        this.disabled = true
                        this.$http.retailAdd(payDataObj).then((res) => {
                            this.disabled = false
                            if (!isReturn) {
                                this.closeIndex = 0
                                this.closeFlag = false
                                this.payShow = false
                                clearTimeout(this.payTimer);
                            }
                            console.log(this.orderSubmitId, this.orderSubmitTime);
                            console.log(res, "res添加付款信息");
                            if (res && res.status === 200) {
                                this.escShow = true
                                this.$message({
                                    message: "添加付款信息成功",
                                    type: "success",
                                });
                                // 打印小票
                                if (this.autoPrint == 1) {
                                    this.printReceipt(res.result);
                                } else {
                                    this.$confirm("是否打印小票？", "提示", {
                                        confirmButtonText: "确定",
                                        cancelButtonText: "取消",
                                        type: "warning",
                                    })
                                        .then(() => {
                                            this.printReceipt(res.result);
                                        })
                                        .catch(() => { });
                                }
                                this.bookSelectDialogVisible = false;
                                // 移除键盘事件监听
                                document.removeEventListener(
                                    "keydown",
                                    this.handleBookDialogKeyDown
                                );
                                // 新增：重置购物车和会员卡为初始状态，但保留销售员信息
                                this.initCart()
                            } else {
                                this.allGiftGoods = [];
                                this.pointAmount = 0;
                                this.escShow = false
                                this.alertShow = true
                                this.$alert(res.message, '提示', {
                                    type: "error", closeOnPressEscape: true, callback: action => {
                                        this.alertShow = false
                                        this.escShow = true
                                    }
                                });
                            }
                        }).catch((error) => {
                            this.closeIndex = 0
                            this.closeFlag = false
                            this.payShow = false
                            clearTimeout(this.payTimer);
                        });
                    }

                } catch (error) {
                    console.error("添加门店零售单据失败:", error);
                }
            }
        },
        timeClose() {
            this.closeIndex++
            if (this.closeIndex < 10) {
                setTimeout(() => {
                    this.timeClose()
                }, 1000)
            } else {
                this.closeFlag = true
            }

        },
        async closePayClick() {
            const res = await this.$http.orderMsgcancelOrder({ ids: [this.payCode] })
            if (res.status == 200) {
                this.$message({
                    message: "请求成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: "请求失败",
                    type: "error",
                });
            }
        },
        queryPay() {
            this.$http.orderMsggetByOrderKey({
                ids: [this.payCode],
            }).then((res) => {
                console.log(res);
                this.payTimer = setTimeout(() => {
                    this.queryPay()
                }, 1000)
                if (!res.result) {
                    this.payMessage = "单据处理中"
                } else {
                    this.payMessage = res.result.msg;
                }
            });
        },
        initCart() {
            this.isZt = 0;
            this.cartItems = [];
            this.isDZJG = false;
            this.esuList = [];
            this.selectedItemIndex = -1;
            this.selectedProduct = {};
            this.quantityChange = "";
            this.originId = ""
            this.printShow = false

            // this.memberCardNo = '';
            // 清空账簿输入金额
            this.bookList.forEach((book) => {
                book.inputMoney = 0;
            });
            // 保存当前的销售员信息
            const currentSalesPerson = this.memberInfo.salesPerson;

            const currentSalesPersonName = this.memberInfo.salesPersonName;

            this.memberInfo = {
                name: "",
                points: "",
                level: "",
                storedBalance: "",
                storeName: this.memberInfo.storeName,
                deskId: this.memberInfo.deskId,
                salesPerson: currentSalesPerson, // 保留销售员信息
                salesPersonName: currentSalesPersonName, // 保留销售员名称
                deskCode: this.memberInfo.deskCode,
                cashier: this.memberInfo.cashier,
                doctor: "",
                pharmacist: "",
                customerName: "",
                customerPhoneNumber: "",
                customerIdCard: "",
                cardType: "",
                memId: "",
                registerStore: "",
                isSmall: this.memberInfo.isSmall,
            };
            this.storemastgetLaseSalesPerson()
            this.clearMemberInfo();
            this.updateTotal();
            this.focusCartTable();
        },
        clearPayCode() {
            if (!this.payReadonly) {
                this.closeIndex = 0
                this.closeFlag = false
                this.timeClose()
                this.payCode = '';
                this.escPayShow = true;
                this.$nextTick(() => {
                    this.$refs['payCode'].focus();
                });
            }
        },

        /**
         * 账簿选择确认方法（防抖版本）
         * 防止用户快速重复点击导致重复提交
         */
        onBookSelectConfirm() {
            // 使用防抖函数包装核心逻辑，延迟500毫秒执行
            const debouncedConfirm = this.debounce(this._onBookSelectConfirmCore, 300, 'bookSelectConfirm');
            debouncedConfirm();
        },

        // 打印小票
        printReceipt(id) {
            this.$http
                .retailOrderPrint({
                    id: id,
                    isPrint: 1,
                })
                .then((res) => {
                    if (res.status === 200) {
                        console.log(res.result, "res.result");
                        //  // 打印方法
                        this.$printSocketApi.previewReport(
                            res.result,
                            this.skPrint,
                            "print",
                            "",
                            0, //打印次数
                            id
                        );
                    }
                });
        },
        // 计算购物车商品应收价
        getCartItemReceivablePrice(row) {
            // 计算实际数量（考虑中药副数）
            const actualQuantity = row.tcmDosage ? row.quantity * row.tcmDosage : row.quantity;

            // 如果是退货商品（数量为负数），直接使用退货价格计算
            if (row.isReturn && row.quantity < 0) {
                return {
                    amount: NP.times(row.changePrice || row.price || 0, actualQuantity || 0),
                    type: 3
                }
            }

            // 如果是限购商品且超出限购数量，分别计算限购部分和超出部分
            if (row.isLimitedQuantity && actualQuantity > row.limitedQuantity) {
                // 限购部分金额
                let limitedPartAmount = 0
                if (this.memberInfo.addRate) {
                    limitedPartAmount = NP.times(row.limitedQuantity, row.changePrice || 0)
                } else {
                    limitedPartAmount = NP.times(row.limitedQuantity, row.changePrice || row.actualPrice || 0)
                }
                console.log(limitedPartAmount, 'limitedPartAmount')
                // 超出部分金额
                const extraPartAmount = NP.times(actualQuantity - row.limitedQuantity, row.extraPrice || row.price || 0)

                // 总金额
                return {
                    amount: NP.plus(limitedPartAmount, extraPartAmount),
                    type: 3
                }
            }
            if (this.memberInfo.addRate && row.changePrice) {
                return {
                    amount: NP.times(row.changePrice || 0, actualQuantity || 0),
                    type: 3
                }
            }
            // 如果不是限购商品或未超出限购数量

            // 1. 如果是打折商品，使用已计算好的金额
            if (row.isDiscounted && row.actualPrice !== undefined) {
                return {
                    amount: NP.times(row.actualPrice || 0, actualQuantity || 0),
                    type: 3
                }
            }

            // 2. 如果单价被手动修改，直接用修改后的单价
            if (row.isPriceManuallyChanged && row.changePrice) {
                return {
                    amount: NP.times(row.changePrice || 0, actualQuantity || 0),
                    type: 3
                }
            }

            // 3. 有会员
            if (this.memberInfo && this.memberInfo.memId) {
                if (this.memberInfo.addRate && row.changePrice) {
                    return {
                        amount: NP.times(row.changePrice || 0, actualQuantity || 0),
                        type: 3
                    }
                } else if (row.spPrice) {
                    // 会员+促销，取最低价（会员价、促销价）
                    let minPrice = Math.min(
                        row.memberPrice !== undefined ? row.memberPrice : Infinity,
                        row.spPrice !== undefined ? row.spPrice : Infinity
                    );
                    return {
                        amount: NP.times(minPrice || 0, actualQuantity || 0),
                        type: 3
                    }
                } else {
                    // 会员无促销
                    return {
                        amount: NP.times(row.memberPrice || 0, actualQuantity || 0),
                        type: 3
                    }
                }
            } else {
                if (this.memberInfo.addRate && row.changePrice) {
                    return {
                        amount: NP.times(row.changePrice || 0, actualQuantity || 0),
                        type: 3
                    }
                } else if (row.spPrice) {// 4. 无会员
                    return {
                        amount: NP.times(row.spPrice || 0, actualQuantity || 0),
                        type: 3
                    }
                } else {
                    return {
                        amount: NP.times(row.price || 0, actualQuantity || 0),
                        type: 3
                    }
                }
            }

        },
        // 新增：商品录入弹窗关闭时聚焦商品录入输入框
        onProductDialogClose() {
            this.productSelectDialogVisible = false;
            this.selectedProductIndex2 = -1;
        },
        // 新增：统一控制账簿选择弹窗显示的方法
        async openBookSelectDialog(val) {
            if (!this.cartItems || this.cartItems.length === 0) {
                this.$message.warning("购物车为空，无法付款");
                return;
            }
            //return 退货
            if (this.payReturnList && this.payReturnList.length > 0 && val == 'return') {
                //this.returnForbidden()//原单退款
                // this.returnQuery()//可选所有账簿，未使用线上支付禁用线上支付
                this.returnQuery1()//可选所有账簿
            }
            this.bookSelectDialogVisible = true;
            this.isRechargeMode = false;
            // 添加键盘事件监听
            this.$nextTick(() => {
                document.addEventListener("keydown", this.handleBookDialogKeyDown);
                // 找到第一个未禁用的账簿输入框并聚焦
                const inputs = document.querySelectorAll(".book-card-input input");
                for (let input of inputs) {
                    if (!input.disabled) {
                        input.focus();
                        break;
                    }
                }
            });
        },
        //原单退款，使用什么账簿就用什么账簿退款
        returnForbidden() {
            this.bookList.forEach(item => {
                let arr = this.payReturnList.filter(item2 => item2.abookId === item.abookId && item2.ableMoney > 0);
                if (arr.length > 0) {
                    this.$set(item, "maxMoney", arr[0].ableMoney);
                } else {
                    this.$set(item, "disabled", true);
                }
            });
        },
        //线下支付金额可以多账簿退款（线上支付除外）, 线上支付金额只能选择线上退款
        returnQuery() {
            var arr1 = []
            this.bookList.forEach(item => {
                let arr = this.payReturnList.filter(item2 => item2.abookId === item.abookId);
                if (arr.length > 0) {
                    arr1.push(item)
                }
            });
            if (arr1.filter(item => item.isAbleWebPay === 0).length > 0) {
                this.bookList.forEach(item => {
                    this.$set(item, "disabled", false);
                    let arr = this.payReturnList.filter(item2 => item2.abookId === item.abookId && item2.ableMoney > 0);
                    if (arr.length > 0) {
                        if (item.isAbleWebPay == 1) {
                            this.$set(item, "maxMoney", arr[0].ableMoney);
                        }
                    } else {
                        if (item.isAbleWebPay == 1) {
                            this.$set(item, "disabled", true);
                        }
                    }
                });
            } else {
                this.bookList.forEach(item => {
                    this.$set(item, "disabled", false);
                    let arr = this.payReturnList.filter(item2 => item2.abookId === item.abookId && item2.ableMoney > 0);
                    if (arr.length > 0) {
                        this.$set(item, "maxMoney", arr[0].ableMoney);
                    } else {
                        this.$set(item, "disabled", true);
                    }
                })
            }
        },
        //都可以选择所有账簿
        returnQuery1() {
            var arr1 = []
            this.bookList.forEach(item => {
                let arr = this.payReturnList.filter(item2 => item2.abookId === item.abookId);
                if (arr.length > 0) {
                    arr1.push(item)
                }
            });
            if (arr1.filter(item => item.isAbleWebPay === 0).length > 0) {

                this.bookList.forEach(item => {
                    this.$set(item, "disabled", false);
                    if (item.isAbleWebPay == 1) {
                        if (this.payReturnList.filter(item2 => item2.abookId == item.abookId).length > 0) {
                            this.$set(item, "disabled", false);
                        } else {
                            this.$set(item, "disabled", true);
                        }
                    }
                    let arr = this.payReturnList.filter(item2 => item2.abookId === item.abookId && item2.ableMoney > 0);
                    if (arr.length > 0) {
                        if (item.isAbleWebPay == 1) {
                            this.$set(item, "maxMoney", arr[0].ableMoney);
                        }
                    }
                });
            } else {
                this.bookList.forEach(item => {
                    this.$set(item, "disabled", false);
                    if (item.isAbleWebPay == 1) {
                        if (this.payReturnList.filter(item2 => item2.abookId == item.abookId).length > 0) {
                            this.$set(item, "disabled", false);
                        } else {
                            this.$set(item, "disabled", true);
                        }
                    }
                    let arr = this.payReturnList.filter(item2 => item2.abookId === item.abookId && item2.ableMoney > 0);
                    if (arr.length > 0) {
                        this.$set(item, "maxMoney", arr[0].ableMoney);
                    }
                })
            }
            console.log(this.bookList, "测试123456")
        },
        // 账簿选择弹窗键盘事件处理
        handleBookDialogKeyDown(event) {
            // 如果账簿选择弹窗未显示，不处理事件
            if (!this.bookSelectDialogVisible) {
                return;
            }
            // 如果正在显示支付弹窗，不处理事件
            if (this.payShow) {
                if (event.keyCode === 16) {
                    this.payCode = ""
                    this.payReadonly = false
                    this.$nextTick(() => {
                        this.$refs['payCode'].focus()
                    })
                }
                return;
            }

            console.log(event.key, "event.key in handleBookDialogKeyDown");

            // 处理F1-F12快捷键，直接选择对应索引的账簿
            if (event.key.match(/^F(\d+)$/)) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation(); // 阻止事件冒泡到全局处理器

                // 获取F键后面的数字（1-12）
                const keyNum = parseInt(event.key.substring(1));
                console.log("F键数字:", keyNum);

                // 确保索引在有效范围内（0-11对应F1-F12）
                if (keyNum >= 1 && keyNum <= 12 && keyNum <= this.bookList.length) {
                    const bookIndex = keyNum - 1; // 转换为0基索引
                    console.log("选择账簿索引:", bookIndex);
                    if (this.bookList[bookIndex].disabled) {
                        return
                    }
                    // 聚焦到对应的账簿输入框
                    this.focusBookInput(bookIndex);

                    // 如果autoPayMoney为1且账簿输入框为空，自动填入剩余金额
                    if (this.autoPayMoney == 1 && !this.bookList[bookIndex].inputMoney) {
                        // 计算当前已输入总金额
                        // const totalInputMoney = this.bookList.reduce((sum, book, index) => {
                        //     if (index !== bookIndex) {
                        //         const amount = parseFloat(book.inputMoney || 0);
                        //         return sum + amount;
                        //     }
                        //     return sum;
                        // }, 0);

                        // // 计算剩余金额（包括负金额）
                        // const remainingAmount = parseFloat(
                        //     (this.payableAmount - totalInputMoney).toFixed(9)
                        // );

                        // // 更新账簿输入金额
                        // this.$set(this.bookList, bookIndex, {
                        //     ...this.bookList[bookIndex],
                        //     inputMoney: remainingAmount,
                        // });
                        // 更新当前账簿输入金额
                        this.$set(this.bookList, bookIndex, {
                            ...this.bookList[bookIndex],
                            inputMoney: 0,
                        });
                        this.handleBookInputFocus(this.bookList[bookIndex])
                    }

                    return;
                }
            }

            // 处理空格键，自动计算剩余金额
            if (event.key === " " || event.key === "Space") {
                event.preventDefault();
                event.stopPropagation();



                // 获取当前焦点的输入框
                const activeElement = document.activeElement;
                const isInputElement = activeElement.tagName === "INPUT" &&
                    activeElement.closest(".book-card-input");

                if (isInputElement) {
                    // 找到当前输入框对应的账簿索引
                    const inputs = Array.from(
                        document.querySelectorAll(".book-card-input input:not([disabled])")
                    );
                    const currentIndex = inputs.indexOf(activeElement);

                    if (currentIndex !== -1 && currentIndex < this.bookList.length) {
                        // 计算当前已输入总金额（排除当前输入框）
                        // const totalInputMoney = this.bookList.reduce((sum, book, index) => {
                        //     if (index !== currentIndex) {
                        //         const amount = parseFloat(book.inputMoney || 0);
                        //         return sum + amount;
                        //     }
                        //     return sum;
                        // }, 0);

                        // // 计算剩余金额（包括负金额）
                        // const remainingAmount = parseFloat(
                        //     (this.payableAmount - totalInputMoney).toFixed(2)
                        // );

                        // 更新当前账簿输入金额
                        this.$set(this.bookList, currentIndex, {
                            ...this.bookList[currentIndex],
                            inputMoney: 0,
                        });
                        this.handleBookInputFocus(this.bookList[currentIndex])

                        console.log(`空格键自动填入剩余金额: ${remainingAmount}`);
                    }
                }
                return;
            }

            // 获取当前焦点元素
            const activeElement = document.activeElement;
            const isInputElement =
                activeElement.tagName === "INPUT" ||
                activeElement.tagName === "TEXTAREA" ||
                activeElement.closest(".el-input") ||
                activeElement.closest(".el-select");

            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                // 如果是在输入框中，但不是在下拉选择框中，则阻止默认行为
                if (isInputElement && !activeElement.closest(".el-select")) {
                    event.preventDefault();
                    event.stopPropagation();
                    const direction = event.key === "ArrowUp" ? -1 : 1;
                    const inputs = Array.from(
                        document.querySelectorAll(".book-card-input input:not([disabled])")
                    );
                    const currentIndex = inputs.indexOf(activeElement);
                    if (currentIndex !== -1) {
                        const nextIndex =
                            (currentIndex + direction + inputs.length) % inputs.length;
                        inputs[nextIndex].focus();
                        inputs[nextIndex].select();
                    }
                }
            } else if (event.key === "Enter") {
                event.preventDefault();
                if (!isInputElement || this.validateBookInputs()) {
                    if (this.alertShow) {
                        const alertEl = document.querySelector('.el-message-box');
                        if (alertEl && alertEl.style.display !== 'none') {
                            // 执行与 alert 回调相同的逻辑
                            this.alertShow = false;
                            this.escShow = true;

                            // 关闭弹窗
                            const closeBtn = alertEl.querySelector('.el-message-box__btns .el-button');
                            if (closeBtn) {
                                closeBtn.click();
                            } else {
                                // 如果找不到按钮，则手动触发关闭
                                const msgBoxInstance = document.querySelector('.el-message-box');
                                if (msgBoxInstance) {
                                    msgBoxInstance.style.display = 'none';
                                }
                            }
                        }
                    } else {
                        this.onBookSelectConfirm();
                    }
                }
            } else if (event.key === "Escape") {
                event.preventDefault();
                if (this.escShow) {
                    this.bookSelectDialogVisible = false;
                    // 移除键盘事件监听
                    document.removeEventListener("keydown", this.handleBookDialogKeyDown);
                }
            }
        },

        // 聚焦到指定索引的账簿输入框
        focusBookInput(bookIndex) {
            this.$nextTick(() => {
                const inputs = document.querySelectorAll(
                    ".book-select-grid .book-card-input input"
                );
                if (inputs && inputs[bookIndex]) {
                    // 先移除其他输入框的焦点
                    inputs.forEach((input, index) => {
                        if (index !== bookIndex) {
                            input.blur();
                        }
                    });
                    // 聚焦到目标输入框
                    inputs[bookIndex].focus();
                    inputs[bookIndex].select();

                    // 滚动到聚焦的输入框
                    const currentCard = inputs[bookIndex].closest(".book-card");
                    if (currentCard) {
                        currentCard.scrollIntoView({
                            behavior: "smooth",
                            block: "nearest",
                            inline: "nearest",
                        });
                    }

                    // 更新最后修改的账簿索引
                    this.lastBookInputIndex = bookIndex;
                }
            });
        },
        // 取消账簿选择
        onBookSelectCancel() {
            this.bookSelectDialogVisible = false;
            this.pointAmount = 0;
            this.allGiftGoods = [];
            this.cartItems = this.cartItems.filter((item) => !item.allGiftGoods);
            this.updateTotal();
            // 移除键盘事件监听
            document.removeEventListener("keydown", this.handleBookDialogKeyDown);
        },

        // 账簿弹窗打开事件处理
        onBookSelectDialogOpened() {

            // 重置所有账簿金额
            this.bookList.forEach((book) => {
                book.inputMoney = 0;
            });

            // 如果autoPayMoney为0，不进行自动金额计算，所有输入框保持为0
            if (this.autoPayMoney == 0) {
                // 找到第一个未禁用的输入框并聚焦
                const firstIndex = this.bookList.findIndex(
                    (book) => !this.isRechargeMode
                );

                if (firstIndex !== -1) {
                    // 聚焦到该输入框
                    this.$nextTick(() => {
                        this.focusBookInput(firstIndex);
                    });
                }
                return;
            }

            //退货逻辑
            if (this.payableAmount < 0) {
                // 正常销售逻辑
                //this.returnForbiddenInit()  //原单退回逻辑
                // this.returnQueryInit()  //多账簿退回逻辑
                this.returnQueryInit1()  //多账簿退回逻辑
            } else {
                // 正常销售逻辑
                // 找到第一个未禁用的输入框
                const firstIndex = this.bookList.findIndex(
                    (book) =>
                        !this.isRechargeMode && !book.disabled
                );
                if (firstIndex !== -1) {
                    // 设置第一个未禁用的输入框金额为应付金额，保留两位小数
                    const payable = parseFloat(this.payableAmount.toFixed(9));

                    // 对于退货（负金额），允许负数；对于正常销售，确保不为负数
                    const initialAmount = payable;
                    this.$set(this.bookList, firstIndex, {
                        ...this.bookList[firstIndex],
                        inputMoney: initialAmount,
                    });

                    // 聚焦到该输入框
                    this.$nextTick(() => {
                        this.focusBookInput(firstIndex);
                    });
                }
            }
            // 添加键盘事件监听
            document.addEventListener("keydown", this.handleBookDialogKeyDown);
        },
        //原单退回逻辑
        returnForbiddenInit() {
            // 找到第一个未禁用的输入框
            const firstIndex = this.bookList.findIndex(
                (book) =>
                    !this.isRechargeMode && !book.disabled
            );
            if (firstIndex !== -1) {
                // 设置第一个未禁用的输入框金额为应付金额，保留两位小数
                const payable = parseFloat(this.payableAmount.toFixed(9));
                // 对于退货（负金额），允许负数；对于正常销售，确保不为负数
                const initialAmount = payable;
                let indexs = 0
                if (this.bookList[firstIndex].maxMoney && this.bookList[firstIndex].maxMoney < Math.abs(initialAmount)) {
                    let initAmount = 0
                    this.bookList.forEach((book, index) => {
                        if (!this.isRechargeMode && !book.disabled) {
                            if (index === firstIndex) {
                                this.$set(this.bookList, index, {
                                    ...this.bookList[index],
                                    inputMoney: book.maxMoney * -1,
                                });
                                initAmount = (Math.abs(initialAmount) - book.maxMoney).toFixed(9) * -1
                                indexs = index
                            } else {
                                if (Math.abs(initAmount) != 0) {
                                    if (book.maxMoney < Math.abs(initAmount)) {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: book.maxMoney * -1,
                                        });
                                        initAmount = (Math.abs(initAmount) - book.maxMoney).toFixed(9) * -1
                                    } else {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: initAmount,
                                        });
                                        initAmount = 0
                                        indexs = index
                                    }
                                }
                            }
                        }

                    })
                } else {
                    this.$set(this.bookList, firstIndex, {
                        ...this.bookList[firstIndex],
                        inputMoney: initialAmount,
                    });
                    indexs = firstIndex
                }

                // 聚焦到该输入框
                this.$nextTick(() => {
                    this.focusBookInput(indexs);
                });
            }
        },
        //多账簿退回逻辑
        returnQueryInit() {
            // 找到第一个未禁用的输入框
            const firstIndex = this.bookList.findIndex(
                (book) =>
                    !this.isRechargeMode && !book.disabled
            );
            if (firstIndex !== -1) {
                const amount = Math.abs(this.payableAmount)//现在需要退款总金额
                //获取可退线上总金额
                const totalAmount = this.$common.getDecimalInfo(3, this.bookList.reduce((sum, b) => {
                    let value = 0;
                    if (!this.isRechargeMode && !b.disabled && b.isAbleWebPay == 1) {
                        value = b.maxMoney
                    }
                    return sum + value;
                }, 0));
                let initialAmount = 0 //非线上金额
                if (amount < this.return_money) {
                    //计算 非线上金额=实际退款金额-(线上总金额-(总金额-实际退款金额))
                    initialAmount = amount - (totalAmount - (this.return_money - amount))
                } else {
                    //计算 非线上金额= 总金额-线上金额
                    initialAmount = this.$common.getDecimalInfo(3, amount - totalAmount)
                }
                let indexs = 0
                if (this.bookList[firstIndex].isAbleWebPay == 1) {
                    let initAmount = 0
                    if (totalAmount <= amount) {
                        initAmount = totalAmount
                    } else {
                        initAmount = amount
                    }

                    this.bookList.forEach((book, index) => {
                        if (!this.isRechargeMode && !book.disabled) {
                            if (index === firstIndex) {
                                if (book.maxMoney) {
                                    if (book.maxMoney <= initAmount) {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: book.maxMoney * -1,
                                        });
                                    } else if (book.maxMoney > initAmount) {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: initAmount * -1,
                                        });
                                    }
                                }
                                initAmount = this.$common.getDecimalInfo(3, (inputMoney - book.maxMoney)) * -1
                                indexs = index
                            } else {
                                if (book.isAbleWebPay == 1) {
                                    if (initAmount != 0) {
                                        if (book.maxMoney < initAmount) {
                                            this.$set(this.bookList, index, {
                                                ...this.bookList[index],
                                                inputMoney: book.maxMoney * -1,
                                            });
                                            initAmount = this.$common.getDecimalInfo(3, (inputMoney - book.maxMoney)) * -1
                                        }
                                    } else {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: initAmount * -1,
                                        });
                                        initAmount = 0
                                    }
                                } else {
                                    this.$set(this.bookList, index, {
                                        ...this.bookList[index],
                                        inputMoney: initialAmount * -1,
                                    });
                                }
                            }
                        }
                    })
                } else {
                    let totalAmount1 = 0
                    if (amount > initialAmount) {
                        totalAmount1 = this.$common.getDecimalInfo(3, amount - initialAmount);
                        this.$set(this.bookList, firstIndex, {
                            ...this.bookList[firstIndex],
                            inputMoney: initialAmount * -1,
                        });
                    } else {
                        totalAmount1 = 0
                        this.$set(this.bookList, firstIndex, {
                            ...this.bookList[firstIndex],
                            inputMoney: amount * -1,
                        });
                    }
                    let initAmount = totalAmount1
                    indexs = firstIndex
                    this.bookList.forEach((book, index) => {
                        if (!this.isRechargeMode && !book.disabled && book.isAbleWebPay == 1) {
                            if (totalAmount1 >= book.maxMoney) {
                                this.$set(this.bookList, index, {
                                    ...this.bookList[index],
                                    inputMoney: book.maxMoney * -1,
                                });
                                initAmount = this.$common.getDecimalInfo(3, totalAmount1 - book.maxMoney)
                            } else {
                                if (initAmount != 0) {
                                    if (book.maxMoney < initAmount) {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: book.maxMoney * -1,
                                        });
                                        initAmount = this.$common.getDecimalInfo(3, (initAmount - book.maxMoney)) * -1
                                    } else {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: initAmount * -1,
                                        });
                                        initAmount = 0
                                        indexs = index
                                    }
                                } else {
                                    this.$set(this.bookList, index, {
                                        ...this.bookList[index],
                                        inputMoney: initAmount * -1,
                                    });
                                    indexs = index
                                }
                            }

                        }
                    })
                }
                // 聚焦到该输入框
                this.$nextTick(() => {
                    this.focusBookInput(indexs);
                });
            }
        },
        //多账簿退回逻辑
        returnQueryInit1() {
            // 找到第一个未禁用的输入框
            const firstIndex = this.bookList.findIndex(
                (book) =>
                    !this.isRechargeMode && !book.disabled
            );
            if (firstIndex !== -1) {
                const amount = Math.abs(this.payableAmount)//现在需要退款总金额
                //获取可退线上总金额
                const totalAmount = this.$common.getDecimalInfo(3, this.bookList.reduce((sum, b) => {
                    let value = 0;
                    if (!this.isRechargeMode && !b.disabled && b.isAbleWebPay == 1) {
                        value = b.maxMoney
                    }
                    return sum + value;
                }, 0));
                console.log(totalAmount, "测试123456")
                let initialAmount = 0 //非线上金额
                if (amount < this.return_money) {
                    //计算 非线上金额=实际退款金额-(线上总金额-(总金额-实际退款金额))
                    initialAmount = amount - (totalAmount - (this.return_money - amount))
                } else {
                    //计算 非线上金额= 总金额-线上金额
                    initialAmount = this.$common.getDecimalInfo(3, amount - totalAmount)
                }
                let indexs = 0
                if (this.bookList[firstIndex].isAbleWebPay == 1) {
                    let initAmount = 0
                    if (totalAmount <= amount) {
                        initAmount = totalAmount
                    } else {
                        initAmount = amount
                    }

                    this.bookList.forEach((book, index) => {
                        if (!this.isRechargeMode && !book.disabled) {
                            if (index === firstIndex) {
                                if (book.maxMoney) {
                                    if (book.maxMoney <= initAmount) {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: book.maxMoney * -1,
                                        });
                                    } else if (book.maxMoney > initAmount) {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: initAmount * -1,
                                        });
                                    }
                                }
                                initAmount = this.$common.getDecimalInfo(3, (inputMoney - book.maxMoney)) * -1
                                indexs = index
                            } else {
                                if (book.isAbleWebPay == 1) {
                                    if (initAmount != 0) {
                                        if (book.maxMoney < initAmount) {
                                            this.$set(this.bookList, index, {
                                                ...this.bookList[index],
                                                inputMoney: book.maxMoney * -1,
                                            });
                                            initAmount = this.$common.getDecimalInfo(3, (inputMoney - book.maxMoney)) * -1
                                        }
                                    } else {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: initAmount * -1,
                                        });
                                        initAmount = 0
                                    }
                                } else {
                                    this.$set(this.bookList, index, {
                                        ...this.bookList[index],
                                        inputMoney: initialAmount * -1,
                                    });
                                }
                            }
                        }
                    })
                } else {
                    let totalAmount1 = 0
                    if (amount > initialAmount) {
                        totalAmount1 = this.$common.getDecimalInfo(3, amount - initialAmount);
                        this.$set(this.bookList, firstIndex, {
                            ...this.bookList[firstIndex],
                            inputMoney: initialAmount * -1,
                        });
                    } else {
                        totalAmount1 = 0
                        this.$set(this.bookList, firstIndex, {
                            ...this.bookList[firstIndex],
                            inputMoney: amount * -1,
                        });
                    }
                    let initAmount = totalAmount1
                    indexs = firstIndex
                    this.bookList.forEach((book, index) => {
                        if (!this.isRechargeMode && !book.disabled && book.isAbleWebPay == 1) {
                            if (totalAmount1 >= book.maxMoney) {
                                this.$set(this.bookList, index, {
                                    ...this.bookList[index],
                                    inputMoney: book.maxMoney * -1,
                                });
                                initAmount = this.$common.getDecimalInfo(3, totalAmount1 - book.maxMoney)
                            } else {
                                if (initAmount != 0) {
                                    if (book.maxMoney < initAmount) {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: book.maxMoney * -1,
                                        });
                                        initAmount = this.$common.getDecimalInfo(3, (initAmount - book.maxMoney)) * -1
                                    } else {
                                        this.$set(this.bookList, index, {
                                            ...this.bookList[index],
                                            inputMoney: initAmount * -1,
                                        });
                                        initAmount = 0
                                        indexs = index
                                    }
                                } else {
                                    this.$set(this.bookList, index, {
                                        ...this.bookList[index],
                                        inputMoney: initAmount * -1,
                                    });
                                    indexs = index
                                }
                            }

                        }
                    })
                }
                // 聚焦到该输入框
                this.$nextTick(() => {
                    this.focusBookInput(indexs);
                });
            }
        },
        // 处理账簿输入框聚焦事件
        handleBookInputFocus(book) {
            // 如果autoPayMoney为0，不进行自动计算，直接返回
            if (this.autoPayMoney == 0) {
                return;
            }
            //正向付款计算
            if (this.payableAmount > 0) {
                // 计算当前剩余应付金额
                const totalInputMoney = this.bookList.reduce((sum, b) => {
                    const amount = parseFloat(b.inputMoney) || 0;
                    return sum + amount;
                }, 0);
                const remainingAmount = this.$common.getDecimalInfo(3, parseFloat(this.payableAmount - totalInputMoney));
                let inputMoney = 0
                // 如果输入金额大于账簿最大金额，则自动填入最大金额
                if (book.maxMoney) {
                    if (Math.abs(remainingAmount) > book.maxMoney) {
                        //退货： 如果剩余金额小于0，则自动填入最大金额的负数
                        if (remainingAmount < 0) {
                            inputMoney = book.maxMoney * -1
                        } else {//正常销售： 如果剩余金额大于0，则自动填入最大金额
                            inputMoney = book.maxMoney
                        }
                    } else {
                        inputMoney = remainingAmount
                    }
                } else {
                    inputMoney = remainingAmount
                }
                // 如果当前输入框没有值，且账簿未禁用，则自动填入剩余金额（包括负金额）
                if (
                    !book.disabled &&
                    (!book.inputMoney || parseFloat(book.inputMoney) === 0)
                ) {
                    if (inputMoney !== 0) {
                        this.$set(book, "inputMoney", inputMoney);
                    }
                }
            } else {//退货退款
                // this.returnFocus(book)//聚焦到输入框(原单)
                // this.returnQueryFocus(book)//聚焦到输入框(多账簿)
                this.returnQueryFocus1(book)//聚焦到输入框(多账簿)
            }

        },
        //聚焦到输入框(原单)
        returnFocus(book) {
            // 计算当前剩余应付金额
            const totalInputMoney = this.bookList.reduce((sum, b) => {
                const amount = parseFloat(b.inputMoney) || 0;
                return sum + amount;
            }, 0);
            const remainingAmount = this.$common.getDecimalInfo(3, parseFloat(this.payableAmount - totalInputMoney));
            let inputMoney = 0
            // 如果输入金额大于账簿最大金额，则自动填入最大金额
            if (book.maxMoney) {
                if (Math.abs(remainingAmount) > book.maxMoney) {
                    //退货： 如果剩余金额小于0，则自动填入最大金额的负数
                    if (remainingAmount < 0) {
                        inputMoney = book.maxMoney * -1
                    } else {//正常销售： 如果剩余金额大于0，则自动填入最大金额
                        inputMoney = book.maxMoney
                    }
                } else {
                    inputMoney = remainingAmount
                }
            } else {
                inputMoney = remainingAmount
            }
            // 如果当前输入框没有值，且账簿未禁用，则自动填入剩余金额（包括负金额）
            if (
                !book.disabled &&
                (!book.inputMoney || parseFloat(book.inputMoney) === 0)
            ) {
                if (inputMoney !== 0) {
                    this.$set(book, "inputMoney", inputMoney);
                }
            }
        },
        //聚焦到输入框(多账簿)（线下的线下的退，线上的线上的退）
        returnQueryFocus(book) {
            console.log(123123);
            // 计算总输入金额(非现金)
            const totalInputMoney1 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0 && b.isAbleWebPay == 0) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            // 计算总输入金额（线上金额）
            const totalInputMoney2 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0 && b.isAbleWebPay == 1) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            // 已输入的总金额=已输入的非线上金额+已输入的线上金额
            const totalInputMoney = totalInputMoney1 + totalInputMoney2
            const remainingAmount = this.$common.getDecimalInfo(3, parseFloat(this.payableAmount - totalInputMoney));
            if (remainingAmount > 0) {
                this.$set(book, "inputMoney", 0);
                return
            }
            let inputMoney = 0
            // 如果输入金额大于账簿最大金额，则自动填入最大金额
            if (book.isAbleWebPay == 1) {
                if (Math.abs(remainingAmount) > book.maxMoney) {
                    //退货： 如果剩余金额小于0，则自动填入最大金额的负数
                    if (remainingAmount < 0) {
                        inputMoney = book.maxMoney * -1
                    } else {//正常销售： 如果剩余金额大于0，则自动填入最大金额
                        inputMoney = book.maxMoney
                    }
                } else {
                    inputMoney = remainingAmount
                }
            } else {
                const amount = Math.abs(this.payableAmount)//现在需要退款总金额
                //获取可退线上总金额
                const totalAmount = this.$common.getDecimalInfo(3, this.bookList.reduce((sum, b) => {
                    let value = 0;
                    if (!this.isRechargeMode && !b.disabled && b.isAbleWebPay == 1) {
                        value = b.maxMoney
                    }
                    return sum + value;
                }, 0));
                let initialAmount = 0 //非线上金额
                if (amount < this.return_money) {
                    //计算 非线上金额=实际退款金额-(线上总金额-(总金额-实际退款金额))
                    initialAmount = amount - (totalAmount - (this.return_money - amount))
                } else {
                    //计算 非线上金额= 总金额-线上金额
                    initialAmount = this.$common.getDecimalInfo(3, amount - totalAmount)
                }
                console.log(initialAmount);
                if (initialAmount <= Math.abs(totalInputMoney1)) {
                    inputMoney = 0
                } else if (initialAmount <= Math.abs(remainingAmount)) {
                    inputMoney = initialAmount * -1
                } else {
                    inputMoney = remainingAmount
                }
            }
            // 如果当前输入框没有值，且账簿未禁用，则自动填入剩余金额（包括负金额）
            if (
                !book.disabled &&
                (!book.inputMoney || parseFloat(book.inputMoney) === 0)
            ) {
                if (inputMoney !== 0) {
                    this.$set(book, "inputMoney", inputMoney);
                }
            }
        },
        //聚焦到输入框(多账簿)(线上的金额可以放到线下退款，线上的金额只能线上退款不能退线下的金额)
        returnQueryFocus1(book) {
            console.log(123123);
            // 计算总输入金额(非现金)
            const totalInputMoney1 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            // 计算总输入金额（线上金额）
            const totalInputMoney2 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0 && b.isAbleWebPay == 1) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            // 已输入的总金额=已输入的非线上金额+已输入的线上金额
            const totalInputMoney = totalInputMoney1
            const remainingAmount = this.$common.getDecimalInfo(3, parseFloat(this.payableAmount - totalInputMoney));
            if (remainingAmount > 0) {
                this.$set(book, "inputMoney", 0);
                return
            }
            let inputMoney = 0
            // 如果输入金额大于账簿最大金额，则自动填入最大金额
            if (book.isAbleWebPay == 1) {
                if (Math.abs(remainingAmount) > book.maxMoney) {
                    //退货： 如果剩余金额小于0，则自动填入最大金额的负数
                    if (remainingAmount < 0) {
                        inputMoney = book.maxMoney * -1
                    } else {//正常销售： 如果剩余金额大于0，则自动填入最大金额
                        inputMoney = book.maxMoney
                    }
                } else {
                    inputMoney = remainingAmount
                }
            } else {
                const amount = Math.abs(this.payableAmount)//现在需要退款总金额
                let initialAmount = 0 //非线上金额
                //计算 非线上金额= 总金额-线上金额
                initialAmount = this.$common.getDecimalInfo(3, amount)
                if (initialAmount <= Math.abs(totalInputMoney1)) {
                    inputMoney = 0
                } else if (initialAmount <= Math.abs(remainingAmount)) {
                    inputMoney = initialAmount * -1
                } else {
                    inputMoney = remainingAmount
                }
            }
            // 如果当前输入框没有值，且账簿未禁用，则自动填入剩余金额（包括负金额）
            if (
                !book.disabled &&
                (!book.inputMoney || parseFloat(book.inputMoney) === 0)
            ) {
                if (inputMoney !== 0) {
                    this.$set(book, "inputMoney", inputMoney);
                }
            }
        },
        // 处理账簿输入框值变化事件
        handleBookInputChange(book) {
            // 确保输入的是有效数字
            let amount = parseFloat(book.inputMoney) || 0;

            if (this.payableAmount >= 0) {
                //如果输入金额为负数，设为0
                if (amount < 0) {
                    amount = 0;
                }
            } else {
                if (amount > 0) {
                    amount = 0;
                }
            }

            // 保留两位小数
            amount = parseFloat(this.$common.getDecimalInfo(3, amount));

            // 更新输入框的值
            this.$set(book, "inputMoney", amount);

            // 计算总输入金额
            const totalInputMoney = this.bookList.reduce((sum, b) => {
                const value = parseFloat(b.inputMoney) || 0;
                return sum + value;
            }, 0);
            // 验证总输入金额是否合理
            if (this.payableAmount >= 0) {
                // 计算非现金付款金额（排除payType=1的现金）
                const nonCashInputMoney = this.bookList.reduce((sum, b) => {
                    if (b.payType != 1) { // 非现金
                        const value = parseFloat(b.inputMoney) || 0;
                        return sum + value;
                    }
                    return sum;
                }, 0);
                money = this.$common.getDecimalInfo(3, nonCashInputMoney)
                // 正常销售：非现金付款金额不能超过应付金额
                if (money > this.payableAmount) {
                    this.$message.warning(
                        `非现金付款金额${this.$common.getDecimalInfo(3, nonCashInputMoney)}不能超过应付金额${this.$common.getDecimalInfo(3, this.payableAmount)}，请重新输入`
                    );
                }
            } else {
                // this.returnChange(totalInputMoney,book)
                //this.returnQueryChange(book)//线下的对应线下的，线上金额的对应线上金额
                this.returnQueryChange1(book)//线下对应（线下和线上的），线上金额对应线上金额
            }
        },
        returnChange(totalInputMoney, book) {
            var money = 0
            // 退货：非现金付款金额不能超过最大金额
            if (book.maxMoney >= Math.abs(book.inputMoney)) {
                money = this.$common.getDecimalInfo(3, totalInputMoney)
                // 退货：输入金额不能小于应付金额（负数）
                if (money < this.payableAmount) {
                    this.$message.warning(
                        `输入金额${this.$common.getDecimalInfo(3, totalInputMoney)}小于应付金额${this.$common.getDecimalInfo(3, this.payableAmount)}，请重新输入`
                    );
                }
            } else {
                this.$set(book, "inputMoney", book.maxMoney * -1);
            }
        },
        returnQueryChange(book) {
            // 计算总输入金额(非现金)
            const totalInputMoney1 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0 && b.isAbleWebPay == 0) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            // 计算总输入金额（线上金额）
            const totalInputMoney2 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0 && b.isAbleWebPay == 1) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            console.log(totalInputMoney1, totalInputMoney2);

            // 已输入的总金额=已输入的非线上金额+已输入的线上金额
            const totalInputMoney = totalInputMoney1 + totalInputMoney2
            if (book.isAbleWebPay == 1) {
                // 退货：非现金付款金额不能超过最大金额
                if (book.maxMoney >= Math.abs(book.inputMoney)) {
                    money = this.$common.getDecimalInfo(3, totalInputMoney)
                    // 退货：输入金额不能小于应付金额（负数）
                    if (money < this.payableAmount) {
                        this.$message.warning(
                            `输入金额${this.$common.getDecimalInfo(3, totalInputMoney)}小于应付金额${this.$common.getDecimalInfo(3, this.payableAmount)}，请重新输入`
                        );
                    }
                } else {
                    this.$set(book, "inputMoney", book.maxMoney * -1);
                }
            } else {
                const amount = Math.abs(this.payableAmount)//现在需要退款总金额
                //获取可退线上总金额
                const totalAmount = this.$common.getDecimalInfo(3, this.bookList.reduce((sum, b) => {
                    let value = 0;
                    if (!this.isRechargeMode && !b.disabled && b.isAbleWebPay == 1) {
                        value = b.maxMoney
                    }
                    return sum + value;
                }, 0));
                let initialAmount = 0 //非线上金额
                if (amount < this.return_money) {
                    //计算 非线上金额=实际退款金额-(线上总金额-(总金额-实际退款金额))
                    initialAmount = amount - (totalAmount - (this.return_money - amount))
                } else {
                    //计算 非线上金额= 总金额-线上金额
                    initialAmount = this.$common.getDecimalInfo(3, amount - totalAmount)
                }
                var money = this.$common.getDecimalInfo(3, totalInputMoney)
                if (initialAmount < Math.abs(totalInputMoney1)) {
                    this.$message.warning(
                        `输入金额${this.$common.getDecimalInfo(3, totalInputMoney1)}小于非线上金额${this.$common.getDecimalInfo(3, initialAmount * -1)}，请重新输入`
                    );
                    this.$set(book, "inputMoney", this.$common.getDecimalInfo(3, book.inputMoney - (totalInputMoney1 - (initialAmount * -1))));
                } else if (Math.abs(money) > Math.abs(this.payableAmount)) { // 退货：输入金额不能小于应付金额（负数）
                    this.$message.warning(
                        `输入金额${this.$common.getDecimalInfo(3, totalInputMoney)}小于应付金额${this.$common.getDecimalInfo(3, this.payableAmount)}，请重新输入`

                    );
                }
            }
        },
        returnQueryChange1(book) {
            // 计算总输入金额(线上金额+线下金额)
            const totalInputMoney1 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            // 计算总输入金额（线上金额）
            let totalInputMoney2 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0 && b.isAbleWebPay == 1) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            // 计算总输入金额（线下金额）
            let totalInputMoney3 = this.bookList.reduce((sum, b) => {
                let value = 0;
                if (b.inputMoney < 0 && b.isAbleWebPay == 0) {
                    value = b.inputMoney
                }
                return sum + value;
            }, 0);
            console.log(totalInputMoney1, totalInputMoney2);

            // 已输入的总金额=已输入的非线上金额+已输入的线上金额
            const totalInputMoney = totalInputMoney1
            if (book.isAbleWebPay == 1) {
                // 退货：非现金付款金额不能超过最大金额
                if (book.maxMoney >= Math.abs(book.inputMoney)) {
                    money = this.$common.getDecimalInfo(3, totalInputMoney)
                    // 退货：输入金额不能小于应付金额（负数）
                    if (money < this.payableAmount) {
                        this.$message.warning(
                            `输入金额${this.$common.getDecimalInfo(3, totalInputMoney)}小于应付金额${this.$common.getDecimalInfo(3, this.payableAmount)}，请重新输入`

                        );
                        const syMoney = this.$common.getDecimalInfo(3, this.payableAmount - totalInputMoney3 - (totalInputMoney2 - book.inputMoney))
                        this.$set(book, "inputMoney", syMoney);
                    }
                } else {
                    this.$set(book, "inputMoney", book.maxMoney * -1);
                }
            } else {
                const amount = Math.abs(this.payableAmount)//现在需要退款总金额
                let initialAmount = 0 //非线上金额
                //计算 非线上金额= 总金额-线上金额
                initialAmount = this.$common.getDecimalInfo(3, amount)
                var money = this.$common.getDecimalInfo(3, totalInputMoney)
                if (initialAmount < Math.abs(totalInputMoney1)) {
                    this.$message.warning(
                        `输入金额${this.$common.getDecimalInfo(3, totalInputMoney1)}小于非线上金额${this.$common.getDecimalInfo(3, initialAmount * -1)}，请重新输入`
                    );
                    this.$set(book, "inputMoney", this.$common.getDecimalInfo(3, book.inputMoney - (totalInputMoney1 - (initialAmount * -1))));
                } else if (Math.abs(money) > Math.abs(this.payableAmount)) { // 退货：输入金额不能小于应付金额（负数）
                    this.$message.warning(
                        `输入金额${this.$common.getDecimalInfo(3, totalInputMoney)}小于应付金额${this.$common.getDecimalInfo(3, this.payableAmount)}，请重新输入`
                    );
                }
            }
        },
        validateBookInputs() {
            // 验证总金额是否超过应付金额（对于正数）或小于应付金额（对于负数）
            const totalInputAmount = parseFloat(this.$common.getDecimalInfo(3, this.totalInputMoney));
            const payableAmount = parseFloat(this.$common.getDecimalInfo(3, this.payableAmount));

            if (payableAmount >= 0) {
                // 计算非现金付款金额（排除payType=1的现金）
                const nonCashInputMoney = this.bookList.reduce((sum, b) => {
                    if (b.payType != 1) { // 非现金
                        const value = parseFloat(b.inputMoney) || 0;
                        return sum + value;
                    }
                    return sum;
                }, 0);

                // 正常销售：非现金付款金额不能超过应付金额
                if (nonCashInputMoney > this.payableAmount) {
                    this.$message.warning(
                        `非现金付款金额${this.$common.getDecimalInfo(3, nonCashInputMoney)}不能超过应付金额${this.$common.getDecimalInfo(3, this.payableAmount)}，请重新输入`

                    );
                }
            } else {
                // 退货：输入金额不能小于应付金额（负数）
                if (totalInputAmount < payableAmount) {
                    this.$message.warning(
                        `输入金额${this.$common.getDecimalInfo(3, totalInputAmount)}小于应付金额${this.$common.getDecimalInfo(3, payableAmount)}，请重新输入`

                    );
                    return false;
                }
            }

            // 检查是否有输入金额（正数或负数）
            const hasInput = this.bookList.some(
                (book) => book.inputMoney !== 0 && book.inputMoney !== ""
            );
            if (!hasInput) {
                this.$message.warning("请输入付款金额");
                return false;
            }
            return true;
        },

        // 实时参与活动方案
        async getRealTimePromotions() {
            try {
                const res = await this.$http.checkBgmAblePlan({
                    bgmList: this.cartItems
                        .filter((item) => !item.isGift) // 筛选掉赠品商品
                        .map((item) => ({
                            bgmId: item.bgmId,
                            batchno: item.batchno,
                            num: item.quantity,
                            recPrice: item.amount,
                            sellPrice: item.price * item.quantity,
                        })),
                    curDate: this.curDate,
                    curTime: this.curTime,
                    day: this.day,
                    memId: this.memberInfo.memId ? this.memberInfo.memId : "",
                    storeId: this.storeId,
                    week: this.week,
                });

                if (res && res.status === 200 && res.result) {
                    if (
                        (!res.result.clList || res.result.clList.length === 0) &&
                        (!res.result.mzList || res.result.mzList.length === 0)
                    ) {
                        console.log("当前商品暂无可用促销方案");
                        this.resetPromotion();
                        this.removeGiftItemsFromCart([])
                        this.usedPromotions = [];

                        return;
                    }

                    // 合并所有类型的促销方案
                    let allPromotions = [];
                    // 处理超量促销
                    if (res.result.clList && res.result.clList.length > 0) {
                        allPromotions = allPromotions.concat(
                            res.result.clList.map((item) => ({
                                ...item,
                                sellType: 31, // 超量促销
                            }))
                        );
                    }
                    // 处理买赠促销
                    if (res.result.mzList && res.result.mzList.length > 0) {
                        allPromotions = allPromotions.concat(
                            res.result.mzList.map((item) => ({
                                ...item,
                                sellType: 32, // 买赠促销
                            }))
                        );
                        // 处理买赠促销的赠品列表
                        this.giftList = [];
                        this.giftYhqList = [];
                        res.result.mzList.forEach((plan) => {
                            if (plan.mzGiftType == 1) {
                                // 赠品
                                if (plan.giftBgmList && Array.isArray(plan.giftBgmList)) {
                                    plan.giftBgmList.forEach((gift) => {
                                        this.giftList.push({
                                            ...gift,
                                            planId: plan.planId,
                                            planName: plan.planName,
                                            stageDesc: `满${plan.mzConBgmNum || 0}件赠送${plan.mzGiftNum || 0
                                                }件`,
                                            giftNum: gift.giftNum || 0,
                                            retailPrice: 0,
                                        });
                                    });
                                }
                            }
                            if (plan.mzGiftType == 2) {
                                // 优惠券
                                if (plan.giftYhqList && Array.isArray(plan.giftYhqList)) {
                                    plan.giftYhqList.forEach((gift) => {
                                        this.giftYhqList.push({
                                            ...gift,
                                            yhqId: gift.yhqId,
                                            yhqName: gift.yhqName,
                                            yhqDesc: gift.yhqDesc,
                                            limitDay: gift.limitDay,
                                            remark: gift.remark,
                                            inputNum: 0,
                                        });
                                    });
                                }
                            }
                        });
                    }
                    // 处理调价促销（积分）
                    if (res.result.tjPoint && res.result.tjPoint.length > 0) {
                        allPromotions = allPromotions.concat(
                            res.result.tjPoint.map((item) => ({
                                ...item,
                                sellType: 41, // 调价
                            }))
                        );
                    }
                    // 处理调价促销（价格）
                    if (res.result.tjPrice && res.result.tjPrice.length > 0) {
                        allPromotions = allPromotions.concat(
                            res.result.tjPrice.map((item) => ({
                                ...item,
                                sellType: 42, // 调价
                            }))
                        );
                    }
                    this.promotionSelectList = allPromotions;

                    // 检查已使用的促销方案是否还在可用列表中，如果不在则删除
                    if (this.usedPromotions.length > 0) {
                        this.usedPromotions = this.usedPromotions.filter(usedItem => {
                            const matchedPlan = allPromotions.find(plan => plan.planId === usedItem.planId);
                            return !!matchedPlan; // 只保留在allPromotions中存在的促销方案
                        });
                        this.removeGiftItemsFromCart(this.usedPromotions); // 传入空数组，清除所有赠品
                    }


                    this.selectedPromotions = [];
                    // 检查购物车中是否有商品已经享受特价优惠
                    const hasSpecialPriceItems = this.cartItems.some(
                        (item) =>
                            item.spPrice !== undefined || item.spMemberPrice !== undefined
                    );

                    console.log("购物车中是否有特价商品:", hasSpecialPriceItems);

                    // 如果有特价商品，则过滤掉调价促销，优先使用特价优惠
                    let filteredPromotions = hasSpecialPriceItems
                        ? allPromotions.filter(
                            (promotion) =>
                                promotion.sellType !== 41 && promotion.sellType !== 42
                        )
                        : allPromotions;

                    // 检查可用的促销方案数量
                    if (filteredPromotions.length === 0) {
                        console.log("没有可自动应用的促销方案");
                        return;
                    } else if (filteredPromotions.length === 1) {
                        // 只有一个促销方案，自动应用
                        this.resetPromotion(-1, false, false);
                        this.selectedPromotions = [filteredPromotions[0]];

                        this.confirmPromotionSelection();
                        return;
                    } else {
                        // 有多个促销方案，检查是否有冲突
                        const autoApplicablePromotions =
                            this.getAutoApplicablePromotions(filteredPromotions);
                        this.resetPromotion(-1, false, false);
                        if (autoApplicablePromotions.length === filteredPromotions.length) {
                            // 所有方案都无冲突，可以全部自动应用
                            this.selectedPromotions = autoApplicablePromotions;
                            this.confirmPromotionSelection();
                            return;
                        } else if (autoApplicablePromotions.length > 0) {
                            // 部分方案有冲突，自动应用无冲突的方案，提醒用户有冲突的方案
                            const conflictPromotions = filteredPromotions.filter(
                                (p) => !autoApplicablePromotions.includes(p)
                            );
                            // 自动应用无冲突的方案
                            this.selectedPromotions = autoApplicablePromotions;
                            this.confirmPromotionSelection();
                            // 提醒用户有冲突的方案和赠品方案
                            let warningMessage = `已自动应用：${autoApplicablePromotions
                                .map((p) => p.planName)
                                .join("、")}。冲突方案：${conflictPromotions
                                    .map((p) => p.planName)
                                    .join("、")}`;
                            warningMessage += `，如需选择请使用快捷键=`;
                            this.$message.warning(warningMessage);
                            return;
                        }
                    }
                } else {
                    this.removeGiftItemsFromCart([])
                    console.log("获取促销方案失败");
                }

            } catch (error) {
                console.log("获取促销方案列表失败", error);
                this.removeGiftItemsFromCart([])
                this.promotionSelectList = [];
            }
            this.promotionSelectSearch = "";
        },
        // 获取可以自动应用的促销方案（基于现有的冲突检测逻辑）
        getAutoApplicablePromotions(promotions) {
            if (!promotions || promotions.length === 0) {
                return [];
            }

            // 如果只有一个促销方案，直接返回
            if (promotions.length === 1) {
                return promotions;
            }

            // 使用贪心算法选择最多的无冲突促销方案
            const autoApplicable = [];

            // 临时设置 selectedPromotions 为空，模拟选择过程
            const originalSelected = [...this.selectedPromotions];
            this.selectedPromotions = [];

            for (const promotion of promotions) {
                // 使用现有的 promotionSelectable 方法检查是否可选
                if (this.promotionSelectable(promotion)) {
                    // 如果可选，添加到结果中并更新临时选择列表
                    autoApplicable.push(promotion);
                    this.selectedPromotions.push(promotion);
                    console.log(`✅ 可自动应用促销方案: ${promotion.planName}`);
                } else {
                    console.log(`❌ 促销方案冲突，优先选择第一个: ${promotion.planName}`);
                    // 如果是第一个促销方案且当前没有选择任何方案，则选择它
                    if (autoApplicable.length === 0) {
                        autoApplicable.push(promotion);
                        this.selectedPromotions.push(promotion);
                    }
                }
            }

            // 恢复原始的 selectedPromotions
            this.selectedPromotions = originalSelected;

            return autoApplicable;
        },
    },
    computed: {
        // 实时计算购物车获得的积分
        totalEarnedPoints() {
            return this.calculatedPoints;
        },
        totalInputMoney() {
            // 计算总金额并保留两位小数
            return this.bookList.reduce((sum, book) => {
                const amount = parseFloat(
                    this.$common.getDecimalInfo(3, (parseFloat(book.inputMoney) || 0))
                );
                return parseFloat(this.$common.getDecimalInfo(3, sum + amount));
            }, 0);
        },
        // 计算找零金额
        cashChangeAmount() {
            // 计算现金输入金额
            const cashInputMoney = this.bookList.reduce((sum, book) => {
                if (book.payType == 1) { // 现金
                    const amount = parseFloat(
                        this.$common.getDecimalInfo(3, (parseFloat(book.inputMoney) || 0))
                    );
                    return parseFloat(this.$common.getDecimalInfo(3, sum + amount));
                }
                return sum;
            }, 0);

            // 计算非现金输入金额
            const nonCashInputMoney = this.bookList.reduce((sum, book) => {
                if (book.payType != 1) { // 非现金
                    const amount = parseFloat(
                        this.$common.getDecimalInfo(3, (parseFloat(book.inputMoney) || 0))
                    );
                    return parseFloat(this.$common.getDecimalInfo(3, sum + amount));
                }
                return sum;
            }, 0);

            // 找零 = 现金金额 - (应付金额 - 非现金金额)
            const remainingPayable = Math.max(0, this.payableAmount - nonCashInputMoney);
            const changeAmount = Math.max(0, cashInputMoney - remainingPayable);

            return parseFloat(this.$common.getDecimalInfo(3, changeAmount));
        },
        // 获取可用的赠品列表（合并 giftList 和 allGiftList）
        availableGiftList() {
            const availableGifts = [];
            // 添加 giftList 中的赠品
            if (this.giftList && this.giftList.length > 0) {
                availableGifts.push(...this.giftList);
            }

            // 添加 allGiftList 中的赠品（避免重复）
            if (this.allGiftList && this.allGiftList.length > 0) {
                this.allGiftList.forEach((gift) => {
                    const exists = availableGifts.some(
                        (existing) =>
                            existing.bgmId === gift.bgmId && existing.planId === gift.planId
                    );
                    if (!exists) {
                        availableGifts.push(gift);
                    }
                });
            }

            // 为每个赠品设置数量信息（只读操作，不修改原数据）
            const processedGifts = availableGifts.map((gift) => {
                const giftCopy = { ...gift };

                // 设置赠品的固定数量（从促销方案配置中获取）
                const plan = this.selectedPromotions.find(
                    (p) => p.planId === gift.planId
                );
                if (plan) {
                    // 优先使用赠品自身的数量配置，其次使用方案的配置
                    giftCopy.giftNum = gift.giftNum || 1;
                } else {
                    giftCopy.giftNum = gift.giftNum || 1;
                }

                // inputNum 用于内部处理，初始为0（未选择状态）
                if (giftCopy.inputNum === undefined || giftCopy.inputNum === null) {
                    giftCopy.inputNum = 0;
                }

                return giftCopy;
            });

            // 注意：自动选择逻辑已移到 singleSelectGiftList 计算属性中

            return processedGifts;
        },
        // 获取任选一个模式的赠品列表（只展示当前方案的赠品）
        singleSelectGiftList() {
            const singleSelectGifts = [];

            // 只获取任选一个模式的促销方案的赠品
            const singleSelectPromotions = this.selectedPromotions.filter(
                (plan) => plan.mzGiftNumType === 1
            );

            // 如果没有任选一个模式的促销方案，返回空数组
            if (singleSelectPromotions.length === 0) {
                return [];
            }

            // 获取当前高亮的促销方案（当前方案）
            const currentPlan = singleSelectPromotions[this.currentHighlightRowIndex] || singleSelectPromotions[0];

            if (!currentPlan) {
                return [];
            }

            // 只获取当前方案的赠品
            // 从 giftList 中获取该方案的赠品
            if (this.giftList && this.giftList.length > 0) {
                const planGifts = this.giftList.filter(
                    (gift) => gift.planId === currentPlan.planId
                );
                singleSelectGifts.push(...planGifts);
            }

            // 从 allGiftList 中获取该方案的赠品（避免重复）
            if (this.allGiftList && this.allGiftList.length > 0) {
                this.allGiftList.forEach((gift) => {
                    if (gift.planId === currentPlan.planId) {
                        const exists = singleSelectGifts.some(
                            (existing) =>
                                existing.bgmId === gift.bgmId &&
                                existing.planId === gift.planId
                        );
                        if (!exists) {
                            singleSelectGifts.push(gift);
                        }
                    }
                });
            }

            // 为每个赠品设置数量信息
            const processedGifts = singleSelectGifts.map((gift) => {
                const giftCopy = { ...gift };
                // 设置赠品的固定数量
                giftCopy.giftNum = gift.giftNum || 1;
                return giftCopy;
            });

            // 如果是任选一个赠品模式，且没有选中任何赠品，标记需要自动选择
            if (processedGifts.length > 0 && !this.selectedSingleGift) {
                // 标记需要自动选择，在 watch 中处理
                this._needAutoSelectGift = true;
            }

            return processedGifts;
        },
        // 获取多选模式的赠品列表
        multiSelectGiftList() {
            const multiSelectGifts = [];

            // 只获取多选模式的促销方案的赠品
            const multiSelectPromotions = this.selectedPromotions.filter(
                (plan) => plan.mzGiftNumType === 2
            );

            multiSelectPromotions.forEach((plan) => {
                // 从 giftList 中获取该方案的赠品
                if (this.giftList && this.giftList.length > 0) {
                    const planGifts = this.giftList.filter(
                        (gift) => gift.planId === plan.planId
                    );
                    multiSelectGifts.push(...planGifts);
                }

                // 从 allGiftList 中获取该方案的赠品（避免重复）
                if (this.allGiftList && this.allGiftList.length > 0) {
                    this.allGiftList.forEach((gift) => {
                        if (gift.planId === plan.planId) {
                            const exists = multiSelectGifts.some(
                                (existing) =>
                                    existing.bgmId === gift.bgmId &&
                                    existing.planId === gift.planId
                            );
                            if (!exists) {
                                multiSelectGifts.push(gift);
                            }
                        }
                    });
                }
            });

            // 为每个赠品设置数量信息
            const processedGifts = multiSelectGifts.map((gift) => {
                const giftCopy = { ...gift };

                // 设置赠品的固定数量
                const plan = this.selectedPromotions.find(
                    (p) => p.planId === gift.planId
                );
                if (plan) {
                    giftCopy.giftNum =
                        gift.giftNum ||
                        gift.mzGiftNum ||
                        plan.mzGiftTypeNum ||
                        this.mzGiftTypeNum ||
                        1;
                } else {
                    giftCopy.giftNum = gift.giftNum || gift.mzGiftNum || 1;
                }

                return giftCopy;
            });

            console.log("多选模式赠品列表:", processedGifts);
            return processedGifts;
        },
        // 获取可用的优惠券列表（合并 giftYhqList 和 allGiftYhqList）
        availableCouponList() {
            const availableCoupons = [];

            // 添加 giftYhqList 中的优惠券
            if (this.giftYhqList && this.giftYhqList.length > 0) {
                availableCoupons.push(...this.giftYhqList);
            }

            // 添加 allGiftYhqList 中的优惠券（避免重复）
            if (this.allGiftYhqList && this.allGiftYhqList.length > 0) {
                this.allGiftYhqList.forEach((coupon) => {
                    const exists = availableCoupons.some(
                        (existing) =>
                            existing.yhqId === coupon.yhqId &&
                            existing.planId === coupon.planId
                    );
                    if (!exists) {
                        availableCoupons.push(coupon);
                    }
                });
            }

            // 为每个优惠券设置数量信息（只读操作，不修改原数据）
            const processedCoupons = availableCoupons.map((coupon) => {
                const couponCopy = { ...coupon };

                // 设置赠送条件描述
                if (coupon.planId) {
                    const plan = this.selectedPromotions.find(
                        (p) => p.planId === coupon.planId
                    );
                    if (plan) {
                        couponCopy.stageDesc = `满${plan.mzConBgmNum || 0}件赠送${plan.mzGiftNum || 0
                            }张`;
                    }
                }

                return couponCopy;
            });

            // 注意：自动选择逻辑已移到 singleSelectCouponList 计算属性中

            return processedCoupons;
        },
        // 获取任选一个模式的优惠券列表
        singleSelectCouponList() {
            const singleSelectCoupons = [];

            // 只获取任选一个模式的促销方案的优惠券
            const singleSelectPromotions = this.selectedPromotions.filter(
                (plan) => plan.mzGiftNumType === 1
            );

            singleSelectPromotions.forEach((plan) => {
                // 从 giftYhqList 中获取该方案的优惠券
                if (this.giftYhqList && this.giftYhqList.length > 0) {
                    const planCoupons = this.giftYhqList.filter(
                        (coupon) => coupon.planId === plan.planId
                    );
                    singleSelectCoupons.push(...planCoupons);
                }

                // 从 allGiftYhqList 中获取该方案的优惠券（避免重复）
                if (this.allGiftYhqList && this.allGiftYhqList.length > 0) {
                    this.allGiftYhqList.forEach((coupon) => {
                        if (coupon.planId === plan.planId) {
                            const exists = singleSelectCoupons.some(
                                (existing) =>
                                    existing.yhqId === coupon.yhqId &&
                                    existing.planId === coupon.planId
                            );
                            if (!exists) {
                                singleSelectCoupons.push(coupon);
                            }
                        }
                    });
                }
            });

            // 为每个优惠券设置数量信息
            const processedCoupons = singleSelectCoupons.map((coupon) => {
                const couponCopy = { ...coupon };

                // 设置优惠券的固定数量
                const plan = this.selectedPromotions.find(
                    (p) => p.planId === coupon.planId
                );
                if (plan) {
                    couponCopy.giftNum =
                        coupon.giftNum ||
                        coupon.mzGiftNum ||
                        plan.mzGiftTypeNum ||
                        this.mzGiftNum ||
                        1;
                } else {
                    couponCopy.giftNum = coupon.giftNum || coupon.mzGiftNum || 1;
                }

                return couponCopy;
            });

            // 如果是任选一个优惠券模式，且没有选中任何优惠券，标记需要自动选择
            if (processedCoupons.length > 0 && !this.selectedSingleCoupon) {
                console.log("🔍 检测到需要自动选择第一个优惠券");
                // 标记需要自动选择，在 watch 中处理
                this._needAutoSelectCoupon = true;
            }

            console.log("任选一个模式优惠券列表:", processedCoupons);

            return processedCoupons;
        },
        // 获取多选模式的优惠券列表
        multiSelectCouponList() {
            const multiSelectCoupons = [];

            // 只获取多选模式的促销方案的优惠券
            const multiSelectPromotions = this.selectedPromotions.filter(
                (plan) => plan.mzGiftNumType === 2
            );

            multiSelectPromotions.forEach((plan) => {
                // 从 giftYhqList 中获取该方案的优惠券
                if (this.giftYhqList && this.giftYhqList.length > 0) {
                    const planCoupons = this.giftYhqList.filter(
                        (coupon) => coupon.planId === plan.planId
                    );
                    multiSelectCoupons.push(...planCoupons);
                }

                // 从 allGiftYhqList 中获取该方案的优惠券（避免重复）
                if (this.allGiftYhqList && this.allGiftYhqList.length > 0) {
                    this.allGiftYhqList.forEach((coupon) => {
                        if (coupon.planId === plan.planId) {
                            const exists = multiSelectCoupons.some(
                                (existing) =>
                                    existing.yhqId === coupon.yhqId &&
                                    existing.planId === coupon.planId
                            );
                            if (!exists) {
                                multiSelectCoupons.push(coupon);
                            }
                        }
                    });
                }
            });

            // 为每个优惠券设置数量信息
            const processedCoupons = multiSelectCoupons.map((coupon) => {
                const couponCopy = { ...coupon };

                // 设置优惠券的固定数量
                const plan = this.selectedPromotions.find(
                    (p) => p.planId === coupon.planId
                );
                if (plan) {
                    couponCopy.giftNum =
                        coupon.giftNum ||
                        coupon.mzGiftNum ||
                        plan.mzGiftTypeNum ||
                        this.mzGiftNum ||
                        1;
                } else {
                    couponCopy.giftNum = coupon.giftNum || coupon.mzGiftNum || 1;
                }

                return couponCopy;
            });

            console.log("多选模式优惠券列表:", processedCoupons);
            return processedCoupons;
        },

    },
    beforeDestroy() {
        // 清理积分计算定时器
        if (this.pointsCalculationTimer) {
            clearTimeout(this.pointsCalculationTimer);
            this.pointsCalculationTimer = null;
        }
    },
    watch: {
        'memberInfo.doctor': {
            handler(newVal) {
                var arr = this.doctorList.filter(item => item.opmId == newVal)
                if (arr.length > 0) {
                    this.memberInfo.addRate = Number(arr[0].addRate) || 0
                    if (this.cartItems.length > 0) {
                        this.cartItems.forEach((item, index) => {
                            if (this.memberInfo.addRate && !item.isPriceManuallyChanged) {
                                this.updateItemPriceRate(index)
                            }
                        })
                    }
                }
            },
            deep: true,
        },
        bookSelectDialogVisible: {
            handler(newVal) {
                if (!newVal) {
                    if (this.totalInputMoney < 0) {
                        this.initCart()
                    }
                }
            },
            deep: true,
        },
        payShow: {
            handler(newVal) {
                this.escPayShow = true
                if (!newVal) {
                    this.closeIndex = 0
                    this.closeFlag = false
                    clearTimeout(this.payTimer);
                    this.payReadonly = false
                    this.payMessage = ""
                } else {
                    this.payCode = ""
                }
            },
            deep: true,
        },
        // 监听任选一个模式赠品列表变化，自动选择第一个赠品
        singleSelectGiftList: {
            handler(newList) {
                if (
                    this._needAutoSelectGift &&
                    newList.length > 0 &&
                    !this.selectedSingleGift
                ) {
                    console.log("🔄 执行自动选择第一个赠品:", newList[0].bgmName);
                    this.selectedSingleGift = newList[0].bgmId;
                    this.setDefaultGiftSelection(newList[0]);
                    this._needAutoSelectGift = false;
                }
            },
            immediate: true,
        },
        // 监听任选一个模式优惠券列表变化，自动选择第一个优惠券
        singleSelectCouponList: {
            handler(newList) {
                if (
                    this._needAutoSelectCoupon &&
                    newList.length > 0 &&
                    !this.selectedSingleCoupon
                ) {
                    console.log("🔄 执行自动选择第一个优惠券:", newList[0].yhqName);
                    this.selectedSingleCoupon = newList[0].yhqId;
                    this.setDefaultCouponSelection(newList[0]);
                    this._needAutoSelectCoupon = false;
                }
            },
            immediate: true,
        },
        // 监听当前高亮行索引变化，切换方案时重置赠品选择
        currentHighlightRowIndex: {
            handler(newIndex, oldIndex) {
                // 只有当索引真正改变时才处理
                if (newIndex !== oldIndex) {
                    console.log("🔄 方案切换，重置赠品选择:", newIndex);
                    // 重置单选赠品选择
                    this.selectedSingleGift = null;
                    // 重置单选优惠券选择
                    this.selectedSingleCoupon = null;
                    // 标记需要自动选择赠品和优惠券
                    this._needAutoSelectGift = true;
                    this._needAutoSelectCoupon = true;
                }
            },
            immediate: false,
        },
        // 监听购物车商品数量变化，自动更新总计
        cartItems: {
            handler(newCartItems, oldCartItems) {
                this.totalCount = newCartItems.length
                if (this.memberInfo.addRate) {
                    newCartItems.forEach((item, index) => {
                        if (this.memberInfo.addRate && !item.isPriceManuallyChanged) {
                            this.updateItemPriceRate(index)
                        }
                    });
                }
                setTimeout(() => {
                    this.updateTotal();
                }, 300);
                // 防抖处理积分计算，避免频繁调用API
                if (this.pointsCalculationTimer) {
                    clearTimeout(this.pointsCalculationTimer);
                }
                this.pointsCalculationTimer = setTimeout(() => {
                    this.calculatePoints();
                }, 500); // 500ms防抖延迟

                console.log("🔄 购物车商品数量变化，自动更新总计和积分");
            },
            deep: true, // 深度监听，能够检测到数组内对象属性的变化
            immediate: false, // 不立即执行，避免初始化时触发
        },
    },
};
</script>

<style scoped>
.cashier-page {
    background: #f5f7fa;
    min-height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100vh;
    padding: 0;
    /* 禁用文本选择 */
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

:deep(.cart-table .el-table__header) {
    background: #f5f7fa;
}

:deep(.cart-table .el-table__header th) {
    background: #f5f7fa !important;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
    padding: 8px 0;
}

:deep(.cart-table .el-table__body tr) {
    height: 40px;
}

:deep(.cart-table .el-table__body td) {
    padding: 6px 0;
    font-size: 14px;
}

.product-select-area::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0.05) 100%
    );
    pointer-events: none;
}

.product-select-area .el-form {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    position: relative;
    z-index: 1;
}

.product-select-area .el-form-item {
    margin-bottom: 0;
}

.product-select-area .el-form-item__label {
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.product-select-area .el-input__inner {
    border: 2px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
    transition: all 0.3s ease;
}

.product-select-area .el-input__inner:focus {
    border-color: #fff;
    background: #fff;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

.product-select-area .el-input-number {
    border: 2px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
}

.product-select-area .el-input-number .el-input__inner {
    border: none;
    background: transparent;
}

.product-select-area .el-button--primary {
    background: linear-gradient(135deg, #ff6b6b, #ff8e53);
    border: none;
    border-radius: 8px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
    transition: all 0.3s ease;
}

.product-select-area .el-button--primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
}

/* 选中行样式 */
:deep(.cart-table .selected-row) {
    background-color: #ffdb12 !important;
}

:deep(.cart-table .selected-row td) {
    background-color: #ffdb12 !important;
}

:deep(.el-form .el-form-item) {
    margin-bottom: 0 !important;
}

:deep(.el-form .el-form-item label) {
    color: #fff;
}

/* 隐藏表头全选框 */
:deep(.promotion-dialog .el-table__header .el-checkbox) {
    display: none !important;
}

:deep(.promotion-dialog .el-dialog__body) {
    padding-top: 10px;
    padding-bottom: 0;
}

:deep(.promotion-dialog .el-table th) {
    background: #f5f7fa;
    color: #333;
    font-size: 15px;
    font-weight: bold;
}

:deep(.promotion-dialog .el-table__row) {
    font-size: 15px;
    height: 44px;
}

:deep(.promotion-type) {
    color: #67c23a;
    font-weight: bold;
}

:deep(.promotion-name) {
    color: #409eff;
    font-weight: bold;
}

:deep(.promotion-desc) {
    color: #666;
}

:deep(.promotion-condition) {
    color: #faad14;
    font-weight: bold;
}

:deep(.promotion-benefit) {
    color: #e67e22;
    font-weight: bold;
}

:deep(.promotion-dialog .el-table__row:hover) {
    background: #ffdb12 !important;
}

/* 会员选择弹窗中选中行的样式 */
:deep(.selected-member-row) {
    background-color: #ffdb12 !important;
}

:deep(.selected-member-row td) {
    background-color: #ffdb12 !important;
}

/* 商品选择弹窗中选中行的样式 */
:deep(.selected-product-row) {
    background-color: #ffdb12 !important;
}

/* 商品选择弹窗中选中行的样式 */
:deep(.el-table--border .product-expidate-row .el-table__cell .cell) {
    color: red;
}

:deep(#productTable .el-table__header th) {
    background: #f5f7fa !important;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
    padding: 8px 0;
}

:deep(#productTable .el-table__body tr) {
    height: 60px !important;
}

:deep(#memberTable .el-table tr) {
    min-height: 30px !important;
}

:deep(.selected-product-row td) {
    background-color: #ffdb12 !important;
}

/* 确保Element UI的当前行高亮样式不会被覆盖 */
:deep(#productTable .el-table__row.current-row td) {
    background-color: #ffdb12 !important;
}

/* 购物车中选中行的样式 */
:deep(.selected-row) {
    background-color: #ffdb12 !important;
}

:deep(.selected-row td) {
    background-color: #ffdb12 !important;
}

/* 顶部聚集样式 */
:deep(.selected-row td.focused-column).sales-person-focused {
    background-color: #fff !important;
    border: 2px solid #ff9800 !important;
    /* box-shadow: 0 0 0 1px #ff9800 !important; */
}

/* 兼容 el-input、el-select 内部输入框的高亮 */
:deep(.sales-person-focused .el-input__inner) {
    background-color: #fff !important;
    border: 2px solid #ff9800 !important;
    /* box-shadow: 0 0 0 1px #ff9800 !important; */
    color: #000 !important;
}

:deep(.sales-person-focused .el-input__suffix),
:deep(.sales-person-focused .el-select__caret) {
    color: #ff9800 !important;
}

/* 专门为el-select组件添加聚焦效果 */
:deep(.input-focused.el-select) {
    transform: scale(1.02);
    transition: all 0.3s ease;
    position: relative;
}

::v-deep #buyerInfoForm .el-form-item__label {
    color: #606266 !important;
}

::v-deep #merPassword .el-form-item__label {
    color: #606266 !important;
}

::v-deep #header-right-form span {
    color: #fff !important;
    margin-bottom: 5px;
    font-size: 14px;
}

#header-right-form .points-value {
    font-size: 20px;
    font-weight: bold;
    color: red !important;
}

::v-deep #buyerInfoForm .el-form-item {
    margin-bottom: 15px !important;
}
.is-zero-checkbox ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #ff5640;
    border-color: #ff5640;
}
.product-select-area-right p:hover {
    font-weight: bold;
    cursor: pointer;
}

@import "./penetrateCashier/pCommon.css";

.payment-code-container {
    padding: 15px;
    text-align: center;
}

.payment-amount-section {
    margin-bottom: 20px;
    padding: 15px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.payment-title {
    margin: 0 0 8px 0;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
}

.payment-amount {
    margin: 0;
    font-size: 28px;
    color: #e6a23c;
    font-weight: bold;
    letter-spacing: 1px;
}

.payment-input-section {
    margin-bottom: 15px;
}

.payment-input {
    margin-bottom: 8px;
}

.payment-input .el-input__inner {
    height: 45px;
    line-height: 45px;
    border-radius: 8px;
    border: 2px solid #dcdfe6;
    transition: border-color 0.3s;
}

.payment-input .el-input__inner:focus {
    border-color: #409eff;
}

.payment-input .el-input__prefix {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    color: #409eff;
}

.shortcut-info {
    text-align: left;
    padding-left: 10px;
    font-size: 14px;
    color: #909399;
    margin-top: 8px;
}

.shortcut-info kbd {
    display: inline-block;
    padding: 0 6px;
    font-family: monospace;
    line-height: 1;
    color: #fff;
    background-color: #409eff;
    border-radius: 3px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

.payment-message-section {
    min-height: 30px;
    margin: 15px 0;
}

.payment-message {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    padding: 8px 15px;
    border-radius: 20px;
    display: inline-block;
}

.payment-message.success {
    color: #67c23a;
    background-color: rgba(103, 194, 58, 0.1);
}

.payment-message.error {
    color: #f56c6c;
    background-color: rgba(245, 108, 108, 0.1);
}

.payment-message.warning {
    color: #e6a23c;
    background-color: rgba(230, 162, 60, 0.1);
}

.payment-scan-hint {
    margin-top: 20px;
    padding: 15px;
    border: 2px dashed #dcdfe6;
    border-radius: 10px;
    background-color: #f8f9ff;
}

.payment-scan-hint .scan-icon {
    width: 60px;
    height: 60px;
    margin: 0 auto 10px;
    background-color: #ecf5ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 24px;
}

.payment-scan-hint p {
    margin: 0;
    font-size: 14px;
    color: #909399;
}
</style>
